webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _routes = __webpack_require__(7);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _auth = __webpack_require__(39);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _application = __webpack_require__(215);
	
	var _app = __webpack_require__(216);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routing = __webpack_require__(213);
	
	var _promisify = __webpack_require__(19);
	
	var _arrays = __webpack_require__(24);
	
	var _rng = __webpack_require__(48);
	
	var _rng2 = _interopRequireDefault(_rng);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _location$search$subs = location.search.substring(1).split('&').filter(function (p) {
	    return 0 === p.indexOf('locale=');
	}),
	    _location$search$subs2 = _slicedToArray(_location$search$subs, 1),
	    q = _location$search$subs2[0];
	
	if (q) {
	    _config2.default.locale(q.replace('locale=', ''));
	    location.assign(location.href.replace('?' + q, '').replace('&' + q, ''));
	}
	
	var start = !q ? Promise.resolve() : Promise.reject();
	
	window.$ = window.jQuery = _jquery2.default;
	__webpack_require__(217);
	
	var app = new _application.Application();
	var appState = new _app2.default();
	
	start.then(function () {
	    return (0, _promisify.requestify)(_jquery2.default.getJSON('/languages?apiVersion=2.0'));
	}).then(function (languages) {
	    _config2.default.languages(languages);
	
	    var _languages$filter = languages.filter(function (lang) {
	        return lang.main;
	    }),
	        _languages$filter2 = _slicedToArray(_languages$filter, 1),
	        main = _languages$filter2[0];
	
	    var hash = (0, _arrays.hashify)(languages.filter(function (lang) {
	        return lang.visible;
	    }).map(function (lang) {
	        return lang.code;
	    }));
	
	    if (!_config2.default.locale()) _config2.default.locale(main.code);else if (!hash[_config2.default.locale()]) _config2.default.locale(main.code);
	}).then(function () {
	    return (0, _promisify.requestify)(_auth2.default);
	}).then(function () {
	    var baselayers = (0, _promisify.requestify)(_jquery2.default.getJSON('/baselayers?apiVersion=2.0')).then(function (layers) {
	        return layers.filter(function (layer) {
	            return layer.main;
	        })[0];
	    }).then(function (_ref) {
	        var className = _ref.className,
	            firstKey = _ref.firstKey,
	            options = _ref.options;
	
	        var Class = className.split('.').reduce(function (obj, prop) {
	            return obj[prop];
	        }, window);
	        _config2.default.mapClass({ Class: Class,
	            firstAttr: firstKey,
	            options: eval('(' + (options || '{}') + ')') });
	    });
	
	    var mapextent = (0, _promisify.requestify)(_jquery2.default.getJSON('/mapextent')).then(function (_ref2) {
	        var _ref2$mapExtent$exten = _ref2.mapExtent.extent,
	            minX = _ref2$mapExtent$exten.minX,
	            minY = _ref2$mapExtent$exten.minY,
	            maxX = _ref2$mapExtent$exten.maxX,
	            maxY = _ref2$mapExtent$exten.maxY;
	        return _config2.default.mapExtent([minX, minY, maxX, maxY]);
	    });
	
	    var settings = (0, _promisify.requestify)(_jquery2.default.getJSON('/mapsurfer/settings')).then(function (c) {
	        return c.title;
	    }).catch(function () {
	        return 'ActiveMap';
	    }).then(function (title) {
	        return _config2.default.title(title);
	    });
	
	    var ru = _config2.default.locale() != 'ru' ? {} : (0, _arrays.hashify)(["Asia/Anadyr", "Asia/Barnaul", "Asia/Chita", "Asia/Irkutsk", "Asia/Kamchatka", "Asia/Khandyga", "Asia/Krasnoyarsk", "Asia/Magadan", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Sakhalin", "Asia/Srednekolymsk", "Asia/Tomsk", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yekaterinburg", "Europe/Astrakhan", "Europe/Kaliningrad", "Europe/Kirov", "Europe/Minsk", "Europe/Moscow", "Europe/Samara", "Europe/Saratov", "Europe/Simferopol", "Europe/Ulyanovsk", "Europe/Volgograd"]);
	
	    var fn = function fn(_ref3) {
	        var id = _ref3.id,
	            name = _ref3.name;
	
	        var time = +name.replace('(GMT', '').split(':')[0];
	        var title = name.replace(/^[^ ]+ /, '');
	        var abs = Math.abs(time);
	        return [!ru[id], abs < 10 ? '0' + abs : abs, time, title];
	    };
	
	    var timezones = (0, _promisify.requestify)(_jquery2.default.getJSON('/mapsurfer/timezones?token=' + _config2.default.token() + '&lang=' + _config2.default.locale())).then(function (zones) {
	        return zones.map(function (_ref4) {
	            var zoneId = _ref4.zoneId,
	                name = _ref4.name;
	            return { id: zoneId, name: name };
	        });
	    }).then(function (zones) {
	        return zones.sort(function (zA, zB) {
	            return fn(zA) < fn(zB) ? -1 : fn(zA) > fn(zB) ? 1 : 0;
	        });
	    }).then(function (zones) {
	        return _config2.default.timezones(zones);
	    });
	
	    return Promise.all([baselayers, mapextent, settings, timezones]);
	}).then(function () {
	    return app.render();
	}).then(function () {
	    return (0, _routing.routing)(app, appState, _routes2.default);
	}).catch(function (reason) {
	    return console.error(reason);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(4);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _route$route$route$ro;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _common = __webpack_require__(9);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _capabilities = __webpack_require__(167);
	
	var _capabilities2 = _interopRequireDefault(_capabilities);
	
	var _configuration = __webpack_require__(174);
	
	var _configuration2 = _interopRequireDefault(_configuration);
	
	var _contract = __webpack_require__(21);
	
	var _contract2 = _interopRequireDefault(_contract);
	
	var _contracts = __webpack_require__(177);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _contracts3 = __webpack_require__(178);
	
	var _contracts4 = _interopRequireDefault(_contracts3);
	
	var _fields = __webpack_require__(180);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _fieldsForm = __webpack_require__(183);
	
	var _fieldsForm2 = _interopRequireDefault(_fieldsForm);
	
	var _fieldsForm3 = __webpack_require__(184);
	
	var _fieldsForm4 = _interopRequireDefault(_fieldsForm3);
	
	var _fieldsForm5 = __webpack_require__(185);
	
	var _fieldsForm6 = _interopRequireDefault(_fieldsForm5);
	
	var _fieldsForm7 = __webpack_require__(182);
	
	var _fieldsForm8 = _interopRequireDefault(_fieldsForm7);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _scripts = __webpack_require__(186);
	
	var _scripts2 = _interopRequireDefault(_scripts);
	
	var _scripts3 = __webpack_require__(187);
	
	var _scripts4 = _interopRequireDefault(_scripts3);
	
	var _servers = __webpack_require__(188);
	
	var _servers2 = _interopRequireDefault(_servers);
	
	var _priorities = __webpack_require__(189);
	
	var _priorities2 = _interopRequireDefault(_priorities);
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _script = __webpack_require__(150);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _calendar = __webpack_require__(191);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _tasks = __webpack_require__(195);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _list = __webpack_require__(198);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _runs = __webpack_require__(200);
	
	var _runs2 = _interopRequireDefault(_runs);
	
	var _templates3 = __webpack_require__(194);
	
	var _templates4 = _interopRequireDefault(_templates3);
	
	var _statuses = __webpack_require__(202);
	
	var _statuses2 = _interopRequireDefault(_statuses);
	
	var _sticker = __webpack_require__(59);
	
	var _sticker2 = _interopRequireDefault(_sticker);
	
	var _stickers = __webpack_require__(203);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _stickers3 = __webpack_require__(204);
	
	var _stickers4 = _interopRequireDefault(_stickers3);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _form3 = __webpack_require__(205);
	
	var _form4 = _interopRequireDefault(_form3);
	
	var _list3 = __webpack_require__(179);
	
	var _list4 = _interopRequireDefault(_list3);
	
	var _map = __webpack_require__(206);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _newstype = __webpack_require__(158);
	
	var _newstype2 = _interopRequireDefault(_newstype);
	
	var _types = __webpack_require__(207);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _typesForm = __webpack_require__(208);
	
	var _typesForm2 = _interopRequireDefault(_typesForm);
	
	var _typesForm3 = __webpack_require__(209);
	
	var _typesForm4 = _interopRequireDefault(_typesForm3);
	
	var _typesForm5 = __webpack_require__(210);
	
	var _typesForm6 = _interopRequireDefault(_typesForm5);
	
	var _typeGroups = __webpack_require__(211);
	
	var _typeGroups2 = _interopRequireDefault(_typeGroups);
	
	var _date = __webpack_require__(29);
	
	var _router = __webpack_require__(212);
	
	var _routing = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var commonModule = new _common2.default({});
	var schedulesModule = commonModule;
	
	exports.default = (_route$route$route$ro = {}, _defineProperty(_route$route$route$ro, (0, _router.route)(''), (0, _routing.handle)(_routing.restore, commonModule, _list4.default)), _defineProperty(_route$route$route$ro, (0, _router.route)('tasks'), (0, _routing.handle)(_routing.restore, commonModule, _list4.default)), _defineProperty(_route$route$route$ro, (0, _router.route)('map'), (0, _routing.handle)(_routing.restore, commonModule, _map2.default)), _defineProperty(_route$route$route$ro, (0, _router.route)('task/:id'), (0, _routing.handle)(_routing.restore, commonModule, _form4.default, function (moduleState, id) {
	    return _task2.default.byId(id);
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_list4.default.OPEN_LIST), (0, _routing.handle)(_routing.replace, commonModule, _list4.default, function (filtersState) {
	    return {
	        moduleState: _extends({}, filtersState)
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_list4.default.OPEN_MAP), (0, _routing.handle)(_routing.replace, commonModule, _map2.default, function (filtersState) {
	    return {
	        moduleState: _extends({}, filtersState)
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_list4.default.OPEN_TASK), (0, _routing.handle)(_routing.popup, commonModule, _form4.default)), _defineProperty(_route$route$route$ro, (0, _router.event)(_form4.default.BACK), (0, _routing.handle)(_routing.closePopup)), _defineProperty(_route$route$route$ro, (0, _router.event)(_list4.default.OPEN_CONTRACTS), (0, _routing.handle)(_routing.replace, commonModule, _contracts4.default, function (tasksFiltersState) {
	    return {
	        moduleState: { tasksFiltersState: tasksFiltersState }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_contracts2.default.OPEN), (0, _routing.handle)(_routing.popup, commonModule, _contracts2.default, function (contract) {
	    return contract || new _contract2.default();
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('contracts/list'), (0, _routing.handle)(_routing.restore, commonModule, _contracts4.default)), _defineProperty(_route$route$route$ro, (0, _router.route)('contracts/new'), (0, _routing.handle)(_routing.restore, commonModule, _contracts2.default, function () {
	    return new _contract2.default();
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('contracts/:id'), (0, _routing.handle)(_routing.restore, commonModule, _contracts2.default, function (moduleState, id) {
	    return _contract2.default.byId(+id);
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/stats/:yyyymm'), (0, _routing.handle)(_routing.restore, schedulesModule, _calendar2.default, function (_ref, yyyymm) {
	    var date = _ref.date,
	        moduleState = _objectWithoutProperties(_ref, ['date']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            month: (0, _date.parseYYYYMMDD)(yyyymm + '-01'),
	            date: date
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_calendar2.default.TOGGLE_LIST_VIEW), (0, _routing.handle)(_routing.replace, schedulesModule, _list2.default, function (month, date, filters, scheduleId, time) {
	    return {
	        moduleState: {
	            month: (0, _date.unixts)((0, _date.datify)(month)),
	            date: (0, _date.unixts)((0, _date.datify)(date)),
	            filters: filters,
	            scheduleId: scheduleId,
	            time: time,
	            page: 1
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/runs/:yyyymmdd'), (0, _routing.handle)(_routing.restore, schedulesModule, _runs2.default, function (_ref2, yyyymmdd) {
	    var month = _ref2.month,
	        moduleState = _objectWithoutProperties(_ref2, ['month']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [month, (0, _date.parseYYYYMMDD)(yyyymmdd)]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/list'), (0, _routing.handle)(_routing.restore, schedulesModule, _list2.default)), _defineProperty(_route$route$route$ro, (0, _router.event)(_form2.default.POPUP_NEW), (0, _routing.handle)(_routing.popup, schedulesModule, _form2.default, function () {
	    return [{ schedule: new _schedule2.default() }];
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_form2.default.POPUP_EDIT), (0, _routing.handle)(_routing.popup, schedulesModule, _form2.default,
	// may be passed 99, '99', { scheduleAttrs }
	function (arg) {
	    return [isNaN(+arg) ? { schedule: arg } : { id: arg }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/new/:groupType/random/:yyyy'), (0, _routing.handle)(_routing.restore, schedulesModule, _form2.default, function (moduleState, groupType, yyyy) {
	    return [{ schedule: new _schedule2.default(), groupType: groupType, openedTab: 'random', yyyy: yyyy }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/new/:groupType/:openedTab'), (0, _routing.handle)(_routing.restore, schedulesModule, _form2.default, function (moduleState, groupType, openedTab) {
	    return [{ schedule: new _schedule2.default(), groupType: groupType, openedTab: openedTab }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/edit/:groupType/random/:yyyy'), (0, _routing.handle)(_routing.restore, schedulesModule, _form2.default, function (moduleState, id, groupType, yyyy) {
	    return [{ id: id, groupType: groupType, openedTab: 'random', yyyy: yyyy }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/edit/:groupType/:openedTab'), (0, _routing.handle)(_routing.restore, schedulesModule, _form2.default, function (moduleState, id, groupType, openedTab) {
	    return [{ id: id, groupType: groupType, openedTab: openedTab }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/template/:templateTaskId'), (0, _routing.handle)(_routing.restore, schedulesModule, _templates4.default, function (moduleState, scheduleId, templateTaskId) {
	    return [{ scheduleId: scheduleId, templateTaskId: templateTaskId }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/new-template'), (0, _routing.handle)(_routing.restore, schedulesModule, _templates4.default, function (moduleState, scheduleId) {
	    return [{ scheduleId: scheduleId, templateTask: new _task2.default({ is_template: true }) }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/tasks/:yyyymmdd/@/:hhmm'), (0, _routing.handle)(_routing.restore, schedulesModule, _tasks2.default, function (_ref3, scheduleId, yyyymmdd, hhmm) {
	    var month = _ref3.month,
	        moduleState = _objectWithoutProperties(_ref3, ['month']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            scheduleId: scheduleId,
	            time: hhmm.replace('-', ':'),
	            month: month,
	            date: (0, _date.parseYYYYMMDD)(yyyymmdd)
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/tasks/:yyyymmdd'), (0, _routing.handle)(_routing.restore, schedulesModule, _tasks2.default, function (_ref4, scheduleId, yyyymmdd) {
	    var month = _ref4.month,
	        moduleState = _objectWithoutProperties(_ref4, ['month']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            scheduleId: scheduleId,
	            month: month,
	            date: (0, _date.parseYYYYMMDD)(yyyymmdd)
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/stats/:yyyymm/@/:hhmm'), (0, _routing.handle)(_routing.restore, schedulesModule, _calendar2.default, function (_ref5, scheduleId, yyyymm, hhmm) {
	    var date = _ref5.date,
	        moduleState = _objectWithoutProperties(_ref5, ['date']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            scheduleId: scheduleId,
	            time: hhmm.replace('-', ':'),
	            date: date,
	            month: (0, _date.parseYYYYMMDD)(yyyymm + '-01')
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/stats/:yyyymm'), (0, _routing.handle)(_routing.restore, schedulesModule, _calendar2.default, function (_ref6, scheduleId, yyyymm) {
	    var date = _ref6.date,
	        time = _ref6.time,
	        moduleState = _objectWithoutProperties(_ref6, ['date', 'time']);
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            scheduleId: scheduleId, time: time, date: date,
	            month: (0, _date.parseYYYYMMDD)(yyyymm + '-01')
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule/:id/templates'), (0, _routing.handle)(_routing.restore, schedulesModule, _templates2.default, function (moduleState, id) {
	    return [{ id: id }];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('schedule'), (0, _routing.handle)(_routing.restore, schedulesModule, _calendar2.default, function () {
	    var moduleState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (!moduleState.filters) moduleState.filters = _launch2.default.defaultFilterValues();
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{
	            month: (0, _date.today)(),
	            date: (0, _date.today)()
	        }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_calendar2.default.OPEN_LAUNCHES_DAILY), (0, _routing.handle)(_routing.replace, schedulesModule, _runs2.default, function (month, date, filters) {
	    return {
	        moduleState: { filters: filters, page: 1 },
	        moduleArgs: [month, date]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_templates4.default.POPUP_NEW), (0, _routing.handle)(_routing.popup, schedulesModule, _templates4.default,
	// may be passed 99, '99', { scheduleAttrs }
	function (arg) {
	    return [isNaN(+arg) ? { schedule: arg, templateTask: new _task2.default({ is_template: true }) } : { scheduleId: arg, templateTask: new _task2.default({ is_template: true }) }];
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_templates4.default.POPUP_EDIT), (0, _routing.handle)(_routing.popup, schedulesModule, _templates4.default,
	// may be passed 99, '99', { scheduleAttrs }
	function (arg, templateTaskId) {
	    return [isNaN(+arg) ? { schedule: arg, templateTaskId: templateTaskId } : { scheduleId: arg, templateTaskId: templateTaskId }];
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_tasks2.default.REPLACE), (0, _routing.handle)(_routing.replace, schedulesModule, _tasks2.default, function (scheduleId, time, month, date, filters) {
	    return {
	        moduleState: { filters: filters },
	        moduleArgs: [{ scheduleId: scheduleId, time: time, month: month, date: date }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_templates2.default.POPUP), (0, _routing.handle)(_routing.popup, schedulesModule, _templates2.default,
	// may be passed 99, '99', { scheduleAttrs }
	function (arg) {
	    return {
	        moduleState: {
	            filters: _launch2.default.defaultFilterValues(),
	            page: 1
	        },
	        moduleArgs: isNaN(+arg) ? [{ schedule: arg }] : [{ id: arg }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_templates2.default.REPLACE), (0, _routing.handle)(_routing.replace, schedulesModule, _templates2.default,
	// may be passed 99, '99', { scheduleAttrs }
	function (arg) {
	    return {
	        moduleState: {
	            filters: _launch2.default.defaultFilterValues(),
	            page: 1
	        },
	        moduleArgs: isNaN(+arg) ? [{ schedule: arg }] : [{ id: arg }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_calendar2.default.TOGGLE_CALENDAR), (0, _routing.handle)(_routing.replace, schedulesModule, _calendar2.default, function (scheduleId, time, month, date, filters) {
	    return {
	        moduleState: { filters: filters },
	        moduleArgs: [{ scheduleId: scheduleId, time: time, month: month, date: date }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_module2.default.BACK), (0, _routing.handle)(_routing.closePopup)), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.CAPABILITIES), (0, _routing.handle)(_routing.replace, commonModule, _capabilities2.default, function (_ref7) {
	    var cluster = _ref7.cluster;
	    return {
	        moduleState: {
	            cluster: cluster,
	            filters: {},
	            sort: 'role',
	            direction: 'asc',
	            page: 1,
	            limit: 10
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('capabilities'), (0, _routing.handle)(_routing.restore, commonModule, _capabilities2.default, function () {
	    var moduleState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (!moduleState.filters) moduleState.filters = {};
	    if (!moduleState.sort) moduleState.sort = 'role', moduleState.direction = 'asc';
	    if (!moduleState.page) moduleState.page = 1;
	    if (!moduleState.limit) moduleState.limit = 10;
	
	    return {
	        moduleState: moduleState,
	        moduleArgs: []
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.PRIORITIES), (0, _routing.handle)(_routing.replace, commonModule, _priorities2.default, function (_ref8) {
	    var cluster = _ref8.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('priorities'), (0, _routing.handle)(_routing.restore, commonModule, _priorities2.default, function (_ref9) {
	    var _ref9$page = _ref9.page,
	        page = _ref9$page === undefined ? 1 : _ref9$page,
	        _ref9$limit = _ref9.limit,
	        limit = _ref9$limit === undefined ? 10 : _ref9$limit,
	        _ref9$sort = _ref9.sort,
	        sort = _ref9$sort === undefined ? 'order' : _ref9$sort,
	        _ref9$direction = _ref9.direction,
	        direction = _ref9$direction === undefined ? 'asc' : _ref9$direction,
	        _ref9$search = _ref9.search,
	        search = _ref9$search === undefined ? '' : _ref9$search,
	        activeId = _ref9.activeId,
	        cluster = _ref9.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.STATUSES), (0, _routing.handle)(_routing.replace, commonModule, _statuses2.default, function (_ref10) {
	    var cluster = _ref10.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'order', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('statuses'), (0, _routing.handle)(_routing.restore, commonModule, _statuses2.default, function (_ref11) {
	    var _ref11$page = _ref11.page,
	        page = _ref11$page === undefined ? 1 : _ref11$page,
	        _ref11$limit = _ref11.limit,
	        limit = _ref11$limit === undefined ? 10 : _ref11$limit,
	        _ref11$sort = _ref11.sort,
	        sort = _ref11$sort === undefined ? 'order' : _ref11$sort,
	        _ref11$direction = _ref11.direction,
	        direction = _ref11$direction === undefined ? 'asc' : _ref11$direction,
	        _ref11$search = _ref11.search,
	        search = _ref11$search === undefined ? '' : _ref11$search,
	        activeId = _ref11.activeId,
	        cluster = _ref11.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('stickers/new'), (0, _routing.handle)(_routing.restore, commonModule, _stickers4.default, function () {
	    return new _sticker2.default();
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('stickers/:id/edit'), (0, _routing.handle)(_routing.restore, commonModule, _stickers4.default, function (_ref12, id) {
	    var sort = _ref12.sort,
	        direction = _ref12.direction,
	        page = _ref12.page,
	        limit = _ref12.limit,
	        search = _ref12.search,
	        activeId = _ref12.activeId;
	    return _sticker2.default.byId(+id).then(function (stickerFetched) {
	        return {
	            moduleState: { sort: sort, direction: direction, page: page, limit: limit, search: search, activeId: activeId },
	            moduleArgs: [stickerFetched]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_stickers4.default.OPEN_STICKER), (0, _routing.handle)(_routing.popup, commonModule, _stickers4.default, function (stickerModel, cluster) {
	    var promise = void 0;
	    if (stickerModel instanceof _sticker2.default) promise = stickerModel.id ? _sticker2.default.byId(+stickerModel.id) : Promise.resolve(stickerModel);else promise = _sticker2.default.byId(+stickerModel);
	
	    return promise.then(function (stickerFetched) {
	        return {
	            moduleState: { cluster: cluster, sort: 'name', direction: 'asc', page: 1, limit: 10, search: '' },
	            moduleArgs: [stickerFetched]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.STICKERS), (0, _routing.handle)(_routing.replace, commonModule, _stickers2.default, function (_ref13) {
	    var cluster = _ref13.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('stickers'), (0, _routing.handle)(_routing.restore, commonModule, _stickers2.default, function (_ref14) {
	    var _ref14$page = _ref14.page,
	        page = _ref14$page === undefined ? 1 : _ref14$page,
	        _ref14$limit = _ref14.limit,
	        limit = _ref14$limit === undefined ? 10 : _ref14$limit,
	        _ref14$sort = _ref14.sort,
	        sort = _ref14$sort === undefined ? 'title' : _ref14$sort,
	        _ref14$direction = _ref14.direction,
	        direction = _ref14$direction === undefined ? 'asc' : _ref14$direction,
	        _ref14$search = _ref14.search,
	        search = _ref14$search === undefined ? '' : _ref14$search,
	        activeId = _ref14.activeId,
	        cluster = _ref14.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/new/bound-types'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm2.default, function () {
	    return {
	        field: new _field2.default()
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/new/nested-fields'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm4.default, function () {
	    return {
	        field: new _field2.default({ format: 'composite' })
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/new/bound-stickers'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm6.default, function () {
	    return {
	        field: new _field2.default({ format: 'file' })
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/:id/edit/bound-types'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm2.default, function (moduleState, id) {
	    return _field2.default.byId(+id).then(function (field) {
	        return {
	            moduleState: moduleState,
	            moduleArgs: [{ field: field }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/:id/edit/nested-fields'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm4.default, function (moduleState, id) {
	    return _field2.default.byId(+id).then(function (field) {
	        return {
	            moduleState: moduleState,
	            moduleArgs: [{ field: field }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('fields/:id/edit/bound-stickers'), (0, _routing.handle)(_routing.restore, commonModule, _fieldsForm6.default, function (moduleState, id) {
	    return _field2.default.byId(+id).then(function (field) {
	        return {
	            moduleState: moduleState,
	            moduleArgs: [{ field: field }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_fieldsForm8.default.OPEN_FIELD), (0, _routing.handle)(_routing.popup, commonModule, _fieldsForm2.default, function (field, cluster) {
	    var promise = field instanceof _field2.default ? Promise.resolve(field) : _field2.default.byId(+field);
	
	    return promise.then(function (field) {
	        return {
	            moduleState: { cluster: cluster },
	            moduleArgs: [{ field: field }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_fieldsForm8.default.TOGGLE_BOUND_TYPES), (0, _routing.handle)(_routing.replace, commonModule, _fieldsForm2.default,
	// field is always Model, not id
	function (field, original, moduleState) {
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{ field: field, original: original }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_fieldsForm8.default.TOGGLE_NESTED_FIELDS), (0, _routing.handle)(_routing.replace, commonModule, _fieldsForm4.default,
	// field is always Model, not id
	function (field, original, moduleState) {
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{ field: field, original: original }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_fieldsForm8.default.TOGGLE_BOUND_STICKERS), (0, _routing.handle)(_routing.replace, commonModule, _fieldsForm6.default,
	// field is always Model, not id
	function (field, original, moduleState) {
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{ field: field, original: original }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.FIELDS), (0, _routing.handle)(_routing.replace, commonModule, _fields2.default, function (_ref15) {
	    var cluster = _ref15.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('custom-fields'), (0, _routing.handle)(_routing.restore, commonModule, _fields2.default, function (_ref16) {
	    var _ref16$page = _ref16.page,
	        page = _ref16$page === undefined ? 1 : _ref16$page,
	        _ref16$limit = _ref16.limit,
	        limit = _ref16$limit === undefined ? 10 : _ref16$limit,
	        _ref16$sort = _ref16.sort,
	        sort = _ref16$sort === undefined ? 'name' : _ref16$sort,
	        _ref16$direction = _ref16.direction,
	        direction = _ref16$direction === undefined ? 'asc' : _ref16$direction,
	        _ref16$search = _ref16.search,
	        search = _ref16$search === undefined ? '' : _ref16$search,
	        activeId = _ref16.activeId,
	        cluster = _ref16.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.TYPEGROUPS), (0, _routing.handle)(_routing.replace, commonModule, _typeGroups2.default, function (_ref17) {
	    var cluster = _ref17.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types/groups'), (0, _routing.handle)(_routing.restore, commonModule, _typeGroups2.default, function (_ref18) {
	    var _ref18$page = _ref18.page,
	        page = _ref18$page === undefined ? 1 : _ref18$page,
	        _ref18$limit = _ref18.limit,
	        limit = _ref18$limit === undefined ? 10 : _ref18$limit,
	        _ref18$sort = _ref18.sort,
	        sort = _ref18$sort === undefined ? 'name' : _ref18$sort,
	        _ref18$direction = _ref18.direction,
	        direction = _ref18$direction === undefined ? 'asc' : _ref18$direction,
	        _ref18$search = _ref18.search,
	        search = _ref18$search === undefined ? '' : _ref18$search,
	        activeId = _ref18.activeId,
	        cluster = _ref18.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types/new/bound-organizations'), (0, _routing.handle)(_routing.restore, commonModule, _typesForm4.default, function () {
	    return { type: new _newstype2.default() };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types/:id/edit/bound-organizations'), (0, _routing.handle)(_routing.restore, commonModule, _typesForm4.default, function (moduleState, id) {
	    return _newstype2.default.byId(+id).then(function (type) {
	        return {
	            moduleState: moduleState,
	            moduleArgs: [{ type: type }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_typesForm2.default.OPEN_TYPE), (0, _routing.handle)(_routing.popup, commonModule, _typesForm4.default, function (typeModel, cluster) {
	    var promise = typeModel instanceof _newstype2.default ? Promise.resolve(typeModel) : _newstype2.default.byId(+typeModel);
	
	    return promise.then(function (type) {
	        return {
	            moduleState: { cluster: cluster },
	            moduleArgs: [{ type: type }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types/new/bound-roles'), (0, _routing.handle)(_routing.restore, commonModule, _typesForm6.default, function () {
	    return { type: new _newstype2.default() };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types/:id/edit/bound-roles'), (0, _routing.handle)(_routing.restore, commonModule, _typesForm6.default, function (moduleState, id) {
	    return _newstype2.default.byId(+id).then(function (type) {
	        return {
	            moduleState: moduleState,
	            moduleArgs: [{ type: type }]
	        };
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_typesForm2.default.TOGGLE_BOUND_ORGANIZATIONS), (0, _routing.handle)(_routing.replace, commonModule, _typesForm4.default,
	// type is always Model, not id
	function (type, original, moduleState) {
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{ type: type, original: original }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_typesForm2.default.TOGGLE_BOUND_ROLES), (0, _routing.handle)(_routing.replace, commonModule, _typesForm6.default,
	// type is always Model, not id
	function (type, original, moduleState) {
	    return {
	        moduleState: moduleState,
	        moduleArgs: [{ type: type, original: original }]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('types'), (0, _routing.handle)(_routing.restore, commonModule, _types2.default, function (_ref19) {
	    var _ref19$page = _ref19.page,
	        page = _ref19$page === undefined ? 1 : _ref19$page,
	        _ref19$limit = _ref19.limit,
	        limit = _ref19$limit === undefined ? 10 : _ref19$limit,
	        _ref19$sort = _ref19.sort,
	        sort = _ref19$sort === undefined ? 'name' : _ref19$sort,
	        _ref19$direction = _ref19.direction,
	        direction = _ref19$direction === undefined ? 'asc' : _ref19$direction,
	        _ref19$search = _ref19.search,
	        search = _ref19$search === undefined ? '' : _ref19$search,
	        activeId = _ref19.activeId,
	        cluster = _ref19.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.TYPES), (0, _routing.handle)(_routing.replace, commonModule, _types2.default, function (_ref20) {
	    var cluster = _ref20.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.SERVERS), (0, _routing.handle)(_routing.replace, commonModule, _servers2.default, function (_ref21) {
	    var cluster = _ref21.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/servers/list'), (0, _routing.handle)(_routing.restore, commonModule, _servers2.default, function (_ref22) {
	    var _ref22$page = _ref22.page,
	        page = _ref22$page === undefined ? 1 : _ref22$page,
	        _ref22$limit = _ref22.limit,
	        limit = _ref22$limit === undefined ? 10 : _ref22$limit,
	        _ref22$sort = _ref22.sort,
	        sort = _ref22$sort === undefined ? 'name' : _ref22$sort,
	        _ref22$direction = _ref22.direction,
	        direction = _ref22$direction === undefined ? 'asc' : _ref22$direction,
	        _ref22$search = _ref22.search,
	        search = _ref22$search === undefined ? '' : _ref22$search,
	        activeId = _ref22.activeId,
	        cluster = _ref22.cluster;
	    return {
	        moduleState: {
	            page: page, limit: limit, sort: sort, direction: direction, search: search, activeId: activeId, cluster: cluster
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/list/:type/:op'), (0, _routing.handle)(_routing.restore, commonModule, _scripts4.default, function (moduleState, type, operation) {
	    return {
	        moduleState: _extends({}, moduleState, {
	            operation: operation.toUpperCase(),
	            type: type.toUpperCase()
	        })
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_refbooks2.default.SCRIPTS), (0, _routing.handle)(_routing.replace, commonModule, _scripts4.default, function (_ref23) {
	    var cluster = _ref23.cluster;
	    return {
	        moduleState: {
	            page: 1, limit: 10, sort: 'name', direction: 'asc', search: '', cluster: cluster,
	            operation: 'ALL-OPS',
	            type: 'ALL-TYPES'
	        }
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/list'),
	// default route; set filter parameters
	(0, _routing.handle)(_routing.restore, commonModule, _scripts4.default, function () {
	    return (/*moduleState*/{
	            moduleState: {
	                page: 1, limit: 10, sort: 'title', direction: 'asc', search: '',
	                operation: 'ALL-OPS',
	                type: 'ALL-TYPES'
	            }
	        }
	    );
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/validation/insert'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'INSERT', type: 'VALIDATION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/validation/update'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'UPDATE', type: 'VALIDATION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/validation/delete'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'DELETE', type: 'VALIDATION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/reaction/insert'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'INSERT', type: 'REACTION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/reaction/update'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'UPDATE', type: 'REACTION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/new/reaction/delete'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function () {
	    return [new _script2.default({ operation: 'DELETE', type: 'REACTION' })];
	})), _defineProperty(_route$route$route$ro, (0, _router.route)('scripts/:id'), (0, _routing.handle)(_routing.restore, commonModule, _scripts2.default, function (moduleState, id) {
	    return _script2.default.byId(+id).then(function (script) {
	        return [script];
	    });
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_scripts2.default.NEW), (0, _routing.handle)(_routing.popup, commonModule, _scripts2.default, function (script, cluster) {
	    return {
	        moduleState: { cluster: cluster },
	        moduleArgs: [script]
	    };
	})), _defineProperty(_route$route$route$ro, (0, _router.event)(_scripts2.default.EDIT), (0, _routing.handle)(_routing.popup, commonModule, _scripts2.default)), _defineProperty(_route$route$route$ro, (0, _router.route)('configuration'), (0, _routing.handle)(_routing.restore, commonModule, _configuration2.default)), _route$route$route$ro);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var _mapClass = void 0;
	
	exports.default = {
	    host: function host() {
	        return '';
	    },
	    wsHost: function wsHost() {
	        return '';
	    },
	    base: function base() {
	        return '/rest';
	    },
	    wsBase: function wsBase() {
	        return '/rest';
	    },
	    map: function map() {
	        return {
	            lat: 54.8998811,
	            lon: 52.2995088,
	            zoom: 10
	        };
	    },
	    mapClass: function mapClass(value) {
	        if (undefined !== value) _mapClass = value;
	        return _mapClass;
	    },
	    token: function token(value) {
	        if (undefined !== value) {
	            localStorage['talitrum.session.token'] = value;
	            // set token expiration date
	            // to one day forward (86400 second
	            // per day and 1000ms per second)
	            localStorage['talitrum.session.tokenExpirationDate'] = new Date().getTime() + 30 * 86400 * 1000;
	        }
	
	        var expirationDate = localStorage['talitrum.session.tokenExpirationDate'];
	        if (expirationDate) {
	            // convert to long
	            expirationDate = parseInt(expirationDate);
	            // expired?
	            if (new Date() > new Date(expirationDate)) return null;
	        }
	
	        return localStorage['talitrum.session.token'];
	    },
	    mapExtent: function mapExtent(value) {
	        if (undefined !== value) localStorage['talitrum.session.map.extent'] = JSON.stringify(value);
	
	        var stringValue = localStorage['talitrum.session.map.extent'];
	        return stringValue && JSON.parse(stringValue);
	    },
	    languages: function languages(value) {
	        if (undefined !== value) localStorage['talitrum.session.languages'] = JSON.stringify(value);
	
	        var stringValue = localStorage['talitrum.session.languages'];
	        return stringValue && JSON.parse(stringValue);
	    },
	    timezones: function timezones(value) {
	        if (undefined !== value) localStorage['talitrum.session.timezones'] = JSON.stringify(value);
	
	        var stringValue = localStorage['talitrum.session.timezones'];
	        return stringValue && JSON.parse(stringValue);
	    },
	    locale: function locale(value) {
	        if (undefined !== value) localStorage['talitrum.locale'] = value;
	
	        return localStorage['talitrum.locale'];
	    },
	    title: function title(value) {
	        if (undefined !== value) this.title_ = value;
	
	        return this.title_;
	    },
	    user: function user(value) {
	        if (undefined !== value) localStorage['talitrum.session.userName'] = value;
	
	        return localStorage['talitrum.session.userName'];
	    },
	    userId: function userId(value) {
	        if (undefined !== value) localStorage['talitrum.session.userId'] = value;
	
	        return localStorage['talitrum.session.userId'];
	    },
	    role: function role(value) {
	        if (undefined !== value) localStorage['talitrum.session.roleId'] = value;
	
	        return localStorage['talitrum.session.roleId'];
	    },
	    cluster: function cluster(value) {
	        if (undefined !== value) localStorage['talitrum.session.clusterId'] = JSON.stringify(value);
	
	        value = localStorage['talitrum.session.clusterId'];
	        return value !== undefined ? JSON.parse(value) : value;
	    },
	    clusters: function clusters(value) {
	        if (undefined !== value) localStorage['talitrum.session.clusters'] = JSON.stringify(value);
	
	        value = localStorage['talitrum.session.clusters'];
	        return value !== undefined ? JSON.parse(value) : value;
	    },
	    organization: function organization(value) {
	        if (typeof value === 'string') {
	            if ('null' === value) delete localStorage['talitrum.session.organizationId'];else if ('undefined' === value) delete localStorage['talitrum.session.organizationId'];else localStorage['talitrum.session.organizationId'] = value;
	        } else if (null === value) delete localStorage['talitrum.session.organizationId'];else if (undefined !== value) localStorage['talitrum.session.organizationId'] = value;
	
	        if (localStorage['talitrum.session.organizationId']) return +localStorage['talitrum.session.organizationId'];
	
	        return undefined;
	    },
	    orgs: function orgs(value) {
	        if (null === value) delete localStorage['talitrum.session.orgs'];else if (undefined !== value) localStorage['talitrum.session.orgs'] = JSON.stringify(value);
	
	        if (localStorage['talitrum.session.orgs']) return JSON.parse(localStorage['talitrum.session.orgs'] || '[]');
	
	        return undefined;
	    },
	    url: function url(_url) {
	        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            _ref$addToken = _ref.addToken,
	            addToken = _ref$addToken === undefined ? true : _ref$addToken,
	            _ref$addBase = _ref.addBase,
	            addBase = _ref$addBase === undefined ? true : _ref$addBase;
	
	        if ('/' !== _url.charAt(0)) _url = '/' + _url;
	
	        _url = addBase ? this.host() + this.base() + _url : this.host() + _url;
	
	        var token = this.token();
	        if (addToken && token) _url = this.add(_url, 'token', this.token());
	
	        _url = this.add(_url, 'lang', this.locale());
	
	        return _url;
	    },
	    add: function add(url, name, value) {
	        var hash = '';
	        if (~url.indexOf('#')) hash = url.substr(url.indexOf('#')), url = url.substr(0, url.indexOf('#'));
	
	        url += ~url.indexOf('?') ? '&' : '?';
	        url += name + '=' + encodeURIComponent(value).replace(/,/g, '%2C');
	
	        if (hash) url += hash;
	
	        return url;
	    }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _contracts = __webpack_require__(10);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _clusters = __webpack_require__(25);
	
	var _clusters2 = _interopRequireDefault(_clusters);
	
	var _fields = __webpack_require__(27);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _layers = __webpack_require__(34);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _datatables = __webpack_require__(36);
	
	var _datatables2 = _interopRequireDefault(_datatables);
	
	var _locations = __webpack_require__(38);
	
	var _locations2 = _interopRequireDefault(_locations);
	
	var _organizations = __webpack_require__(141);
	
	var _organizations2 = _interopRequireDefault(_organizations);
	
	var _priorities = __webpack_require__(147);
	
	var _priorities2 = _interopRequireDefault(_priorities);
	
	var _roles = __webpack_require__(95);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _scripts = __webpack_require__(149);
	
	var _scripts2 = _interopRequireDefault(_scripts);
	
	var _servers = __webpack_require__(151);
	
	var _servers2 = _interopRequireDefault(_servers);
	
	var _serviceObject = __webpack_require__(153);
	
	var _serviceObject2 = _interopRequireDefault(_serviceObject);
	
	var _statuses = __webpack_require__(155);
	
	var _statuses2 = _interopRequireDefault(_statuses);
	
	var _stickers = __webpack_require__(58);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _types = __webpack_require__(157);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _type = __webpack_require__(159);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _user = __webpack_require__(161);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _user3 = __webpack_require__(163);
	
	var _user4 = _interopRequireDefault(_user3);
	
	var _workgroups = __webpack_require__(165);
	
	var _workgroups2 = _interopRequireDefault(_workgroups);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Mod = function () {
	    function Mod(options) {
	        _classCallCheck(this, Mod);
	    }
	
	    _createClass(Mod, [{
	        key: 'init',
	        value: function init() {
	            return !this.initialized_ ? fetch.call(this) : Promise.resolve();
	        }
	    }, {
	        key: 'injectable',
	        value: function injectable() {
	            return {
	                layers: this.layers_,
	                datatables: this.datatables_,
	                contracts: this.contracts_,
	                clusters: this.clusters_,
	                organizations: this.organizations_,
	                types: this.types_,
	                typeGroups: this.typeGroups_,
	                statuses: this.statuses_,
	                priorities: this.priorities_,
	                fields: this.fields_,
	                stickers: this.stickers_,
	                roles: this.roles_,
	                workgroups: this.workgroups_,
	                scripts: this.scripts_,
	                servers: this.servers_,
	                userTypes: this.userTypes_,
	                userTags: this.userTags_,
	                locationService: this.locations_,
	                serviceObjectMappings: this.serviceObjectMappings_
	            };
	        }
	    }]);
	
	    return Mod;
	}();
	
	exports.default = Mod;
	
	
	function fetch() {
	    var _this = this;
	
	    return this.layers_ = new _layers2.default(), this.datatables_ = new _datatables2.default(), this.contracts_ = new _contracts2.default({ endpoint: 'contracts/list?apiVersion=2.0&limit=1000000' }), this.clusters_ = new _clusters2.default({ endpoint: 'clusters/list?apiVersion=2.0&limit=1000000' }), this.organizations_ = new _organizations2.default(), this.types_ = new _types2.default(), this.typeGroups_ = new _type2.default(), this.statuses_ = new _statuses2.default(), this.priorities_ = new _priorities2.default(), this.fields_ = new _fields2.default(), this.stickers_ = new _stickers2.default(), this.roles_ = new _roles2.default(), this.workgroups_ = new _workgroups2.default(), this.scripts_ = new _scripts2.default(), this.servers_ = new _servers2.default(), this.userTypes_ = new _user2.default(), this.userTags_ = new _user4.default(), this.serviceObjectMappings_ = new _serviceObject2.default({ endpoint: '/service-objects/mappings/list?apiVersion=2.0&limit=1000000' }), this.locations_ = _locations2.default, Promise.all([_locations2.default.ready(), this.layers_.fetch(), this.datatables_.fetch(), this.contracts_.fetch(), this.clusters_.fetch(), this.organizations_.fetch(), this.types_.fetch().then(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            types = _ref2[0],
	            coll = _ref2[1];
	
	        return coll.reset(types.sort(function (_ref3, _ref4) {
	            var tA = _ref3.name,
	                iA = _ref3.id;
	            var tB = _ref4.name,
	                iB = _ref4.id;
	            return tA.toLowerCase() < tB.toLowerCase() ? -1 : tA.toLowerCase() > tB.toLowerCase() ? 1 : iA - iB;
	        }));
	    }), this.typeGroups_.fetch(), this.statuses_.fetch(), this.priorities_.fetch(), this.fields_.fetch(), this.stickers_.fetch(), this.roles_.fetch(), this.workgroups_.fetch(), this.scripts_.fetch(), this.servers_.fetch(), this.userTypes_.fetch(), this.userTags_.fetch(), this.serviceObjectMappings_.fetch()]).then(function () {
	        return _this.initialized_ = true;
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _contract = __webpack_require__(21);
	
	var _contract2 = _interopRequireDefault(_contract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'contracts/list?apiVersion=2.0',
		responseAt: 'items',
		model: _contract2.default
	});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // todo: change activeId after sync
	
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actionList = __webpack_require__(14);
	
	var _actionList2 = _interopRequireDefault(_actionList);
	
	var _urlify = __webpack_require__(15);
	
	var _urlify2 = _interopRequireDefault(_urlify);
	
	var _live = __webpack_require__(16);
	
	var _actions = __webpack_require__(17);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Collection.extend({
	    initialize: function initialize(items, options) {
	        if (!options) if (!items) {
	            options = {}, items = [];
	        } else if (items instanceof Array) options = {};else options = items, items = [];
	
	        this.endpoint = options.endpoint || this.endpoint;
	        this.responseAt = options.responseAt || this.responseAt || 'items';
	        this.countAt = options.countAt || this.countAt;
	        this.model = options.model || this.model;
	        this.filters = {};
	        this.activeId = undefined;
	        this.parseResponse = options.parseResponse || this.parseResponse;
	        this.restoreActive = options.restoreActive || this.restoreActive;
	
	        // let's rewrite actions definition
	        if (options.actions) this.setActions(options.actions);
	
	        // todo: bug here
	        this.options = options;
	
	        _backbone2.default.Collection.prototype.initialize.call(this, items, options);
	    },
	    sync: function sync(method, collection, options) {
	        // By setting the dataType to "jsonp", jQuery creates a function
	        // and adds it as a callback parameter to the request, e.g.:
	        // [url]&callback=jQuery19104472605645155031_1373700330157&q=bananarama
	        // If you want another name for the callback, also specify the
	        // jsonpCallback option.
	        // After this function is called (by the JSONP response), the script tag
	        // is removed and the parse method is called, just as it would be
	        // when AJAX was used.
	        if (undefined === this.jsonp || true === this.jsonp) options.dataType = "jsonp";
	        return _backbone2.default.sync(method, collection, options);
	    },
	    parse: function parse(response) {
	        var modelAttrs = this.responseAt ? response[this.responseAt] instanceof Array ? response[this.responseAt] : response instanceof Array ? response : [] : response;
	
	        this.page = +response.page || 1;
	        this.limit = this.countAt ? +response.limit : modelAttrs.length;
	        this.total = this.countAt ? +response[this.countAt] || undefined : modelAttrs.length;
	
	        return this.parseResponse(modelAttrs, response);
	    },
	    parseResponse: function parseResponse(modelAttrs, response) {
	        return modelAttrs;
	    },
	    setPage: function setPage(page) {
	        return this.page = page, this.fetch();
	    },
	    getUrl: function getUrl() {
	        var url = this.endpoint;
	        for (var name in this.filters) {
	            if (this.filters.hasOwnProperty(name)) if (undefined !== this.filters[name]) url = _config2.default.add(url, name, this.filters[name]);
	        }url = _config2.default.url(url);
	        if (this.page) url = _config2.default.add(url, 'page', this.page);
	
	        return url;
	    },
	    fetch: function fetch() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var defaultUseCache = undefined !== this.options.useCache ? this.options.useCache : true;
	
	        var _options$useCache = options.useCache,
	            useCache = _options$useCache === undefined ? defaultUseCache : _options$useCache;
	
	
	        this.url = useCache ? this.getUrl() : '' + (0, _urlify2.default)(this.getUrl()).write('useCache', false);
	
	        // todo: reject
	        return new Promise(function (resolve, reject) {
	            // manage success handler
	            // to maintain active row
	            var success = options.success,
	                error = options.error;
	
	            options.success = function (coll, resp, http) {
	                _this.restoreActive();
	
	                if (success) success.call(options.context, _this, resp, options);
	
	                resolve([_this.toJSON(), _this, resp]);
	            };
	
	            options.error = function (collection, xhr, options) {
	                _this.restoreActive();
	
	                var result = error ? error.call(options.context, collection, xhr, options) : undefined;
	
	                reject(options.errorThrown);
	
	                return result;
	            };
	
	            _backbone2.default.Collection.prototype.fetch.call(_this, options);
	        });
	    },
	    predicate: function predicate(fn) {
	        return _backbone2.default.Collection.prototype.filter.call(this, fn);
	    },
	    filter: function filter(name, value, page, activeId) {
	        if ('object' === (typeof name === 'undefined' ? 'undefined' : _typeof(name))) {
	            this.filters = name;
	            activeId = page;
	            page = value;
	        } else {
	            this.filters[name] = value;
	        }
	
	        // if active id isn't passed, don't clear current active id
	        if (activeId) this.activeId = activeId;
	        // if page isn't passed, clear current page
	        this.page = page;
	
	        return this.fetch();
	    },
	    restoreActive: function restoreActive() {
	        // this condition will fire if
	        // there is no active id in collection
	        // (!this.activeId) or there is active id
	        // but it's not actual because there
	        // is no active record with this id
	        // (!this.activeRow())
	        if (!this.activeId || !this.activeRow()) {
	            // if no active row, try to select first one
	            this.length ? this.activate(0) : this.deactivate();
	        }
	    },
	    activate: function activate(index) {
	        if (index < 0) return;
	        if (index >= this.length) return;
	
	        this.activeId = this.at(index).id;
	        this.trigger('activate', this.activeId);
	    },
	    deactivate: function deactivate() {
	        this.activeId = undefined;
	        this.trigger('deactivate', this.activeId);
	    },
	    activeRow: function activeRow() {
	        var _this2 = this;
	
	        var result = undefined;
	        this.forEach(function (item, index) {
	            if (_this2.activeId === item.id) result = index;
	        });
	        return result;
	    },
	    prevRow: function prevRow() {
	        var row = this.activeRow();
	        if (row > 0) this.activate(row - 1);
	    },
	    nextRow: function nextRow() {
	        var row = this.activeRow();
	        if (row < this.models.length - 1) this.activate(row + 1);
	    },
	    save: function save(viewOrModel) {
	        var _this3 = this;
	
	        var model = viewOrModel.model ? viewOrModel.model : viewOrModel;
	        var view = viewOrModel.model ? viewOrModel : null;
	        // try to find the original model
	        // in this collection
	        var index = void 0;
	        var original = this.get(model);
	        if (original) index = this.indexOf(original);
	
	        var saving = view ? (0, _actions.save)(view) : model.save();
	        return (0, _promisify.promisify)(saving).then(function (resp, x) {
	            // if found
	            if (original) {
	                // merge attributes back 
	                original.set(model.attributes);
	                // notify subscribers about changes in model
	                _this3.trigger('poke', index, original);
	            } else {
	                // model not found in collection:
	                // parse server-passed attributes
	                // into the model, because Backbone won't do it
	                var parsed = model.parse(resp);
	                model.set(parsed);
	
	                // todo: find the position to place model into
	                // add new model into the collection;
	                // sync event will be fire here
	                _this3.add(model);
	            }
	        });
	    },
	    destroy: function destroy(model) {
	        var _this4 = this;
	
	        // try to find the original model
	        // in this collection
	        var index = this.indexOf(this.get(model));
	
	        // notice how we don't manually remove model
	        // from collection, because calling .destroy()
	        // automatically does it.
	        return model.destroy({ wait: true }).done(function () {
	            // set current active model:
	            // 1. if deleted model wasn't the last one,
	            //    cursor must stay at the same position.
	            //    (next model will be at thos position)
	            if (index < _this4.length) _this4.activeId = _this4.at(index).id;
	            // 2. otherwise,
	            //    cursor must move to one position back.
	            else if (index > 0) _this4.activeId = _this4.at(index - 1).id;
	
	            // can't use "remove" event for this purpose,
	            // cause "remove" will be fired before
	            // recalculating this.activeId (few lines earlier)
	            // in code.
	            _this4.trigger('pull-out', index);
	
	            _this4.fetch({ useCache: false });
	        });
	    },
	    current: function current() {
	        var _this5 = this;
	
	        return _underscore2.default.filter(this.models, function (item) {
	            return _this5.activeId === item.id;
	        })[0];
	    },
	    setActions: function setActions(actions) {
	        var _this6 = this;
	
	        Object.keys(actions).forEach(function (eventName) {
	            // skip "default" key in action definition
	            if ('defaults' === eventName) return;
	            var actionDef = actions[eventName];
	
	            // if definition contains single function:
	            // convert it into object
	            if ('function' === typeof actionDef) actionDef = actions[eventName] = { handler: actionDef };
	
	            // handler's signature contains single argument?
	            var handler = actionDef.handler;
	            if (handler.toString().match(/^function\s*[^\(]*\([^, \)]+/)) {
	                // this argument is a collection's cursor.
	                // So, handling can be done if collection
	                // has an active record. Let's modify
	                // "disabled()" and "handler()" properties 
	                // accordingly.
	                var disabled = actionDef.disabled;
	                if ('function' === typeof disabled) actionDef.disabled = function () {
	                    return !_this6.current() || disabled(_this6.current());
	                };else if (undefined !== disabled) actionDef.disabled = function () {
	                    return !_this6.current() || disabled;
	                };else actionDef.disabled = function () {
	                    return !_this6.current();
	                };
	
	                actionDef.handler = function () {
	                    return handler(_this6.current());
	                };
	            }
	        });
	
	        this.actions = new _actionList2.default(actions);
	        // actions state will depend on 
	        // statuses' activate and deactivate events
	        // (change of active record)
	        this.actions.depend(this, 'activate deactivate');
	    },
	    serialize: function serialize() {
	        var _this7 = this;
	
	        return this.toJSON().map(function (item, index) {
	            return {
	                item: _extends({}, item, { model: _this7.models[index] }),
	                active: item.id === _this7.activeId
	            };
	        });
	    },
	    plugActionSource: function plugActionSource(source) {
	        if (this.actions) this.actions.plug(source);
	    },
	    unplugActionSource: function unplugActionSource(source) {
	        if (this.actions) this.actions.unplug(source);
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ActionList = function () {
	    function ActionList(actions) {
	        var _this = this;
	
	        _classCallCheck(this, ActionList);
	
	        this.actions = actions;
	
	        // this.actions.default gives us name 
	        // of default action
	        this.defaultAction = this.actions[this.actions.defaults];
	        // mark default action
	        if (this.defaultAction) this.defaultAction.defaults = true;
	        // delete "default" key
	        delete this.actions.defaults;
	
	        // add code (backlink) to each action
	        // (useful for handling)
	        Object.keys(this.actions).forEach(function (actionName) {
	            return _this.actions[actionName].code = actionName;
	        });
	    }
	
	    // listen for "events" on "context"
	    // and change state of actions accordingly
	    // (trigger "update" event to recalc enabled/disabled properties)
	
	
	    _createClass(ActionList, [{
	        key: 'depend',
	        value: function depend(context, events) {
	            var _this2 = this;
	
	            this.listenTo(context, events, function () {
	                return _this2.trigger('update');
	            });
	        }
	    }, {
	        key: 'clearDependencies',
	        value: function clearDependencies(context) {
	            this.stopListening(context);
	        }
	    }, {
	        key: 'plug',
	        value: function plug(eventSource) {
	            var _this3 = this;
	
	            if (!this.actions) return;
	
	            Object.keys(this.actions).forEach(function (eventName) {
	                return (
	                    // event name is "action:<eventName>" 
	                    _this3.listenTo(eventSource, 'action:' + eventName,
	                    // create handler for this action
	                    getHandler(_this3.actions[eventName]))
	                );
	            });
	
	            if (this.defaultAction) this.listenTo(eventSource, 'action:default', getHandler(this.defaultAction));
	        }
	    }, {
	        key: 'unplug',
	        value: function unplug(eventSource) {
	            this.stopListening(eventSource);
	        }
	    }]);
	
	    return ActionList;
	}();
	
	;
	
	_underscore2.default.extend(ActionList.prototype, _backbone2.default.Events);
	
	exports.default = ActionList;
	
	
	function getHandler(action) {
	    return function () {
	        // if info is a function, then it's handler
	        // itself. Let's call it immediately
	        if ('function' === typeof action) return action.apply(undefined, arguments);
	
	        // otherwise: 
	        // - "disabled" property is a 
	        // function that returns boolean flag
	        // of availability of action
	        // - "handler" property is a handler itself
	        var disabled = action.disabled ? action.disabled.apply(action, arguments) : false;
	
	        if (!disabled) return action.handler.apply(action, arguments);
	    };
	}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = url;
	
	var Url = function () {
	    function Url() {
	        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
	
	        _classCallCheck(this, Url);
	
	        var queryStringStart = ~url.indexOf('?') ? url.indexOf('?') : url.length;
	
	        this.url = url.substr(0, queryStringStart);
	        this.params = url.substr(queryStringStart + 1).split('&').map(function (p) {
	            return p.split('=');
	        }).filter(function (arr) {
	            return arr.length == 2;
	        }).reduce(function (params, kv) {
	            params[kv[0]] = decodeURIComponent(kv[1]);return params;
	        }, {});
	    }
	
	    _createClass(Url, [{
	        key: 'read',
	        value: function read(name, defaults) {
	            return name in this.params ? params[name] : defaults;
	        }
	    }, {
	        key: 'write',
	        value: function write(name, value) {
	            this.params[name] = value;
	            return this;
	        }
	    }, {
	        key: 'substitute',
	        value: function substitute(params) {
	            var _this = this;
	
	            Object.keys(params).map(function (key) {
	                return [key, params[key]];
	            }).forEach(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    value = _ref2[1];
	
	                return _this.url = _this.url.replaceAll('{' + key + '}', value);
	            });
	
	            Object.keys(this.params).filter(function (key) {
	                return _this.params[key].toString().match(/^\{[^\}]+\}$/);
	            }).map(function (key) {
	                return [key, _this.params[key].toString()];
	            }).map(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    key = _ref4[0],
	                    mask = _ref4[1];
	
	                return [key, mask.substring(1, mask.length - 1)];
	            }).filter(function (_ref5) {
	                var _ref6 = _slicedToArray(_ref5, 2),
	                    key = _ref6[0],
	                    name = _ref6[1];
	
	                return name in params;
	            }).forEach(function (_ref7) {
	                var _ref8 = _slicedToArray(_ref7, 2),
	                    key = _ref8[0],
	                    name = _ref8[1];
	
	                return _this.params[key] = '' + params[name];
	            });
	
	            return this;
	        }
	    }, {
	        key: 'toString',
	        value: function toString() {
	            var _this2 = this;
	
	            var queryString = Object.keys(this.params).filter(function (key) {
	                return !_this2.params[key].toString().match(/^\{[^\}]+\}$/);
	            }).map(function (key) {
	                return key + '=' + encodeURIComponent(_this2.params[key]);
	            }).join('&');
	
	            return queryString.length > 0 ? this.url + '?' + queryString : this.url;
	        }
	    }]);
	
	    return Url;
	}();
	
	function url() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
	
	    return new Url(url);
	}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Insert = function () {
	    function Insert(model) {
	        _classCallCheck(this, Insert);
	
	        this.model = model;
	    }
	
	    _createClass(Insert, [{
	        key: "toString",
	        value: function toString() {
	            return "insert for " + this.model.id;
	        }
	    }]);
	
	    return Insert;
	}();
	
	var Update = function () {
	    function Update(model) {
	        _classCallCheck(this, Update);
	
	        this.model = model;
	    }
	
	    _createClass(Update, [{
	        key: "toString",
	        value: function toString() {
	            return "update for " + this.model.id;
	        }
	    }]);
	
	    return Update;
	}();
	
	var Delete = function () {
	    function Delete(model) {
	        _classCallCheck(this, Delete);
	
	        this.model = model;
	    }
	
	    _createClass(Delete, [{
	        key: "toString",
	        value: function toString() {
	            return "delete for " + this.model.id;
	        }
	    }]);
	
	    return Delete;
	}();
	
	exports.Insert = Insert;
	exports.Update = Update;
	exports.Delete = Delete;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.restrict = exports.save = undefined;
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _diff = __webpack_require__(18);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.save = save;
	exports.restrict = restrict;
	
	
	function restrict(roles, fn, handler) {
	    if (typeof roles === 'function') handler = fn, fn = roles, roles = undefined;
	    if (handler === undefined) handler = fn, fn = undefined;
	
	    return {
	        handler: handler,
	
	        disabled: function disabled() {
	            if (roles && !(roles.indexOf(_config2.default.role()) !== -1)) return true;
	
	            return fn ? !fn() : false;
	        }
	    };
	}
	
	function save(view) {
	    var diff = view.diff();
	
	    var pendingUploadDiff = diff.filter(function (_ref) {
	        var newValue = _ref.newValue;
	        return newValue instanceof File;
	    }).map(function (_ref2) {
	        var file = _ref2.newValue,
	            attrName = _ref2.attrName;
	        return (
	            // wait for upload and then construct new diff item
	            // with actual file name
	            file.upload.then(function (fname) {
	                return { attrName: attrName, newValue: fname };
	            })
	        );
	    });
	
	    return Promise.all(pendingUploadDiff).then(function (uploadDiff) {
	        // combine changed attrs and uploaded files
	        // into one single attrs hash
	        var attrs = (0, _diff.diffHash)([].concat(_toConsumableArray(diff), _toConsumableArray(uploadDiff)));
	
	        // todo post через промежуточную модель
	        // скорее всего наследие Task.save()
	        // где мы отправляем на сервер один JSON, а 
	        // получаем обратно совсем другой
	
	        var model = new view.model.constructor({ id: view.model.id });
	
	        var options = { patch: model.id !== undefined };
	
	        return (0, _promisify.promisify)(model.save(attrs, options));
	    }); //, failure => console.log( failure ) );
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.diffHash = diffHash;
	
	
	function diffHash(diff) {
	    // cannot use hashify: will change "undefined" values to "true"
	    return diff.reduce(function (diff, item) {
	        diff[item.attrName] = item.newValue;return diff;
	    }, {});
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deferred = exports.promisify = exports.requestify = exports.rejectOn = exports.resolveOn = exports.delay = exports.postpone = undefined;
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.postpone = postpone;
	exports.delay = delay;
	exports.resolveOn = resolveOn;
	exports.rejectOn = rejectOn;
	exports.requestify = requestify;
	exports.promisify = promisify;
	exports.deferred = deferred;
	
	
	var listener = _underscore2.default.extend({}, _backbone2.default.Events);
	
	function postpone() {
	    return delay(0);
	}
	
	function delay(ms) {
	    return new Promise(function (resolve) {
	        return setTimeout(resolve, ms);
	    });
	}
	
	function rejectOn(event, context) {
	    return new Promise(function (resolve, reject) {
	        return listener.listenToOnce(context, event, reject);
	    });
	}
	
	function resolveOn(event, context) {
	    return new Promise(function (resolve) {
	        return listener.listenToOnce(context, event, resolve);
	    });
	}
	
	function requestify(deferred) {
	    (0, _loader.requestBegins)();
	
	    var request = promisify(deferred);
	    return request.then(_loader.requestEnds, _loader.requestEnds), request;
	}
	
	function promisify(deferred) {
	    if ('boolean' === typeof deferred) return Promise.resolve(deferred);
	
	    if ('number' === typeof deferred) return Promise.resolve(deferred);
	
	    if ('boolean' === typeof deferred) return Promise.resolve(deferred);
	
	    if (undefined === deferred) return Promise.resolve(deferred);
	
	    if (null === deferred) return Promise.resolve(deferred);
	
	    if (deferred instanceof Promise) return deferred;
	
	    if (!deferred.always) return Promise.resolve(deferred);
	
	    return new Promise(function (resolve, reject) {
	        return deferred.then(resolve, reject);
	    });
	}
	
	function deferred(promise) {
	    return _backbone2.default.$.Deferred(function (def) {
	        return promise.then(function () {
	            return def.resolve.apply(def, arguments);
	        }, function () {
	            return def.reject.apply(def, arguments);
	        });
	    }).promise();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.endLock = exports.beginLock = exports.requestEnds = exports.requestBegins = undefined;
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var queryCount = 0;
	
	exports.requestBegins = requestBegins;
	exports.requestEnds = requestEnds;
	exports.beginLock = beginLock;
	exports.endLock = endLock;
	
	
	function requestBegins() {
	    queryCount++;
	    setTimeout(function () {
	        if (queryCount > 0) _backbone2.default.$('body').addClass('loader');
	    }, 200);
	}
	
	function requestEnds() {
	    setTimeout(function () {
	        if (0 === --queryCount) _backbone2.default.$(document.body).removeClass('loader');
	    }, 50);
	}
	
	var globalLockObject__ = {
	    $el: _backbone2.default.$(document.body),
	    lockCount__: 0
	};
	
	function beginLock() {
	    var lockObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalLockObject__;
	
	    lockObject.lockCount__ = (lockObject.lockCount__ || 0) + 1;
	    setTimeout(function () {
	        if (lockObject.lockCount__ > 0) lockObject.$el.addClass('disabled');
	    }, 100);
	}
	
	function endLock() {
	    var lockObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalLockObject__;
	
	    setTimeout(function () {
	        if (0 === (lockObject.lockCount__ = (lockObject.lockCount__ || 0) - 1)) lockObject.$el.removeClass('disabled');
	    }, 50);
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'contracts?apiVersion=2.0',
	
	    defaults: function defaults() {
	        return {
	            title: '',
	            no: '',
	            cluster: undefined,
	            start_date: null,
	            finish_date: null,
	            customer: undefined,
	            assigned_organization: undefined,
	            grant_task_creation: false,
	            description: '',
	            groups: []
	        };
	    },
	    clone: function clone() {
	        var other = _model2.default.prototype.clone.call(this);
	        other.set('groups', this.get('groups').map(function (_ref) {
	            var objects = _ref.objects,
	                types = _ref.types,
	                attrs = _objectWithoutProperties(_ref, ['objects', 'types']);
	
	            return _extends({
	                objects: [].concat(_toConsumableArray(objects)),
	                types: [].concat(_toConsumableArray(types))
	            }, attrs);
	        }));
	        return other;
	    }
	});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _backbone3 = __webpack_require__(23);
	
	var _backbone4 = _interopRequireDefault(_backbone3);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _diff = __webpack_require__(18);
	
	var _loader = __webpack_require__(20);
	
	var _promisify = __webpack_require__(19);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// todo: correct promise support
	// todo: support jsonp
	// todo: move into backbone.js
	// todo: message as {}, not []
	// todo: support { exception_message }
	var ajax = _backbone2.default.ajax;
	_backbone2.default.ajax = function (options) {
	    var error = options.error || function () {},
	        success = options.success || function () {};
	
	    options.error = failed;
	    options.success = function (resp) {
	        return '0' === resp.res || 0 === resp.res ? failed(xhr, '', resp.resText) : successful(resp);
	    };
	
	    options.headers = options.headers || {};
	    options.headers['Accept-Language'] = _config2.default.locale();
	
	    var promise = _backbone2.default.$.Deferred(),
	        xhr = ajax.call(_backbone2.default.$, options);
	
	    if (!options.noLoader) (0, _loader.requestBegins)();
	
	    if (!options.noLoader) promise.always(_loader.requestEnds);
	
	    return promise;
	
	    function successful(resp) {
	        var result = success(resp);
	        promise.resolve(resp);
	        return result;
	    }
	
	    function failed(xhr, textStatus) {
	        var errorThrown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        // [text, field]
	        var err = parseError();
	        var result = error.call(options.context, xhr, textStatus, err);
	        promise.rejectWith(options.context, [err]);
	        return result;
	
	        // returns [text, field]
	        function parseError() {
	            if (!xhr.responseJSON || !xhr.responseJSON.translit) if (xhr.responseJSON && xhr.responseJSON.error_description) {
	                var ed = xhr.responseJSON.error_description;
	                if (!~ed.indexOf(':')) return [ed];
	
	                var index = ed.indexOf(':');
	                return [ed.substr(index + 1).trim(), ed.substr(0, index)];
	            } else return [errorThrown];
	
	            var _xhr$responseJSON = xhr.responseJSON,
	                message = _xhr$responseJSON.message,
	                parents = _xhr$responseJSON.parents,
	                translit = _xhr$responseJSON.translit;
	
	            var prefix = parents.reduce(function (result, _ref) {
	                var translit = _ref.translit,
	                    instance_index = _ref.instance_index;
	                return [].concat(_toConsumableArray(result), [translit, instance_index]);
	            }, []);
	
	            return [message, [].concat(_toConsumableArray(prefix), [translit])];
	        }
	    }
	};
	
	var Model = void 0;exports.default = Model = _backbone2.default.Epoxy.Model.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        this.endpoint = options.endpoint || this.endpoint;
	
	        _backbone2.default.Model.prototype.initialize.apply(this, arguments);
	    },
	    url: function url() {
	        var url = this.endpoint,
	            suffix = '';
	
	        if (~url.indexOf('?')) {
	            suffix = url.substr(url.indexOf('?'));
	            url = url.replace(suffix, '');
	        }
	
	        if (this.id) url += '/' + this.id;
	
	        url += suffix;
	
	        return _config2.default.url(url);
	    },
	
	
	    // make fetch() return promise of [model, response]
	    fetch: function fetch() {
	        var _this = this;
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _backbone2.default.Epoxy.Model.prototype.fetch.apply(this, args).then(function (resp) {
	            return [_this, resp];
	        });
	    },
	    parse: function parse(data, options) {
	        var _this2 = this;
	
	        var fn = function fn(payload) {
	
	            if (_this2.renameProperties) Object.keys(_this2.renameProperties).forEach(function (propName) {
	                if (!(propName in payload)) return;
	
	                var newName = _this2.renameProperties[propName];
	                payload[newName] = payload[propName];
	                delete payload[propName];
	            });
	
	            if (_this2.customParser) payload = _this2.customParser(payload, data);
	
	            return payload;
	        };
	
	        var res = data.res,
	            resText = data.resText,
	            attrs = _objectWithoutProperties(data, ['res', 'resText']);
	
	        if (res !== undefined) return fn(this.responseAt ? attrs[this.responseAt] || {} : attrs);
	
	        if (this.responseAt && attrs[this.responseAt]) return fn(attrs[this.responseAt]);
	
	        return fn(attrs || {});
	    },
	    patch: function patch() {
	        var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return (0, _promisify.promisify)(this.save(attrs, { patch: true }));
	    },
	
	
	    // Returns the changes (difference) applied to this
	    // model comparing it with anotherModel.
	    // Changes are returned as array [{attrName, newValue: attrValue}]. 
	    diff: function diff(another /*, options = {}*/) {
	        var sameItem = function sameItem(a, b) {
	            return a instanceof Array && b instanceof Array ? (0, _arrays.eq)(a, b) : a === b;
	        };
	
	        var attrs = another instanceof Model ? another.toJSON() : another,
	            thisAttrs = this.toJSON();
	
	        return Object.keys(attrs).map(function (attrName) {
	            return [thisAttrs[attrName], attrs[attrName], attrName];
	        }).filter(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                newValue = _ref3[0],
	                oldValue = _ref3[1];
	
	            return !sameItem(newValue, oldValue);
	        }).map(function (_ref4) {
	            var _ref5 = _slicedToArray(_ref4, 3),
	                newValue = _ref5[0],
	                oldValue = _ref5[1],
	                attrName = _ref5[2];
	
	            return { attrName: attrName, newValue: newValue, oldValue: oldValue };
	        });
	    }
	}, {
	    byId: function byId(id) {
	        var Class = this,
	            model = new Class({ id: +id });
	
	        return (0, _promisify.promisify)(model.fetch())
	        // Backbone bug? changedAttributes() says that attributes
	        // got from server by fetch() are "new".
	        // So, let's set them explicitly.
	        .then(function () {
	            return model.set(model.toJSON());
	        });
	    }
	});

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.mapEl = exports.eq = exports.diffuse = exports.hashify = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.hashify = hashify;
	exports.diffuse = diffuse;
	exports.eq = eq;
	exports.mapEl = mapEl;
	
	
	function eq(a, b) {
	    // todo not only { id }, but just id
	    var std = function std(arr) {
	        var fn = arr.every(function (model) {
	            return model.hasOwnProperty('id');
	        }) ? function (model) {
	            return +model.id;
	        } : function (el) {
	            return el;
	        };
	
	        return arr.map(fn).sort().join(',');
	    };
	
	    return std(a) === std(b);
	}
	
	function hashify() {
	    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item, hash) {
	        return [item, true];
	    };
	
	    if (array instanceof _collection2.default) array = array.toJSON();
	
	    return array.reduce(function (hash, item) {
	        var _fn = fn(item, hash),
	            _fn2 = _slicedToArray(_fn, 2),
	            key = _fn2[0],
	            value = _fn2[1];
	
	        hash[key] = value != undefined ? value : true;
	        return hash;
	    }, {});
	}
	
	function diffuse(array, fn) {
	    if (!fn) return array.slice();
	
	    return array.reduce(function (result, item, index) {
	        var pivot = void 0;if (index) if (pivot = fn(array[index - 1], item)) result.push(pivot);
	
	        return result.push(item), result;
	    }, []);
	}
	
	function mapEl(array, findFn, newFn, mapFn) {
	    array = [].concat(_toConsumableArray(array || []));
	
	    var index = array.findIndex(findFn);
	    var el = mapFn(array[index] || newFn());
	
	    if (el && index > -1) array[index] = el;else if (el) array.push(el);else if (index > -1) array.splice(index, 1);
	
	    return array;
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _cluster = __webpack_require__(26);
	
	var _cluster2 = _interopRequireDefault(_cluster);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'clusters/list?apiVersion=2.0',
		responseAt: 'items',
		model: _cluster2.default
	});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'clusters?apiVersion=2.0',
	
	    defaults: {
	        title: '',
	        defaults: null
	    }
	
	});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'fields/list',
		responseAt: 'custom_fields',
		model: _field2.default,
	
		system: function system() {
			return this.toJSON().filter(function (field) {
				return [true, 't'].indexOf(field.system) !== -1;
			});
		},
		nonSystem: function nonSystem() {
			return this.toJSON().filter(function (field) {
				return [false, 'f'].indexOf(field.system) !== -1;
			});
		}
	});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'fields', responseAt: 'custom_field',
	
	    defaults: function defaults() {
	        return {
	            // "id" must be specified here in order
	            // to make Epoxy's "toggle:not(id)" binding filter work.
	            // (see customField.form.handlebars and "format"
	            // field for example).
	            id: undefined,
	            cluster: null,
	            table_id: undefined, multiselect: undefined, allow_add_num: undefined,
	            name: '',
	            format: 'string',
	            group_name: undefined,
	            possible_values: [],
	            regexp: undefined,
	            min_length: undefined,
	            max_length: undefined,
	            is_required: 'f',
	            default_value: undefined,
	            visible: 't',
	            is_for_all: 'f',
	            bindings: [],
	            min_count: 1,
	            max_count: 1,
	            min_size: undefined,
	            max_size: undefined,
	            auto_apply_sticker: 'f',
	            subfields: [],
	            file_semantics: ['PHOTO'],
	            sticker_ids: null, __all_stickers_available: undefined
	        };
	    },
	
	
	    computeds: {
	
	        // make copy of "regexp" property
	        // with start and end "/"
	        regexp_: {
	            set: function set(value) {
	                if ('string' !== typeof value) return { regexp: value };
	
	                if ('' === value) return { regexp: '' };
	
	                return { regexp: '/' + value + '/' };
	            },
	            get: function get() {
	                var value = this.get('regexp');
	                // "/value/"
	                if ('string' === typeof value)
	                    // correct for empty string too
	                    value = value.substring(1, value.length - 1);
	                return value;
	            }
	        },
	
	        // treat "0" for minlength and maxlength as no value
	        min_length_: {
	            set: function set(value) {
	                if ('' === value) return { min_length: 0 };
	                return { min_length: value };
	            },
	            get: function get() {
	                var value = this.get('min_length');
	                if ('0' === value) return undefined;
	                if (0 === value) return undefined;
	
	                return value;
	            }
	        },
	
	        // treat "0" for minlength and maxlength as no value
	        max_length_: {
	            set: function set(value) {
	                if ('' === value) return { max_length: 0 };
	                return { max_length: value };
	            },
	            get: function get() {
	                var value = this.get('max_length');
	                if ('0' === value) return undefined;
	                if (0 === value) return undefined;
	
	                return value;
	            }
	        },
	
	        // treat list of strings as string with "\n"s
	        // at UI level
	        possible_values_: {
	            set: function set(value) {
	                var newPossibleValues = value.split('\n');
	
	                var defaultValue = this.get('default_value');
	                if (!defaultValue) return { possible_values: newPossibleValues };
	
	                // default value hasn't changed in possible values list
	                if (~newPossibleValues.indexOf(defaultValue)) return { possible_values: newPossibleValues };
	
	                var oldPossibleValues = this.get('possible_values') || [];
	                if (newPossibleValues.length !== oldPossibleValues.length) return { possible_values: newPossibleValues, default_value: '' };
	
	                var oldDefaultValueIndex = oldPossibleValues.indexOf(defaultValue);
	                if (oldDefaultValueIndex < 0) return { possible_values: newPossibleValues, default_value: '' };
	
	                var changedItems = newPossibleValues.filter(function (value, index) {
	                    return value !== oldPossibleValues[index];
	                });
	                // no changes or more than one row has been changed:
	                // cannot find match for old default value in changed rows
	                if (!changedItems.length || changedItems.length > 1) return { possible_values: newPossibleValues, default_value: '' };
	
	                // * lengths are equal
	                // * one change 
	                // * defval is in old list
	                // * defval is not in new list
	                // -> take new list in position of change
	                return { possible_values: newPossibleValues, default_value: changedItems[0] };
	            },
	            get: function get() {
	                var value = this.get('possible_values');
	                if (value instanceof Array) value = value.join('\n');
	
	                return value;
	            }
	        },
	
	        default_datetime: {
	            set: function set(value) {
	                if (this.get('format') !== 'date') return {};
	
	                return { default_value: value };
	            },
	            get: function get() {
	                if (this.get('format') !== 'date') return null;
	
	                var value = this.get('default_value');
	                if (!value) return null;
	
	                return value;
	            }
	        },
	
	        // for converting timestamp (as in binder) to string (as in model/server)
	        default_date: {
	            set: function set(value) {
	                if (this.get('format') !== 'date-only') return {};
	
	                return { default_value: (0, _date.fmt)(value, 'YYYY-MM-DD') };
	            },
	            get: function get() {
	                if (this.get('format') !== 'date-only') return null;
	
	                var value = this.get('default_value');
	                if (!value) return null;
	
	                // no need in fake "00:00:00" string
	                // because this timestamp will be converted to date string next
	                return (0, _date.unixts)((0, _date.parseYYYYMMDD)(value));
	            }
	        },
	
	        default_possible_value: {
	            set: function set(value) {
	                return { default_value: value };
	            },
	            get: function get() {
	                return {
	                    selected: this.get('default_value'),
	                    options: this.get('possible_values')
	                };
	            }
	        }
	
	    },
	
	    customParser: function customParser(payload) {
	        var _this = this;
	
	        if (payload.subfields instanceof Array) payload.subfields = payload.subfields.map(function (subfieldPayload) {
	            return _this.customParser(subfieldPayload);
	        });
	
	        if ('string' === typeof payload.possible_values) payload.possible_values = payload.possible_values.split('\n');
	        if ('' === payload.regexp) payload.regexp = undefined;
	        if (payload.order) payload.order = +payload.order;
	
	        var news_type_ids = payload.news_type_ids,
	            json = _objectWithoutProperties(payload, ['news_type_ids']);
	
	        return _extends({}, json);
	    },
	    clone: function clone() {
	        var clonify = function clonify(_ref) {
	            var subfields = _ref.subfields,
	                json = _objectWithoutProperties(_ref, ['subfields']);
	
	            return _extends({}, json, {
	                subfields: subfields.map(clonify)
	            });
	        };
	
	        var Class = this.constructor;
	        return new Class(clonify(this.toJSON()));
	    },
	    diff: function diff(another) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var diff = _model2.default.prototype.diff.call(this, another, options).filter(function (_ref2) {
	            var attrName = _ref2.attrName;
	            return attrName !== 'bindings';
	        });
	
	        var oldBindings = another.get('bindings');
	        var newBindings = this.get('bindings');
	
	        var normalizeBindings = function normalizeBindings(bindings) {
	            return bindings.map(normalizeBinding).sort(function (bindingA, bindingB) {
	                return bindingA.type.id - bindingB.type.id;
	            });
	        };
	
	        var originalBindings = normalizeBindings(oldBindings);
	        var fieldBindings = normalizeBindings(newBindings);
	
	        if (JSON.stringify(originalBindings) !== JSON.stringify(fieldBindings)) diff.push({
	            attrName: 'bindings',
	            oldValue: oldBindings, newValue: newBindings
	        });
	
	        var oldSubfields = another.get('subfields');
	        var newSubfields = this.get('subfields');
	
	        var normalize = function normalize(array) {
	            return array.sort(function (_ref3, _ref4) {
	                var a = _ref3.order;
	                var b = _ref4.order;
	                return a - b;
	            })
	            // ignore "bindings" for subfields
	            .map(function (json) {
	                return Object.keys(json).filter(function (key) {
	                    return key != 'bindings' && key != 'new-order';
	                }).sort().map(function (key) {
	                    return [key, json[key]];
	                }).map(function (_ref5) {
	                    var _ref6 = _slicedToArray(_ref5, 2),
	                        key = _ref6[0],
	                        value = _ref6[1];
	
	                    return 'subfields' === key ? [key, normalize([].concat(_toConsumableArray(value)))] : [key, value];
	                }).reduce(function (hash, _ref7) {
	                    var _ref8 = _slicedToArray(_ref7, 2),
	                        key = _ref8[0],
	                        value = _ref8[1];
	
	                    return hash[key] = value, hash;
	                }, {});
	            });
	        };
	
	        var originalSubfields = normalize(oldSubfields);
	        var fieldSubfields = normalize(newSubfields);
	
	        if (JSON.stringify(originalSubfields) !== JSON.stringify(fieldSubfields)) return diff.push({
	            attrName: 'subfields',
	            oldValue: oldSubfields, newValue: newSubfields
	        }), diff;
	
	        return diff;
	    },
	    suggestionOptions: function suggestionOptions(text) {
	        var _this2 = this;
	
	        var url = _config2.default.url('/fields/' + this.id + '/values?search=' + text);
	        return _backbone2.default.$.ajax(url).then(function (_ref9) {
	            var values = _ref9.values;
	            return values.map(function (value) {
	                return value[_this2.get('titleField')];
	            });
	        });
	    }
	}, {
	    isBindingChanged: function isBindingChanged(binding, originalModel) {
	        if (!binding.id) return true;
	
	        var _originalModel$get$fi = originalModel.get('bindings').filter(function (otherBinding) {
	            return otherBinding.id == binding.id;
	        }),
	            _originalModel$get$fi2 = _slicedToArray(_originalModel$get$fi, 1),
	            otherBinding = _originalModel$get$fi2[0];
	
	        return JSON.stringify(normalizeBinding(binding)) !== JSON.stringify(normalizeBinding(otherBinding));
	    },
	    encodeString: function encodeString(decodedString) {
	        return encodeURIComponent(decodedString.replaceAll('.', '[dot]').replaceAll("'", '[apo]'));
	    },
	    decodeString: function decodeString(encodedString) {
	        return decodeURIComponent(encodedString).replaceAll('[dot]', '.').replaceAll('[apo]', "'");
	    }
	});
	
	
	function normalizeBinding(_ref10) {
	    var id = _ref10.id,
	        type = _ref10.type,
	        on = _ref10.on,
	        visible_by_default = _ref10.visible_by_default,
	        rules = _ref10.rules;
	
	    rules = rules || [];
	    if (!rules.length) rules = [].concat(_toConsumableArray(rules), [{ visible_by_default: true, visible_inverted_for_roles: [] }]);
	
	    return {
	        id: id, type: type, on: on, visible_by_default: visible_by_default,
	        rules: rules.map(function (_ref11) {
	            var rule = _objectWithoutProperties(_ref11, []),
	                visible_by_default = _ref11.visible_by_default,
	                visible_inverted_for_roles = _ref11.visible_inverted_for_roles;
	
	            return _extends({}, rule, {
	                visible_by_default: [true, 't'].indexOf(visible_by_default) !== -1,
	                visible_inverted_for_roles: (visible_inverted_for_roles || []).map(function (id) {
	                    return +id;
	                }).sort()
	            });
	        })
	    };
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.same = exports.zp = exports.unixts = exports.parseTime = exports.parseYYYYMMDD = exports.parseDDMMYYYY = exports.parse = exports.diffTime = exports.schoolYear = exports.monthDuration = exports.september = exports.july = exports.june = exports.month = exports.prevYear = exports.nextYear = exports.prevMonth = exports.nextMonth = exports.endDay = exports.beginDay = exports.endMonth = exports.beginYear = exports.beginMonth = exports.past = exports.future = exports.monday = exports.sunday = exports.today = exports.afterEq = exports.beforeEq = exports.after = exports.before = exports.is = exports.yesterday = exports.tomorrow = exports.ddmmyyyy = exports.fmt = exports.datify = undefined;
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.datify = datify;
	exports.fmt = fmt;
	exports.ddmmyyyy = ddmmyyyy;
	exports.tomorrow = tomorrow;
	exports.yesterday = yesterday;
	exports.is = is;
	exports.before = before;
	exports.after = after;
	exports.beforeEq = beforeEq;
	exports.afterEq = afterEq;
	exports.today = today;
	exports.sunday = sunday;
	exports.monday = monday;
	exports.future = future;
	exports.past = past;
	exports.beginMonth = beginMonth;
	exports.beginYear = beginYear;
	exports.endMonth = endMonth;
	exports.beginDay = beginDay;
	exports.endDay = endDay;
	exports.nextMonth = nextMonth;
	exports.prevMonth = prevMonth;
	exports.nextYear = nextYear;
	exports.prevYear = prevYear;
	exports.month = month;
	exports.june = june;
	exports.july = july;
	exports.september = september;
	exports.monthDuration = monthDuration;
	exports.schoolYear = schoolYear;
	exports.diffTime = diffTime;
	exports.parse = parse;
	exports.parseDDMMYYYY = parseDDMMYYYY;
	exports.parseYYYYMMDD = parseYYYYMMDD;
	exports.parseTime = parseTime;
	exports.unixts = unixts;
	exports.zp = zp;
	var same = exports.same = {
	    time: function time(one, another) {
	        return fmt(one, 'YYYY-MM-DD HH:mm') === fmt(another, 'YYYY-MM-DD HH:mm');
	    },
	    month: function month(one, another) {
	        return fmt(one, 'YYYY-MM') === fmt(another, 'YYYY-MM');
	    },
	    date: function date(one, another) {
	        return is(one, another);
	    }
	};
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	function datify(value) {
	    if ('string' === typeof value && +value) return datify(+value);
	
	    if ('number' === typeof value) if (value >= 1000000000000)
	        // milliseconds
	        return new Date(value);else
	        // seconds
	        return new Date(value * 1000);
	
	    if ('string' === typeof value) try {
	        return ~value.indexOf('-') ? parseYYYYMMDD(value) : parseDDMMYYYY(value);
	    } catch (ex) {
	        try {
	            return parseDDMMYYYY(value);
	        } catch (ex) {}
	    }
	
	    return value;
	}
	
	function fmt(date, format) {
	    date = datify(date);
	    if (date instanceof Date) return format.replace('DofMonthYYYY', '*7*').replace('DofMonthHHmm', '*8*').replace('DofMonYYYY', '*9*').replace('DofMonHHmm', '*10*').replace('DofMonth', '*11*').replace('DofMon', '*12*').replace('YYYY', zp(date.getFullYear(), 4)).replace('YY', zp(date.getFullYear() % 100)).replace('Month', '*2*').replace('Mon', '*3*').replace('MM', zp(date.getMonth() + 1)).replace('M', date.getMonth() + 1).replace('DD', zp(date.getDate())).replace('D', date.getDate()).replace('Sunday', '*4*').replace('Sun', '*5*').replace('SU', '*6*').replace('HH', zp(date.getHours())).replace('H', date.getHours() + '').replace('mm', zp(date.getMinutes())).replace('ss', zp(date.getSeconds())).replace('*2*', ifn(['dates::january', 'dates::february', 'dates::march', 'dates::april', 'dates::may', 'dates::june', 'dates::july', 'dates::august', 'dates::september', 'dates::october', 'dates::november', 'dates::december'][date.getMonth()])).replace('*3*', ifn(['dates::jan', 'dates::feb', 'dates::mar', 'dates::apr', 'dates::may3', 'dates::jun', 'dates::jul', 'dates::aug', 'dates::sep', 'dates::oct', 'dates::nov', 'dates::dec'][date.getMonth()])).replace('*4*', ifn(['dates::sunday', 'dates::monday', 'dates::tuesday', 'dates::wednesday', 'dates::thursday', 'dates::friday', 'dates::saturday'][date.getDay()])).replace('*5*', ifn(['dates::sun', 'dates::mon', 'dates::tue', 'dates::wed', 'dates::thu', 'dates::fr', 'dates::sa'][date.getDay()])).replace('*6*', ifn(['dates::su', 'dates::mo', 'dates::tu', 'dates::we', 'dates::th', 'dates::fr', 'dates::sa'][date.getDay()])).replace('*11*', ifn(['dates::DofJanuary', 'dates::DofFebruary', 'dates::DofMarch', 'dates::DofApril', 'dates::DofMay', 'dates::DofJune', 'dates::DofJuly', 'dates::DofAugust', 'dates::DofSeptember', 'dates::DofOctober', 'dates::DofNovember', 'dates::DofDecember'][date.getMonth()], { D: date.getDate() })).replace('*12*', ifn(['dates::DofJan', 'dates::DofFeb', 'dates::DofMar', 'dates::DofApr', 'dates::DofMay3', 'dates::DofJun', 'dates::DofJul', 'dates::DofAug', 'dates::DofSep', 'dates::DofOct', 'dates::DofNov', 'dates::DofDec'][date.getMonth()], { D: date.getDate() })).replace('*7*', ifn(['dates::DofJanuaryYYYY', 'dates::DofFebruaryYYYY', 'dates::DofMarchYYYY', 'dates::DofAprilYYYY', 'dates::DofMayYYYY', 'dates::DofJuneYYYY', 'dates::DofJulyYYYY', 'dates::DofAugustYYYY', 'dates::DofSeptemberYYYY', 'dates::DofOctoberYYYY', 'dates::DofNovemberYYYY', 'dates::DofDecemberYYYY'][date.getMonth()], { D: date.getDate(), YYYY: date.getFullYear() })).replace('*9*', ifn(['dates::DofJanYYYY', 'dates::DofFebYYYY', 'dates::DofMarYYYY', 'dates::DofAprYYYY', 'dates::DofMay3YYYY', 'dates::DofJunYYYY', 'dates::DofJulYYYY', 'dates::DofAugYYYY', 'dates::DofSepYYYY', 'dates::DofOctYYYY', 'dates::DofNovYYYY', 'dates::DofDecYYYY'][date.getMonth()], { D: date.getDate(), YYYY: date.getFullYear() })).replace('*8*', ifn(['dates::DofJanuaryHHmm', 'dates::DofFebruaryHHmm', 'dates::DofMarchHHmm', 'dates::DofAprilHHmm', 'dates::DofMayHHmm', 'dates::DofJuneHHmm', 'dates::DofJulyHHmm', 'dates::DofAugustHHmm', 'dates::DofSeptemberHHmm', 'dates::DofOctoberHHmm', 'dates::DofNovemberHHmm', 'dates::DofDecemberHHmm'][date.getMonth()], { D: date.getDate(), HH: zp(date.getHours()), H: date.getHours() + '', mm: zp(date.getMinutes()) })).replace('*10*', ifn(['dates::DofJanHHmm', 'dates::DofFebHHmm', 'dates::DofMarHHmm', 'dates::DofAprHHmm', 'dates::DofMay3HHmm', 'dates::DofJunHHmm', 'dates::DofJulHHmm', 'dates::DofAugHHmm', 'dates::DofSepHHmm', 'dates::DofOctHHmm', 'dates::DofNovHHmm', 'dates::DofDecHHmm'][date.getMonth()], { D: date.getDate(), HH: zp(date.getHours()), H: date.getHours() + '', mm: zp(date.getMinutes()) }));
	}
	
	// DofMonth DofMon 
	function ddmmyyyy(date) {
	    return fmt(date, 'DD.MM.YYYY');
	}
	
	function parse(dateStr) {
	    if ('string' === typeof dateStr) return parseYYYYMMDD(dateStr);
	    if ('number' === typeof dateStr) return new Date(dateStr * 1000);
	
	    return dateStr;
	}
	
	function parseDDMMYYYY(dateStr) {
	    var m = dateStr.match(/(\d\d)\.(\d\d)\.(\d\d\d\d)/),
	        date = parseInt(m[1], 10),
	        month = parseInt(m[2], 10),
	        year = parseInt(m[3], 10);
	
	    var result = new Date();
	    // to avoid transforming 01.06 into 01.07 when making it at 31.05 :-)))
	    result.setDate(1);
	
	    result.setFullYear(year);
	    result.setMonth(month - 1);
	    result.setDate(date);
	
	    result.setHours(0);
	    result.setMinutes(0);
	    result.setSeconds(0);
	    result.setMilliseconds(0);
	
	    var timeMatch = dateStr.match(/(\d\d):(\d\d):(\d\d)/);
	    if (timeMatch) result.setHours(parseInt(timeMatch[1], 10)), result.setMinutes(parseInt(timeMatch[2], 10)), result.setSeconds(parseInt(timeMatch[3], 10));
	
	    return result;
	}
	
	function parseYYYYMMDD(dateStr) {
	    var m = dateStr.match(/(\d\d\d\d)-(\d\d)-(\d\d)/);
	    var date = parseInt(m[3], 10),
	        month = parseInt(m[2], 10),
	        year = parseInt(m[1], 10);
	
	    var result = new Date();
	    // to avoid transforming 01.06 into 01.07 when making it at 31.05 :-)))
	    result.setDate(1);
	
	    result.setFullYear(year);
	    result.setMonth(month - 1);
	    result.setDate(date);
	
	    m = dateStr.match(/(\d\d):(\d\d):(\d\d)/);
	    if (m) result.setHours(parseInt(m[1], 10)), result.setMinutes(parseInt(m[2], 10)), result.setSeconds(parseInt(m[3], 10));
	
	    return result;
	}
	
	function parseTime(timeStr) {
	    return parseYYYYMMDD(fmt(today(), 'YYYY-MM-DD') + ' ' + timeStr + ':00');
	}
	
	function tomorrow(date) {
	    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    var tomorrow = new Date(date);
	    while (count--) {
	        tomorrow.setDate(tomorrow.getDate() + 1);
	    }return tomorrow;
	}
	
	function yesterday(date) {
	    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    var yesterday = new Date(date);
	    while (count--) {
	        yesterday.setDate(yesterday.getDate() - 1);
	    }return yesterday;
	}
	
	function zp(value) {
	    var pad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	    value += '';
	    while (value.length < pad) {
	        value = '0' + value;
	    }return value;
	}
	
	function is(one, another) {
	    return fmt(one, 'DD.MM.YYYY') === fmt(another, 'DD.MM.YYYY');
	}
	
	function before(one, another) {
	    return unixts(datify(one)) < unixts(datify(another));
	}
	
	function after(one, another) {
	    return unixts(datify(one)) > unixts(datify(another));
	}
	
	function beforeEq(one, another) {
	    return unixts(datify(one)) <= unixts(datify(another));
	}
	
	function afterEq(one, another) {
	    return unixts(datify(one)) >= unixts(datify(another));
	}
	
	function today() {
	    return new Date();
	}
	
	function future(date) {
	    return fmt(date, 'YYYY-MM-DD') > fmt(today(), 'YYYY-MM-DD');
	}
	
	function past(date) {
	    return fmt(date, 'YYYY-MM-DD') < fmt(today(), 'YYYY-MM-DD');
	}
	
	function monday(day) {
	    return 1 === day.getDay();
	}
	
	function sunday(day) {
	    return 0 === day.getDay();
	}
	
	function beginMonth(date) {
	    var newDate = new Date(datify(date));
	    newDate.setDate(1);
	    return newDate;
	}
	
	function endMonth(date) {
	    var newDate = new Date(datify(date));
	    newDate.setDate(monthDuration(date));
	    return newDate;
	}
	
	function beginDay(date) {
	    var newDate = new Date(datify(date));
	    newDate.setHours(0);
	    newDate.setMinutes(0);
	    newDate.setSeconds(0);
	    newDate.setMilliseconds(0);
	    return newDate;
	}
	
	function endDay(date) {
	    var newDate = new Date(datify(date));
	    newDate.setHours(24);
	    newDate.setMinutes(0);
	    newDate.setSeconds(0);
	    newDate.setMilliseconds(0);
	    return newDate;
	}
	
	function beginYear(date) {
	    var newDate = new Date(datify(date));
	    newDate.setMonth(0);
	    newDate.setDate(1);
	    return newDate;
	}
	
	function month(date) {
	    return date.getMonth();
	}
	
	function june(date) {
	    return 5 === month(date);
	}
	
	function july(date) {
	    return 6 === month(date);
	}
	
	function september(date) {
	    return 8 === month(date);
	}
	
	function nextMonth(date) {
	    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    while (count--) {
	        date = nextMonthStep(date);
	    }return new Date(datify(date));
	}
	
	function nextMonthStep(date) {
	    var newDate = new Date(date);
	    var checkDate = beginMonth(date);
	    checkDate.setMonth(checkDate.getMonth() + 1);
	
	    // don't go over month bounds
	    if (newDate.getDate() > monthDuration(checkDate)) newDate.setDate(monthDuration(checkDate));
	
	    newDate.setMonth(date.getMonth() + 1);
	    return newDate;
	}
	
	function prevMonth(date) {
	    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    while (count--) {
	        date = prevMonthStep(date);
	    }return date;
	}
	
	function prevMonthStep(date) {
	    var newDate = new Date(date);
	    var checkDate = beginMonth(date);
	    checkDate.setMonth(checkDate.getMonth() - 1);
	
	    // don't go over month bounds
	    if (newDate.getDate() > monthDuration(checkDate)) newDate.setDate(monthDuration(checkDate));
	
	    newDate.setMonth(date.getMonth() - 1);
	    return newDate;
	}
	
	function nextYear(date) {
	    var newDate = new Date(datify(date));
	    newDate.setFullYear(newDate.getFullYear() + 1);
	    return newDate;
	}
	
	function prevYear(date) {
	    var newDate = new Date(datify(date));
	    newDate.setFullYear(newDate.getFullYear() - 1);
	    return newDate;
	}
	
	function diffTime(timeB, timeA) {
	    return minutes(timeB) - minutes(timeA);
	}
	
	function minutes(time) {
	    return time.substring(0, 2) * 60 + (time.substring(3, 5) - 0);
	}
	
	function schoolYear(date) {
	    // >= september -> current year, < september -> prev year
	    if (date.getMonth() < 8) date = prevYear(date);
	
	    return fmt(date, 'YYYY') + '/' + fmt(nextYear(date), 'YY');
	}
	
	function unixts(date) {
	    if (typeof date === 'number') return date;else if (typeof date === 'string' && date.length === 10) return +date;
	
	    return Math.floor(date / 1000);
	}
	
	var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function monthDuration(date) {
	    var month = date.getMonth();
	    // not feb?
	    if (1 != month) return daysInMonth[month];
	
	    // leap year
	    var year = date.getFullYear();
	    return 0 === year % 4 && 0 !== year % 100 || 0 === year % 400 ? 29 : 28;
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _handlebars = __webpack_require__(31);
	
	var _handlebars2 = _interopRequireDefault(_handlebars);
	
	var _i18next = __webpack_require__(32);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextXhrBackend = __webpack_require__(33);
	
	var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = {
	    debug: false,
	    lng: _config2.default.locale(),
	    fallbackLng: 'en',
	    ns: ['glossary', 'actions', 'labels', 'columns', 'units', 'types', 'dates', 'errors', 'calendar', 'filters', 'type', 'field', 'issue', 'priority', 'status', 'sticker', 'file', 'script', 'contract', 'server', 'schedule', 'comment', 'service.object', 'datatables', 'configuration', 'capabilities', 'application', 'forms', 'grids', 'popups', 'navs', 'auth'],
	    nsSeparator: '::',
	    backend: {
	        loadPath: 'locales/{{lng}}/{{ns}}.json'
	    }
	};
	
	exports.default = _i18next2.default.use(_i18nextXhrBackend2.default).init(options).then(function () {
	    return _i18next2.default.changeLanguage(_config2.default.locale());
	}).then(function () {
	    document.title = i('application::title');
	
	    _handlebars2.default.registerHelper('i', function (key) {
	        for (var _len = arguments.length, other = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            other[_key - 1] = arguments[_key];
	        }
	
	        return other.pop(), i.apply(undefined, [key].concat(other));
	    });
	
	    return i;
	
	    function i(key) {
	        for (var _len2 = arguments.length, other = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            other[_key2 - 1] = arguments[_key2];
	        }
	
	        var context = other[0],
	            more = other[1];
	
	
	        if ((typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') return _i18next2.default.t(key, context);
	
	        if (typeof context !== 'number') return context !== undefined ? _i18next2.default.t(key, { context: context }) : _i18next2.default.t(key);
	
	        var data = { count: context, more: more };
	        for (var _i = 0; _i < other.length; _i++) {
	            data[_i] = other[_i];
	        }return _i18next2.default.t(key, data);
	    }
	});

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _layer = __webpack_require__(35);
	
	var _layer2 = _interopRequireDefault(_layer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		getUrl: function getUrl() {
			var url = 'layers';
			for (var name in this.filters) {
				if (this.filters.hasOwnProperty(name)) if (undefined !== this.filters[name]) url = _config2.default.add(url, name, this.filters[name]);
			}url = _config2.default.url(url, { addToken: true, addBase: false });
			if (this.page) url = _config2.default.add(url, 'page', this.page);
	
			return url;
		},
		parseResponse: function parseResponse(modelsAttrs, response) {
			return modelsAttrs.map(function (modelAttrs) {
				return modelAttrs.layer;
			});
		},
	
	
		endpoint: 'layers',
		responseAt: 'layers',
		model: _layer2.default,
		jsonp: false
	});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _datatable = __webpack_require__(37);
	
	var _datatable2 = _interopRequireDefault(_datatable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		getUrl: function getUrl() {
			var url = 'datatables';
			for (var name in this.filters) {
				if (this.filters.hasOwnProperty(name)) if (undefined !== this.filters[name]) url = _config2.default.add(url, name, this.filters[name]);
			}url = _config2.default.url(url, { addToken: true, addBase: false });
			if (this.page) url = _config2.default.add(url, 'page', this.page);
	
			return url;
		},
	
	
		endpoint: 'datatables',
		model: _datatable2.default,
		jsonp: false
	});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _auth = __webpack_require__(39);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _immortal = __webpack_require__(80);
	
	var _immortal2 = _interopRequireDefault(_immortal);
	
	var _ws = __webpack_require__(81);
	
	var _ws2 = _interopRequireDefault(_ws);
	
	var _taskAssignee = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storage = {};
	
	var initialLocationsQuery = _auth2.default.then(function () {
	    return (0, _taskAssignee.getLocations)();
	}).then(function (_ref) {
	    var users = _ref.users;
	    return users;
	}).then(function (response) {
	    return response.filter(function (item) {
	        return !!item.location;
	    });
	}).then(function (response) {
	    return response.filter(function (item) {
	        return !!item.location.date;
	    });
	}).then(function (locationsResponse) {
	    return handleLocations(locationsResponse);
	}).then(function () {
	    return undefined;
	});
	
	var Locations = new _channel2.default(function (writeFn) {
	    return initialLocationsQuery.then(function () {
	        return (0, _immortal2.default)(function () {
	            return (0, _ws2.default)('/users/locations/live');
	        }, 5, // 5 attempts
	        15 * 1000, // in 15 secs each,
	        5 * 60 * 1000 // reconnecting in 5 min 
	        );
	    }).then(function (ch) {
	        return ch.dest(writeFn);
	    });
	}).map(function (_ref2) {
	    var points = _ref2.points;
	    return points;
	});
	
	Locations.ready = function () {
	    return initialLocationsQuery;
	};
	
	Locations.getLoc = function (userId) {
	    return storage[userId];
	};
	
	Locations.forEach(function (locations) {
	    return handleLocations(locations);
	});
	
	exports.default = Locations;
	
	
	function handleLocations(locations) {
	    locations.forEach(function (locationInfo) {
	        var id = locationInfo.user.id,
	            location = locationInfo.location;
	
	        storage[id] = location;
	    });
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _auth = __webpack_require__(40);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _checklogin = __webpack_require__(41);
	
	var _checklogin2 = _interopRequireDefault(_checklogin);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _user = __webpack_require__(146);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _popups = __webpack_require__(62);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var fn = function fn(authCallback) {
	    return Promise.resolve().then(function () {
	        // No token?  
	        if (!_config2.default.token()) throw new Error();
	    }).then(function () {
	        var cbUser = (0, _promisify.requestify)(_jquery2.default.getJSON(_config2.default.url('/users/current')));
	        var msUser = (0, _promisify.requestify)(_jquery2.default.getJSON('/users/current?token=' + _config2.default.token()));
	
	        return Promise.all([cbUser, msUser]).then(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                cbResp = _ref2[0],
	                msResp = _ref2[1];
	
	            // Token expired?
	            if (+cbResp.res === 0) throw new Error();
	            if (!msResp.user) throw new Error();
	
	            return cbResp;
	        });
	    })
	    // otherwise run authorization
	    .catch(function () {
	        return authCallback();
	    })
	    // remember auth data
	    .then(function (subject) {
	        var id = subject.id,
	            token = subject.token,
	            fio = subject.fio,
	            role_id = subject.role_id,
	            clusters = subject.clusters,
	            department_id = subject.department_id,
	            map_extent = subject.map_extent,
	            organization_ids = subject.organization_ids;
	
	        var _clusters = _slicedToArray(clusters, 1),
	            cluster = _clusters[0];
	
	        _config2.default.token(token);
	        _config2.default.user(fio);
	        _config2.default.userId(id);
	        _config2.default.cluster(cluster ? cluster : null);
	        _config2.default.clusters(clusters);
	        _config2.default.role(role_id);
	        _config2.default.organization(department_id);
	        _config2.default.orgs(organization_ids.map(function (id) {
	            return +id;
	        }));
	        _config2.default.mapExtent(map_extent.map(function (number) {
	            return +number;
	        }));
	
	        (0, _jquery2.default)(document.body).on('click', '.logout-link', logout);
	
	        delete subject.token;
	        delete subject.res;
	        delete subject.resText;
	
	        return { subject: subject, token: _config2.default.token() };
	    });
	};
	
	exports.default = fn(window.usePhoneAuthentication ? authByPhone : authByLogin);
	
	
	function auth(_ref3) {
	    var login = _ref3.login,
	        password = _ref3.password;
	
	    var cbAuth = (0, _promisify.requestify)(new _auth2.default({ login: login, password: password }).save());
	    var msAuth = (0, _promisify.requestify)(_jquery2.default.ajax({
	        url: '/auth',
	        data: { login: login, password: password },
	        method: 'POST'
	    }));
	
	    return Promise.all([cbAuth, msAuth]).then(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 1),
	            cbResp /*, msResp*/ = _ref5[0];
	
	        return cbResp;
	    })
	    // cb or ms fail -> 
	    //   cb ok -> look at ms
	    //   cb fail -> fail, take cb message
	    .catch(function () {
	        return cbAuth.then(function () {
	            return msAuth;
	        });
	    });
	}
	
	function authByLogin() {
	    var form = new _form2.default({
	        template: 'jst/auth.login.form'
	    });
	
	    return (0, _popups.ask)(form.bind(new _auth2.default()), 'auth::modal - title', 'actions::sign in', 'actions::cancel', function (form) {
	        form.enable(false);
	
	        var _form$model$toJSON = form.model.toJSON(),
	            login = _form$model$toJSON.login,
	            secretString = _form$model$toJSON.secretString;
	
	        var process = auth({ login: login, password: secretString });
	        process.then(function () {
	            return form.enable();
	        }, function () {
	            return form.enable();
	        });
	        return process;
	    });
	}
	
	function authByPhone() {
	    firebase.initializeApp({
	        apiKey: "AIzaSyB9XK7kDbcn1YuUTgCg_2QXADDA9uXB4kE",
	        authDomain: "fsminformkz.firebaseapp.com",
	        databaseURL: "https://fsminformkz.firebaseio.com",
	        projectId: "fsminformkz",
	        storageBucket: "fsminformkz.appspot.com",
	        messagingSenderId: "694779413752",
	        appId: "1:694779413752:web:68f82a84bfd5db43ab270d"
	    });
	
	    return (0, _popups.ask)(new _form2.default({
	        template: 'jst/auth.phone.form'
	    }).bind(new _auth2.default()), 'auth::modal - title', 'Получить код', undefined, function (form) {
	        return new Promise(function (resolve, reject) {
	            var btn = (0, _jquery2.default)('#recaptcha')[0];
	            console.log(btn);
	            var verifier = new firebase.auth.RecaptchaVerifier(btn, {
	                size: 'invisible',
	                callback: function callback(response) {
	                    // todo captcha fail
	                    console.log('got success recaptcha callback');
	                    firebase.auth().signInWithPhoneNumber('+7' + form.model.get('phone'), verifier).then(resolve);
	                }
	            });
	            verifier.render().then(function (widgetId) {
	                if (typeof grecaptcha !== 'undefined') {
	                    grecaptcha.reset(widgetId);
	                    grecaptcha.execute(widgetId);
	                }
	            });
	        });
	    }).then(function (confirmationResult) {
	        return (0, _popups.ask)(new _form2.default({
	            template: 'jst/auth.code.form'
	        }).bind(new _auth2.default()), 'auth::modal - title', 'Подтвердить', undefined, function (form) {
	            return confirmationResult.confirm(form.model.get('code')).then(function (_ref6) {
	                var user = _ref6.user,
	                    attrs = _objectWithoutProperties(_ref6, ['user']);
	
	                console.log(attrs, user);return user;
	            }).then(function (_ref7) {
	                var phoneNumber = _ref7.phoneNumber,
	                    password = _ref7.uid;
	                return {
	                    login: phoneNumber.replace('+', ''),
	                    password: password
	                };
	            }).then(function (_ref8) {
	                var login = _ref8.login,
	                    password = _ref8.password;
	                return (0, _promisify.promisify)(new _checklogin2.default({ login: login }).save()).then(function (response) {
	                    console.log(response);
	                    if (response.check)
	                        // todo organizationId
	                        return (0, _promisify.promisify)(new _user2.default({
	                            login: login,
	                            paswd: password,
	                            fio: 'User_' + login,
	                            email: 'User_' + login + '@t.t',
	                            phone: '+' + login,
	                            organization_id: 3,
	                            role_id: 6
	                        }).save()).then(function () {
	                            return {
	                                login: login,
	                                password: password
	                            };
	                        });
	
	                    return { login: login, password: password };
	                });
	            }).then(auth);
	        });
	    });
	}
	
	function logout() {
	    _config2.default.token('');
	    _config2.default.user('');
	    _config2.default.userId('');
	    _config2.default.role('');
	    _config2.default.organization('');
	
	    // Logout from MapSurfer
	    _jquery2.default.get('/logout').always(function () {
	        return location.assign('/');
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'authentication',
	
	    defaults: {
	        login: '',
	        secretString: '',
	        phone: undefined,
	        code: undefined,
	        action: 'post'
	    }
	
	});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'users/check-login',
	
	    defaults: {
	        login: ''
	    }
	
	});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _fields = __webpack_require__(27);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _arrays = __webpack_require__(24);
	
	var _field3 = __webpack_require__(57);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        this.gather = options.gather || this.gather;
	
	        _view2.default.prototype.initialize.apply(this, arguments);
	    },
	
	
	    events: {
	
	        'keyup textarea': function keyupTextarea(e) {
	            if (13 === e.keyCode) e.stopPropagation();
	        }
	
	    },
	
	    validate: function validate() {
	        var _this = this;
	
	        var fields = this.options.fields;
	
	
	        var fl = function fl(fields) {
	            return (0, _field3.flatify)(fields).filter(function (field) {
	                return field.default_value != undefined && field.default_value != '';
	            });
	        };
	        var defvals = (0, _arrays.hashify)(fl(new _fields2.default(fields instanceof _collection2.default ? fields.toJSON() : fields).nonSystem()), function (_ref) {
	            var translit = _ref.translit,
	                format = _ref.format,
	                default_value = _ref.default_value;
	            return [translit, format === 'bool' ? default_value === 'true' : default_value];
	        });
	
	        var take = function take(_ref2) {
	            var _ref3 = _toArray(_ref2),
	                prop = _ref3[0],
	                rest = _ref3.slice(1);
	
	            var here = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.model.get('fields') || {};
	
	            if (here == undefined) return here; // null -> null, undefined -> undefined
	
	            if (!prop) return (typeof here === 'undefined' ? 'undefined' : _typeof(here)) == 'object' ? here.values // Data-Table with values
	            : here; // Any other type of Custom field
	
	            if (!here[prop]) return undefined;
	
	            return here instanceof Array ? take(rest, here[prop]) // Composite[index]
	            : take(rest, here[prop].value); // Any other type of Custom field
	        };
	
	        var val = function val(name) {
	            var path = name.split(/\.|\[|\]/).map(function (s) {
	                return _field2.default.decodeString(s);
	            }).filter(function (s) {
	                return s.length;
	            });
	            var value = take(path);
	            return value ? value : path.length === 1 ? _this.model.get(name) : value;
	        };
	
	        var messages = [].concat(_toConsumableArray(this.$('[required]:not([disabled]):visible'))).map(function (el) {
	            return _this.$(el);
	        }).filter(function ($el) {
	            return $el.closest('.disabled').length == 0 && $el.closest('[disabled]').length == 0;
	        }).map(function ($el) {
	            var path = $el.attr('name');
	
	            var _path$split$reverse = path.split('.').reverse(),
	                _path$split$reverse2 = _slicedToArray(_path$split$reverse, 1),
	                encodedTranslit = _path$split$reverse2[0];
	
	            var translit = _field2.default.decodeString(encodedTranslit);
	
	            var value = val(path);
	            return value !== undefined ? [value, $el] : [defvals[translit], $el];
	        }).filter(function (_ref4) {
	            var _ref5 = _slicedToArray(_ref4, 1),
	                value = _ref5[0];
	
	            return value == undefined || value === '' || value instanceof Array && value.length === 0 || typeof value === 'boolean' && !value;
	        }).map(function (_ref6) {
	            var _ref7 = _slicedToArray(_ref6, 2),
	                value = _ref7[0],
	                $el = _ref7[1];
	
	            return [ifn('forms::required field'), $el[0], value];
	        });
	
	        return {
	            result: messages.length === 0,
	            messages: messages
	        };
	    },
	    commit: function commit() {
	        this.originalModel = this.model.clone();
	    },
	    rollback: function rollback() {
	        this.model.set(this.originalModel.toJSON());
	    },
	    diff: function diff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.model ? this.model.diff(this.originalModel, options) : [];
	    },
	    hasDiff: function hasDiff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.diff(options).length > 0;
	    }
	});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _handlebars = __webpack_require__(44);
	
	var _handlebars2 = _interopRequireDefault(_handlebars);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone3 = __webpack_require__(23);
	
	var _backbone4 = _interopRequireDefault(_backbone3);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _trigger = __webpack_require__(145);
	
	var _trigger2 = _interopRequireDefault(_trigger);
	
	var _cf = __webpack_require__(71);
	
	var _cf2 = _interopRequireDefault(_cf);
	
	var _date = __webpack_require__(29);
	
	var _handlebars3 = __webpack_require__(45);
	
	var _promisify = __webpack_require__(19);
	
	var _arrays = __webpack_require__(24);
	
	var _loader = __webpack_require__(20);
	
	var _messages = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var partialsRegistered = false;
	
	var View = _backbone2.default.Epoxy.View.extend({
	    initialize: function initialize(options) {
	        var _this = this;
	
	        options = options || {};
	
	        this.template = options.template || this.template;
	        this.tpl_ = options.tpl;
	        this.messages = [];
	        this.rendered = false;
	        this.holds = {};
	
	        if (options.style) this.el.style = options.style;
	
	        this.nests = options.nests || this.nests || {};
	        this.ds = options.ds || this.ds || {};
	        if (options.onBind) this.onBind = options.onBind;
	        if (options.onUnBind) this.onUnBind = options.onUnBind;
	        if (options.serialize) this.serialize = options.serialize;
	        if (options.focus) this.focus = options.focus;
	        if (options.open) this.open = options.open;
	        if (options.afterRender) this.afterRender = options.afterRender;
	
	        this.renderCount_ = 0;
	        this.lastRendering_ = Promise.resolve();
	
	        // todo: bug here
	        this.options = options;
	        var parentView = this.options[_handlebars3.constants.PARENT_VIEW];
	        var injectedName = this.options[_handlebars3.constants.INJECTED_NAME];
	
	        if (parentView) this.listenTo(this, 'all', function (event) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }
	
	            return event.split(' ').forEach(function (eventName) {
	                if (eventName[0] === ':') return parentView.trigger.apply(parentView, [eventName].concat(args));
	
	                if (eventName[0].toUpperCase() === eventName[0]) return parentView.trigger.apply(parentView, [eventName].concat(args));
	
	                if (injectedName) parentView.trigger.apply(parentView, [injectedName + ':' + eventName].concat(args));
	            });
	        });
	
	        // *** automatic event handler binding *** 
	        // based on props [View.event( 'event:name' )]
	        // of view
	
	        // scan events key in prototype and passed options;
	        var eventNames = [];
	        for (var potentialEventKey in this) {
	            if (potentialEventKey.startsWith(':')) eventNames.push(potentialEventKey);
	        }for (var potentialEventName in options) {
	            if (potentialEventName.startsWith(':')) eventNames.push(potentialEventName);
	        }eventNames.map(function (eventKey) {
	            return [eventKey.substring(1),
	            // options' priority is higher
	            options[eventKey] || _this[eventKey]];
	        }).forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                eventToListen = _ref2[0],
	                methodToCall = _ref2[1];
	
	            return _this.listenTo(_this, eventToListen, function () {
	                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                    args[_key2] = arguments[_key2];
	                }
	
	                return methodToCall.call.apply(methodToCall, [_this].concat(args));
	            });
	        });
	
	        // *** end of automatic event handler binding ***
	
	        _backbone2.default.Epoxy.View.prototype.initialize.call(this, options);
	    },
	
	
	    events: {
	        'click [data-click-trigger]': function clickDataClickTrigger(e) {
	            var holds = this.holds[e.currentTarget.dataset.clickTrigger];
	            if (!holds) return;
	
	            e.stopPropagation();
	
	            var _holds = _toArray(holds),
	                eventName = _holds[0],
	                args = _holds.slice(1);
	
	            this.trigger.apply(this, [eventName].concat(_toConsumableArray(args), [e]));
	        }
	    },
	
	    bindingFilters: {
	        is: function is(value) {
	            for (var _len3 = arguments.length, values = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	                values[_key3 - 1] = arguments[_key3];
	            }
	
	            return values.some(function (possible) {
	                return value === possible;
	            });
	        },
	        isnt: function isnt(value) {
	            for (var _len4 = arguments.length, values = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	                values[_key4 - 1] = arguments[_key4];
	            }
	
	            return values.every(function (possible) {
	                return value !== possible;
	            });
	        },
	        has: function has(value) {
	            return undefined !== value;
	        },
	        absent: function absent(value) {
	            return undefined === value;
	        },
	        some: function some() {
	            for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	                values[_key5] = arguments[_key5];
	            }
	
	            return values.some(function (value) {
	                return value !== undefined && value !== null;
	            });
	        },
	        not: function not(value) {
	            switch (value) {
	                case 't':
	                    return 'f';
	                case 'f':
	                    return 't';
	                case true:
	                    return false;
	                case false:
	                    return true;
	                default:
	                    return !value;
	            }
	        },
	
	
	        arrayProp: {
	            get: function get(array, keyName, keyValue, propName) {
	                var index = array.findIndex(function (el) {
	                    return el[keyName] == keyValue;
	                });
	                if (index === -1 || !array[index]) return [undefined, meta];
	
	                var meta = { index: index, propName: propName, array: array };
	
	                return [array[index][propName], meta];
	            },
	            set: function set(_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    value = _ref4[0],
	                    meta = _ref4[1];
	
	                var index = meta.index,
	                    propName = meta.propName,
	                    array = meta.array;
	
	                var result = [].concat(_toConsumableArray(array));
	                return result[index][propName] = value, result;
	            }
	        },
	
	        prepareCf: {
	
	            // from model to binder
	            get: function get(fields, field_id, translit, format, default_value, min_count, table_id, multiselect, amountEditable, propName, path, index, attachments) {
	                translit = _field2.default.decodeString(translit);
	
	                var meta = {
	                    fields: fields || {},
	                    field_id: +field_id,
	                    translit: translit, format: format, default_value: default_value,
	                    min_count: +min_count,
	                    table_id: +table_id,
	                    multiselect: multiselect, amountEditable: amountEditable, propName: propName,
	                    index: index
	                };
	                if (path) meta.path = path.split('|').map(function (str) {
	                    return str.split('=');
	                }).map(function (_ref5) {
	                    var _ref6 = _slicedToArray(_ref5, 4),
	                        parentId = _ref6[0],
	                        parentTranslit = _ref6[1],
	                        index = _ref6[2],
	                        minCount = _ref6[3];
	
	                    return [+parentId, _field2.default.decodeString(parentTranslit), +index, +minCount];
	                }).reduce(function (result, arr) {
	                    return [].concat(_toConsumableArray(result), _toConsumableArray(arr));
	                }, []);else meta.path = [];
	
	                var nest = godown(meta.fields, meta.path);
	
	                var value = nest[translit] && 'value' in nest[translit] ? nest[translit].value !== '' ? nest[translit].value : null : format === 'composite' || format === 'file' ? [] : undefined;
	
	                if (format !== 'dataTableObjects') if (value === undefined) {
	                    if (typeof default_value !== 'string') return [null, meta];
	
	                    var parsed = Base64.decode(default_value);
	                    if (parsed === 'null') return [null, meta];else if (parsed === '') return [null, meta];else if (parsed === 'true') return [true, meta];else if (parsed === 'false') return [false, meta];else return [parsed, meta];
	                } else return [value, meta];
	
	                if (!value) return [null, meta];
	
	                if (value.values && value.values.length && value.table_id == table_id) return multiselect === 't' ? [value.values, meta] : [propName ? value.values[0][propName] : value.values[0], meta];else return [null, meta];
	            },
	
	
	            // from binder to model
	            set: function set(_ref7) {
	                var _ref8 = _slicedToArray(_ref7, 2),
	                    value = _ref8[0],
	                    meta = _ref8[1];
	
	                var format = meta.format,
	                    fields = meta.fields,
	                    field_id = meta.field_id,
	                    translit = meta.translit,
	                    table_id = meta.table_id,
	                    multiselect = meta.multiselect,
	                    propName = meta.propName,
	                    path = meta.path;
	
	
	                var nest = godown(fields, path);
	                var result = nest && nest[translit] ? _extends({}, nest[translit]) : { field_id: field_id };
	
	                if (result.value != null && _typeof(result.value) === 'object') result.value = _extends({}, result.value);
	
	                if (result.value && result.value.values) if (result.value.values instanceof Array) result.value.values = result.value.values.map(function (item) {
	                    return item != null && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' ? _extends({}, item) : item;
	                });
	
	                if (format === 'dataTableObjects') {
	                    if (propName) {
	                        if (result.value && result.value.values && result.value.values[0]) {
	                            result.value.values[0][propName] = value;
	                            if (!multiselect || multiselect === 'f') result.value.values.splice(1, result.value.values.length - 1);
	                        } else
	                            // impossible case, do nothing
	                            ;
	                        // result.value = {
	                        //     table_id,
	                        //     values: [{
	                        //         [propName]: value
	                        //     }]
	                        // };
	
	                    } else if (value == null) result.value = null;else if (value instanceof Array) {
	                            var prev = (0, _arrays.hashify)(result.value && result.value.values || [], function (item) {
	                                return [item.object_id, item];
	                            });
	                            result.value = {
	                                table_id: table_id,
	                                values: value.map(function (item) {
	                                    return [item, prev[item.object_id]];
	                                }).map(function (_ref9) {
	                                    var _ref10 = _slicedToArray(_ref9, 2),
	                                        item = _ref10[0],
	                                        prev = _ref10[1];
	
	                                    return {
	                                        object_id: +item.object_id,
	                                        // preserve title from old objects
	                                        title: prev ? prev.title : item.name,
	                                        // preserve num from old objects if not set
	                                        num: prev ? item.num !== undefined ? item.num : prev.num : item.num || null
	                                    };
	                                })
	                            };
	                        } else result.value = {
	                            table_id: table_id,
	                            values: [{
	                                // hack, better to just pass value here itself
	                                object_id: value.id,
	                                title: value.title,
	                                num: null
	                            }]
	                        };
	                } else if (propName) {
	                    if (result.value == null || _typeof(result.value) != 'object') result.value = _defineProperty({}, propName, value);else result.value[propName] = value;
	                } else if (value == null) result.value = null;else result.value = value;
	
	                var finalize = function finalize(json, _ref11) {
	                    var _ref12 = _toArray(_ref11),
	                        id = _ref12[0],
	                        translit = _ref12[1],
	                        index = _ref12[2],
	                        minCount = _ref12[3],
	                        rest = _ref12.slice(4);
	
	                    if (!translit) return _extends({}, json, _defineProperty({}, meta.translit, result));
	
	                    // clone instances array
	                    var instances = [].concat(_toConsumableArray(json[translit] && json[translit].value || []));
	                    // and add required amount of instances
	                    while (instances.length < Math.max(index + 1, minCount)) {
	                        instances.push({});
	                    } // recursively proceed target instance and replace one with result of proceeding
	                    instances[index] = finalize(instances[index] || {}, rest);
	
	                    return _extends({}, json, _defineProperty({}, translit, {
	                        field_id: id,
	                        value: instances
	                    }));
	                };
	
	                return {
	                    fields: finalize(fields, path)
	                };
	            }
	        }
	
	    },
	
	    bindingHandlers: {
	
	        tfCheckbox: {
	            set: function set($el, value) {
	                $el[0].checked = 't' === value;
	            },
	            get: function get($el, value, event) {
	                return $el[0].checked ? 't' : 'f';
	            }
	        },
	
	        trueFalseCheckbox: {
	            set: function set($el, value) {
	                $el[0].checked = 'true' === value || true === value;
	            },
	            get: function get($el, value, event) {
	                return $el[0].checked;
	            }
	        },
	
	        float: {
	            set: function set($el, value) {
	                if (!(value instanceof Array)) $el.val(value != undefined ? value : '');else $el.val(value[0] != undefined ? value[0] : '');
	            },
	            get: function get($el, prevValue /*, event */) {
	                var parsed = parseFloat($el.val());
	                var value = parsed || parsed == 0 ? parsed : null;
	
	                if (!(prevValue instanceof Array)) return value;
	
	                var _prevValue = _slicedToArray(prevValue, 2),
	                    prev = _prevValue[0],
	                    meta = _prevValue[1];
	
	                return [value, meta];
	            }
	        },
	
	        readonly: function readonly($el, value) {
	            if (!(value instanceof Array)) $el.prop('readonly', !value);else $el.prop('readonly', !value[0]);
	        },
	
	
	        date: {
	            set: function set($element, timestamp) {
	                $element.val(timestamp ? (0, _date.fmt)(timestamp, 'YYYY-MM-DD') : '');
	            },
	            get: function get($element) {
	                if (!$element.val()) return null;
	
	                var date = (0, _date.parseYYYYMMDD)($element.val());
	                if (!date) return date;
	
	                return date.setHours(0), date.setMinutes(0), date.setSeconds(0), (0, _date.unixts)(date);
	            }
	        },
	
	        days: {
	            set: function set($el, value) {
	                if (!value) return $el.val('');
	
	                $el.val(value / 86400 | 0);
	            },
	            get: function get($el, value, event) {
	                var newDays = +$el.val() || 0,
	                    oldDays = value / 86400 | 0,
	                    oldHours = (value - oldDays * 86400) / 3600 | 0,
	                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
	                    oldSeconds = value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60 || 0;
	
	                var newValue = newDays * 86400 + oldHours * 3600 + oldMinutes * 60 + oldSeconds;
	                if (newValue < 0) return $el.val(0), null;
	
	                return newValue || null;
	            }
	        },
	
	        hours: {
	            set: function set($el, value) {
	                if (!value) return $el.val('');
	
	                var oldDays = value / 86400 | 0,
	                    oldHours = (value - oldDays * 86400) / 3600 | 0;
	
	                $el.val(oldHours);
	            },
	            get: function get($el, value, event) {
	                var newHours = +$el.val() || 0,
	                    oldDays = value / 86400 | 0,
	                    oldHours = (value - oldDays * 86400) / 3600 | 0,
	                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
	                    oldSeconds = value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60 || 0;
	
	                var newValue = oldDays * 86400 + newHours * 3600 + oldMinutes * 60 + oldSeconds;
	                if (newValue < 0) return $el.val(0), null;
	
	                return newValue || null;
	            }
	        },
	
	        minutes: {
	            set: function set($el, value) {
	                if (!value) return $el.val('');
	
	                var oldDays = value / 86400 | 0,
	                    oldHours = (value - oldDays * 86400) / 3600 | 0,
	                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0;
	
	                $el.val(oldMinutes);
	            },
	            get: function get($el, value, event) {
	                var newMinutes = +$el.val() || 0,
	                    oldDays = value / 86400 | 0,
	                    oldHours = (value - oldDays * 86400) / 3600 | 0,
	                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
	                    oldSeconds = value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60 || 0;
	
	                var newValue = oldDays * 86400 + oldHours * 3600 + newMinutes * 60 + oldSeconds;
	                if (newValue < 0) return $el.val(0), null;
	
	                return newValue || null;
	            }
	        },
	
	        metaString: {
	
	            set: _cf2.default.setMetaString,
	
	            get: _cf2.default.getMetaString
	
	        },
	
	        metaBool: {
	
	            set: _cf2.default.setMetaBool,
	
	            get: _cf2.default.getMetaBool
	
	        },
	
	        metaNumber: {
	
	            set: _cf2.default.setMetaString,
	
	            get: _cf2.default.getMetaNumber
	
	        },
	
	        metaDate: {
	
	            set: _cf2.default.setMetaDate,
	
	            get: _cf2.default.getMetaDate
	
	        },
	
	        metaDateOnlyString: {
	
	            set: _cf2.default.setMetaDate,
	
	            get: _cf2.default.getMetaDateOnlyString
	
	        },
	
	        metaTime: {
	
	            set: _cf2.default.setMetaTime,
	
	            get: _cf2.default.getMetaTime
	
	        },
	
	        metaDataTableObjects: {
	
	            set: _cf2.default.setMetaDataTableObjects
	
	        },
	
	        metaFile: {
	
	            set: _cf2.default.setMetaFile
	
	        }
	
	    },
	
	    tpl: function tpl() {
	        if (this.tpl_) return this.tpl_;
	
	        if (!partialsRegistered) {
	            registerPartials(global.partials, []);
	            partialsRegistered = true;
	        }
	
	        if (!this.template) this.template = 'jst/default.view';
	
	        var template = this.template.replace('jst/', '').replaceAll('/', '.').split('.').reduce(function (root, here) {
	            return root[here];
	        }, global);
	
	        if (!template) return Promise.reject(this.template);
	
	        return this.tpl_ = Promise.resolve(_handlebars2.default.template(template));
	    },
	    html: function html(context, meta) {
	        var _this2 = this;
	
	        return Promise.all([this.tpl(), _i18n2.default]).then(function (_ref13) {
	            var _data;
	
	            var _ref14 = _slicedToArray(_ref13, 1),
	                templateFn = _ref14[0];
	
	            var passedPartialBlockHelper = _this2.options[_handlebars3.constants.PASSED_PARTIAL_BLOCK_HELPER];
	
	            var options = { data: (_data = {
	                    options: _this2.options,
	                    not: _handlebars3.constants.NOT,
	                    or: _handlebars3.constants.OR,
	                    and: _handlebars3.constants.AND,
	                    eq: _handlebars3.constants.EQ,
	                    eqq: _handlebars3.constants.EQQ,
	                    less: _handlebars3.constants.LESS,
	                    more: _handlebars3.constants.MORE,
	                    t: _handlebars3.constants.T,
	                    f: _handlebars3.constants.F,
	                    begin: _handlebars3.constants.BEGIN,
	                    end: _handlebars3.constants.END,
	                    currentUser: {
	                        role: _config2.default.role(),
	                        name: _config2.default.user(),
	                        id: +_config2.default.userId()
	                    },
	                    currentOrganization: _config2.default.organization(),
	                    chiefAdmin: 8 === +_config2.default.role(),
	                    chiefInspector: 12 === +_config2.default.role(),
	                    adminOfOrg: 10 === +_config2.default.role(),
	                    inspectorOfOrg: 11 === +_config2.default.role(),
	                    adminOfCluster: 5 === +_config2.default.role(),
	                    inspectorOfCluster: 4 === +_config2.default.role(),
	                    admin: 8 === +_config2.default.role() || 12 == +_config2.default.role(),
	                    orgAdmin: 10 === +_config2.default.role() || 11 == +_config2.default.role(),
	                    orgUser: 7 === +_config2.default.role(),
	                    clusters: _config2.default.clusters(),
	                    orgs: _config2.default.orgs(),
	                    timezones: _config2.default.timezones(),
	                    model: _this2.model
	                }, _defineProperty(_data, _handlebars3.constants.BODY_INJECTOR, _this2.options[_handlebars3.constants.BODY_INJECTOR]), _defineProperty(_data, _handlebars3.constants.PARENT_VIEW, _this2), _defineProperty(_data, '___bodycall___', passedPartialBlockHelper ? function (options) {
	                    return new _handlebars2.default.SafeString(passedPartialBlockHelper(this, options));
	                } : undefined), _defineProperty(_data, 'meta', meta), _data) };
	
	            if (context.capabilities) options.data.caps = context.capabilities;
	
	            var html = templateFn(context, options);
	
	            return html;
	        });
	    },
	    serialize: function serialize() {},
	    render: function render(contextBase, onFinalize) {
	        var _this3 = this;
	
	        var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { views: {} };
	
	        if (!onFinalize) onFinalize = new _trigger2.default().fire().onFire;
	
	        var finalizeSubviews = new _trigger2.default();
	        meta.finalizeSubviews = finalizeSubviews.onFire;
	
	        var renderCount = ++this.renderCount_,
	            lastRendering = this.afterRendering();
	
	        // save focused element in order
	        // to restore focus later        
	
	        var _$ = this.$(':focus'),
	            _$2 = _slicedToArray(_$, 1),
	            focused = _$2[0];
	
	        if (focused) focused.dataset.cursorPosition = focused.selectionStart;
	
	        (0, _loader.requestBegins)();
	
	        this.undelegateEvents();
	
	        var dataSourcesContext = Promise.resolve({});
	        if (this.ds) {
	            dataSourcesContext = Object.keys(this.ds).map(function (name) {
	                var Class = _this3.ds[name],
	                    dataSource = new Class([]),
	                    url = dataSource.getUrl();
	
	                if (!meta[url]) meta[url] = dataSource.fetch().then(function (_ref15) {
	                    var _ref16 = _slicedToArray(_ref15, 1),
	                        ds = _ref16[0];
	
	                    return ds;
	                });
	
	                return meta[url].then(function (data) {
	                    return { name: name, data: data };
	                });
	            });
	
	            dataSourcesContext = Promise.all(dataSourcesContext).then(function (ds) {
	                return ds.reduce(function (hash, _ref17) {
	                    var name = _ref17.name,
	                        data = _ref17.data;
	                    return hash[name] = data, hash;
	                }, {});
	            });
	        }
	
	        var parentContext = (0, _promisify.promisify)(contextBase || {}).then(function (context) {
	            return Object.create(context);
	        })
	        // extend by data sources
	        .then(function (context) {
	            return dataSourcesContext.then(function (dsContext) {
	                return _underscore2.default.extend(context, dsContext);
	            });
	        });
	
	        var localContext = this.serialize.toString().match(/^function\s?\(\)/) ? (0, _promisify.promisify)(this.serialize()) : parentContext.then(function (context) {
	            return (0, _promisify.promisify)(_this3.serialize(context));
	        });
	
	        var contextify = Promise.all([parentContext, localContext]).then(function (_ref18) {
	            var _ref19 = _slicedToArray(_ref18, 2),
	                parentContext = _ref19[0],
	                localContext = _ref19[1];
	
	            if (localContext === parentContext) localContext = {};
	
	            if (localContext === undefined) localContext = {};
	
	            return _underscore2.default.extend(parentContext, localContext);
	        }).then(function (context) {
	            return _this3.lastContext = context;
	        });
	
	        var htmlify = contextify.then(function (context) {
	            return _this3.html(context, meta);
	        });
	
	        var subviewsRendering = htmlify.then(function () {
	            // must be after htmlify done
	            var embeddedViewsImporting = Object.keys(meta.views).map(function (id) {
	                return meta.views[id];
	            });
	
	            var embeddedViewsRendering = embeddedViewsImporting.map(function (importing) {
	                return importing.then(function (_ref20) {
	                    var rendering = _ref20.rendering;
	                    return rendering;
	                });
	            });
	            var embeddedViewsPreparing = embeddedViewsImporting.map(function (importing) {
	                return importing.then(function (_ref21) {
	                    var prepared = _ref21.prepared;
	                    return prepared;
	                });
	            });
	
	            var nestedViewsRendering = _this3.subviews(function (subview) {
	                return subview.render(contextify, finalizeSubviews.onFire, meta);
	            });
	            var nestedViewsPreparing = nestedViewsRendering.map(function (rendering) {
	                return rendering.prepared;
	            });
	
	            var renderingArray = [].concat(_toConsumableArray(embeddedViewsRendering), _toConsumableArray(nestedViewsRendering));
	            var preparingArray = [].concat(_toConsumableArray(embeddedViewsPreparing), _toConsumableArray(nestedViewsPreparing));
	
	            var rendering = Promise.all(renderingArray);
	            var prepared = Promise.all(preparingArray);
	
	            return { rendering: rendering, prepared: prepared };
	        });
	
	        var subviewsRendered = subviewsRendering.then(function (_ref22) {
	            var rendering = _ref22.rendering;
	            return rendering;
	        });
	        var subviewsPrepared = subviewsRendering.then(function (_ref23) {
	            var prepared = _ref23.prepared;
	            return prepared;
	        });
	
	        var rendering = this.lastRendering_ = Promise.all([htmlify, subviewsPrepared])
	        // queue renders, ignore previous errors
	        .then(function () {
	            return lastRendering;
	        }).then(function (embeddedViewsLoading) {
	            return Promise.all([contextify, htmlify].concat(_toConsumableArray(Object.keys(meta.views).map(function (id) {
	                return meta.views[id];
	            }))));
	        }).then(function (_ref24) {
	            var _ref25 = _toArray(_ref24),
	                context = _ref25[0],
	                html = _ref25[1],
	                views = _ref25.slice(2);
	
	            return onFinalize(function () {
	                // interrupt current rendering
	                if (renderCount !== _this3.renderCount_) throw new Error('rendering cancelled');
	
	                if (_this3.rendered) _this3.detachSubviews();
	                _this3.performRender(html, context, !_this3.rendered);
	                if (_this3.model) _this3.applyBindings();
	                _this3.attachSubviews();
	                views.forEach(function (_ref26) {
	                    var id = _ref26.id,
	                        view = _ref26.view;
	                    return _this3.$el.find('#' + id).replaceWith(view.el);
	                });
	
	                finalizeSubviews.fire();
	            });
	        }).then(function () {
	            return subviewsRendered;
	        }).then(function () {
	            return contextify;
	        }).then(function (context) {
	            return _this3.afterRender(context, !_this3.rendered);
	        }).then(function () {
	            return _this3;
	        });
	
	        rendering.then(_loader.requestEnds, _loader.requestEnds);
	        rendering.then(function () {
	            _this3.delegateEvents();
	            (0, _messages.restore)(_this3);
	            if (focused) _this3.restoreFocus(focused);
	            _this3.rendered = true;
	            _this3.trigger('render');
	        });
	
	        rendering.catch(function (ex) {
	            if (String(ex) !== 'Error: rendering cancelled') console.error(ex, _this3.el);else console.log(String(ex), _this3.el);
	            finalizeSubviews.cancel(ex);
	        });
	
	        return rendering.view = this, rendering.prepared = Promise.all([htmlify, subviewsPrepared]), rendering;
	    },
	    afterRendering: function afterRendering() {
	        return this.lastRendering_.catch(function () {});
	    },
	    afterSuccesfulRendering: function afterSuccesfulRendering() {
	        return this.lastRendering_;
	    },
	    performRender: function performRender(bodyString, context, firstTime, meta) {
	        this.$el.html(bodyString);
	    },
	    afterRender: function afterRender() {},
	    bind: function bind(model) {
	        var _this4 = this;
	
	        var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	            return _this4.render();
	        };
	
	        if (!!model) if (!(model instanceof _model2.default)) model = new _model2.default(model);
	
	        // bind recursively
	        recBind(this);
	        onBindDone(this);
	        // messages
	        (0, _messages.clear)(this);
	
	        var rendering = render();
	        var binding = rendering.then(function () {
	            return _this4;
	        });
	        return binding.view = this, binding.prepared = rendering.prepared, binding;
	
	        function recBind(view) {
	            view.previousModel = view.model;
	
	            if (view.model && model !== view.model) view.stopListening(view.model);
	
	            if (model && model !== view.model) view.originalModel = model.clone();else if (!model) view.originalModel = undefined;
	
	            view.model = model;
	
	            view.subviews(recBind);
	            //embeddedViews( view, recBind );
	        }
	
	        function onBindDone(view) {
	            if (view.previousModel) view.onUnBind(view.previousModel);
	            if (model) view.onBind(model, view.previousModel);
	
	            view.subviews(onBindDone);
	            //embeddedViews( view, onBindDone );
	        }
	    },
	    unbind: function unbind() {
	        var _this5 = this;
	
	        var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	            return _this5.render();
	        };
	
	        return this.bind(undefined, render);
	    },
	    onBind: function onBind(model) {},
	    onUnBind: function onUnBind() {},
	    final: function final() {
	        return this.subviews().length === 0;
	    },
	    subviews: function subviews(callback) {
	        var _this6 = this;
	
	        return Object.keys(this.nests).map(function (selector) {
	            var subview = _this6.subview(selector);
	            if ('function' === typeof callback) return callback.call(null, subview, selector);
	
	            return subview;
	        });
	    },
	    subview: function subview(nestSelector) {
	        var subview = this.nests[nestSelector];
	        if ('function' === typeof subview) this.nests[nestSelector] = subview = new subview();
	        if ('string' === typeof subview) this.nests[nestSelector] = subview = new View({ template: subview });
	
	        return subview;
	    },
	    detachSubviews: function detachSubviews() {
	        this.subviews().forEach(function (view) {
	            return view.$el.detach();
	        });
	        embeddedViews(this, function (embeddedView) {
	            return embeddedView.$el.detach();
	        });
	    },
	    attachSubviews: function attachSubviews() {
	        var _this7 = this;
	
	        this.subviews(function (view, selector) {
	            return _this7.$(selector).append(view.$el);
	        });
	    },
	    remove: function remove() {
	        if (this.rendered) this.subviews().forEach(function (view) {
	            return view.remove();
	        });
	        _backbone2.default.Epoxy.View.prototype.remove.call(this);
	    },
	    focus: function focus() {
	        this.$el.find('input, select, textarea').filter(':visible:enabled').eq(0).focus();
	
	        return this;
	    },
	    restoreFocus: function restoreFocus(focused) {
	        var _ref27 = focused.id ? this.$('#' + focused.id) : this.$('[data-id="' + focused.dataset.id + '"]'),
	            _ref28 = _slicedToArray(_ref27, 1),
	            el = _ref28[0];
	
	        if (!el) return;
	
	        var len = (0, _jquery2.default)(el).val().length;
	        var pos = +focused.dataset.cursorPosition || len;
	
	        el.selectionStart = pos;
	        el.selectionEnd = pos;
	
	        // Set cursor on focus
	        el.focus();
	    },
	    enable: function enable() {
	        var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { restoreFocus: false };
	
	        // treat the case enable( {options} )
	        if ('object' === (typeof on === 'undefined' ? 'undefined' : _typeof(on))) {
	            options = on;
	            on = true;
	        }
	
	        if (!on && !this.disabled) {
	            this.$focused = this.$el.find(':focus');
	        }
	
	        var $forms = this.$el.is('fieldset') ? this.$el : this.$el.add(this.$('fieldset'));
	        enableEl($forms, on);
	
	        if (on) {
	            if (this.$focused && options.restoreFocus) this.$focused.focus();
	
	            this.$focused = null;
	        }
	
	        return this;
	    },
	    disable: function disable() {
	        var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        return this.enable(!on);
	    },
	    disabled: function disabled() {
	        return this.$el.hasClass('disabled') || this.$el.attr('disabled') || this.$el.closest('.disabled').length > 0 || this.$el.closest('[disabled]').length > 0;
	    }
	}, {
	    extend: function extend() {
	        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var statics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var _props$bindingHandler = props.bindingHandlers,
	            bindingHandlers = _props$bindingHandler === undefined ? {} : _props$bindingHandler,
	            _props$bindingFilters = props.bindingFilters,
	            bindingFilters = _props$bindingFilters === undefined ? {} : _props$bindingFilters,
	            _props$events = props.events,
	            events = _props$events === undefined ? {} : _props$events,
	            otherProps = _objectWithoutProperties(props, ['bindingHandlers', 'bindingFilters', 'events']);
	
	        var newEvents = _underscore2.default.extend({}, this.prototype.events);
	
	        var newProps = _extends({
	            events: newEvents
	        }, otherProps);
	
	        newProps.bindingHandlers = _underscore2.default.extend({}, this.prototype.bindingHandlers, bindingHandlers);
	
	        newProps.bindingFilters = _underscore2.default.extend({}, this.prototype.bindingFilters, bindingFilters);
	
	        // split event defs like "click .link; keydown .input"
	        // to events "click .link" and "keydown .input"
	
	        var _loop = function _loop(eventDescList) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = eventDescList.split(';')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var eventDesc = _step.value;
	
	                    newProps.events[eventDesc.trim()] = function (e) {
	                        var holds = e.currentTarget.dataset.holds;
	
	
	                        var args = holds ? this.holds[holds] : [];
	
	                        events[eventDescList].apply(this, [e].concat(_toConsumableArray(args)));
	                    };
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        };
	
	        for (var eventDescList in events) {
	            _loop(eventDescList);
	        }return _backbone2.default.Epoxy.View.extend.call(this, newProps, statics);
	    },
	    fromTemplate: function fromTemplate(template) {
	        return View.extend({ template: template });
	    },
	    event: function event(name) {
	        return ':' + name;
	    }
	});
	
	exports.default = View;
	
	
	function registerPartials(root, path) {
	    if ('compiler' in root) return _handlebars2.default.registerPartial(path.join('/'), _handlebars2.default.template(root));
	
	    for (var part in root) {
	        if (root.hasOwnProperty(part)) {
	            path.push(part);
	            registerPartials(root[part], path);
	            path.pop();
	        }
	    }
	}
	
	function embeddedViews(view, callback) {
	    Object.keys(view).filter(function (key) {
	        return key[0].toUpperCase() === key[0];
	    }).filter(function (key) {
	        return view[key] instanceof View;
	    }).map(function (key) {
	        return view[key];
	    }).forEach(callback);
	}
	
	function enableEl($el, enable) {
	    if (!enable) return disableEl($el, true);
	
	    $el.each(function (index, el) {
	        var prevCount = +el.dataset.disabledCount || 0;
	        var count = Math.max(0, prevCount - 1);
	
	        el.dataset.disabledCount = count;
	        if (count <= 1) (0, _jquery2.default)(el).removeAttr('disabled').removeClass('disabled');
	    });
	}
	
	function disableEl($el, disable) {
	    if (!disable) return enableEl($el, true);
	
	    $el.each(function (index, el) {
	        var prevCount = +el.dataset.disabledCount || 0;
	        var count = prevCount + 1;
	
	        if (count > 0) (0, _jquery2.default)(el).attr('disabled', true).addClass('disabled');
	    });
	}
	
	function godown(fields, path) {
	    while (path.length) {
	        var _path = path,
	            _path2 = _toArray(_path),
	            parentId = _path2[0],
	            parentTranslit = _path2[1],
	            instanceIndex = _path2[2],
	            minCount = _path2[3],
	            rest = _path2.slice(4);
	
	        fields = fields && fields[parentTranslit] && fields[parentTranslit].value && fields[parentTranslit].value[instanceIndex] || {};
	        path = rest;
	    }
	
	    return fields;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), (function() { return this; }())))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _handlebars = __webpack_require__(31);
	
	var _handlebars2 = _interopRequireDefault(_handlebars);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _handlebars3 = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_i18n2.default.then(function () {
	    return Object.keys(_handlebars3.helpers).forEach(function (key) {
	        // allow to name block-level helpers with "#" in the beginning
	        var helperName = key.startsWith('#') ? key.substr(1) : key;
	
	        _handlebars2.default.registerHelper(helperName, _handlebars3.helpers[key]);
	    });
	});
	
	exports.default = _handlebars2.default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Promise, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.interval = exports.helpers = exports.constants = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _systemImportTransformerGlobalIdentifier = typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : typeof global !== 'undefined' ? global : {};
	
	var _helpers;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _handlebars = __webpack_require__(31);
	
	var _handlebars2 = _interopRequireDefault(_handlebars);
	
	var _v = __webpack_require__(47);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _collection2 = __webpack_require__(11);
	
	var _collection3 = _interopRequireDefault(_collection2);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _idgen = __webpack_require__(50);
	
	var _arrays = __webpack_require__(24);
	
	var _date = __webpack_require__(29);
	
	var _handlebars3 = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	var caseStack = [];
	
	var guidStack = [];
	
	var topLevelView = {};
	
	var constants = {
	    NOT: '@@@NOT@@@',
	    OR: '@@@OR@@@',
	    AND: '@@@AND@@@',
	    EQ: '@@@EQ@@@',
	    EQQ: '@@@EQQ@@@',
	    LESS: '@@@LESS@@@',
	    MORE: '@@@MORE@@@',
	    T: '@@@T@@@',
	    F: '@@@F@@@',
	    BEGIN: '@@@BEGIN@@@',
	    END: '@@@END@@@',
	
	    BODY_INJECTOR: '@@@BODY_INJECTOR@@@',
	    PARENT_VIEW: '@@@PARENT_VIEW@@@',
	    INJECTED_NAME: '@@@INJECTED_NAME@@@',
	    PASSED_PARTIAL_BLOCK_HELPER: '@@@PASSED_PARTIAL_BLOCK_HELPER@@@'
	};
	
	var zoneHash = void 0;
	
	var helpers = (_helpers = {
	
	    cond: _handlebars3.cond,
	
	    binary: function binary(predicate, value) {
	        return predicate ? value : undefined;
	    },
	    ternary: function ternary(predicate, value, elseValue) {
	        return predicate ? value : elseValue;
	    },
	    print: function print(value) {
	        return value !== undefined ? value : '';
	    },
	    concat: function concat() {
	        for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	            values[_key] = arguments[_key];
	        }
	
	        return values.pop(), values.join('');
	    },
	    extend: function extend(array) {
	        for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            values[_key2 - 1] = arguments[_key2];
	        }
	
	        return values.pop(), [].concat(_toConsumableArray(array), values);
	    },
	    pick: function pick() {
	        for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            values[_key3] = arguments[_key3];
	        }
	
	        return values.pop(), values.filter(function (value) {
	            return value != undefined;
	        })[0];
	    },
	    either: function either() {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	        }
	
	        return args.pop(), args.filter(function (arg) {
	            return arg !== undefined;
	        })[0];
	    },
	    escape: function escape(value) {
	        return value != undefined ? value.replaceAll('\\', '\\\\').replaceAll('"', '&quot;') : value;
	    },
	    contains: function contains(bigger, smaller) {
	        if (bigger == null) bigger = [];
	        if (bigger instanceof _collection3.default) bigger = bigger.toJSON();
	
	        if (bigger instanceof Array) if (bigger[0]) if (bigger[0].id) bigger = bigger.map(function (b) {
	            return b.id;
	        });
	
	        if (typeof smaller === 'string') return bigger.includes ? bigger.indexOf(smaller) !== -1 || bigger.indexOf(+smaller) !== -1 : bigger[smaller];else if (typeof smaller === 'number') return bigger.includes ? bigger.indexOf(smaller) !== -1 || bigger.indexOf('' + smaller) !== -1 : bigger[smaller];
	
	        if (bigger instanceof Array) bigger = (0, _arrays.hashify)(bigger);
	        if (!(smaller instanceof Array)) smaller = [smaller];
	
	        return smaller.every(function (item) {
	            return bigger[item];
	        });
	    },
	    groups: function groups(size, collection) {
	        if (collection instanceof _collection3.default) collection = collection.toJSON();
	
	        var result = [];
	        for (var now = [], i = 0; i < collection.length; i++) {
	            now.push(collection[i]);
	            if (now.length == size || i == collection.length - 1) result.push(now), now = [];
	        }
	
	        return result;
	    },
	    sort: function sort(array) {
	        return [].concat(_toConsumableArray(array)).sort();
	    },
	    pluck: function pluck(attr, collection) {
	        if (collection instanceof _collection3.default) collection = collection.toJSON();
	
	        return collection.map(function (model) {
	            return model[attr];
	        });
	    },
	    json: function json(model) {
	        return model.toJSON() ? model.toJSON() : model;
	    },
	    odd: function odd(value) {
	        return value % 2;
	    },
	    or: function or() {
	        for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	            values[_key5] = arguments[_key5];
	        }
	
	        // pop - to drop "options"
	        return values.pop(), values.some(function (val) {
	            return !!val;
	        });
	    },
	    and: function and() {
	        for (var _len6 = arguments.length, values = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	            values[_key6] = arguments[_key6];
	        }
	
	        // pop - to drop "options"
	        return values.pop(), values.every(function (val) {
	            return !!val;
	        });
	    },
	    not: function not(value) {
	        return !value;
	    },
	    dehtmlify: function dehtmlify(value) {
	        return value && _flatify.call(this, value).replace(/<p>/, '').replace(/<p>/g, ' ');
	    },
	    flatify: function flatify(value) {
	        return _flatify.call(this, value);
	    }
	}, _defineProperty(_helpers, 'json', function json(value) {
	    return value instanceof _model2.default ? value.toJSON() : value instanceof _collection3.default ? value.toJSON() : value;
	}), _defineProperty(_helpers, 'global', function global(refbookItems) {
	    return refbookItems instanceof _collection3.default ? refbookItems.toJSON().filter(function (item) {
	        return !item.cluster;
	    }) : refbookItems.filter(function (item) {
	        return !item.cluster;
	    });
	}), _defineProperty(_helpers, 'nonglobal', function nonglobal(refbookItems) {
	    return refbookItems instanceof _collection3.default ? refbookItems.toJSON().filter(function (item) {
	        return !!item.cluster;
	    }) : refbookItems.filter(function (item) {
	        return !!item.cluster;
	    });
	}), _defineProperty(_helpers, 'cut', function cut(length, value) {
	    var _value$trim$split$red = value.trim().split(' ').reduce(function (_ref, word) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            str = _ref2[0],
	            end = _ref2[1];
	
	        return end ? [str, end] : !str.length ? [word, false] : str.length + word.length + 1 <= length ? [str + ' ' + word, false] : [str, true];
	    }, ['', false]),
	        _value$trim$split$red2 = _slicedToArray(_value$trim$split$red, 1),
	        string = _value$trim$split$red2[0];
	
	    if (string.length === value.trim().length) return string;
	
	    while (string.length) {
	        if (string.match(/[а-яА-Яa-zA-Z0-9]$/)) break;else string = string.substr(0, string.length - 1);
	    }return string ? string + '...' : '';
	}), _defineProperty(_helpers, 'hold', function hold() {
	    var uuid = (0, _v2.default)();
	
	    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	    }
	
	    var options = args.pop();
	    var parent = options.data[constants.PARENT_VIEW];
	
	    if (parent) return parent.holds[uuid] = args, uuid;
	}), _defineProperty(_helpers, '#iff', function iff() {
	    for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        args[_key8] = arguments[_key8];
	    }
	
	    var options = args.pop();
	
	    return tru(evaluate(args)) ? options.fn(this) : options.inverse(this);
	}), _defineProperty(_helpers, '#View', makeViewHelper('./view')), _defineProperty(_helpers, '#define', function define(name, options) {
	    var view = options.data[constants.PARENT_VIEW];
	    var embeds = view.embeds = view.embeds || {};
	    var fn = embeds[name];
	    return fn ? fn(this, options) : options.fn(this);
	}), _defineProperty(_helpers, '#embed', function embed(name, options) {
	    var view = options.data[constants.PARENT_VIEW];
	    var embeds = view.embeds = view.embeds || {};
	    embeds[name] = options.fn;
	}), _defineProperty(_helpers, '#InjectBody', function InjectBody(options) {
	    if (options.data[constants.BODY_INJECTOR]) return new _handlebars2.default.SafeString(options.data[constants.BODY_INJECTOR](this, options));
	
	    return '';
	}), _defineProperty(_helpers, '#case', function _case(context, options) {
	    caseStack.push(context);
	    var val = options.fn(this);
	    caseStack.pop();
	    return val;
	}), _defineProperty(_helpers, '#of', function of(context, options) {
	    if (context === caseStack[caseStack.length - 1]) return options.fn(this);
	}), _defineProperty(_helpers, '#ifOneOf', function ifOneOf(context) {
	    for (var _len9 = arguments.length, values = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
	        values[_key9 - 1] = arguments[_key9];
	    }
	
	    var options = values.pop();
	    return ~values.indexOf(context) ? options.fn(this) : options.inverse(this);
	}), _defineProperty(_helpers, ':dt', function dt(date, format) {
	    return date ? (0, _date.fmt)((0, _date.datify)(date), format) : '';
	}), _defineProperty(_helpers, 'dt', function dt(date, format) {
	    return date ? (0, _date.fmt)((0, _date.datify)(date), format) : '';
	}), _defineProperty(_helpers, 'dtlower', function dtlower(date) {
	    return (0, _date.beginDay)((0, _date.datify)(date));
	}), _defineProperty(_helpers, 'dtupper', function dtupper(date) {
	    return (0, _date.tomorrow)((0, _date.beginDay)((0, _date.datify)(date)));
	}), _defineProperty(_helpers, 'datify', function datify(value) {
	    return (0, _date.datify)(value);
	}), _defineProperty(_helpers, 'now', function now() {
	    return new Date();
	}), _defineProperty(_helpers, 'prev-month', function prevMonth(date) {
	    return (0, _date.prevMonth)(date);
	}), _defineProperty(_helpers, 'next-month', function nextMonth(date) {
	    return (0, _date.nextMonth)(date);
	}), _defineProperty(_helpers, 'unixts', function unixts(date) {
	    return date ? (0, _date.unixts)((0, _date.datify)(date)) : undefined;
	}), _defineProperty(_helpers, 'past', function past(date) {
	    return new Date() > (0, _date.datify)(date);
	}), _defineProperty(_helpers, '#row', function row(_ref3) {
	    var hash = _ref3.hash,
	        fn = _ref3.fn;
	    var style = hash.style,
	        toggle = hash.toggle;
	
	    return '<div class="r row ' + hash['show-grid' ? 'show-grid' : ''] + '" style="' + (style || '') + '" ' + (toggle ? 'data-bind="toggle:' + toggle + '"' : '') + '>' + fn(this) + '</div>';
	}), _defineProperty(_helpers, '#col', makeColumn(undefined)), _defineProperty(_helpers, '#col1', makeColumn(1)), _defineProperty(_helpers, '#col2', makeColumn(2)), _defineProperty(_helpers, '#col3', makeColumn(3)), _defineProperty(_helpers, '#col4', makeColumn(4)), _defineProperty(_helpers, '#col5', makeColumn(5)), _defineProperty(_helpers, '#col6', makeColumn(6)), _defineProperty(_helpers, '#col7', makeColumn(7)), _defineProperty(_helpers, '#col8', makeColumn(8)), _defineProperty(_helpers, '#col9', makeColumn(9)), _defineProperty(_helpers, '#col10', makeColumn(10)), _defineProperty(_helpers, '#col11', makeColumn(11)), _defineProperty(_helpers, '#col12', makeColumn(12)), _defineProperty(_helpers, 'tabs', function tabs(_ref4) {
	    var fn = _ref4.fn,
	        _ref4$hash = _ref4.hash,
	        klass = _ref4$hash.class,
	        style = _ref4$hash.style;
	
	    return '<ul class="nav nav-tabs ' + klass + '" style="margin-bottom: 20px; ' + style + '">' + fn(this) + '</ul>';
	}), _defineProperty(_helpers, 'pills', function pills(_ref5) {
	    var fn = _ref5.fn,
	        _ref5$hash = _ref5.hash,
	        klass = _ref5$hash.class,
	        style = _ref5$hash.style,
	        colorScheme = _ref5$hash['color-scheme'],
	        toggle = _ref5$hash.toggle;
	
	    return '<nav class="nav nav-pills ' + klass + ' ' + (colorScheme == 'purple' && '--color-scheme-purple') + '" style="' + style + '" ' + (!toggle ? '' : 'data-bind="toggle:' + toggle + '"') + '>' + fn(this) + '</nav>';
	}), _defineProperty(_helpers, 'tab', makeNavItemHelper('')), _defineProperty(_helpers, 'pill', makeNavItemHelper('padding-top: 7px; padding-bottom: 8px; ')), _defineProperty(_helpers, 'buttons', function buttons(_ref6) {
	    var hash = _ref6.hash,
	        fn = _ref6.fn;
	    var className = hash.class,
	        style = hash.style;
	
	
	    return '<div \n            class="btn-group ' + (className || '') + '" \n            ' + (style ? 'style="' + style + '"' : '') + ' \n            role=group aria-label=...>' + fn(this) + '</div>';
	}), _defineProperty(_helpers, 'button', function button(_ref7) {
	    var hash = _ref7.hash,
	        fn = _ref7.fn;
	    var label = hash.label;
	
	    var disabledValue = hash['disabled'];
	    var enabledValue = hash['enabled'];
	
	    var disabled = false;
	
	    if (~['t', 'f', 'true', 'false', true, false].indexOf(disabledValue)) disabled = bool(disabledValue);else if (disabledValue !== undefined) disabled = !!disabledValue;else if (~['t', 'f', 'true', 'false', true, false].indexOf(enabledValue)) disabled = !bool(enabledValue);else if (enabledValue !== undefined) disabled = !enabledValue;
	
	    var body = '<button type=button \n            class="btn btn-default -' + hash['action'] + ' ' + (hash['active'] ? 'active' : '') + '"\n            ' + (hash['name'] ? 'name="' + hash['name'] + '"' : '') + '\n            ' + (hash['data-click-trigger'] ? 'data-click-trigger="' + hash['data-click-trigger'] + '"' : '') + '\n            ' + (disabled ? 'disabled' : '') + '\n            >' + (label ? ifn(label) : fn(this)) + '</button>';
	
	    return label ? new _handlebars2.default.SafeString(body) : body;
	}), _defineProperty(_helpers, 'form', makeViewHelper('./form')), _defineProperty(_helpers, 'grid-context', function gridContext(_ref8) {
	    var fn = _ref8.fn,
	        data = _ref8.data;
	
	    var _items$map$filter$map = this.items.map(function (it, index) {
	        return [it, index];
	    }).filter(function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 1),
	            it = _ref10[0];
	
	        return it.active;
	    }).map(function (_ref11) {
	        var _ref12 = _slicedToArray(_ref11, 2),
	            it = _ref12[0],
	            index = _ref12[1];
	
	        return index;
	    }),
	        _items$map$filter$map2 = _slicedToArray(_items$map$filter$map, 1),
	        activeIndex = _items$map$filter$map2[0];
	
	    data = _handlebars2.default.createFrame(data);
	    data.activeIndex = activeIndex;
	    data.columns = [];
	
	    return fn(this, { data: data });
	}), _defineProperty(_helpers, 'gh', function gh(_ref13) {
	    var fn = _ref13.fn,
	        _ref13$hash = _ref13.hash,
	        title = _ref13$hash.title,
	        label = _ref13$hash.label,
	        width = _ref13$hash.width,
	        style = _ref13$hash.style,
	        data = _ref13.data;
	
	    data.columns.push(undefined);
	
	    var html = '<th title="' + (title ? title : '') + '" style="' + (width ? 'width:' + width : '') + ';' + (style ? style : '') + '">\n            <span class="grid-head">\n                ' + (label ? ifn(label) : fn ? fn(this) : '') + '\n            </span></th>';
	
	    return new _handlebars2.default.SafeString(html);
	}), _defineProperty(_helpers, 'gd', function gd(_ref14) {
	    var fn = _ref14.fn,
	        _ref14$hash = _ref14.hash,
	        title = _ref14$hash.title,
	        text = _ref14$hash.text,
	        width = _ref14$hash.width,
	        style = _ref14$hash.style,
	        colspan = _ref14$hash.colspan,
	        rowspan = _ref14$hash.rowspan,
	        hash = _objectWithoutProperties(_ref14$hash, ['title', 'text', 'width', 'style', 'colspan', 'rowspan']);
	
	    var html = '<td title="' + (title ? title : '') + '" \n            style="' + (width ? 'width:' + width : '') + ';' + (style ? style : '') + '"\n            ' + (colspan ? 'colspan="' + colspan + '"' : '') + '\n            ' + (rowspan ? 'rowspan="' + rowspan + '"' : '') + '\n            >\n            <span class="grid-cell" ' + (hash['line-height'] ? 'style="line-height:' + hash['line-height'] + '"' : '') + '>\n                ' + (text ? ifn(text) : fn ? fn(this) : '') + '\n            </span></th>';
	
	    return new _handlebars2.default.SafeString(html);
	}), _defineProperty(_helpers, 'gr-split', function grSplit(_ref15) {
	    var _ref15$data = _ref15.data,
	        index = _ref15$data.index,
	        activeIndex = _ref15$data.activeIndex;
	
	    return new _handlebars2.default.SafeString('</tr><tr data-index="' + index + '" \n            class="secondary-row ' + (index === activeIndex ? 'info' : '') + '">');
	}), _defineProperty(_helpers, 'grid-column-counter', function gridColumnCounter(_ref16) {
	    var data = _ref16.data;
	
	    return data.columns.length;
	}), _defineProperty(_helpers, 'timeleft', function timeleft(date) {
	    return _interval((0, _date.unixts)(date) - (0, _date.unixts)(new Date()));
	}), _defineProperty(_helpers, 'timepassed', function timepassed(date) {
	    if ((0, _date.is)(date, (0, _date.today)())) return _interval((0, _date.unixts)(new Date()) - (0, _date.unixts)(date));else if ((0, _date.is)(date, (0, _date.yesterday)((0, _date.today)()))) return ifn('dates::yesterday') + ', ' + (0, _date.fmt)(date, 'HH:mm');else if ((0, _date.fmt)(date, 'MM.YYYY') === (0, _date.fmt)((0, _date.today)(), 'MM.YYYY')) return (0, _date.fmt)(date, 'DofMonHHmm');else if ((0, _date.fmt)(date, 'YYYY') === (0, _date.fmt)((0, _date.today)(), 'YYYY')) return (0, _date.fmt)(date, 'DofMon');else return (0, _date.fmt)(date, 'DofMonYYYY');
	}), _defineProperty(_helpers, ':interval', function interval(seconds) {
	    return _interval(seconds);
	}), _defineProperty(_helpers, 'interval', function interval(seconds) {
	    return _interval(seconds);
	}), _defineProperty(_helpers, 'tokenize', function tokenize(url) {
	    return _config2.default.url('/' + url);
	}), _defineProperty(_helpers, '#fileurl', function fileurl(options) {
	    return _config2.default.url('/department_files/' + options.fn(this)).replace('/rest', '');
	}), _defineProperty(_helpers, ':html-drop-dataset', function htmlDropDataset() {
	    var _this = this;
	
	    var html = Object.keys(this).filter(function (key) {
	        return 0 === key.indexOf('data-');
	    }).map(function (key) {
	        return key + '="' + _this[key] + '"';
	    }).join(' ');
	
	    return new _handlebars2.default.SafeString(html);
	}), _defineProperty(_helpers, '__bodycall__', function __bodycall__(options) {
	    return new _handlebars2.default.SafeString(options.data.options[constants.PASSED_PARTIAL_BLOCK_HELPER](this, options));
	}), _defineProperty(_helpers, 'log', function log() {
	    for (var _len10 = arguments.length, values = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
	        values[_key10] = arguments[_key10];
	    }
	
	    return values.pop(), console.log.apply(console, values), '';
	}), _defineProperty(_helpers, ':log', function log() {
	    for (var _len11 = arguments.length, values = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
	        values[_key11] = arguments[_key11];
	    }
	
	    return values.pop(), console.log.apply(console, values), '';
	}), _defineProperty(_helpers, 'tick', function tick(value) {
	    return 't' === value || true === value ? new _handlebars2.default.SafeString('&#10003;') : '';
	}), _defineProperty(_helpers, '#genguid', function genguid(options) {
	    guidStack.push((0, _v2.default)());
	    var html = options.fn(this);
	    return guidStack.pop(), html;
	}), _defineProperty(_helpers, 'guid', function guid() {
	    return guidStack[guidStack.length - 1] || (0, _v2.default)();
	}), _defineProperty(_helpers, 'dict', function dict(_ref17) {
	    var hash = _ref17.hash;
	
	    var context = {};
	    for (var propName in hash) {
	        context[propName] = dictFn(hash[propName]);
	    }return context;
	}), _defineProperty(_helpers, 'names', function names(values, _ref18) {
	    var _ref18$hash = _ref18.hash,
	        collection = _ref18$hash.collection,
	        dict = _ref18$hash.dict,
	        nothingSelectedLabel = _ref18$hash.nothingSelectedLabel,
	        nItemsSelectedLabel = _ref18$hash.nItemsSelectedLabel,
	        nItemsSelectedLimit = _ref18$hash.nItemsSelectedLimit;
	
	    if (!dict) dict = dictFn(collection);
	
	    if (!(values instanceof Array)) values = values === null || values === undefined ? [] : [values];
	
	    var filtered = values.map(function (item) {
	        return ifn(dict[item instanceof Object ? item.id : item]);
	    });
	    if (filtered.length === 0) return ifn(nothingSelectedLabel || '');else if (nItemsSelectedLabel && filtered.length >= (nItemsSelectedLimit || 3)) return ifn(nItemsSelectedLabel, { count: filtered.length });else return filtered.join(', ') || '';
	}), _defineProperty(_helpers, 'custom-field-prop', function customFieldProp(translit, path, options) {
	    if (!options) {
	        ;
	
	        var _ref19 = [path, undefined];
	        options = _ref19[0];
	        path = _ref19[1];
	    }var _options = options,
	        model = _options.data.model;
	
	
	    var fields = (path || '').split('|').map(function (part) {
	        return part.split('=');
	    }).map(function (_ref20) {
	        var _ref21 = _slicedToArray(_ref20, 3),
	            id = _ref21[0],
	            encodedTranslit = _ref21[1],
	            index = _ref21[2];
	
	        return [_field2.default.decodeString(encodedTranslit), index];
	    }).reduce(function (fields, _ref22) {
	        var _ref23 = _slicedToArray(_ref22, 2),
	            translit = _ref23[0],
	            index = _ref23[1];
	
	        return fields && fields[translit] && fields[translit].value && fields[translit].value[index] || undefined;
	    }, model.get('fields')) || model.get('fields');
	
	    return fields && fields[translit] && fields[translit].value || undefined;
	}), _defineProperty(_helpers, 'namify', function namify(translit, path /*, options */) {
	    if (!path) return translit;
	
	    var breadcrumbs = path.split('|').map(function (part) {
	        return part.split('=');
	    }).map(function (_ref24) {
	        var _ref25 = _slicedToArray(_ref24, 3),
	            id = _ref25[0],
	            translit = _ref25[1],
	            index = _ref25[2];
	
	        return translit + '[' + index + ']';
	    });
	
	    return breadcrumbs.join('.') + '.' + _field2.default.encodeString(translit);
	}), _defineProperty(_helpers, 'prop', function prop(dottedProps) {
	    for (var _len12 = arguments.length, args = Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
	        args[_key12 - 1] = arguments[_key12];
	    }
	
	    var _args$pop = args.pop(),
	        model = _args$pop.data.model;
	
	    var fn = function fn(value, _ref26) {
	        var _ref27 = _toArray(_ref26),
	            head = _ref27[0],
	            tail = _ref27.slice(1);
	
	        return !head || !value ? value : head.startsWith('$') ? fn(value[args[head.substring(1)]], tail) : fn(value[head], tail);
	    };
	
	    var _dottedProps$split = dottedProps.split('.'),
	        _dottedProps$split2 = _toArray(_dottedProps$split),
	        head = _dottedProps$split2[0],
	        tail = _dottedProps$split2.slice(1);
	
	    return fn(model.get(head), tail);
	}), _defineProperty(_helpers, 'length', function length(array) {
	    if (array instanceof Object) return 'length' in array ? array.length : undefined;
	    return undefined;
	}), _defineProperty(_helpers, 'diff', function diff(_ref28) {
	    var data = _ref28.data;
	
	    if (!data.model) return undefined;
	
	    var view = data[constants.PARENT_VIEW];
	    while (view) {
	        if (view.diff) return view.diff();else if (view.options[constants.PARENT_VIEW]) view = view.options[constants.PARENT_VIEW];else return undefined;
	    }
	}), _defineProperty(_helpers, 'collection', function collection(_collection, options) {
	    if (_collection instanceof _collection3.default) _collection = _collection.toJSON();
	
	    if (!(_collection instanceof Array)) if (typeof _collection === 'number') {
	        var left = _collection;
	        _collection = [];
	        while (left--) {
	            _collection.unshift(left);
	        }
	    } else return;
	
	    var data = options.data && _handlebars2.default.createFrame(options.data);
	
	    var contentItems = [];
	
	    for (var index = 0; index < _collection.length; index++) {
	        if (data) data.index = index;
	
	        contentItems.push(options.fn(_collection[index], { data: data }));
	    }
	
	    return contentItems.join('');
	}), _defineProperty(_helpers, 'takeFirst', function takeFirst(items) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (item) return item;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}), _defineProperty(_helpers, 'join', function join(delimiter, items, _ref29) {
	    var fn = _ref29.fn;
	
	    return fn ? items.map(fn).join(delimiter) : items.join(delimiter);
	}), _defineProperty(_helpers, 'gt', function gt(a, b) {
	    return (a instanceof Date ? (0, _date.unixts)(a) : a) > (b instanceof Date ? (0, _date.unixts)(b) : b);
	}), _defineProperty(_helpers, 'lt', function lt(a, b) {
	    return (a instanceof Date ? (0, _date.unixts)(a) : a) < (b instanceof Date ? (0, _date.unixts)(b) : b);
	}), _defineProperty(_helpers, 'base64', function base64(string) {
	    return Base64.encodeURI(string);
	}), _defineProperty(_helpers, 'encodeTranslit', function encodeTranslit(fieldTranslit) {
	    return _field2.default.encodeString(fieldTranslit);
	}), _defineProperty(_helpers, 'subtract', function subtract(a, b) {
	    return a - b;
	}), _defineProperty(_helpers, 'sum', function sum() {
	    for (var _len13 = arguments.length, items = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
	        items[_key13] = arguments[_key13];
	    }
	
	    return items.pop(), items.reduce(function (total, el) {
	        return total + +el;
	    }, 0);
	}), _defineProperty(_helpers, 'inc', function inc(x) {
	    return x + 1;
	}), _defineProperty(_helpers, 'dec', function dec(x) {
	    return x - 1;
	}), _defineProperty(_helpers, 'min', function min() {
	    for (var _len14 = arguments.length, items = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
	        items[_key14] = arguments[_key14];
	    }
	
	    items.pop();
	    var result = undefined;
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var item = _step2.value;
	            if (item != undefined) if (result === undefined || +item < result) result = +item;
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return result;
	}), _defineProperty(_helpers, 'max', function max() {
	    for (var _len15 = arguments.length, items = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
	        items[_key15] = arguments[_key15];
	    }
	
	    items.pop();
	    var result = undefined;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var item = _step3.value;
	            if (item != undefined) if (result === undefined || +item > result) result = +item;
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return result;
	}), _defineProperty(_helpers, 'int', function int(value) {
	    return +value;
	}), _defineProperty(_helpers, 'take', function take(count, items) {
	    return !!items ? items.filter(function (_, index) {
	        return index < count;
	    }) : items;
	}), _defineProperty(_helpers, 'tz', function tz(id) {
	    if (!zoneHash) zoneHash = (0, _arrays.hashify)(_config2.default.timezones(), function (zone) {
	        return [zone.id, zone.name];
	    });
	
	    if (!zoneHash) return id;
	
	    return zoneHash[id];
	}), _defineProperty(_helpers, 'sortedi', function sortedi(items, prop) {
	    if (!prop) return [].concat(_toConsumableArray(items)).sort();
	
	    return [].concat(_toConsumableArray(items)).sort(function (a, b) {
	        return a[prop] - b[prop];
	    });
	}), _helpers);
	
	exports.constants = constants;
	exports.helpers = helpers;
	exports.interval = _interval;
	
	
	function _flatify(value) {
	    if (!value) return value;
	    return value.replace(/<(\/?(strong|b|em|span|ul|ol)|\/li)>/g, '').replace(/<li>/g, '[paragraph]').replace(/<[^>]+>/g, ' ').replace(/\[paragraph\]/g, '<p>').replace(/\s\s+/g, ' ').trim();
	}
	
	function dictFn(collection) {
	    for (var _len16 = arguments.length, propNames = Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
	        propNames[_key16 - 1] = arguments[_key16];
	    }
	
	    if (!propNames.length) propNames = ['name', 'title'];
	
	    if (typeof collection === 'function') collection = collection();else if (collection instanceof _collection3.default) collection = collection.toJSON();
	
	    var takeFirst = function takeFirst(item, props) {
	        return props.map(function (name) {
	            return item[name];
	        }).filter(function (value) {
	            return value !== undefined;
	        })[0];
	    };
	
	    return (0, _arrays.hashify)(collection, function (item) {
	        return [item.id, takeFirst(item, propNames)];
	    });
	}
	
	function makeColumn(width) {
	    return function (w, options) {
	        if (width) options = w, w = undefined;
	
	        var _options$hash = options.hash,
	            offset = _options$hash.offset,
	            style = _options$hash.style;
	
	
	        var styleString = style ? ' style="' + style + '"' : '';
	
	        var classString = offset ? ' class="col col-lg-' + (width || w) + ' col-lg-offset-' + offset + '"' : ' class="col col-lg-' + (width || w) + '"';
	
	        return '<div ' + classString + styleString + '>' + options.fn(this) + '</div>';
	    };
	}
	
	function makeNavItemHelper(style) {
	    return function (_ref30) {
	        var fn = _ref30.fn,
	            hash = _ref30.hash;
	
	        var toggle = hash.toggle,
	            disabled = hash.disabled,
	            enabled = hash.enabled,
	            active = hash.active,
	            label = hash.label,
	            icon = hash.icon,
	            href = hash.href,
	            action = hash.action,
	            className = hash.class,
	            altStyle = hash.style,
	            dense = hash.dense,
	            darker = hash.darker,
	            clickableActive = hash.clickableActive,
	            otherHashAttrs = _objectWithoutProperties(hash, ['toggle', 'disabled', 'enabled', 'active', 'label', 'icon', 'href', 'action', 'class', 'style', 'dense', 'darker', 'clickableActive']);
	
	        if (disabled !== undefined) disabled = bool(disabled);else if (enabled !== undefined) disabled = !bool(enabled);else disabled = false;
	
	        active = active !== undefined && bool(active);
	
	        var attrsString = [];
	        for (var attrName in otherHashAttrs) {
	            if (attrName !== 'bind-active') attrsString.push(attrName + '="' + otherHashAttrs[attrName] + '"');
	        }var text = label ? ifn(label) : fn ? fn(this) : '';
	
	        var body = '<li role=presentation ' + (disabled || active && !clickableActive ? 'disabled' : '') + ' \n            ' + (!toggle ? '' : 'data-bind="toggle:' + toggle + '"') + '\n            class="' + (active ? 'active' : '') + ' ' + (darker ? '__pill-darker' : '') + ' ' + (className ? className : '') + '"\n            ' + (otherHashAttrs['bind-active'] ? 'data-bind="' + otherHashAttrs['bind-active'] + '"' : '') + '>\n            <a  href="' + (href && (!active || clickableActive) ? href : 'javascript:void(0);') + '" \n                style="' + style + ' ' + (dense ? 'padding-top:3px;padding-bottom:3px;' : '') + ' ' + (altStyle ? altStyle : '') + '"\n                ' + attrsString.join(' ') + '\n                class=-' + action + '>' + (icon ? '<span class="glyphicon glyphicon-' + icon + '"></span>' : '') + (icon && text.trim() ? '&nbsp;' : '') + text + '</a></li>';
	
	        return new _handlebars2.default.SafeString(body);
	    };
	}
	
	function makeViewHelper(defaultSrc) {
	    return function (options) {
	        var _this2 = this;
	
	        var _options$hash2 = options.hash,
	            _options$hash2$src = _options$hash2.src,
	            viewModuleSrc = _options$hash2$src === undefined ? defaultSrc : _options$hash2$src,
	            viewInjectedName = _options$hash2.inject,
	            passedModel = _options$hash2.model,
	            className = _options$hash2.class,
	            style = _options$hash2.style,
	            passedOptions = _objectWithoutProperties(_options$hash2, ['src', 'inject', 'model', 'class', 'style']);
	
	        var meta = options.data.meta,
	            capabilities = options.data.caps;
	
	
	        var htmlNestId = (0, _idgen.idgen)(),
	            htmlNestPlaceholder = '<script type="x-placeholder" id="' + htmlNestId + '"></script>';
	
	        // throw out "./" from the beginning of "src"
	        // and resolve to "view" dir
	        var importing = typeof _systemImportTransformerGlobalIdentifier.define === 'function' && _systemImportTransformerGlobalIdentifier.define.amd ? new Promise(function (resolve, reject) {
	            _systemImportTransformerGlobalIdentifier.require(['../view/' + viewModuleSrc.substr(2)], resolve, reject);
	        }) : typeof module !== 'undefined' && module.exports && "function" !== 'undefined' || typeof module !== 'undefined' && module.component && _systemImportTransformerGlobalIdentifier.require && _systemImportTransformerGlobalIdentifier.require.loader === 'component' ? Promise.resolve(__webpack_require__(52)("./" + viewModuleSrc.substr(2))) : Promise.resolve(_systemImportTransformerGlobalIdentifier['../view/' + viewModuleSrc.substr(2)]);
	        meta.views[htmlNestId] = importing.then(function (module) {
	            var _extends2;
	
	            var parentView = options.data[constants.PARENT_VIEW];
	
	            // view must be injected into parent
	            // if parent exists and "inject" parameter is passed
	            var mustBeInjected = parentView && viewInjectedName !== undefined;
	
	            // copy {{#View}} options to this view's options
	            var viewOptions = _extends({}, passedOptions, (_extends2 = {
	                className: className, style: style,
	                injectedName: viewInjectedName
	            }, _defineProperty(_extends2, constants.BODY_INJECTOR, options.fn), _defineProperty(_extends2, constants.PARENT_VIEW, parentView), _defineProperty(_extends2, constants.INJECTED_NAME, mustBeInjected && viewInjectedName), _defineProperty(_extends2, constants.PASSED_PARTIAL_BLOCK_HELPER, options.data['partial-block']), _extends2));
	
	            // check: maybe view already has been rendered
	            // and contained in its parent view?
	            var view = void 0;
	            if (mustBeInjected) view = parentView[viewInjectedName];
	
	            if (view && !(view instanceof module.default)) view = new module.default(viewOptions);
	            if (!view) view = new module.default(viewOptions);
	
	            if (mustBeInjected) parentView[viewInjectedName] = view;
	
	            // assign options (if not first-time render)
	            Object.assign(view.options, viewOptions);
	
	            // assign view's el its new name in view hierarchy
	            view.$el.attr('name', viewInjectedName);
	
	            // run rendering; create rendering context before
	            // by just passing current rendering context
	            // todo: I don't know why copy capabilities directly here
	            var newContext = Object.create(_this2);
	            if (passedModel && passedModel.capabilities_) newContext.capabilities = _extends({}, passedModel.capabilities_);else if (capabilities) newContext.capabilities = _extends({}, capabilities);
	
	            var modelToBind = passedModel !== undefined ? passedModel : parentView
	            // view must be bound to parent's model if parent view exists 
	            // todo: does it even work?
	            ? parentView.model : view.model;
	
	            // note: pass "renderer" function to bind() to catch desired context and function-finalizer
	            // if no modelToBind found, calling bind(undefined)
	            // is equivalent of calling unbind()
	            var rendering = view.bind(modelToBind, function () {
	                return view.render(newContext, meta.finalizeSubviews);
	            });
	
	            return {
	                id: htmlNestId,
	                view: view,
	                rendering: rendering,
	                prepared: rendering.prepared
	            };
	        });
	
	        // return view placeholder which will be inserted into html
	        // and replaced by actual view after its rendering
	        return htmlNestPlaceholder;
	    };
	}
	
	function evaluate(args) {
	    return args.reduceRight(function (stack, op) {
	        switch (op) {
	            case constants.NOT:
	                return not(stack);
	            case constants.AND:
	                return and(stack);
	            case constants.OR:
	                return or(stack);
	            case constants.EQ:
	                return eq(stack);
	            case constants.EQQ:
	                return eqq(stack);
	            case constants.LESS:
	                return less(stack);
	            case constants.MORE:
	                return more(stack);
	            case constants.T:
	                return t(stack);
	            case constants.F:
	                return f(stack);
	            case constants.BEGIN:
	                return begin(stack);
	            case constants.END:
	                return end(stack);
	            default:
	                return cnst(op, stack);
	        }
	    }, []);
	}
	
	function not(_ref31) {
	    var _ref32 = _toArray(_ref31),
	        head = _ref32[0],
	        tail = _ref32.slice(1);
	
	    return [!tru(head)].concat(_toConsumableArray(tail));
	}
	
	function and(_ref33) {
	    var _ref34 = _toArray(_ref33),
	        head = _ref34[0],
	        tail = _ref34.slice(1);
	
	    if (head !== constants.BEGIN) return [[head].concat(_toConsumableArray(tail)).every(tru)];
	
	    // throw out left @{ by not including head
	    var args = [];
	    // search for right @}
	    while (tail[0] !== constants.END) {
	        args.push(tail.shift());
	    } // throw out right @}
	    tail.shift();
	    // build result
	    return [args.every(tru)].concat(_toConsumableArray(tail));
	}
	
	function or(_ref35) {
	    var _ref36 = _toArray(_ref35),
	        head = _ref36[0],
	        tail = _ref36.slice(1);
	
	    if (head !== constants.BEGIN) return [[head].concat(_toConsumableArray(tail)).some(tru)];
	
	    // throw out left @{ by not including head
	    var args = [];
	    // search for right @}
	    while (tail[0] !== constants.END) {
	        args.push(tail.shift());
	    } // throw out right @}
	    tail.shift();
	    // build result
	    return [args.some(tru)].concat(_toConsumableArray(tail));
	}
	
	function eq(_ref37) {
	    var _ref38 = _toArray(_ref37),
	        x = _ref38[0],
	        y = _ref38[1],
	        tail = _ref38.slice(2);
	
	    if (x instanceof Date && y instanceof Date)
	        // 1-minute diff
	        return [Math.abs(x - y) < 60 * 1000].concat(_toConsumableArray(tail));else return [x == y].concat(_toConsumableArray(tail));
	}
	
	function eqq(_ref39) {
	    var _ref40 = _toArray(_ref39),
	        x = _ref40[0],
	        y = _ref40[1],
	        tail = _ref40.slice(2);
	
	    return [x === y].concat(_toConsumableArray(tail));
	}
	
	function less(_ref41) {
	    var _ref42 = _toArray(_ref41),
	        x = _ref42[0],
	        y = _ref42[1],
	        tail = _ref42.slice(2);
	
	    return [x < y].concat(_toConsumableArray(tail));
	}
	
	function more(_ref43) {
	    var _ref44 = _toArray(_ref43),
	        x = _ref44[0],
	        y = _ref44[1],
	        tail = _ref44.slice(2);
	
	    return [x > y].concat(_toConsumableArray(tail));
	}
	
	function t(_ref45) {
	    var _ref46 = _toArray(_ref45),
	        head = _ref46[0],
	        tail = _ref46.slice(1);
	
	    return [head === true || head === 'true' || head === 't'].concat(_toConsumableArray(tail));
	}
	
	function bool(value) {
	    return t([value])[0];
	}
	
	function f(_ref47) {
	    var _ref48 = _toArray(_ref47),
	        head = _ref48[0],
	        tail = _ref48.slice(1);
	
	    return [head === false || head === 'false' || head === 'f'].concat(_toConsumableArray(tail));
	}
	
	function begin(stack) {
	    return [constants.BEGIN].concat(_toConsumableArray(stack));
	}
	
	function end(stack) {
	    return [constants.END].concat(_toConsumableArray(stack));
	}
	
	function cnst(op, stack) {
	    return [op].concat(_toConsumableArray(stack));
	}
	
	function tru(value) {
	    if (value === constants.BEGIN) throw new Error('Unexpected @{');
	    if (value === constants.END) throw new Error('Unexpected @}');
	    if (value === 0) return false;
	    if (value === '') return false;
	    if (value instanceof Array) return !!value[0];
	    if (value === 'false') return false;
	
	    return !!value;
	}
	
	function _interval(seconds) {
	    if (seconds === undefined) return undefined;
	
	    var mins = Math.floor(seconds / 60),
	        hours = Math.floor(mins / 60),
	        days = Math.floor(hours / 24);
	
	    var result = '';
	    if (days > 0) result += ifn('units::count days', days) + ' ';
	    if (hours % 24 > 0) result += ifn('units::count hours', hours % 24) + ' ';
	
	    if (mins % 60 > 0 && days === 0) result += ifn('units::count minutes', mins % 60) + ' ';else if (mins % 60 > 0) result = '~' + result;else if (days === 0 && hours == 0) result = ifn('units::less than minute');
	
	    return result.trim();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(2), __webpack_require__(46)(module)))

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(48);
	var bytesToUuid = __webpack_require__(49);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.idgen = idgen;
	function idgen() {
	    return ("" + Math.random()).substring(2);
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cond = cond;
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cond() {
	    for (var _len = arguments.length, tokens = Array(_len), _key = 0; _key < _len; _key++) {
	        tokens[_key] = arguments[_key];
	    }
	
	    // throw out options
	    return tokens.pop(), expr(tokens);
	}
	
	function expr(tokens) {
	    var x = conjunction(tokens);
	    while (tokens.length && tokens[0] == '|') {
	        tokens.shift(); // throw out the first "or"
	        if (!!conjunction(tokens)) x = true;
	    }
	
	    return x;
	}
	
	function conjunction(tokens) {
	    var x = operation(tokens);
	    while (tokens.length && tokens[0] == '&') {
	        tokens.shift(); // throw out the first "and"
	        if (!operation(tokens)) x = false;
	    }
	
	    return x;
	}
	
	function operation(tokens) {
	    var x = operand(tokens);
	
	    if (!(['==', '===', '!=', '!==', '<=', '>=', '<', '>'].indexOf(tokens[0]) !== -1)) return x;
	
	    var op = tokens.shift();
	    var y = operand(tokens);
	
	    if (x instanceof Date || y instanceof Date) x = (0, _date.unixts)((0, _date.datify)(x)), y = (0, _date.unixts)((0, _date.datify)(y));
	
	    switch (op) {
	        case '==':
	            return x == y;
	        case '===':
	            return x === y;
	        case '!=':
	            return x != y;
	        case '!==':
	            return x !== y;
	        case '<=':
	            return x <= y;
	        case '>=':
	            return x >= y;
	        case '<':
	            return x < y;
	        case '>':
	            return x > y;
	    }
	
	    return x;
	}
	
	function calc(op, x, y) {}
	
	function operand(tokens) {
	    if (tokens[0] === '!') return tokens.shift(), !operand(tokens);
	
	    var x = void 0;
	    if (tokens[0] === '(') return tokens.shift(), x = expr(tokens), tokens.shift(), x;
	
	    return tokens.shift();
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./attachments.component": 53,
		"./attachments.component.js": 53,
		"./attachments.controls": 61,
		"./attachments.controls.js": 61,
		"./attachments.list": 70,
		"./attachments.list.js": 70,
		"./binders/cf": 71,
		"./binders/cf.js": 71,
		"./comment": 72,
		"./comment.feed": 73,
		"./comment.feed.js": 73,
		"./comment.form": 84,
		"./comment.form.js": 84,
		"./comment.js": 72,
		"./comment.list": 85,
		"./comment.list.js": 85,
		"./common.left-nav": 87,
		"./common.left-nav.js": 87,
		"./config.breadcrumb": 88,
		"./config.breadcrumb.js": 88,
		"./config.property.actions": 89,
		"./config.property.actions.js": 89,
		"./config.property.intermediate.form": 90,
		"./config.property.intermediate.form.js": 90,
		"./config.property.list": 91,
		"./config.property.list.js": 91,
		"./config.property.terminal.form": 92,
		"./config.property.terminal.form.js": 92,
		"./config.sections": 93,
		"./config.sections.js": 93,
		"./config.value.item.mode.edit": 94,
		"./config.value.item.mode.edit.js": 94,
		"./config.value.item.mode.view": 99,
		"./config.value.item.mode.view.js": 99,
		"./config.value.list": 100,
		"./config.value.list.js": 100,
		"./core.nav": 101,
		"./core.nav.js": 101,
		"./core.search": 102,
		"./core.search.js": 102,
		"./ext/ace": 103,
		"./ext/ace.js": 103,
		"./field.datetime": 106,
		"./field.datetime.js": 106,
		"./field.fields": 107,
		"./field.fields.js": 107,
		"./field.file": 108,
		"./field.file.js": 108,
		"./field.suggest": 110,
		"./field.suggest.js": 110,
		"./field/gallery": 113,
		"./field/gallery.js": 113,
		"./field/pick": 114,
		"./field/pick.js": 114,
		"./file.badge.uploading": 86,
		"./file.badge.uploading.js": 86,
		"./form": 42,
		"./form.js": 42,
		"./forms/task": 115,
		"./forms/task.js": 115,
		"./gallery": 82,
		"./gallery.js": 82,
		"./grid": 65,
		"./grid.js": 65,
		"./layers/objects": 118,
		"./layers/objects.js": 118,
		"./map": 119,
		"./map.assignees": 122,
		"./map.assignees.js": 122,
		"./map.icons": 121,
		"./map.icons.js": 121,
		"./map.js": 119,
		"./modal": 63,
		"./modal.js": 63,
		"./module/contracts/group": 123,
		"./module/contracts/group.js": 123,
		"./module/refbooks/fields.form.stickers.grid": 124,
		"./module/refbooks/fields.form.stickers.grid.js": 124,
		"./module/refbooks/fields.form.subfields.grid": 125,
		"./module/refbooks/fields.form.subfields.grid.js": 125,
		"./module/schedule/launch.filters": 126,
		"./module/schedule/launch.filters.js": 126,
		"./module/schedule/pattern.monthly": 127,
		"./module/schedule/pattern.monthly.js": 127,
		"./module/schedule/pattern.random": 129,
		"./module/schedule/pattern.random.js": 129,
		"./module/schedule/pattern.yearly": 130,
		"./module/schedule/pattern.yearly.js": 130,
		"./module/schedule/preview": 131,
		"./module/schedule/preview.js": 131,
		"./module/tasks/sublist": 132,
		"./module/tasks/sublist.js": 132,
		"./paging": 134,
		"./paging.js": 134,
		"./pick.modal": 64,
		"./pick.modal.js": 64,
		"./pick.objects": 116,
		"./pick.objects.js": 116,
		"./service.objects.fields.mapping": 135,
		"./service.objects.fields.mapping.js": 135,
		"./suggestion": 112,
		"./suggestion.js": 112,
		"./tab.pills": 136,
		"./tab.pills.js": 136,
		"./task.new": 137,
		"./task.new.js": 137,
		"./tasks.filter": 138,
		"./tasks.filter.js": 138,
		"./toolbar": 139,
		"./toolbar.js": 139,
		"./user.find": 140,
		"./user.find.js": 140,
		"./view": 43,
		"./view.js": 43,
		"./widget/calendar": 144,
		"./widget/calendar.js": 144
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 52;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _View$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _task = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _view2.default.extend((_View$extend = {}, _defineProperty(_View$extend, _view2.default.event('Controls:file:upload-done'), function (originalName, fileType, fileSemantics, uploading) {
	    return (0, _task.attach)(this.model, originalName, fileType, fileSemantics, uploading), this.List.render();
	}), _defineProperty(_View$extend, _view2.default.event('List:attachment:toggle'), function (index, editable, deleted) {
	    if (!editable) return;
	
	    this.model.set('attachments', this.model.get('attachments').map(function (attachment, i) {
	        return i == index ? _extends({}, attachment, { deleted: deleted == undefined || deleted == false || deleted == 'f' }) : attachment;
	    }));
	}), _defineProperty(_View$extend, 'serialize', function serialize() {
	    var _this = this;
	
	    return {
	        attachments: function attachments() {
	            return _this.model.get('attachments');
	        }
	    };
	}), _defineProperty(_View$extend, 'onBind', function onBind(model) {
	    var _this2 = this;
	
	    this.listenTo(model, 'change:attachments', function () {
	        return _this2.List.render();
	    });
	}), _defineProperty(_View$extend, 'onUnBind', function onUnBind(previousModel) {
	    this.stopListening(previousModel);
	}), _View$extend));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.attach = attach;
	exports.save = save;
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _v = __webpack_require__(47);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _file = __webpack_require__(55);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _file3 = __webpack_require__(60);
	
	var _diff = __webpack_require__(18);
	
	var _promisify = __webpack_require__(19);
	
	var _field = __webpack_require__(57);
	
	var _arrays = __webpack_require__(24);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// uploading = Promise that resolves with server-file-name
	function attach(task, originalName, fileType, fileSemantics, uploading, binaryFile) {
	    switch (fileType) {
	        case 'photos':
	            fileType = 'PHOTO';break;
	        case 'files':
	            fileType = 'FILE';break;
	        case 'videos':
	            fileType = 'VIDEO';break;
	        case 'sounds':
	            fileType = 'SOUND';break;
	    }
	
	    var attrs = {
	        file_name: originalName,
	        file_type: fileType,
	        semantics: fileSemantics,
	        description: undefined,
	        main_photo: null,
	        sticker_id: undefined,
	        guid: (0, _v2.default)(),
	        uploading: uploading
	    };
	
	    if (binaryFile) attrs.reading = (0, _file3.read)(binaryFile).then(function (result) {
	        return attrs.reading = result;
	    });
	
	    task.set('attachments', [].concat(_toConsumableArray(task.get('attachments')), [attrs]));
	
	    return attrs;
	}
	
	function save(form, propsToSkip) {
	    var _form$model$toJSON = form.model.toJSON(),
	        attachments = _form$model$toJSON.attachments,
	        taskId = _form$model$toJSON.id,
	        taskAttrs = _objectWithoutProperties(_form$model$toJSON, ['attachments', 'id']);
	
	    var fields = (0, _arrays.hashify)((0, _field.flatify)(form.options.fields.nonSystem()), function (field) {
	        return [field.id, field];
	    });
	
	    // hash of non-deleted files
	    var filesToDelete = (0, _arrays.hashify)(attachments.filter(function (_ref) {
	        var deleted = _ref.deleted;
	        return deleted === true || deleted === 't';
	    }).map(function (att) {
	        return att.guid || att.id;
	    }));
	
	    var _ref2 = taskId ? adjust(_extends({}, (0, _diff.diffHash)(form.TaskForm.diff({ fields: form.options.fields })), {
	        // may be omitted from diff-hash when only files deleted
	        fields: form.model.get('fields')
	    })) : adjust(taskAttrs),
	        _ref3 = _slicedToArray(_ref2, 2),
	        attrsToSend = _ref3[0],
	        filesDeletedAutomaticallyList = _ref3[1];
	
	    var filesDeletedAutomatically = (0, _arrays.hashify)(filesDeletedAutomaticallyList.map(function (att) {
	        return att.guid || att.id;
	    }));
	
	    var newAttachments = attachments
	    // new file and not scheduled to delete
	    .filter(function (att) {
	        return !att.id && !filesToDelete[att.guid || att.id];
	    });
	
	    // wait till the end of all new attachment uploading
	    var uploading = newAttachments
	    // attachment.uploading contains uploading Promise
	    .filter(function (att) {
	        return att.uploading instanceof Promise;
	    }).map(function (att) {
	        return att.uploading;
	    });
	
	    var deletingAttachments = attachments
	    // must be existing file and scheduled to delete
	    // and NOT deleted automatically via custom-field-file deletion
	    .filter(function (att) {
	        return att.id && filesToDelete[att.id];
	    }).filter(function (att) {
	        return !filesDeletedAutomatically[att.id];
	    }).map(function (att) {
	        return _file2.default.delete({ id: taskId }, att);
	    });
	
	    return (0, _promisify.requestify)(Promise.all([].concat(_toConsumableArray(uploading), _toConsumableArray(deletingAttachments)))).then(function (result) {
	        return _extends({}, attrsToSend, {
	            attachments: newAttachments
	            // skip "reading" and "uploading" Promise
	            .map(function (_ref4) {
	                var reading = _ref4.reading,
	                    uploading = _ref4.uploading,
	                    attrs = _objectWithoutProperties(_ref4, ['reading', 'uploading']);
	
	                return (
	                    // the first N items of result are names of uploaded files;
	                    // seek items in newAttachments with empty names and resolve one by one
	                    _extends({ file: result.shift() }, attrs)
	                );
	            })
	        });
	    }).then(function (attrsToSend) {
	        return taskId
	        // update
	        ? new _task2.default({ id: taskId }).patch(attrsToSend)
	        // create
	        : new _task2.default(_extends({}, attrsToSend, {
	            date: (0, _date.unixts)(new Date()),
	            text: attrsToSend.text || '-',
	            organization_id: attrsToSend.organization_id || _config2.default.organization()
	        })).save();
	    });
	
	    function adjust(_ref5) {
	        var attrs = _objectWithoutProperties(_ref5, []);
	
	        for (var prop in propsToSkip) {
	            if (attrs.hasOwnProperty(prop)) delete attrs[prop];
	        }var filesDeletedAutomatically = [];
	
	        var fields = attrs.fields,
	            others = _objectWithoutProperties(attrs, ['fields']);
	
	        if (fields) others.fields = traverseInstance(fields, filesDeletedAutomatically);
	
	        others.attachments = newAttachments;
	
	        return [others, filesDeletedAutomatically];
	    }
	
	    function traverseValue(field, value, filesDeletedAutomatically) {
	        if (!value || !field) return value;
	
	        switch (field.format) {
	            case 'file':
	                filesDeletedAutomatically.push.apply(filesDeletedAutomatically, _toConsumableArray(value.filter(function (_ref6) {
	                    var guid = _ref6.guid,
	                        id = _ref6.id;
	                    return filesToDelete[guid || id];
	                })));
	                return value.filter(function (_ref7) {
	                    var guid = _ref7.guid,
	                        id = _ref7.id;
	                    return !filesToDelete[guid || id];
	                });
	            case 'composite':
	                return value.map(function (val) {
	                    return traverseInstance(val, filesDeletedAutomatically);
	                });
	            default:
	                return value;
	        }
	    }
	
	    function traverseNode(node, filesDeletedAutomatically) {
	        if (!node) return node;
	
	        var field_id = node.field_id,
	            value = node.value;
	
	        return {
	            field_id: field_id,
	            value: traverseValue(fields[field_id], value, filesDeletedAutomatically)
	        };
	    }
	
	    function traverseInstance(json, filesDeletedAutomatically) {
	        return Object.keys(json).map(function (key) {
	            return [key, json[key]];
	        }).map(function (_ref8) {
	            var _ref9 = _slicedToArray(_ref8, 2),
	                key = _ref9[0],
	                value = _ref9[1];
	
	            return [key, key !== 'guid' ? traverseNode(value, filesDeletedAutomatically) : value];
	        }).reduce(function (json, _ref10) {
	            var _ref11 = _slicedToArray(_ref10, 2),
	                key = _ref11[0],
	                value = _ref11[1];
	
	            return json[key] = value, json;
	        }, {});
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _promisify = __webpack_require__(19);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	    customParser: function customParser(payload) {
	        if ('string' === typeof payload.create_date) payload.create_date = (0, _date.parseYYYYMMDD)(payload.create_date);else if ('number' === typeof payload.time) payload.create_date = new Date(payload.create_date * 1000);
	
	        return payload;
	    }
	}, {
	    delete: function _delete(taskAttrs, _ref) {
	        var id = _ref.id,
	            file_type = _ref.file_type,
	            type = _ref.type,
	            extension = _ref.extension;
	
	        var suffix = void 0;
	        switch (file_type || type) {
	            case 'FILE':
	                suffix = 'files';break;
	            case 'PHOTO':
	                suffix = 'photos';break;
	            case 'SOUND':
	                suffix = 'sounds';break;
	            case 'VIDEO':
	                suffix = 'flv' === extension ? 'video' : 'difvideo';break;
	        };
	
	        var url = _config2.default.url('news/' + taskAttrs.id + '/' + suffix + '/' + id + '?apiVersion=1.4');
	        return (0, _promisify.requestify)($.ajax({
	            url: url,
	            dataType: 'json',
	            data: JSON.stringify({ action: 'delete' }),
	            method: 'POST',
	            contentType: 'application/json; charset=UTF-8'
	        }));
	    }
	});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _fields = __webpack_require__(27);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _arrays = __webpack_require__(24);
	
	var _field = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Task = _model2.default.extend({
	    defaults: function defaults() {
	        return {
	            id: undefined,
	            contract_id: undefined, contract_title: undefined, contract: undefined,
	            service_object_layer_id: undefined,
	            service_object_id: undefined, service_object_title: undefined,
	            organization_id: undefined,
	            assigned_organization_id: undefined,
	            assigned_user_id: undefined,
	            assigned_user_fio: undefined,
	            type_id: undefined,
	            status_id: undefined,
	            priority_id: undefined,
	            title: undefined,
	            text: undefined,
	            fields: {},
	            stage: undefined,
	            deadline: undefined,
	            attachments: []
	        };
	    },
	
	
	    endpoint: 'tasks?apiVersion=2.1', responseAt: 'task',
	
	    assign: function assign(_ref) {
	        var id = _ref.id,
	            fio = _ref.fio,
	            organization_id = _ref.organization_id;
	
	        var props = {
	            assigned_user_id: id,
	            assigned_user_fio: fio
	        };
	        if (+organization_id) props.assigned_organization_id = organization_id;
	
	        this.set(props);
	    },
	
	
	    renameProperties: {
	        zoom: 'point_zoom'
	    },
	
	    customParser: function customParser(payload) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var point = payload.point,
	            lon = payload.lon,
	            lat = payload.lat,
	            assigned_organization_id = payload.assigned_organization_id,
	            assigned_user_id = payload.assigned_user_id,
	            attachments = payload.attachments,
	            others = _objectWithoutProperties(payload, ['point', 'lon', 'lat', 'assigned_organization_id', 'assigned_user_id', 'attachments']);
	
	        var capabilities = data.capabilities,
	            comments = data.comments,
	            lastComment = data.lastComment,
	            schedule = data.schedule;
	
	
	        if (capabilities) this.capabilities_ = capabilities;
	        if (comments) this.comments_ = comments;
	
	        var result = _extends({
	            point: lon & lat ? [+lon, +lat] : point,
	            assigned_organization_id: +assigned_organization_id || 0,
	            assigned_user_id: +assigned_user_id || 0,
	            attachments: (attachments || []).
	            // swap file and file_name (different meaning in models.Files and forms.Attachment);
	            // here we use forms.Attachment-style
	            map(function (_ref2) {
	                var name = _ref2.name,
	                    file_name = _ref2.file_name,
	                    file = _objectWithoutProperties(_ref2, ['name', 'file_name']);
	
	                return _extends({ file: file_name, file_name: name }, file);
	            }).sort(function (f0, f1) {
	                return f0.id - f1.id;
	            }),
	
	            // the last comment is the first in the list
	            lastComment: comments ? comments[0] : lastComment,
	            schedule: schedule
	
	        }, others);
	
	        return result;
	    },
	    diff: function diff(anotherModel) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var coll = options.fields instanceof _collection2.default ? options.fields.toJSON() : options.fields;
	        var fields = (0, _arrays.hashify)((0, _field.flatify)(new _fields2.default(coll || []).nonSystem()), function (field) {
	            return [field.translit, field];
	        });
	
	        var addedAndImmediatelyDeletedAttachments = (0, _arrays.hashify)(this.get('attachments').filter(function (att) {
	            return att.guid;
	        }).filter(function (att) {
	            return att.deleted === true || att.deleted === 't';
	        }).map(function (att) {
	            return att.guid;
	        }));
	
	        var diff = _model2.default.prototype.diff.call(this, anotherModel, options).filter(function (_ref3) {
	            var attrName = _ref3.attrName,
	                newValue = _ref3.newValue,
	                oldValue = _ref3.oldValue;
	
	            // ignore - field is set automatically by suggestion
	            if (attrName === 'assigned_user_fio') return false;
	
	            if (attrName === 'fields') return diffFields(newValue, oldValue);
	
	            if (attrName === 'attachments') return diffAttachments(newValue, oldValue);
	
	            return true;
	        });
	
	        var hash = (0, _arrays.hashify)(diff.map(function (d) {
	            return d.attrName;
	        }));
	        if (!hash['attachments']) if (diffAttachments(this.get('attachments'))) diff.push({
	            attrName: 'attachments',
	            newValue: this.get('attachments'),
	            oldValue: anotherModel.get('attachments')
	        });
	
	        return diff;
	
	        function diffFields(newValue, oldValue) {
	
	            var valDiffer = function valDiffer(field, nv, ov) {
	                if (field.format === 'file') return hash(ov) !== hash((nv || []).
	                // exclude add-and-immediately-delete attachments
	                filter(function (att) {
	                    return !addedAndImmediatelyDeletedAttachments[att.guid];
	                }));
	
	                if (field.format !== 'composite') return hash(nv) !== hash(ov);
	
	                // no user interaction with composites -> nv is the same as ov
	                // despite new inputs in interface according to auto-expanding;
	                if (nv.some(function (instance, index) {
	                    return difference(instance, ov[index] || {});
	                })) return true;
	
	                // missing some old-element
	                var afterEls = (0, _arrays.hashify)(nv.filter(function (el) {
	                    return el.guid;
	                }), function (_ref4) {
	                    var guid = _ref4.guid;
	                    return [guid, true];
	                });
	                if (!ov.every(function (el) {
	                    return afterEls[el.guid];
	                })) return true;
	
	                // structure of els:
	                // ...old-els ...auto-added else | ...user-added els
	                //                               ^ min-count
	                //
	                // Suppose there are no changes in auto-added and user-added inputs.
	                // We must check if there are user-added els or not.
	                // If lengths are equal:
	                //    1) only auto-added - no changes
	                //    2) user-added + auto-added removed - no changes
	                // 
	                // So, check whether length is greater than min-count or not.
	                // !AND! those elements have no guids
	                if (field.min_count && nv.length > +field.min_count) return nv.filter(function (el, index) {
	                    return index >= +field.min_count;
	                }).some(function (el) {
	                    return !el.guid;
	                });
	            };
	
	            // todo potential troubles with deletions in nested composites
	            var difference = function difference(newInstance, _ref5) {
	                var guid = _ref5.guid,
	                    oldInstance = _objectWithoutProperties(_ref5, ['guid']);
	
	                var copyOldInstance = _extends({}, oldInstance);
	
	                for (var translit in newInstance) {
	                    if (translit != 'guid') {
	                        var nv = newInstance[translit].value;
	                        if (translit in copyOldInstance) {
	                                // field is deleted -> ignore
	                                if (!fields[translit]) delete copyOldInstance[translit];else if (valDiffer(fields[translit], nv, copyOldInstance[translit].value)) return true;else delete copyOldInstance[translit];
	                                // else if (console.log( translit ) || fields[translit].format === 'composite')
	                                //     if (valDiffer( translit, nv, [] ))
	                                //         return true;
	                                //     else
	                                //         ;
	
	                        } else if (fields[translit] && fields[translit].format === 'file' && nv instanceof Array) {
	                                var nonImmediatelyDeleted = nv.filter(function (att) {
	                                    return !addedAndImmediatelyDeletedAttachments[att.guid];
	                                });
	                                if (nonImmediatelyDeleted.length > 0) return true;
	                            } else if (nv !== undefined && nv !== null && nv !== '' && nv !== false) return true;
	                    }
	                }return Object.keys(copyOldInstance).length > 0;
	            };
	
	            var hash = function hash(json) {
	                return JSON.stringify((typeof json === 'undefined' ? 'undefined' : _typeof(json)) !== 'object' || json == null ? json : Object.keys(json).sort().map(function (key) {
	                    return [key, json[key]];
	                }).map(function (_ref6) {
	                    var _ref7 = _slicedToArray(_ref6, 2),
	                        key = _ref7[0],
	                        value = _ref7[1];
	
	                    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? [key, hash(value)] : [key, value];
	                }).reduce(function (hash, _ref8) {
	                    var _ref9 = _slicedToArray(_ref8, 2),
	                        key = _ref9[0],
	                        value = _ref9[1];
	
	                    return hash[key] = value, hash;
	                }, {}));
	            };
	
	            return difference(newValue, oldValue);
	        }
	
	        function diffAttachments(newValue /*, oldValue*/) {
	            var deleted = newValue.filter(function (att) {
	                return att.id != undefined;
	            }).filter(function (_ref10) {
	                var deleted = _ref10.deleted;
	                return deleted == true || deleted == 't';
	            });
	
	            var added = newValue.filter(function (att) {
	                return att.id == undefined;
	            }).filter(function (_ref11) {
	                var deleted = _ref11.deleted;
	                return deleted == undefined || deleted == false || deleted == 'f';
	            });
	
	            return deleted.length > 0 || added.length > 0;
	        }
	    },
	
	
	    computeds: {
	
	        location: {
	            set: function set(value) {
	                if (null == value) return { 'point': null };
	
	                var lon = value.lon,
	                    lat = value.lat;
	
	                return { 'point': [lon, lat] };
	            },
	            get: function get() {
	                var location = this.get('point');
	                if (null == location) return null;
	
	                var _location = _slicedToArray(location, 2),
	                    lon = _location[0],
	                    lat = _location[1];
	
	                return lon && lat ? { lon: +lon, lat: +lat } : null;
	            }
	        },
	
	        worktime_: {
	            set: function set(value) {
	                return +value ? { worktime: value * 3600 } : { worktime: undefined };
	            },
	            get: function get() {
	                var worktime = this.get('worktime');
	                return !!worktime ? Math.floor(worktime / 3600) : undefined;
	            }
	        },
	
	        assigned_user: {
	            set: function set(value) {
	                if (!value) return {
	                    assigned_user_id: 0,
	                    assigned_user_fio: ''
	                };
	
	                var id = value.id,
	                    name = value.name;
	
	
	                return {
	                    assigned_user_id: id,
	                    assigned_user_fio: name
	                };
	            },
	            get: function get() {
	                var id = this.get('assigned_user_id');
	                var fio = this.get('assigned_user_fio');
	
	                return !!id ? { id: id, name: fio } : null;
	            }
	        },
	
	        assigned_organization: {
	            set: function set(value) {
	                if (!value) return {
	                    assigned_organization_id: 0,
	                    assigned_user_id: 0,
	                    assigned_user_fio: ''
	                };
	
	                return {
	                    assigned_organization_id: +value,
	                    assigned_user_id: 0,
	                    assigned_user_fio: ''
	                };
	            },
	            get: function get() {
	                return this.get('assigned_organization_id');
	            }
	        }
	
	    }
	
	});
	
	exports.default = Task;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.flatify = flatify;
	exports.filterAvailableStickers = filterAvailableStickers;
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _stickers = __webpack_require__(58);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function flatify(fields) {
	    return (fields || []).map(function (field) {
	        return [field].concat(_toConsumableArray(flatify(field.subfields)));
	    }).reduce(function (result, array) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(array));
	    }, []);
	}
	
	function filterAvailableStickers(typeCollection, field, stickerCollection) {
	    var _ref = field instanceof _model2.default ? field.toJSON() : field,
	        cluster = _ref.cluster,
	        bindings_array = _ref.bindings_array,
	        bindings = _ref.bindings,
	        is_for_all = _ref.is_for_all;
	
	    var isFieldAttachedToTypeDirectly = (0, _arrays.hashify)((bindings_array || bindings).filter(function (binding) {
	        return [true, 't'].indexOf(binding.on) !== -1;
	    }).map(function (binding) {
	        return binding.type.id;
	    }));
	    var isTypeAvailableToField = (0, _arrays.hashify)(typeCollection.toJSON()
	    // type and field must be cluster-compatible
	    .filter(function (type) {
	        return !cluster || !type.cluster || cluster.id == type.cluster.id;
	    }).map(function (type) {
	        return type.id;
	    }).filter(function (typeId) {
	        return is_for_all === 't' || is_for_all === true || isFieldAttachedToTypeDirectly[typeId];
	    }));
	
	    var availableModels = stickerCollection.models
	    // sticker and field must be cluster-compatible
	    .filter(function (sticker) {
	        return !cluster || !sticker.get('cluster') || cluster.id == sticker.get('cluster').id;
	    }).filter(function (sticker) {
	        return sticker.get('is_for_all') === 't' || sticker.get('types').some(function (typeId) {
	            return isTypeAvailableToField[typeId];
	        });
	    });
	
	    return new _stickers2.default(availableModels);
	}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _sticker = __webpack_require__(59);
	
	var _sticker2 = _interopRequireDefault(_sticker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'sticker/list',
		responseAt: 'stickers',
		model: _sticker2.default
	});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'stickers', responseAt: '',
	
	    defaults: function defaults() {
	        return {
	            title: '',
	            cluster: null,
	            description: '',
	            is_for_all: 'f',
	            types: []
	        };
	    },
	    customParser: function customParser(payload) {
	        var news_type_ids = payload.news_type_ids,
	            type_ids = payload.type_ids,
	            types = payload.types;
	
	        return _extends({}, payload, {
	            types: news_type_ids || type_ids || types || []
	        });
	    }
	});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.read = read;
	function read(binaryFile) {
	    var type = binaryFile.type;
	
	    if (!type.startsWith('image/')) return Promise.resolve({ binaryFile: binaryFile });
	
	    return new Promise(function (resolve, reject) {
	        var reader = new FileReader();
	
	        reader.onload = function (_ref) {
	            var result = _ref.target.result;
	
	            binaryFile.content = result;
	
	            var url = URL.createObjectURL(binaryFile);
	            var img = new Image();
	
	            img.onload = function () {
	                resolve({ binaryFile: binaryFile, width: img.width, height: img.height });
	                URL.revokeObjectURL(img.src);
	            };
	
	            img.onerror = reject;
	
	            img.src = url;
	        };
	
	        reader.onerror = reject;
	
	        reader.readAsBinaryString(binaryFile);
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _promisify = __webpack_require__(19);
	
	var _popups = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _view2.default.extend(_defineProperty({}, _view2.default.event('file:upload'), function (type, semantics, minSize, maxSize) {
	    var _this = this;
	
	    Backbone.$('<input type="file" name="file" style="visibility:hidden;height:0;">').appendTo(document.body).on('change', function (e) {
	        var _e$target$files = _slicedToArray(e.target.files, 1),
	            binaryFile = _e$target$files[0];
	
	        if (typeof minSize === 'number' || typeof minSize === 'string' && typeof +minSize === 'number') if (binaryFile.size < minSize) return (0, _popups.ask)(ifn('errors::file is too small', { size: minSize }), 'errors::common notification', 'actions::close');
	        if (typeof maxSize === 'number' || typeof maxSize === 'string' && typeof +maxSize === 'number') if (binaryFile.size > maxSize) return (0, _popups.ask)(ifn('errors::file is too large', { size: maxSize }), 'errors::common notification', 'actions::close');
	
	        var uploading = upload(binaryFile, type);
	
	        _this.trigger('file:upload-done', binaryFile.name, type, semantics, uploading, binaryFile);
	    }).click();
	}));
	
	
	function upload(binaryFile, type) {
	    var data = new FormData();data.append('file', binaryFile);
	
	    var req = (0, _promisify.promisify)(Backbone.$.ajax({
	        url: _config2.default.url('/files/upload/' + type),
	        data: data,
	        contentType: false,
	        processData: false,
	        method: 'POST'
	    }));
	
	    return req.then(function (response) {
	        return response.name;
	    });
	}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.pick = exports.ask = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _modal = __webpack_require__(63);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _pick = __webpack_require__(64);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _messages = __webpack_require__(68);
	
	var _messages2 = __webpack_require__(69);
	
	var _promisify = __webpack_require__(19);
	
	var _arrays = __webpack_require__(24);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ask = ask;
	exports.pick = pick;
	
	// todo @test, @accept
	
	function pick(selected, _ref) {
	    var collection = _ref.collection,
	        cluster = _ref.cluster,
	        clusters = _ref.clusters,
	        _ref$idOnly = _ref.idOnly,
	        idOnly = _ref$idOnly === undefined ? true : _ref$idOnly,
	        _ref$fullCollection = _ref.fullCollection,
	        fullCollection = _ref$fullCollection === undefined ? false : _ref$fullCollection;
	
	    if (typeof collection === 'function') collection = collection();
	
	    var hash = (0, _arrays.hashify)(collection, function (item) {
	        return [item.id, item];
	    });
	
	    var view = _pick2.default.of(collection, clusters, cluster);
	    var binding = view.bind({ selected: selected }).then(function (view) {
	        return view.focus();
	    });
	
	    binding.view = view;
	
	    return ask(binding, 'popups::pick - title', 'actions::choose', 'actions::cancel', { large: true }).then(function () {
	        return fullCollection || view.model.get('selected').length < collection.length ? view.model.get('selected') : [];
	    }).then(function (selected) {
	        return idOnly ? selected : selected.map(function (_ref2) {
	            var id = _ref2.id;
	            return hash[id];
	        });
	    });
	}
	
	var stack = [];
	
	function ask(possiblyViewRendering, title, accept, cancel) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	    var callback = arguments[5];
	
	    if (!callback && typeof options === 'function') callback = options, options = {};
	    if (options.disable === undefined) options.disable = true;
	
	    var _Backbone$$ = _backbone2.default.$(':focus'),
	        _Backbone$$2 = _slicedToArray(_Backbone$$, 1),
	        focused = _Backbone$$2[0];
	
	    if (focused) focused.blur();
	
	    // fix scrollbars
	    _backbone2.default.$('body').addClass('tl-modal-open');
	    hideTopmost();
	
	    // console.log( 'ask - after hideTopmost' );
	
	    var modal = new _modal2.default(options);
	    stack.push({
	        focused: focused,
	        modal: modal,
	        rendering: (0, _promisify.promisify)(possiblyViewRendering)
	    });
	
	    (0, _promisify.promisify)(possiblyViewRendering).then(function (view) {
	        if (view instanceof _view2.default) modal.listenToOnce(view, 'modal:accept', function (result) {
	            return modal.trigger('ok', result);
	        });
	    });
	
	    var text = 'string' === typeof possiblyViewRendering ? possiblyViewRendering : undefined;
	    modal.render({ title: title, accept: accept, cancel: cancel, text: text })
	    // .then( () => console.log( 'modal render done' ) ) 
	    .then(function () {
	        return (0, _promisify.promisify)(possiblyViewRendering);
	    }).then(function () {
	        if (topmost().modal === modal) openTopmost();
	    });
	
	    return (0, _promisify.promisify)(possiblyViewRendering).then(function (view) {
	        return onOpen(modal, view, callback);
	    });
	}
	
	function topmost() {
	    return [].concat(stack).reverse()[0];
	}
	
	function openTopmost() {
	    if (!stack.length) return;
	
	    // console.log( 'openTopmost call - there is something!' );
	
	    var _topmost = topmost(),
	        modal = _topmost.modal,
	        rendering = _topmost.rendering,
	        focused = _topmost.focused;
	
	    modal.listenTo(modal, 'hide', popTopmost);
	    modal.listenTo(modal, 'hidden', function () {
	        modal.remove();
	        _backbone2.default.$(focused).focus();
	    });
	    rendering.then(function (view) {
	        return modal.open(view);
	    });
	}
	
	function hideTopmost() {
	    // console.log( 'hideTopmost call' );
	    if (!stack.length) return;
	
	    // console.log( `stack.length == ${stack.length}` );
	    topmost().modal.stopListening(topmost().modal, 'hide');
	    topmost().modal.stopListening(topmost().modal, 'hidden');
	    topmost().modal.close();
	}
	
	function popTopmost() {
	    stack.pop();
	    // console.log( `popTopmost call, stack length after pop = ${stack.length}` );
	    if (stack.length) return openTopmost();
	
	    // all modals closed; finish
	    // todo: after 150ms
	    _backbone2.default.$('body').removeClass('tl-modal-open');
	}
	
	function onOpen(modal, form) {
	    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	        return true;
	    };
	
	    var resolve = void 0,
	        reject = void 0;
	    var result = new Promise(function (rs, rj) {
	        return resolve = rs, reject = rj;
	    });
	
	    if (modal.options.onOpen) modal.options.onOpen({
	        reject: function reject() {
	            return modal.$('.action-reject').click();
	        }
	    });
	
	    modal.on('reject', reject);
	
	    // todo: call reject() when modal is just closed
	    // todo: disable "save" button when no data changed
	    modal.on('ok', function (clickResult) {
	        // disable controls and "save" button
	        if (modal.options.disable) disable();
	
	        // result will be undefined if no callback passed
	        var result = callback && callback(form, clickResult, modal);
	
	        // operation returns nothing and thus
	        // allows us to close the window
	        if (undefined === result) return modal.close(), resolve();
	
	        // operation returns "true" and thus
	        // allows us to close the window
	        if (true === result) return modal.close(), resolve();
	
	        // operation doesn't allow to close
	        // the window but we must enable all 
	        // the controls
	        if (false === result) return undoDisable();
	
	        // operation is async
	        // todo: assert Promise
	
	        // after finish of the operation
	        // enable all the controls (and restore focus)
	        if (result.done) return result.done(function (result) {
	            modal.close();undoDisable();
	            // pass result of callback function back of ask()
	            resolve((0, _promisify.promisify)(result));
	        })
	        // todo: show message near the input
	        // if error, show it
	        // [message, field] or { message, field }
	        .fail(function (message) {
	            return (0, _messages.handle)(modal, (0, _messages2.error)(message));
	        })
	        // and enable all the controls
	        .fail(undoDisable);
	
	        return (0, _promisify.promisify)(result).then(function (result) {
	            modal.close();undoDisable();
	            resolve(result);
	        }).catch(function (message) {
	            (0, _messages.handle)(modal, (0, _messages2.error)(message));
	            undoDisable();
	        });
	
	        function undoDisable() {
	            if (modal.options.disable) enable();
	        }
	    });
	
	    return result;
	
	    function enable() {
	        form.enable && form.enable({ restoreFocus: true });
	        modal.enable();
	    }
	
	    function disable() {
	        form.disable && form.disable();
	        modal.disable();
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	        this.$el.find('.modal').modal({ show: false });
	    },
	
	
	    // todo: setElement
	    template: 'jst/modal',
	
	    events: {
	
	        // todo: enabled/disabled
	        'click .action-accept': function clickActionAccept() {
	            this.trigger('ok');
	        },
	
	        'click .action-reject': function clickActionReject() {
	            this.trigger('reject');
	            this.close();
	        },
	
	        'keyup': function keyup(e) {
	            if (13 === e.keyCode) if (this.$primary().length && !this.$primary()[0].disabled) this.trigger('ok');
	        }
	
	    },
	
	    open: function open(view) {
	        var _this = this;
	
	        // already there?
	        if (this.$el.closest('body').length) this.$el.find('.modal').addClass('in');else this.$el.appendTo(document.body).find('.modal-body').append(view && view.el), setTimeout(function () {
	            return _this.$el.find('.modal').addClass('in');
	        }, 0), setTimeout(function () {
	            return view.focus && view.focus();
	        }, 150);
	
	        if (view.undelegateEvents) view.undelegateEvents();
	        if (view.delegateEvents) view.delegateEvents();
	        if (this.undelegateEvents) this.undelegateEvents();
	        if (this.delegateEvents) this.delegateEvents();
	    },
	    serialize: function serialize() {
	        return {
	            large: this.options.large,
	            medium: this.options.medium
	        };
	    },
	    close: function close() {
	        var _this2 = this;
	
	        this.$el.find('.modal').removeClass('in');
	
	        this.trigger('hide');
	        setTimeout(function () {
	            return _this2.trigger('hidden');
	        }, 150);
	    },
	    $primary: function $primary() {
	        return this.$el.find('.modal-footer .btn-primary');
	    },
	    $accept: function $accept() {
	        return this.$el.find('.modal-footer .action-accept');
	    },
	    $reject: function $reject() {
	        return this.$el.find('.modal-footer .action-reject');
	    }
	});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Form$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _strings = __webpack_require__(67);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _form2.default.extend((_Form$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _form2.default.prototype.initialize.call(this, options);
	
	        var clusters = (0, _arrays.hashify)(options.clusters, function (cluster) {
	            return [cluster.id, cluster];
	        });
	        this.options.collection = new _collection2.default(this.options.collection.toJSON().map(function (_ref) {
	            var id = _ref.id,
	                cluster_id = _ref.cluster_id,
	                cluster = _ref.cluster,
	                attrs = _objectWithoutProperties(_ref, ['id', 'cluster_id', 'cluster']);
	
	            return _extends({}, attrs, {
	                id: +id,
	                cluster: cluster || clusters[cluster_id]
	            });
	        }).filter(function (_ref2) {
	            var cluster = _ref2.cluster;
	            return !cluster || !options.cluster || cluster.id == options.cluster.id;
	        }));
	
	        options.sorted = new _collection2.default();
	        options.filtered = new _collection2.default();
	        options.resulted = new _collection2.default();
	
	        var collection = options.collection;
	
	        this.sorted_ = sort({ sort: this.sort_, direction: this.direction_ }, collection, options.sorted);
	    },
	
	
	    template: 'pick.modal',
	
	    search_: '',
	
	    page_: 1,
	
	    sort_: 'title',
	
	    direction_: 'asc',
	
	    viewMode_: 'all',
	
	    serialize: function serialize() {
	        var _this = this;
	
	        return this.sorted_.then(function () {
	            reFilterGrid.call(_this);
	
	            return {
	                filtered: _this.options.filtered,
	                searchString: _this.search_,
	                sort: _this.sort_,
	                direction: _this.direction_,
	                viewMode: _this.viewMode_,
	                hasClusters: _this.options.collection.models.some(function (model) {
	                    return model.get('cluster');
	                })
	            };
	        });
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref3) {
	            var _this2 = this;
	
	            var currentTarget = _ref3.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sortField = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	            var _options = this.options,
	                collection = _options.collection,
	                sorted = _options.sorted;
	
	
	            return this.page_ = 1, this.direction_ = direction, this.sort_ = sortField, sort({ sort: this.sort_, direction: this.direction_ }, collection, sorted).then(function () {
	                return reFilterGrid.call(_this2);
	            })
	            // hack: to rerender grid caption with order direction
	            .then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.focus();
	            });
	        },
	        'click .-toggle-selected': function clickToggleSelected(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var id = currentTarget.dataset.id;
	            var filtered = this.options.filtered;
	
	
	            var needAppend = currentTarget.checked;
	            var oldSelected = this.model.get('selected');
	            var newSelected = needAppend ? [].concat(_toConsumableArray(oldSelected), [{ id: id }]) : oldSelected.filter(function (item) {
	                return item.id != id;
	            });
	
	            this.model.set('selected', newSelected);
	
	            var ids = (0, _arrays.hashify)(newSelected.map(function (el) {
	                return el.id;
	            }));
	            this.$('.-toggle-all')[0].checked = filtered.every(function (el) {
	                return ids[el.id];
	            });
	
	            this.focus();
	        },
	        'click .-toggle-all': function clickToggleAll(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	
	            var value = currentTarget.checked;
	            var filtered = this.options.filtered;
	
	
	            var h = (0, _arrays.hashify)(filtered.models.map(function (el) {
	                return el.id;
	            }));
	            var drained = this.model.get('selected').filter(function (el) {
	                return !h[el.id];
	            });
	
	            this.model.set('selected', value ? [].concat(_toConsumableArray(drained), _toConsumableArray(filtered.models)) : [].concat(_toConsumableArray(drained)));
	
	            this.$('.-toggle-selected').prop('checked', value);
	
	            this.focus();
	        }
	    }
	
	}, _defineProperty(_Form$extend, _view2.default.event('Grid:action:default'), function (index) {
	    this.$('[name="Grid"] tbody tr').eq(index).find('[type="checkbox"]').click();
	    this.Grid.focus();
	}), _defineProperty(_Form$extend, _view2.default.event('toggle-mode'), function (mode) {
	    var _this3 = this;
	
	    if (this.viewMode_ === mode) return;
	
	    return this.viewMode_ = mode, this.page_ = 1, this.render().then(function () {
	        return _this3.focus();
	    });
	}), _defineProperty(_Form$extend, _view2.default.event('Paging:page'), function (page) {
	    return this.page_ = +page, reFilterGrid.call(this), this.focus();
	}), _defineProperty(_Form$extend, _view2.default.event('Search:search'), function (search) {
	    return this.search_ = search, this.page_ = 1, reFilterGrid.call(this);
	}), _Form$extend), {
	    of: function of(collection, clusters, cluster) {
	        var Class = this;
	        return new Class({
	            clusters: clusters, cluster: cluster,
	            collection: collection instanceof _collection2.default ? collection : new _collection2.default(collection)
	        });
	    }
	});
	
	
	function reFilterGrid() {
	    var _options2 = this.options,
	        sorted = _options2.sorted,
	        filtered = _options2.filtered,
	        resulted = _options2.resulted;
	
	    filter.call(this, { search: this.search_, page: this.page_, limit: 10, show: this.viewMode_ }, sorted, filtered, resulted);
	}
	
	function sort(params, source, dest) {
	    var sort = params.sort,
	        direction = params.direction;
	
	    var props = 'title' === sort ? ['name', 'title', 'no', 'id'] : [sort, 'no', 'id'];
	
	    return _grid2.default.sort({ sort: props, direction: direction }, source, dest);
	}
	
	function filter(_ref6, source, filtered, dest) {
	    var search = _ref6.search,
	        page = _ref6.page,
	        limit = _ref6.limit,
	        show = _ref6.show;
	
	    var searchString = search.toLowerCase();
	    var hash = (0, _arrays.hashify)(this.model.get('selected').map(function (_ref7) {
	        var id = _ref7.id;
	        return id;
	    }));
	
	    var models = source.toJSON().filter(function (model) {
	        return 'all' === show || hash[model.id];
	    }).filter(function (model) {
	        return ~(model.id + '').indexOf(searchString) || ~(model.title || model.name || '').toLowerCase().indexOf(searchString) || ~(model.title || model.name || '').toLowerCase().indexOf((0, _strings.switchKeyboardLayout)(searchString));
	    });
	
	    dest.total = filtered.total = models.length;
	    dest.page = filtered.page = page;
	    dest.limit = filtered.limit = limit;
	
	    filtered.reset(models);
	    dest.reset(models.filter(function (_, index) {
	        return index >= limit * (page - 1) && index < limit * page;
	    }));
	}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _sort = __webpack_require__(66);
	
	var _strings = __webpack_require__(67);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        if (options.collection) this.grab(options.collection);
	    },
	
	
	    className: 'grid',
	
	    events: {
	
	        'dblclick tbody tr': function dblclickTbodyTr(e) {
	            var index = parseInt(e.currentTarget.dataset.index);
	            this.trigger('action:default', index, this.options.collection.at(index));
	        },
	
	        'mousedown tbody tr': function mousedownTbodyTr(e) {
	            var _this = this;
	
	            if (this.$(e.originalEvent.target).is('[type=text], [type=number]')) return;else if (typeof this.options.dragMode === 'function' && this.options.dragMode() || typeof this.options.dragMode !== 'function' && this.options.dragMode)
	                // hack: do not re-focus but make grid
	                // look like it's focused
	                setTimeout(function () {
	                    return _this.$el.addClass('__focused');
	                }, 0);else
	                // blocks drag start
	                e.preventDefault(), this.focus();
	        },
	
	        'dragstart tbody tr': function dragstartTbodyTr(e) {
	            var arr = this.$('tbody tr').get().map(function (row, index) {
	                return [index, row];
	            });
	
	            var _arr$filter = arr.filter(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    index = _ref2[0],
	                    row = _ref2[1];
	
	                return row == e.currentTarget;
	            }),
	                _arr$filter2 = _slicedToArray(_arr$filter, 1),
	                _arr$filter2$ = _slicedToArray(_arr$filter2[0], 2),
	                index = _arr$filter2$[0],
	                row = _arr$filter2$[1];
	
	            this.sourceIndex = index;
	            this.startY = e.pageY;
	            this.prevY = e.pageY;
	
	            this.$('tbody tr').get().forEach(function (row, index) {
	                return row.dataset.newIndex = index;
	            });
	
	            this.trigger('click-activate', +index);
	
	            this.$(row).addClass('--drag-target');
	        },
	
	        'dragover tbody tr': function dragoverTbodyTr(e) {
	            e.preventDefault();
	            e.originalEvent.dataTransfer.dropEffect = 'move';
	
	            var deltaY = e.pageY - this.startY;
	            var deltaIndex = deltaY < 0 ? (deltaY - 24.5) / 49 | 0 : (deltaY + 24.5) / 49 | 0;
	
	            if (e.pageY > this.prevY) this.$('.--drag-target').insertAfter(this.$('tbody tr').eq(+this.sourceIndex + deltaIndex));
	
	            if (e.pageY < this.prevY) this.$('.--drag-target').insertBefore(this.$('tbody tr').eq(+this.sourceIndex + deltaIndex));
	
	            this.prevY = e.pageY;
	        },
	
	        'dragend tbody tr': function dragendTbodyTr() /*e*/{
	            var _this2 = this;
	
	            this.$('tbody tr').get().sort(function (rowA, rowB) {
	                return rowA.dataset.newIndex - rowB.dataset.newIndex;
	            }).reverse().forEach(function (row) {
	                return _this2.$(row).prependTo(_this2.$('tbody'));
	            });
	
	            this.$('.--drag-target').removeClass('--drag-target');
	
	            this.focus();
	        },
	
	        'drop tbody tr': function dropTbodyTr() /*e*/{
	            this.$('tbody tr').get().forEach(function (row, index) {
	                return row.dataset.newIndex = index;
	            });
	
	            this.trigger('rows:order', this.$('tbody tr').map(function (index, el) {
	                return +el.dataset.index;
	            }).get());
	        },
	
	        'click tbody tr': function clickTbodyTr(e) {
	            var _$$get$map$filter = this.$('tbody tr').get().map(function (row) {
	                return [row, row.dataset.index];
	            }).filter(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 1),
	                    row = _ref4[0];
	
	                return row == e.currentTarget;
	            }),
	                _$$get$map$filter2 = _slicedToArray(_$$get$map$filter, 1),
	                _$$get$map$filter2$ = _slicedToArray(_$$get$map$filter2[0], 2),
	                row = _$$get$map$filter2$[0],
	                index = _$$get$map$filter2$[1];
	
	            this.trigger('click-activate', index);
	        },
	
	        'keydown [data-id="focus-holder"]': function keydownDataIdFocusHolder(e) {
	            switch (e.keyCode) {
	                case 38:
	                    this.trigger('prevRow');
	                    e.preventDefault();break;
	                case 40:
	                    this.trigger('nextRow');
	                    e.preventDefault();break;
	            }
	        },
	
	        'keyup [data-id="focus-holder"]': function keyupDataIdFocusHolder(e) {
	            switch (e.keyCode) {
	                case 13:
	                    this.trigger('action:default');
	                    break;
	                // i 
	                case 73:
	                    e.ctrlKey && this.trigger('action:create');
	                    break;
	                // del 
	                case 46:
	                    this.trigger('action:destroy');
	                    break;
	            }
	        },
	
	        'focus [data-id="focus-holder"]': function focusDataIdFocusHolder(e) {
	            if (this.$el.hasClass('__focused')) return;
	
	            _backbone2.default.$('.__focused').removeClass('__focused');
	            this.$el.addClass('__focused');
	        },
	
	        'blur [data-id="focus-holder"]': function blurDataIdFocusHolder(e) {
	            this.$el.removeClass('__focused');
	        }
	
	    },
	
	    serialize: function serialize() {
	        var _options = this.options,
	            collection = _options.collection,
	            striped = _options.striped,
	            direction = _options.direction,
	            sort = _options.sort;
	
	        return {
	            items: collection.serialize(),
	            striped: striped, class: this.options.class,
	            direction: direction, sort: sort
	        };
	    },
	    grab: function grab(collection) {
	        var _this3 = this;
	
	        // "sync" is full reload from server;
	        this.listenTo(collection, 'sync reset', function () {
	            return _this3.render({ items: collection.serialize() });
	        });
	
	        // "pull-out" is model's deletion;
	        // update grid (re-render rows)
	        // (model, ctx, options { index } ) => callback
	        this.listenTo(collection, 'pull-out', function () {
	            return _this3.update({ items: collection.serialize() });
	        });
	
	        // "poke" is model's change;
	        // update grid (re-render rows)
	        // this.listenTo( collection, 'merge', () => console.log( 'merge' ) );
	        // this.listenTo( collection, 'poke', () => console.log( 'poke' ) );
	        this.listenTo(collection, 'poke', function () {
	            return (/*index*/_this3.update({ items: collection.serialize() })
	            );
	        });
	
	        // "activate deactivate" is change of 
	        // current row's position;
	        // update active row
	        this.listenTo(collection, 'activate deactivate', function () {
	            return _this3.updateActiveRow(collection);
	        });
	
	        // pass events from UI into collection
	        collection.listenTo(this, 'click-activate', function (index) {
	            return collection.activate(index);
	        });
	        collection.listenTo(this, 'prevRow', function () {
	            return collection.prevRow();
	        });
	        collection.listenTo(this, 'nextRow', function () {
	            return collection.nextRow();
	        });
	
	        return this;
	    },
	    ungrab: function ungrab(collection) {
	        this.stopListening(collection);
	        collection.stopListening(this);
	    },
	    update: function update(context) {
	        var _this4 = this;
	
	        return this.html(context).then(function (html) {
	            var tbody = (0, _jquery2.default)(html).find('tbody');
	            _this4.$('tbody').replaceWith(tbody);
	        });
	    },
	    updateActiveRow: function updateActiveRow(collection) {
	        this.$('tr.info').removeClass('info');
	        var index = collection.activeRow();
	        this.$('tbody tr[data-index="' + index + '"]').addClass('info');
	        if (index || index === 0) this.trigger('activate', index, collection.current());else this.trigger('deactivate');
	    },
	    focus: function focus() {
	        this.$('[data-id="focus-holder"]')[0].focus();
	        return this;
	    }
	}, {
	    sort: function sort(params /* { sort, direction } */, sourceColl, destColl) {
	        var fn = 'asc' === params.direction ? _sort.asc : _sort.desc;
	        var columns = params.sort || ['name', 'title', 'id'];
	        return fn(sourceColl.models || sourceColl, columns).then(function (sortedModels) {
	            return destColl.reset(sortedModels);
	        }).then(function () {
	            return destColl;
	        });
	    },
	    filter: function filter(_ref5, cluster, source, filtered, dest) {
	        var _ref5$search = _ref5.search,
	            search = _ref5$search === undefined ? '' : _ref5$search,
	            _ref5$page = _ref5.page,
	            page = _ref5$page === undefined ? 1 : _ref5$page,
	            _ref5$limit = _ref5.limit,
	            limit = _ref5$limit === undefined ? 10 : _ref5$limit,
	            activeId = _ref5.activeId;
	        var customFilterFn = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {
	            return true;
	        };
	
	
	        filtered = filtered || new _collection2.default();
	        dest = dest || new _collection2.default();
	
	        var models = source.models.filter(function (model) {
	            return !cluster || !model.get('cluster') && !model.get('cluster_id') ||
	            // role
	            model.get('cluster') && model.get('cluster').id == cluster.id ||
	            // org
	            model.get('cluster_id') == cluster.id;
	        }).filter(function (model) {
	            return (0, _strings.find)([model.id, model.get('no'), model.get('name'), model.get('title')], search);
	        }).filter(customFilterFn);
	
	        dest.total = filtered.total = models.length;
	        dest.page = filtered.page = page;
	        dest.limit = filtered.limit = limit;
	        dest.npages = (dest.total / dest.limit | 0) + (dest.total % dest.limit == 0 ? 0 : 1);
	
	        filtered.reset(models);
	        dest.reset(models.filter(function (_, index) {
	            return index >= limit * (page - 1) && index < limit * page;
	        }));
	
	        // setTimeout, because 
	        //  - render() will be called after reset()
	        //  - render() is async
	        setTimeout(function () {
	            var activeIndex = dest.findIndex(function (model) {
	                return +model.id === +activeId;
	            });
	            if (activeIndex > -1) dest.activate(activeIndex);else dest.restoreActive();
	        }, 0);
	
	        return {
	            filtered: filtered, dest: dest
	        };
	    }
	});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reverseOrder = exports.naturalOrder = exports.desc = exports.asc = exports.sort = undefined;
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.sort = sort;
	exports.asc = asc;
	exports.desc = desc;
	exports.naturalOrder = naturalOrder;
	exports.reverseOrder = reverseOrder;
	
	
	function sort(array, compareFn, columns) {
	    if (!Array.isArray(columns)) columns = [columns];
	
	    return _i18n2.default.then(function (i) {
	        return comparator.apply(undefined, [i, compareFn].concat(_toConsumableArray(columns)));
	    }).then(function (cmp) {
	        return [].concat(_toConsumableArray(array)).sort(cmp);
	    });
	}
	
	function asc(arrays, columns) {
	    return sort(arrays, naturalOrder, columns);
	}
	
	function desc(arrays, columns) {
	    return sort(arrays, reverseOrder, columns);
	}
	
	function comparator(i, compareFn) {
	    for (var _len = arguments.length, columns = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        columns[_key - 2] = arguments[_key];
	    }
	
	    return function (modelA, modelB) {
	        return [].concat(columns, ['id']).map(function (column) {
	            return column === 'id' ? function (model) {
	                return +model.id;
	            } : column;
	        }).map(function (column) {
	            return typeof column === 'function' ? compareFn(column(modelA), column(modelB)) : compareFn(get(modelA, column), get(modelB, column));
	        }).filter(function (value) {
	            return value !== 0;
	        })[0];
	    };
	}
	
	function naturalOrder(valueA, valueB) {
	    if (valueA == null && valueB == null) return 0;else if (valueB == null) return -1;else if (valueA == null) return 1;else if (valueA < valueB) return -1;else return valueB < valueA ? 1 : 0;
	}
	
	function reverseOrder(valueA, valueB) {
	    return naturalOrder(valueB, valueA);
	}
	
	function get(model, dottedProps) {
	    var fn = function fn(value, _ref) {
	        var _ref2 = _toArray(_ref),
	            head = _ref2[0],
	            tail = _ref2.slice(1);
	
	        return value == null ? null : !!head ? fn(value[head], tail) : value;
	    };
	
	    var _dottedProps$split = dottedProps.split('.'),
	        _dottedProps$split2 = _toArray(_dottedProps$split),
	        head = _dottedProps$split2[0],
	        tail = _dottedProps$split2.slice(1);
	
	    return fn(model.get ? model.get(head) : model[head], tail);
	}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.switchKeyboardLayout = switchKeyboardLayout;
	exports.find = find;
	
	var _arrays = __webpack_require__(24);
	
	var latin = 'qwertyuiop[]asdfghjkl;\'zxcvbnm,.';
	var cyrillic = 'йцукенгшщзхъфывапролджэячсмитьбю';
	var hash = (0, _arrays.hashify)(Object.keys(latin + cyrillic), function (index) {
	    return [(latin + cyrillic)[index], (cyrillic + latin)[index]];
	});
	
	function switchKeyboardLayout(word) {
	    return word.split('').map(function (ch) {
	        return hash[ch] || ch;
	    }).join('');
	}
	
	function find(haystack, needle) {
	    if (needle === '' || needle === undefined) return true;
	
	    var checkString = function checkString(haystackToken, needleToken) {
	        return needleToken.length > 2 ? ~haystackToken.indexOf(needleToken) : haystackToken.startsWith(needleToken);
	    };
	
	    var needleTokens = needle.split(' ').map(function (w) {
	        return w.toLowerCase().trim();
	    }).filter(function (w) {
	        return !!w;
	    });
	
	    return (haystack instanceof Array ? haystack : [haystack]).join(' ').split(' ').map(function (w) {
	        return w.toLowerCase().trim();
	    }).filter(function (w) {
	        return !!w;
	    }).some(function (haystackToken) {
	        return needleTokens.some(function (needleToken) {
	            return isNaN(+haystackToken)
	
	            // haystack token is a string
	            ? checkString(haystackToken, needleToken) || checkString(haystackToken, switchKeyboardLayout(needleToken))
	
	            // haystack token is a number
	            : ~(haystackToken + '').indexOf(needleToken);
	        });
	    });
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.handle = undefined;
	
	var _messages = __webpack_require__(69);
	
	var _popups = __webpack_require__(62);
	
	exports.handle = handle;
	
	
	function handle(instance, message) {
	    var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (text) {
	        return (0, _popups.ask)(text, 'errors::common notification', 'actions::close');
	    };
	    var text = message.text;
	
	    if (!text) return fallback('errors::no error info, see logs');
	
	    if (!(0, _messages.$place)(instance, message).length) return fallback(text);
	
	    // remove if present
	    (0, _messages.remove)(instance, text);
	    // add as new
	    (0, _messages.of)(instance).push(message);
	
	    (0, _messages.restore)(instance);
	    clearTimeout(instance.restoreTimeout);
	    instance.restoreTimeout = setTimeout(function () {
	        return (0, _messages.restore)(instance);
	    }, 5100);
	
	    var $inputField = (0, _messages.$input)(instance, message);
	    if ($inputField.length) $inputField.addClass('__blink'), setTimeout(function () {
	        return $inputField.removeClass('__blink');
	    }, 500), setTimeout(function () {
	        return $inputField
	        // add - to correctly handle field/html (div with button next)
	        .add($inputField.closest('.form-control').find('button')).focus();
	    }, 0);
	
	    return instance;
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.$input = exports.$place = exports.remove = exports.clear = exports.restore = exports.of = exports.success = exports.error = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: flashify
	exports.error = error;
	exports.success = success;
	exports.of = of;
	exports.restore = restore;
	exports.clear = clear;
	exports.remove = remove;
	exports.$place = $place;
	exports.$input = $input;
	
	
	function error(text) {
	    return make(text, 'danger');
	}
	
	function success(text) {
	    return make(text, 'success');
	}
	
	function make(text, level) {
	    var _text, _text2, _text3;
	
	    var message = void 0,
	        field = void 0;
	
	    if ('string' === typeof text) return cr(text, level);
	
	    if (text instanceof Array) return (_text = text, _text2 = _slicedToArray(_text, 2), message = _text2[0], field = _text2[1], _text), cr(message, level, field);
	
	    if ('object' === (typeof text === 'undefined' ? 'undefined' : _typeof(text))) return (_text3 = text, message = _text3.message, field = _text3.field, _text3), cr(message, level, field);
	
	    return cr(text, level);
	}
	
	function cr(text, level, field) {
	    return {
	        level: level, text: text, field: field,
	        id: 'message' + Math.random().toFixed(10).substr(2),
	        expirationTime: new Date().getTime() + 5000
	    };
	}
	
	var messages = {};
	
	function restore(view) {
	    var now = new Date();
	
	    // create $els if no
	    of(view).filter(function (message) {
	        return !message.$el;
	    }).forEach(function (message) {
	        return message.$el = $html(message);
	    });
	
	    // remove expired with animation;
	    // gather expired ids
	    var expired = of(view).filter(function (message) {
	        return now > message.expirationTime;
	    }),
	        expiredIds = (0, _arrays.hashify)(expired, function (_ref) {
	        var id = _ref.id;
	        return [id];
	    });
	    expired.forEach(function (_ref2) {
	        var $el = _ref2.$el;
	        return $el.addClass('animated fadeOut').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
	            return $el.remove();
	        });
	    });
	
	    // leave out expired from list
	    var nonExpired = of(view).filter(function (message) {
	        return now <= message.expirationTime;
	    });
	    put(view, nonExpired);
	
	    // gather ids of messages those are actual for this view;   
	    // sweep out non-actual messages those are not expired
	    // using map of actual ids;
	    // do not use animation
	    var actualIds = (0, _arrays.hashify)(of(view), function (_ref3) {
	        var id = _ref3.id;
	        return [id];
	    });
	    view.$el.find('.__message').filter(function (id, el) {
	        return !actualIds[el.id];
	    }).filter(function (id, el) {
	        return !expiredIds[el.id];
	    }).remove();
	
	    // append messages those not in the DOM
	    of(view).filter(function (_ref4) {
	        var $el = _ref4.$el;
	        return !_backbone2.default.$.contains(view.$el, $el);
	    }).forEach(function (message) {
	        return append(view, message);
	    });
	
	    // mark messages as old
	    of(view).forEach(function (message) {
	        return message.rendered = true;
	    });
	}
	
	function clear(view) {
	    put(view, []);
	    view.$el.find('.__message').remove();
	    return this;
	}
	
	function of(view) {
	    return messages[view.cid] = messages[view.cid] || [];
	}
	
	function put(view, newMessages) {
	    messages[view.cid] = newMessages;
	}
	
	function $input(view, _ref5) {
	    var field = _ref5.field;
	
	    if (!field) return (0, _jquery2.default)();
	
	    var $fieldItself = typeof field !== 'string' && view.$(field);
	    if ($fieldItself.length) return $fieldItself;
	
	    // regular field - search by (validation-name + name) attrs
	
	    if (!(field instanceof Array)) {
	        var _$input = view.$('[data-validation-name]').filter(function (i, input) {
	            return input.dataset.validationName.split(',').some(function (name) {
	                return name === field;
	            });
	        });
	
	        return _$input.length ? _$input : view.$el.find('[name="' + encodeURIComponent(field) + '"]');
	    }
	
	    // custom field inside composite - search by name attr
	
	    var result = field.map(function (el, index) {
	        return index % 2 === 0
	        // even -> translit or parent/leaf
	        ? _field2.default.encodeString(el)
	        // odd  -> index inside parent
	        : '[' + el + '].';
	    });
	
	    return view.$el.find('[name="' + result.join('') + '"]');
	}
	
	function $place(view, _ref6) {
	    var field = _ref6.field;
	
	    if (!field) return view.$el.find('.messages');
	
	    var $inputField = $input(view, { field: field });
	    if (!$inputField.length || $inputField.closest('.--none').length) return view.$el.find('.messages');
	
	    var $place = $inputField.closest('.form-group').find('.form-field--message-container');
	    if (!$place.length) return view.$el.find('.messages');
	
	    return $place.eq(0);
	}
	
	function remove(instance, text) {
	    var message = find(instance, text);
	    if (!message) return;
	
	    var index = of(instance).indexOf(message);
	    of(instance).splice(index, 1);
	}
	
	function find(instance, text) {
	    return of(instance).filter(function (message) {
	        return message.text === text;
	    })[0];
	}
	
	function stringify(_ref7) {
	    var id = _ref7.id,
	        level = _ref7.level,
	        field = _ref7.field;
	
	    return !field ? '<p id="' + id + '" class="__message alert alert-' + level + '"></p>' : '<span class="form-field-message __message __message-' + level + '"></span>';
	}
	
	function $html(message) {
	    var $html = _backbone2.default.$(stringify(message));
	    _i18n2.default.then(function (i) {
	        return $html.html(i(message.text));
	    });
	
	    return $html;
	}
	
	// TODO: BETTER ANIMATION
	// TODO: fadeOut ANIMATION FOR FIELD MESSAGES
	function append(view, message) {
	    var rendered = message.rendered,
	        $el = message.$el,
	        field = message.field;
	    // message is new? toggle animation on 
	    // TODO: BLINKING!!!
	
	    if (!rendered) $el.addClass('animated fadeIn');
	    // if message is already rendered but (somewhat) not in the DOM ->
	    // then view has been rerendered
	    // and we don't need animation at all
	    // to prevent blinking effect
	    if (rendered) $el.removeClass('animated fadeIn');
	
	    $el.prependTo($place(view, message));
	}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _this = this;
	
	        return {
	            attachments: function attachments() {
	                return _this.attachments();
	            }
	        };
	    },
	    attachments: function attachments() {
	        var attachments = typeof this.options.attachments === 'function' ? this.options.attachments() : this.options.attachments;
	
	        return attachments || [];
	    },
	    afterRender: function afterRender() {
	        var _this2 = this;
	
	        this.attachments().forEach(function (att, index) {
	            if (att.uploading instanceof Promise) att.uploading.then(function () {
	                return _this2.$('.attachment').eq(index).removeClass('--attachment-loading');
	            });else _this2.$('.attachment').eq(index).removeClass('--attachment-loading');
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _date = __webpack_require__(29);
	
	exports.default = {
	    setMetaString: function setMetaString($el, _ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            value /*, meta*/ = _ref2[0];
	
	        $el.val(value != null ? value : '');
	    },
	    getMetaString: function getMetaString($el, _ref3 /*, event */) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            prev = _ref4[0],
	            meta = _ref4[1];
	
	        var value = $el.val();
	        return [value !== '' ? value : null, meta];
	    },
	    setMetaBool: function setMetaBool($el, _ref5) {
	        var _ref6 = _slicedToArray(_ref5, 1),
	            value /*, meta*/ = _ref6[0];
	
	        $el[0].checked = value === true;
	    },
	    getMetaBool: function getMetaBool($el, _ref7 /*, event */) {
	        var _ref8 = _slicedToArray(_ref7, 2),
	            prev = _ref8[0],
	            meta = _ref8[1];
	
	        return [$el[0].checked, meta];
	    },
	    getMetaNumber: function getMetaNumber($el, _ref9 /*, event */) {
	        var _ref10 = _slicedToArray(_ref9, 2),
	            prev = _ref10[0],
	            meta = _ref10[1];
	
	        var value = $el.val();
	        return [value !== '' ? +value : null, meta];
	    },
	    setMetaDate: function setMetaDate($el, _ref11) {
	        var _ref12 = _slicedToArray(_ref11, 1),
	            value /*, meta*/ = _ref12[0];
	
	        $el.val(value != null ? (0, _date.fmt)(value, 'YYYY-MM-DD') : '');
	    },
	    getMetaDate: function getMetaDate($el, _ref13 /*, event */) {
	        var _ref14 = _slicedToArray(_ref13, 2),
	            prev = _ref14[0],
	            meta = _ref14[1];
	
	        var fn = createDateTimeStrToModelConvertor(function (value, prev) {
	            return (0, _date.parseYYYYMMDD)(value + ' ' + (prev ? (0, _date.fmt)(prev, 'HH:mm') : '00:00') + ':00');
	        });
	
	        return [fn($el.val(), prev), meta];
	    },
	    getMetaDateOnlyString: function getMetaDateOnlyString($el, _ref15 /*, event */) {
	        var _ref16 = _slicedToArray(_ref15, 2),
	            prev = _ref16[0],
	            meta = _ref16[1];
	
	        var fn = createDateTimeStrToModelConvertor(function (value /*, prev*/) {
	            return (0, _date.parseYYYYMMDD)(value + ' 00:00:00');
	        });
	
	        return [(0, _date.fmt)(fn($el.val(), prev), 'YYYY-MM-DD'), meta];
	    },
	    setMetaTime: function setMetaTime($el, _ref17) {
	        var _ref18 = _slicedToArray(_ref17, 1),
	            value /*, meta*/ = _ref18[0];
	
	        $el.val(value != null ? (0, _date.fmt)(value, 'HH:mm') : '');
	    },
	    getMetaTime: function getMetaTime($el, _ref19 /*, event */) {
	        var _ref20 = _slicedToArray(_ref19, 2),
	            prev = _ref20[0],
	            meta = _ref20[1];
	
	        var fn = createDateTimeStrToModelConvertor(function (value, prev) {
	            return (0, _date.parseYYYYMMDD)((0, _date.fmt)(prev || (0, _date.today)(), 'YYYY-MM-DD') + ' ' + value + ':00');
	        });
	
	        return [fn($el.val(), prev), meta];
	    },
	    setMetaDataTableObjects: function setMetaDataTableObjects($el, _ref21) {
	        var _ref22 = _slicedToArray(_ref21, 2),
	            values = _ref22[0],
	            meta = _ref22[1];
	
	        var tpl = function tpl(item) {
	            return '<span class="label label-default --lite" data-id="' + item.object_id + '">\n                <span style="display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;">' + item.title + '</span>\n                ' + (item.num != null && meta.amountEditable === 't' ? '<span class="badge">' + item.num + '</span>' : '') + '\n            </span>';
	        };
	
	        $el.html((values || []).sort(function (a, b) {
	            return a.title < b.title ? -1 : a.title > b.title ? 1 : a.object_id - b.object_id;
	        }).map(tpl).join(' '));
	    },
	    setMetaFile: function setMetaFile($el, _ref23) {
	        var _ref24 = _slicedToArray(_ref23, 2),
	            files = _ref24[0],
	            meta = _ref24[1];
	
	        // todo pass already calculated attachments here 
	
	        var file = files[meta.index];
	        if (!file) return;
	
	        var attachment = this.view.model.get('attachments').find(function (att) {
	            return file.guid && att.guid === file.guid || file.id && att.id === file.id;
	        });
	        if (!attachment) return;
	
	        var type = attachment.type || attachment.file_type;
	        var deleted = attachment.deleted;
	
	        if (deleted === true || deleted === 't') $el.addClass('--deleted');else $el.removeClass('--deleted');
	
	        var finalize = function finalize(bin, attachment) {
	            // original file name is not available immediately after PATCH (bug?)
	            var apply = function apply() {
	                var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	                var imageUrl = arguments[1];
	
	                if (imageUrl) $el.find('img')[0].src = imageUrl;else $el.find('.file-instance--extension-mark').addClass('--visible').text(fileName.match(/[^\.]+$/)[0].toUpperCase() /* extension */);
	                $el.closest('.file-instance').find('.file-instance--filename').text(fileName);
	            };
	
	            if (bin) apply(bin.name, type === 'PHOTO' && bin.type.startsWith('image/') ? 'data: image/jpeg; base64, ' + btoa(bin.content) : undefined);else apply(attachment.file_name, attachment.type === 'PHOTO' ? '/rest/tasks/' + attachment.task_id + '/photos/' + attachment.num + '/crop/w128/h128' : undefined);
	        };
	
	        if (attachment.reading) if (attachment.reading.binaryFile) return finalize(attachment.reading.binaryFile);else if (attachment.reading instanceof Promise) return attachment.reading.then(function (_ref25) {
	            var binaryFile = _ref25.binaryFile;
	            return finalize(binaryFile);
	        });
	
	        finalize(undefined, attachment);
	    }
	};
	
	
	function createDateTimeStrToModelConvertor(fn) {
	    return function (value, prev) {
	        if (!value) return null;
	
	        value = fn(value, prev);
	        if (!value) return null;
	
	        return (0, _date.unixts)(value);
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _view2.default.extend({
	
	    template: 'jst/comment.view',
	
	    className: 'comment--wrapper',
	
	    serialize: function serialize() {
	        if (!this.model) return undefined;
	
	        var _model$toJSON = this.model.toJSON(),
	            comment = _model$toJSON.comment,
	            ctx = _objectWithoutProperties(_model$toJSON, ['comment']);
	
	        return _extends({}, ctx, {
	            comment: comment.replace(/<(\/?[\-_:a-zA-Z0-9]+)>/g, '&lt;$1&gt;')
	        });
	    }
	});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _View$extend;
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _v = __webpack_require__(47);
	
	var _v2 = _interopRequireDefault(_v);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _comment = __webpack_require__(75);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _comments = __webpack_require__(76);
	
	var _comments2 = __webpack_require__(78);
	
	var _comments3 = _interopRequireDefault(_comments2);
	
	var _gallery = __webpack_require__(82);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _photos = __webpack_require__(83);
	
	var _photos2 = _interopRequireDefault(_photos);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _live = __webpack_require__(16);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _view2.default.extend((_View$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        // files are common for all observable tasks
	        this.filesChannel = _channel2.default.fromEvents(this, 'file:sent');
	    },
	    onBind: function onBind(model) {
	        var _this = this;
	
	        this.needRecalcUnread_ = false;
	        if (model.comments_) onLoadComments.call(this);else
	            // todo listenToOnce
	            model.once('comments:load', function () {
	                onLoadComments.call(_this);
	                _this.render();
	            });
	
	        this.listenTo(model, 'comments:unread-incoming', function () {
	            return recalcUnreadMessagesCount.call(_this);
	        });
	
	        this.listenTo(this, 'feed:position', function (value) {
	            return localStorage['talitrum.feed.position.' + _config2.default.userId() + '.' + model.id] = value;
	        });
	
	        // todo Channel.merge
	        this.commentsChannel = _comments3.default.filter(function (message) {
	            return message instanceof _live.Insert;
	        }).filter(function (message) {
	            return message.model.task_id === +model.id || message.model.news_id === +model.id;
	        }).map(function (message) {
	            return new _comment2.default(message.model);
	        }) // model === attrs of Model
	        .merge(_channel2.default.fromEvents(this, 'comment:sent'));
	    },
	    onUnBind: function onUnBind(previousModel) {
	        this.stopListening(this, 'feed:position');
	        if (this.commentsChannel) this.commentsChannel.close();
	        if (previousModel) previousModel.off('comments:load'), this.stopListening(previousModel);
	    },
	    serialize: function serialize() {
	        if (!this.model) return {};
	
	        var _options = this.options,
	            left = _options.left,
	            right = _options.right,
	            top = _options.top,
	            bottom = _options.bottom;
	        var commentsChannel = this.commentsChannel,
	            filesChannel = this.filesChannel;
	        var _model$capabilities_ = this.model.capabilities_,
	            attach_photo_video_from_camera = _model$capabilities_.attach_photo_video_from_camera,
	            attach_photo_video_from_gallery = _model$capabilities_.attach_photo_video_from_gallery;
	
	
	        return {
	            allowAttachPhotoVideo: attach_photo_video_from_camera && attach_photo_video_from_gallery,
	            left: left, right: right, top: top, bottom: bottom,
	            commentsChannel: commentsChannel, filesChannel: filesChannel,
	            undock: this.top_ !== undefined, feedPosition: this.top_,
	            collection: this.model.comments_ && this.model.comments_ instanceof Array ? new _comments.Comments(this.model.comments_) : null
	        };
	    },
	    afterRender: function afterRender() {
	        if (!this.needRecalcUnread_) return;
	
	        this.needRecalcUnread_ = false;
	        repositionTopAfterLoadComments.call(this);
	        scrollFeed.call(this);
	    },
	
	
	    events: {
	        'wheel .feed-scroll-container': function wheelFeedScrollContainer(e) {
	            return e.stopPropagation(), e.preventDefault(), scrollFeed.call(this, e.originalEvent.deltaY), false;
	        },
	        'scroll .feed-scroll-container': function scrollFeedScrollContainer(e) {
	            return e.stopPropagation(), e.preventDefault(), false;
	        },
	        'touchmove .feed-scroll-container': function touchmoveFeedScrollContainer(e) {
	            return e.stopPropagation(), e.preventDefault(), false;
	        },
	        'click .comment-list--unread-counter': function clickCommentListUnreadCounter() {
	            return scrollFeed.call(this, 1000000000), false;
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('Form:send'), function (text, replyTo, filePromise) {
	    var _this2 = this;
	
	    if (filePromise) return this.trigger('file:sent', filePromise.then(function (file) {
	        return attach(_this2.model.id, text, file);
	    }));
	
	    var uuid = (0, _v2.default)();
	
	    this.trigger('comment:sent', new _comment2.default({
	        uuid: uuid,
	        user_id: +_config2.default.userId(),
	        fio: _config2.default.user(),
	        type: 1,
	        date: new Date(),
	        task_id: +this.model.id,
	        comment: text,
	        parent: replyTo ? replyTo.toJSON() : undefined
	    }));
	
	    post(this.model.id, text, uuid, replyTo ? replyTo.id : null);
	}), _defineProperty(_View$extend, _view2.default.event('List:gallery:open'), function (activePhotoId) {
	    openGallery(this.model, activePhotoId);
	}), _defineProperty(_View$extend, _view2.default.event('List:list-modified'), function () {
	    return showScrollBar.call(this);
	}), _defineProperty(_View$extend, _view2.default.event('List:reply:begin'), function (replyTo) {
	    this.Form.trigger('reply:begin', replyTo);
	}), _View$extend));
	
	
	function post(taskId, comment, uuid, parentId) {
	    var url = _config2.default.url('news/' + taskId + '/comments' + (parentId ? '/' + parentId : '')),
	        message = {
	        // pass action for MapAdmin-compatibility
	        action: 'post',
	        uuid: uuid,
	        comment: comment
	    };
	
	    var request = _backbone2.default.ajax({
	        url: url,
	        contentType: 'application/json; charset=UTF-8',
	        data: JSON.stringify(message),
	        method: 'post'
	    });
	
	    return (0, _promisify.promisify)(request);
	}
	
	function attach(taskId, comment, _ref) {
	    var name = _ref.name,
	        type = _ref.type,
	        originalName = _ref.originalName;
	
	    var fileType = void 0;
	    switch (type) {
	        case 'photos':
	            fileType = 'PHOTO';break;
	        case 'files':
	            fileType = 'FILE';break;
	        case 'videos':
	            fileType = 'VIDEO';break;
	        case 'sounds':
	            fileType = 'SOUND';break;
	    }
	
	    var attachments = [{
	        file: name,
	        file_name: originalName,
	        file_type: fileType
	    }];
	
	    return new _task2.default({ id: taskId }).patch({ attachments: attachments, update_comments: comment }).then(function () {
	        return {
	            date: new Date(),
	            name: originalName,
	            type: fileType
	        };
	    });
	}
	
	function openGallery(task, activePhotoId) {
	    var photos = new _photos2.default({
	        endpoint: 'news/' + task.id + '/photos?apiVersion=1.4'
	    });
	
	    // todo: multiple openGallery.clicks
	    (0, _promisify.requestify)(photos.fetch()).then(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 1),
	            photos = _ref3[0];
	
	        var urls = photos.map(function (photo) {
	            return '/news/' + task.id + '/photos/' + photo.num;
	        }).map(function (url) {
	            return _config2.default.url(url);
	        });
	
	        var activePhotoIndex = void 0;
	        photos.forEach(function (photo, index) {
	            if (+photo.id === +activePhotoId) activePhotoIndex = index;
	        });
	
	        return _gallery2.default.open(urls, activePhotoIndex);
	    });
	}
	
	function scrollFeed() {
	    var deltaY = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var listHeight = verticalSpace.call(this);
	    var contHeight = visibleSpace.call(this);
	
	    var minTop = -listHeight + contHeight;
	    var top = this.top_ !== undefined ? this.top_ : minTop;
	
	    var prevTop = this.top_;
	    top = Math.max(Math.min(top - deltaY, 0), minTop);
	    if (top < minTop + 1e-6) top = undefined;
	
	    var needDock = top === undefined;
	    var needUndock = prevTop === undefined && top !== undefined;
	
	    var $el = this.$('.feed-scroll-container');
	
	    if (needUndock) {
	        $el.off('transitionend', handleTransitionEnd);
	        $el.css('bottom', 'auto').css('top', minTop + 'px');
	        setTimeout(function () {
	            return $el.css('top', top + 'px');
	        }, 0);
	        this.trigger('feed:position', top);
	    } else if (needDock) {
	        if (prevTop !== undefined) {
	            $el.off('transitionend', handleTransitionEnd);
	            $el.on('transitionend', handleTransitionEnd);
	            $el.css('top', minTop + 'px');
	            this.trigger('feed:position', null);
	        }
	    } else {
	        $el.css('top', top + 'px');
	        this.trigger('feed:position', top);
	    }
	
	    this.top_ = top;
	
	    showScrollBar.call(this);
	    recalcUnreadMessagesCount.call(this);
	}
	
	function handleTransitionEnd() /*e*/{
	    var $el = (0, _jquery2.default)(this);
	    $el.off('transitionend', handleTransitionEnd);
	    $el.css('top', 'auto').css('bottom', '0');
	}
	
	function showScrollBar() {
	    var _this3 = this;
	
	    var scrollHeight = visibleSpace.call(this) / verticalSpace.call(this) * visibleSpace.call(this);
	    if (scrollHeight > visibleSpace.call(this)) return this.$('.feed-scroll').css('display', 'none');
	
	    var bottom = void 0;
	    if (this.top_ === undefined) bottom = 0;else {
	        var minTop = visibleSpace.call(this) - verticalSpace.call(this);
	        var ratio = (minTop - this.top_) / minTop;
	        bottom = (visibleSpace.call(this) - scrollHeight) * ratio;
	    }
	
	    this.$('.feed-scroll').css({
	        display: 'block',
	        height: scrollHeight + 'px',
	        bottom: bottom + 'px'
	    });
	
	    this.$('.feed-scroll').removeClass('__fade-out-after-3000');
	    setTimeout(function () {
	        return _this3.$('.feed-scroll').addClass('__fade-out-after-3000');
	    }, 0);
	}
	
	function verticalSpace() {
	    return this.List.$el.height();
	}
	
	function visibleSpace() {
	    // todo via class
	    return this.$('.feed-scroll-container').parent().height();
	}
	
	function onLoadComments() {
	    this.needRecalcUnread_ = true;
	
	    var feedPosition = localStorage['talitrum.feed.position.' + _config2.default.userId() + '.' + this.model.id];
	    this.top_ = feedPosition === 'null' || feedPosition === undefined ? undefined : parseFloat(feedPosition);
	}
	
	function repositionTopAfterLoadComments() {
	    var unread = this.model.get('unread_message_count');
	    if (unread == null || +unread === 0) return;
	
	    if (this.top_ != undefined) return;
	
	    if (+unread <= 5) return;
	
	    var $lastEl = this.$('.comment--wrapper').eq(this.model.comments_.length - unread + 5);
	
	    var _$lastEl$position = $lastEl.position(),
	        elTop = _$lastEl$position.top;
	
	    var newTop = visibleSpace.call(this) - elTop;
	
	    if (newTop < 0) this.top_ = newTop, this.$('.feed-scroll-container').css('top', newTop + 'px').css('bottom', 'auto');
	}
	
	var recalcUnreadMessagesCount = _underscore2.default.debounce(function () {
	    var unread = this.model.get('unread_message_count');
	    if (unread === null) return;
	
	    var lastRead = this.model.comments_[0];
	    if (this.top_ === undefined) return this.model.set('unread_message_count', 0), // todo null
	    this.trigger('comments:recalc-unread', this.model), _jquery2.default.post(_config2.default.url('/chats/' + lastRead.chat_id + '/messages/' + lastRead.chat_message_number + '/read'));
	
	    var bottomLine = -this.top_ + visibleSpace.call(this);
	
	    var $comments = this.$('.comments-list--item');
	    var i = $comments.length - unread;while (i < $comments.length) {
	        if ($comments.eq(i).position().top + $comments.eq(i).height() <= bottomLine) i++;else break;
	    }var delta = i - $comments.length + unread;
	    lastRead = i > 0 && this.model.comments_[this.model.comments_.length - i];
	    if (delta > 0) this.model.set('unread_message_count', unread - delta), this.trigger('comments:recalc-unread', this.model), console.log(lastRead), lastRead && _jquery2.default.post(_config2.default.url('/chats/' + lastRead.chat_id + '/messages/' + lastRead.chat_message_number + '/read'));
	}, 250);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var guid = 0;
	
	var listener = _underscore2.default.extend({}, _backbone2.default.Events);
	
	var Channel = function () {
	    function Channel(writerFn) {
	        var _this = this;
	
	        _classCallCheck(this, Channel);
	
	        this.readers_ = {};
	        this.closeHandlers_ = [];
	
	        if (!writerFn) return;
	
	        writerFn(function (message) {
	            return !_this.closed_ && _this.write_(message);
	        }, function () {
	            return _this.close();
	        });
	    }
	
	    // writerFn = (writeFn, ...eventArguments) => { ... writeFn( ... ); }
	
	
	    _createClass(Channel, [{
	        key: 'write_',
	        value: function write_(message) {
	            var _this2 = this;
	
	            // todo: if (!this.closed_) ???
	            Object.keys(this.readers_).map(function (id) {
	                return _this2.readers_[id];
	            }).forEach(function (readerFn) {
	                return readerFn(message);
	            });
	        }
	    }, {
	        key: 'forEach',
	        value: function forEach(readerFn) {
	            this.readers_[guid] = readerFn;
	            return guid++;
	        }
	
	        // todo: dest to Channel
	
	    }, {
	        key: 'dest',
	        value: function dest(writeFn) {
	            this.forEach(writeFn);
	        }
	    }, {
	        key: 'spawn',
	        value: function spawn(fn) {
	            var _this3 = this;
	
	            var readerId = void 0;
	            // todo: if parent channel closed?
	            var ch = new Channel(function (writeFn) {
	                return readerId = _this3.forEach(function (message) {
	                    return fn(message, writeFn);
	                });
	            });
	
	            ch.end(function () {
	                return delete _this3.readers_[readerId];
	            });
	
	            return ch;
	        }
	
	        // spawns new channels, each of them receives
	        // only properties named by ...propNames from each message
	
	    }, {
	        key: 'split',
	        value: function split() {
	            var _this4 = this;
	
	            for (var _len = arguments.length, propNames = Array(_len), _key = 0; _key < _len; _key++) {
	                propNames[_key] = arguments[_key];
	            }
	
	            return propNames.map(function (propName) {
	                return _this4.prop(propName);
	            });
	        }
	    }, {
	        key: 'merge',
	        value: function merge() {
	            for (var _len2 = arguments.length, channels = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                channels[_key2] = arguments[_key2];
	            }
	
	            // todo: if ...channels all closed
	            channels.push(this);
	            return new Channel(function (writeFn) {
	                return channels.forEach(function (ch) {
	                    return ch.dest(writeFn);
	                });
	            });
	        }
	
	        // converts [...] message into individual messages
	
	    }, {
	        key: 'flatten',
	        value: function flatten() {
	            return this.spawn(function (message, writeFn) {
	                if (message instanceof Array) return message.forEach(function (m) {
	                    return writeFn(m);
	                });
	
	                writeFn(message);
	            });
	        }
	    }, {
	        key: 'filter',
	        value: function filter(filterFn) {
	            return this.spawn(function (message, writeFn) {
	                if (!!filterFn(message)) writeFn(message);
	            });
	        }
	    }, {
	        key: 'map',
	        value: function map(mapFn) {
	            return this.spawn(function (message, writeFn) {
	                return writeFn(mapFn(message));
	            });
	        }
	    }, {
	        key: 'prop',
	        value: function prop(propName) {
	            return this.spawn(function (message, writeFn) {
	                if (propName in message) writeFn(message[propName]);
	            });
	        }
	    }, {
	        key: 'close',
	        value: function close() {
	            if (this.closed_) return;
	
	            this.closeHandlers_.forEach(function (fn) {
	                return fn();
	            });
	
	            // todo: close readers if those are channels
	            this.closed_ = true;
	            this.readers_ = {};
	            this.closeHandlers_ = [];
	        }
	    }, {
	        key: 'end',
	        value: function end(handleFn) {
	            if (this.closed_) return handleFn(), undefined;
	
	            this.closeHandlers_.push(handleFn);
	        }
	    }], [{
	        key: 'fromEvents',
	        value: function fromEvents(emitter, eventName) {
	            var writerFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (writeFn) {
	                for (var _len3 = arguments.length, eventArguments = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	                    eventArguments[_key3 - 1] = arguments[_key3];
	                }
	
	                return writeFn.apply(undefined, eventArguments);
	            };
	
	            // todo stopListening
	            return new Channel(function (writeFn) {
	                return listener.listenTo(emitter, eventName, function () {
	                    for (var _len4 = arguments.length, eventArguments = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                        eventArguments[_key4] = arguments[_key4];
	                    }
	
	                    return writerFn.apply(undefined, [writeFn].concat(eventArguments));
	                });
	            });
	        }
	    }]);
	
	    return Channel;
	}();
	
	exports.default = Channel;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	    initialize: function initialize(attrs) {
	        _model2.default.prototype.initialize.call(this, attrs);
	
	        if ('string' === typeof attrs.date) this.set('date', (0, _date.parseYYYYMMDD)(attrs.date), { silent: true });else if ('number' === typeof attrs.date) this.set('date', new Date(attrs.date * 1000), { silent: true });
	    },
	    customParser: function customParser(payload) {
	        payload.done = true;
	
	        if ('string' === typeof payload.date) payload.date = (0, _date.parseYYYYMMDD)(payload.date);else if ('number' === typeof payload.date) payload.date = new Date(payload.date * 1000);
	
	        return payload;
	    }
	});

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetch = exports.Comments = undefined;
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _comment = __webpack_require__(75);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _api = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Comments = exports.Comments = _collection2.default.extend({
	    model: _comment2.default,
	    responseAt: 'comments'
	});
	
	var fetch = exports.fetch = function fetch(taskId) {
	    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000000;
	
	    return (0, _api.get)('tasks/' + taskId + '/comments/list?limit=' + limit + '&apiVersion=1.3').cerebellum().hidden().map(function (response) {
	        return response.comments;
	    }).execute().then(function (items) {
	        return new Comments(items);
	    }).then(function (coll) {
	        return [coll.toJSON(), coll];
	    });
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.del = exports.put = exports.ptc = exports.pst = exports.get = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _urlify = __webpack_require__(15);
	
	var _urlify2 = _interopRequireDefault(_urlify);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var get = request('get');
	var pst = request('post');
	var ptc = request('patch');
	var put = request('put');
	var del = request('delete');
	
	exports.get = get;
	exports.pst = pst;
	exports.ptc = ptc;
	exports.put = put;
	exports.del = del;
	
	
	window.get = get;
	
	function request(method) {
	    return function (url) {
	        return extendRequest(function (_ref) {
	            for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                params[_key - 1] = arguments[_key];
	            }
	
	            var sealed = _ref.sealed,
	                hidden = _ref.hidden,
	                body = _ref.body,
	                blocking = _ref.blocking,
	                view = _ref.view,
	                _ref$tokenize = _ref.tokenize,
	                tokenize = _ref$tokenize === undefined ? false : _ref$tokenize,
	                _ref$basify = _ref.basify,
	                basify = _ref$basify === undefined ? false : _ref$basify;
	            return new Promise(function (resolve, reject) {
	                if (!params.length) params = [{}];
	
	                var parsedUrl = new _urlify2.default(url);
	
	                if (!sealed) {
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = params[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var _pi = _step.value;
	
	                            parsedUrl.substitute(_pi);
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	                }if (!hidden) (0, _loader.requestBegins)();
	                if (blocking) (0, _loader.beginLock)(view);
	
	                _jquery2.default.ajax({
	                    method: method,
	                    contentType: 'application/json; charset=UTF-8',
	                    data: body ? JSON.stringify(body) : ['post', 'put', 'patch'].indexOf(method) !== -1 ? '{}' : undefined,
	                    url: _config2.default.url(parsedUrl.toString(), { addToken: tokenize, addBase: basify }),
	                    success: function success(response) {
	                        return !hidden && (0, _loader.requestEnds)(), blocking && (0, _loader.endLock)(view), resolve([response, response].concat(_toConsumableArray(params)));
	                    },
	                    error: function error() {
	                        for (var _len2 = arguments.length, errors = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                            errors[_key2] = arguments[_key2];
	                        }
	
	                        return !hidden && (0, _loader.requestEnds)(), blocking && (0, _loader.endLock)(view), reject([errors]);
	                    }
	                });
	            });
	        });
	    };
	}
	
	function extendRequest(fn) {
	    fn.options = function (options0) {
	        return extendRequest(function (_ref2) {
	            for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	                params[_key3 - 1] = arguments[_key3];
	            }
	
	            var options = _objectWithoutProperties(_ref2, []);
	
	            return fn.apply(undefined, [_extends({}, options0, options)].concat(params));
	        });
	    };
	
	    fn.sealed = function () {
	        return fn.options({ sealed: true });
	    };
	
	    fn.hidden = function () {
	        return fn.options({ hidden: true });
	    };
	
	    fn.body = function (body) {
	        return fn.options({ body: body });
	    };
	
	    fn.cerebellum = function () {
	        return fn.options({ tokenize: true, basify: true });
	    };
	
	    fn.mapsurfer = function () {
	        return fn.options({ tokenize: true });
	    };
	
	    fn.blocking = function (view) {
	        return fn.options({ blocking: true, view: view });
	    };
	
	    return extendResponse(fn);
	}
	
	function extendResponse(func) {
	
	    func.reduce = function (fn, f0, zero) {
	        return extendResponse(function () {
	            return func.apply(undefined, arguments).then(function (_ref3) {
	                var _ref4 = _toArray(_ref3),
	                    result = _ref4[0],
	                    response = _ref4[1],
	                    others = _ref4.slice(2);
	
	                if (result === undefined) return [result, response].concat(_toConsumableArray(others));
	
	                if (typeof result.reduce !== 'function') return [f0.apply(undefined, [result, response].concat(_toConsumableArray(others))), response].concat(_toConsumableArray(others));
	
	                var reduceFn = function reduceFn(cu, el, i) {
	                    return fn.apply(undefined, [cu, el, i, result, response].concat(_toConsumableArray(others)));
	                };
	                return [result.reduce(reduceFn, zero), response].concat(_toConsumableArray(others));
	            });
	        });
	    };
	
	    func.chain = function (f) {
	        return extendResponse(function () {
	            for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                params[_key4] = arguments[_key4];
	            }
	
	            return func.apply(undefined, params).then(function (_ref5) {
	                var _fResult;
	
	                var _ref6 = _toArray(_ref5),
	                    result0 = _ref6[0],
	                    response0 = _ref6[1],
	                    others = _ref6.slice(2);
	
	                if (!result0) return [result0, response0].concat(_toConsumableArray(others));
	
	                var fResult = f.apply(undefined, [result0, response0].concat(_toConsumableArray(others)));
	                if (fResult.execute) fResult = (_fResult = fResult).execute.apply(_fResult, params);
	
	                return fResult.then(function (response) {
	                    return [response, response, result0].concat(_toConsumableArray(others));
	                });
	            });
	        });
	    };
	
	    func.execute = function () {
	        for (var _len5 = arguments.length, params = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	            params[_key5] = arguments[_key5];
	        }
	
	        return func.apply(undefined, [{}].concat(params)).then(function (_ref7) {
	            var _ref8 = _slicedToArray(_ref7, 1),
	                result /*, ...tail*/ = _ref8[0];
	
	            return result;
	        });
	    };
	
	    func.map = function (f) {
	        return func.reduce(function (cu, el) {
	            for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	                args[_key6 - 2] = arguments[_key6];
	            }
	
	            return [].concat(_toConsumableArray(cu), [f.apply(undefined, [el].concat(args))]);
	        }, function (el) {
	            for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	                args[_key7 - 1] = arguments[_key7];
	            }
	
	            return f.apply(undefined, [el].concat(args));
	        }, []);
	    };
	
	    func.filter = function (f) {
	        return func.reduce(function (cu, el) {
	            for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	                args[_key8 - 2] = arguments[_key8];
	            }
	
	            return f.apply(undefined, [el].concat(args)) ? [].concat(_toConsumableArray(cu), [el]) : cu;
	        }, function (el) {
	            for (var _len9 = arguments.length, args = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
	                args[_key9 - 1] = arguments[_key9];
	            }
	
	            return f.apply(undefined, [el].concat(args)) ? el : undefined;
	        }, []);
	    };
	
	    func.concat = function () {
	        return func.reduce(function (cu, el) {
	            return [].concat(_toConsumableArray(cu), _toConsumableArray(el));
	        },
	        // stub fn: must be never called
	        function (cu, el) {
	            return [].concat(_toConsumableArray(cu), _toConsumableArray(el));
	        }, []);
	    };
	
	    func.peek = function (f) {
	        return func.reduce(function (cu, el) {
	            for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	                args[_key10 - 2] = arguments[_key10];
	            }
	
	            return f.apply(undefined, [el].concat(args)), [].concat(_toConsumableArray(cu), [el]);
	        }, function (el) {
	            for (var _len11 = arguments.length, args = Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
	                args[_key11 - 1] = arguments[_key11];
	            }
	
	            return f.apply(undefined, [el].concat(args)), el;
	        }, []);
	    };
	
	    return func;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	     value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _hub = __webpack_require__(79);
	
	var _hub2 = _interopRequireDefault(_hub);
	
	var _live = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Hub$prop$split = _hub2.default.prop('issues').split('commentInsert', 'commentUpdate', 'commentDelete'),
	    _Hub$prop$split2 = _slicedToArray(_Hub$prop$split, 3),
	    insert = _Hub$prop$split2[0],
	    update = _Hub$prop$split2[1],
	    remove = _Hub$prop$split2[2];
	
	insert = insert.flatten().map(function (attrs) {
	     return new _live.Insert(attrs);
	});
	update = update.flatten().map(function (attrs) {
	     return new _live.Update(attrs);
	});
	remove = remove.flatten().map(function (attrs) {
	     return new _live.Delete(attrs);
	});
	
	exports.default = new _channel2.default().merge(insert, update, remove);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _auth = __webpack_require__(39);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _immortal = __webpack_require__(80);
	
	var _immortal2 = _interopRequireDefault(_immortal);
	
	var _ws = __webpack_require__(81);
	
	var _ws2 = _interopRequireDefault(_ws);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hub = new _channel2.default(function (writeFn) {
	    return _auth2.default.then(function () {
	        return (0, _immortal2.default)(function () {
	            return (0, _ws2.default)('/news/cache?apiVersion=2.0');
	        }, 5, // 5 attempts
	        15 * 1000, // in 15 secs each,
	        5 * 60 * 1000 // reconnecting in 5 min 
	        );
	    }).then(function (ch) {
	        return ch.dest(writeFn);
	    });
	});
	
	exports.default = Hub;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = immortal;
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function immortal(connectFn, reconnectAttemptCount, reconnectAttemptDelay, reconnectTimeout) {
	    return new _channel2.default(function (writeFn) {
	        reconnect();
	
	        function makeAttempts(attemptsLeft) {
	            if (!attemptsLeft) return Promise.reject();
	
	            return connectFn().then(function (ch) {
	                ch.forEach(function (message) {
	                    return writeFn(message);
	                });
	                ch.end(function () {
	                    return reconnect();
	                });
	            }).catch(function (e) {
	                if (attemptsLeft > 1) return attemptsLeft--, console.log(attemptsLeft + ' attempt(s) left, waiting for ' + Math.floor(reconnectAttemptDelay / 1000) + ' secs.'), (0, _promisify.delay)(reconnectAttemptDelay).then(function () {
	                    return makeAttempts(attemptsLeft);
	                });
	
	                throw e;
	            });
	        }
	
	        function reconnect() {
	            return makeAttempts(reconnectAttemptCount).catch(function () {
	                console.log(reconnectAttemptCount + ' attempts failed, next attempt in ' + Math.floor(reconnectTimeout / 1000) + ' secs.');
	                return (0, _promisify.delay)(reconnectTimeout).then(function () {
	                    return reconnect();
	                });
	            });
	        }
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _auth = __webpack_require__(39);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = connect;
	
	
	function connect(baseUrl) {
	
	    var conn = _auth2.default.then(function (_ref) {
	        var token = _ref.token;
	
	        return new Promise(function (resolve, reject) {
	            var hostPort = _config2.default.wsHost();
	            if (!hostPort) {
	                var m = location.href.match('http(s?)://([^:/]+):?([0-9]+)?'),
	                    scheme = m[1] ? 'wss' : 'ws',
	                    host = m[2],
	                    port = m[3] || '';
	
	                hostPort = scheme + '://' + host + (port ? ':' : '') + port;
	            }
	
	            var url = '' + hostPort + _config2.default.wsBase() + baseUrl + (~baseUrl.indexOf('?') ? '&' : '?') + 'token=' + token;
	            var socket = new WebSocket(url);
	
	            socket.onopen = function () {
	                return resolve(socket);
	            };
	            socket.onerror = function (e) {
	                console.error(e);
	                reject(e);
	            };
	        });
	    });
	
	    conn.catch(function (e) {
	        return console.log(baseUrl + ': connection attempt failed');
	    });
	
	    return conn.then(function (socket) {
	
	        // create and run pinger
	        var pingInterval = setInterval(function () {
	            return socket.send('{}');
	        }, 15000);
	
	        // todo: delete channel when closing
	        return new _channel2.default(function (writeFn, closeFn) {
	            socket.onmessage = function (message) {
	                return writeFn(JSON.parse(message.data));
	            };
	
	            socket.onclose = function (e) {
	                if (e.wasClean) console.log(baseUrl + ': connection closed');else
	                    // for example, server process killed
	                    console.error(baseUrl + ': connection has been broken');
	
	                clearInterval(pingInterval);
	
	                if (closeFn) closeFn();
	            };
	        });
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Gallery = _view2.default.extend({
	
	    template: 'jst/gallery',
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { urls: [] };
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        this.urls_ = options.urls;
	    },
	    open: function open(index) {
	        this.$('a').eq(index || 0).click();
	    },
	    serialize: function serialize() {
	        var guid = String(Math.random());
	        return {
	            guid: guid,
	            urls: this.urls_.slice()
	        };
	    },
	    afterRender: function afterRender(context, firstTime) {
	        if (firstTime) this.$('a').fancybox({
	            buttons: ['fullScreen', 'close']
	        });
	    }
	}, {
	    open: function open(urls, index) {
	        new Gallery({ urls: urls }).render().then(function (view) {
	            view.$el.appendTo(document.body);
	            view.open(index);
	        });
	    }
	});
	
	exports.default = Gallery;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	    responseAt: 'photos'
	});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _view2.default.extend(_defineProperty({
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        this.listenTo(this, 'reply:begin', function (replyTo) {
	            _this.file_ = null;
	            _this.replyTo_ = replyTo;
	            _this.render().then(function (view) {
	                return view.$('textarea').focus();
	            });
	        });
	    },
	
	
	    events: {
	
	        'keydown textarea': function keydownTextarea(e) {
	            if (e.keyCode !== 13) return;
	
	            return send(this), e.preventDefault(), false;
	        },
	
	        'keyup textarea': function keyupTextarea() {
	            this.text_ = this.$('textarea').val();
	        },
	
	        'click .comment-form--attached-file-remove': function clickCommentFormAttachedFileRemove() {
	            this.removeAttachment();
	        },
	
	        'click .comment-form--attached-file-send': function clickCommentFormAttachedFileSend() {
	            return send(this), false;
	        },
	
	        'click .comment-form--reply-remove': function clickCommentFormReplyRemove() {
	            this.removeReply();
	        }
	
	    },
	
	    serialize: function serialize() {
	        var allowAttachPhotoVideo = this.options.allowAttachPhotoVideo;
	
	        if (allowAttachPhotoVideo === undefined) allowAttachPhotoVideo = true;
	
	        var ctx = {
	            commentText: this.text_ || '',
	            allowAttachPhotoVideo: allowAttachPhotoVideo
	        };
	
	        if (this.file_) ctx.file = Object.create(this.file_);
	
	        if (this.replyTo_) ctx.replyTo = this.replyTo_.toJSON();
	
	        return ctx;
	    },
	    onBind: function onBind(model) {
	        this.file_ = null;
	        this.text_ = null;
	        this.replyTo_ = null;
	    },
	    removeAttachment: function removeAttachment() {
	        this.file_ = null;
	        this.render();
	    },
	    removeReply: function removeReply() {
	        this.replyTo_ = null;
	        this.render().then(function (view) {
	            return view.$('textarea').focus();
	        });
	    },
	    attach_: function attach_(originalName, type, uploading) {
	        this.replyTo_ = null;
	        this.file_ = {
	            originalName: originalName,
	            type: type,
	            uploading: uploading
	        };
	
	        this.render().then(function (view) {
	            return view.$('textarea').focus();
	        });
	    }
	}, _view2.default.event('AttachControls:file:upload-done'), function (originalName, type, fileSemantics, uploading) {
	    this.attach_(originalName, type, uploading);
	}));
	
	
	function send(view) {
	    var attachment = void 0;
	    if (view.file_) {
	        var _view$file_ = view.file_,
	            type = _view$file_.type,
	            originalName = _view$file_.originalName;
	
	        attachment = view.file_.uploading.then(function (name) {
	            return { name: name, type: type, originalName: originalName };
	        });
	    }
	
	    view.trigger('send', view.$('textarea').val(), view.replyTo_, attachment);
	
	    view.file_ = null;
	    view.text_ = null;
	    view.replyTo_ = null;
	
	    view.render().then(function (view) {
	        return view.$('textarea').focus();
	    });
	}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _comment = __webpack_require__(75);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _comment3 = __webpack_require__(72);
	
	var _comment4 = _interopRequireDefault(_comment3);
	
	var _fileBadge = __webpack_require__(86);
	
	var _fileBadge2 = _interopRequireDefault(_fileBadge);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	    },
	
	
	    events: {
	        'click .comment--thumbnail': function clickCommentThumbnail(_ref) {
	            var currentTarget = _ref.currentTarget;
	            var fileId = currentTarget.dataset.fileId;
	
	            if (!fileId) return;
	
	            this.trigger('gallery:open', fileId);
	        },
	
	        'click .--delivered .comment--reply-link': function clickDeliveredCommentReplyLink(_ref2) {
	            var currentTarget = _ref2.currentTarget;
	
	            var $commentEl = this.$(currentTarget).closest('.comment');
	            var _$commentEl$0$dataset = $commentEl[0].dataset,
	                replyId = _$commentEl$0$dataset.replyId,
	                replyComment = _$commentEl$0$dataset.replyComment,
	                replyUpdate_text = _$commentEl$0$dataset.replyUpdate_text,
	                replyFio = _$commentEl$0$dataset.replyFio,
	                replyDate = _$commentEl$0$dataset.replyDate;
	
	
	            var comment = new _comment2.default({
	                type: 1,
	                id: +replyId,
	                comment: replyComment,
	                update_text: replyUpdate_text,
	                fio: replyFio,
	                date: new Date(replyDate)
	            });
	
	            this.trigger('reply:begin', comment);
	        }
	    },
	
	    onBind: function onBind(model) {
	        var _this = this;
	
	        this.loaded_ = {};
	        this.options.collection.toJSON().map(function (comment) {
	            return comment.uuid;
	        }).map(function (uuid) {
	            return [uuid, function () {
	                return _backbone2.default.$('[data-uuid="' + uuid + '"]').parent();
	            }];
	        }).forEach(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                uuid = _ref4[0],
	                $elfn = _ref4[1];
	
	            return _this.loaded_[uuid] = Promise.resolve($elfn);
	        });
	
	        // those are channels
	        var _options = this.options,
	            commentsChannel = _options.commentsChannel,
	            filesChannel = _options.filesChannel;
	
	        if (!commentsChannel || !filesChannel) return;
	
	        if (!this.filesChannel) this.filesChannel = filesChannel, filesChannel.forEach(function (uploading) {
	            return new _fileBadge2.default({ uploading: uploading }).render().then(function (view) {
	                return view.$el.appendTo(_this.$('.comments-list'));
	            }).then(function () {
	                return _this.trigger('list-modified');
	            });
	        });
	
	        commentsChannel.forEach(function (comment) {
	            var uuid = comment.get('uuid');
	            var renderingComment = _this.loaded_[uuid];
	
	            // server received comment -> mark as received
	            if (renderingComment) return renderingComment.then(function ($elfn) {
	                return $elfn().find('.comment').addClass('--delivered')[0].dataset.replyId = comment.id;
	            });
	
	            // server not received comment -> prerender it
	            var view = new _comment4.default();
	            _this.loaded_[uuid] = view.bind(comment).then(function () {
	                return (/*view*/view.$el.appendTo(_this.$('.comments-list'))
	                );
	            }).then(function () {
	                return _this.trigger('list-modified');
	            }).then(function () {
	                return function () {
	                    return view.$el;
	                };
	            });
	        });
	    },
	    serialize: function serialize() {
	        if (!this.model) return { comments: [] };
	
	        // add fake date in the past to force adding separator
	        // into the beginning of list
	        var comments = [makeSeparator(new Date(0))].concat(_toConsumableArray(this.options.collection.toJSON().reverse()));
	
	        // automatically insert date separators between comments
	        comments = (0, _arrays.diffuse)(comments, function (prev, next) {
	            return (0, _date.is)(prev.date, next.date) ? undefined : makeSeparator(next.date);
	        });
	        // remove fake item in the beginning
	        comments.shift();
	
	        var td = (0, _date.today)();
	        var hasToday = comments.filter(function (comment) {
	            return comment.separator;
	        }).some(function (separator) {
	            return (0, _date.is)(separator.date, td);
	        });
	
	        if (!hasToday)
	            // if there is no "today" mark:
	            // it always must be added to the end of list
	            // (see "fake item" above to know why)
	            comments.push(makeSeparator(td));
	
	        return { comments: comments };
	    }
	});
	
	
	function makeSeparator(date) {
	    var prefix = '';
	    if ((0, _date.is)(date, (0, _date.today)())) prefix = 'dates::today';else if ((0, _date.is)(date, (0, _date.yesterday)((0, _date.today)()))) prefix = 'dates::yesterday';
	
	    var mask = date.getFullYear() === (0, _date.today)().getFullYear() ? 'DofMonth' : 'DofMonthYYYY';
	
	    return {
	        separator: true,
	        'caption-verbose': '' + prefix,
	        'caption-date-mask': mask,
	        date: date
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	
	    template: 'jst/file.uploading.badge',
	
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        options.uploading.then(function () {
	            return _this.done_ = true;
	        }, function (e) {
	            return _this.error_ = e;
	        }).then(function () {
	            return _this.render();
	        });
	
	        this.done_ = false;
	        this.error_ = null;
	    },
	    serialize: function serialize() {
	        return {
	            active: !this.done_ && !this.error_,
	            done: this.done_,
	            error: this.error_
	        };
	    }
	});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        return {
	            locale: _config2.default.locale()
	        };
	    }
	});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend({
	
	    events: {
	        'click .-set-page': function clickSetPage(e) {
	            var arrayIndex = e.currentTarget.dataset.arrayIndex;
	            var _options = this.options,
	                breadcrumbs = _options.breadcrumbs,
	                parentProperty = _options.parentProperty;
	
	            var _reverse = [].concat(_toConsumableArray(breadcrumbs)).reverse(),
	                _reverse2 = _slicedToArray(_reverse, 1),
	                lastCrumb = _reverse2[0];
	
	            var _parentProperty$child = parentProperty.children.filter(function (childProperty) {
	                return childProperty.name == lastCrumb.name;
	            }).filter(function (childProperty) {
	                return childProperty.array_index == arrayIndex;
	            }),
	                _parentProperty$child2 = _slicedToArray(_parentProperty$child, 1),
	                page = _parentProperty$child2[0];
	
	            this.trigger('set-page', page);
	        }
	    },
	
	    serialize: function serialize() {
	        var _options2 = this.options,
	            breadcrumbs = _options2.breadcrumbs,
	            parentProperty = _options2.parentProperty;
	
	
	        var pages = void 0;
	        if (breadcrumbs.length && parentProperty) {
	            var _reverse3 = [].concat(_toConsumableArray(breadcrumbs)).reverse(),
	                _reverse4 = _slicedToArray(_reverse3, 1),
	                lastCrumb = _reverse4[0];
	
	            pages = parentProperty.children.filter(function (childProperty) {
	                return childProperty.name == lastCrumb.name;
	            }).sort(function (a, b) {
	                return a.array_index - b.array_index;
	            });
	            if (pages.length === 1) pages = [];
	        }
	
	        return {
	            breadcrumbs: breadcrumbs,
	            pages: pages
	        };
	    }
	});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    events: {
	        'click .-intermediate-property--add-start': function clickIntermediatePropertyAddStart() {
	            this.trigger('intermediate-property:add-start');
	        },
	        'click .-terminal-property--add-start': function clickTerminalPropertyAddStart() {
	            this.trigger('terminal-property:add-start');
	        }
	    }
	});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _form2.default.extend({
	
	    events: {
	        'click .-add-edit-save': function clickAddEditSave() {
	            if (!this.validate()) return;
	            this.trigger('intermediate-property:add-edit-save', this.model.toJSON());
	        },
	        'click .-add-edit-cancel': function clickAddEditCancel() {
	            this.trigger('intermediate-property:add-edit-cancel');
	        }
	    },
	
	    validate: function validate() {
	        var _this = this;
	
	        this.$('.form-group').removeClass('has-error has-warning');
	        var $errorsFound = this.$el.find('fieldset').filter(':not(:disabled)').find('.form-group').filter(function (index, el) {
	            return _this.$(el).find('input, select, textarea').filter(':invalid').length;
	        }).addClass('has-error').first();
	
	        $errorsFound.find('input, select, textarea').focus();
	
	        return !$errorsFound[0];
	    },
	    serialize: function serialize() {
	        return {
	            title: this.options.title
	        };
	    }
	});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	
	    events: {
	        'click .-level-up': function clickLevelUp(e) {
	            this.trigger('property:level-up');
	        },
	        'click .-enter-item': function clickEnterItem(e) {
	            e.stopPropagation();
	
	            var propertyId = e.currentTarget.dataset.propertyId;
	
	            var _options$rootProperty = this.options.rootProperty.children.filter(function (property) {
	                return property.id == propertyId;
	            }),
	                _options$rootProperty2 = _slicedToArray(_options$rootProperty, 1),
	                propertyToEnter = _options$rootProperty2[0];
	
	            this.trigger('property:enter-item', propertyToEnter);
	        },
	        'click .-edit-start': function clickEditStart(e) {
	            e.stopPropagation();
	
	            var propertyId = e.currentTarget.dataset.propertyId;
	
	            var _options$rootProperty3 = this.options.rootProperty.children.filter(function (property) {
	                return property.id == propertyId;
	            }),
	                _options$rootProperty4 = _slicedToArray(_options$rootProperty3, 1),
	                propertyToEdit = _options$rootProperty4[0];
	
	            if (propertyToEdit.is_terminal) this.trigger('terminal-property:edit-start', propertyToEdit);else this.trigger('intermediate-property:edit-start', propertyToEdit);
	        },
	        'click .-remove': function clickRemove(e) {
	            e.stopPropagation();
	
	            var propertyId = e.currentTarget.dataset.propertyId;
	
	            var _options$rootProperty5 = this.options.rootProperty.children.filter(function (property) {
	                return property.id == propertyId;
	            }),
	                _options$rootProperty6 = _slicedToArray(_options$rootProperty5, 1),
	                propertyToRemove = _options$rootProperty6[0];
	
	            this.trigger('property:remove', propertyToRemove);
	        },
	        'click .-remove-sibling': function clickRemoveSibling(e) {
	            e.stopPropagation();
	
	            var propertyId = e.currentTarget.dataset.propertyId;
	
	            var _options$rootProperty7 = this.options.rootProperty.children.filter(function (property) {
	                return property.id == propertyId;
	            }),
	                _options$rootProperty8 = _slicedToArray(_options$rootProperty7, 1),
	                propertyToRemove = _options$rootProperty8[0];
	
	            this.trigger('property:remove-sibling', propertyToRemove);
	        },
	        'click .-append-child-to': function clickAppendChildTo(e) {
	            e.stopPropagation();
	
	            var propertyId = e.currentTarget.dataset.propertyId;
	
	            var _options$rootProperty9 = this.options.rootProperty.children.filter(function (property) {
	                return property.id == propertyId;
	            }),
	                _options$rootProperty10 = _slicedToArray(_options$rootProperty9, 1),
	                propertyToAppendTo = _options$rootProperty10[0];
	
	            this.trigger('property:append-child-to', propertyToAppendTo);
	        },
	        'click .-show-possible-values': function clickShowPossibleValues(e) {
	            var name = e.target.dataset.name;
	
	            this.trigger('property:show-possible-values', name);
	        }
	    },
	
	    serialize: function serialize() {
	        var _options = this.options,
	            isTop = _options.isTop,
	            rootProperty = _options.rootProperty,
	            activeProperty = _options.activeProperty;
	        var children = rootProperty.children;
	
	        var terminal = children.filter(function (property) {
	            return !!property.is_terminal;
	        }).sort(function (a, b) {
	            if (a.label < b.label) return -1;
	            if (a.label > b.label) return 1;
	            return 0;
	        });
	        var preIntermediate = children.filter(function (property) {
	            return !property.is_terminal;
	        });
	
	        var hashed = (0, _arrays.hashify)(preIntermediate, function (childProperty, hash) {
	            var key = childProperty.name;
	            var arrValue = hash[key] || [];
	            arrValue.push(childProperty);
	            return [key, arrValue];
	        });
	
	        var intermediate = Object.keys(hashed).map(function (key) {
	            return hashed[key];
	        }).map(function (siblings) {
	            siblings.sort(function (a, b) {
	                return a.array_index - b.array_index;
	            });
	
	            var _siblings = _slicedToArray(siblings, 1),
	                _siblings$ = _siblings[0],
	                id = _siblings$.id,
	                name = _siblings$.name,
	                label = _siblings$.label,
	                is_system = _siblings$.is_system;
	
	            return {
	                id: id,
	                name: name, label: label,
	                is_system: is_system,
	                siblings: siblings.length > 1 ? siblings : undefined
	            };
	        }).sort(function (a, b) {
	            if (a.label < b.label) return -1;
	            if (a.label > b.label) return 1;
	            return 0;
	        });
	
	        return {
	            intermediate: intermediate,
	            terminal: terminal,
	            activeProperty: activeProperty,
	            isTop: isTop
	        };
	    }
	});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _form2.default.extend({
	
	    events: {
	        'click .-add-edit-save': function clickAddEditSave() {
	            if (!this.validate()) return;
	            this.trigger('terminal-property:add-edit-save', this.model.toJSON());
	        },
	        'click .-add-edit-cancel': function clickAddEditCancel() {
	            this.trigger('terminal-property:add-edit-cancel');
	        }
	    },
	
	    validate: function validate() {
	        var _this = this;
	
	        this.$('.form-group').removeClass('has-error has-warning');
	        var $errorsFound = this.$el.find('fieldset').filter(':not(:disabled)').find('.form-group').filter(function (index, el) {
	            return _this.$(el).find('input, select, textarea').filter(':invalid').length;
	        }).addClass('has-error').first();
	
	        $errorsFound.find('input, select, textarea').focus();
	
	        return !$errorsFound[0];
	    },
	    serialize: function serialize() {
	        return {
	            title: this.options.title
	        };
	    }
	});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	
	    events: {
	        'click .-section--choose': function clickSectionChoose(e) {
	            var sectionId = e.currentTarget.dataset.sectionId;
	
	            var _options$items$filter = this.options.items.filter(function (section) {
	                return section.id == sectionId;
	            }),
	                _options$items$filter2 = _slicedToArray(_options$items$filter, 1),
	                sectionToChoose = _options$items$filter2[0];
	
	            this.trigger('section:choose', sectionToChoose);
	        },
	
	        'click .-section--add-start': function clickSectionAddStart() {
	            this.trigger('section:add-start');
	        },
	        'click .-section--edit-start': function clickSectionEditStart(e) {
	            e.stopPropagation();
	
	            var sectionId = e.currentTarget.dataset.sectionId;
	
	            var _options$items$filter3 = this.options.items.filter(function (section) {
	                return section.id == sectionId;
	            }),
	                _options$items$filter4 = _slicedToArray(_options$items$filter3, 1),
	                sectionToEdit = _options$items$filter4[0];
	
	            this.trigger('section:edit-start', sectionToEdit);
	        },
	
	
	        'click .-section--remove': function clickSectionRemove(e) {
	            e.stopPropagation();
	
	            var sectionId = e.currentTarget.dataset.sectionId;
	
	            this.trigger('section:remove', sectionId);
	        }
	    },
	
	    serialize: function serialize() {
	        return {
	            items: this.options.items,
	            activeSection: this.options.activeSection
	        };
	    }
	});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _roles = __webpack_require__(95);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _task = __webpack_require__(97);
	
	var _task2 = _interopRequireDefault(_task);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _form2.default.extend({
	    events: {
	        'click .-add-edit-cancel': function clickAddEditCancel() {
	            this.trigger(':possible-value:add-edit-cancel');
	        },
	        'click .-add-edit-save': function clickAddEditSave() {
	            this.trigger(':possible-value:' + this.options.saveEvent, this.model.toJSON());
	        }
	    },
	
	    onBind: function onBind(model) {
	        console.log('on bind', model);
	        this.listenTo(model, 'change', function () {
	            return console.log('model changed! =>', model.toJSON());
	        });
	    },
	
	
	    ds: {
	        states: _task2.default
	    },
	
	    serialize: function serialize() {
	        var roles = this.options.roles;
	
	        return {
	            roles: roles.toJSON(),
	            title: this.options.title,
	            type: this.options.type
	        };
	    }
	});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _role = __webpack_require__(96);
	
	var _role2 = _interopRequireDefault(_role);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	    endpoint: 'users/roles?apiVersion=2.0',
	    responseAt: 'items',
	    model: _role2.default
	});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _task = __webpack_require__(98);
	
	var _task2 = _interopRequireDefault(_task);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'tasks/states?apiVersion=2.0',
		responseAt: 'items',
		model: _task2.default
	});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	
	    events: {
	        'click .-edit': function clickEdit(e) {
	            this.trigger(':possible-value:edit-start', this.options.value);
	        },
	        'click .-remove': function clickRemove(e) {
	            this.trigger(':possible-value:remove', this.options.value);
	        },
	        'click .-order-up': function clickOrderUp(e) {
	            this.trigger(':possible-value:order-up', this.options.value);
	        },
	        'click .-order-down': function clickOrderDown(e) {
	            this.trigger(':possible-value:order-down', this.options.value);
	        }
	    },
	
	    serialize: function serialize() {
	        var _options = this.options,
	            value = _options.value,
	            type = _options.type,
	            isFirst = _options.isFirst,
	            isLast = _options.isLast;
	
	        return { value: value, type: type, isFirst: isFirst, isLast: isLast };
	    }
	});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend({
	
	    events: {
	        'click .-possible-value-add-start': function clickPossibleValueAddStart() {
	            this.trigger('possible-value:add-start');
	        }
	    },
	
	    serialize: function serialize() {
	        var _options = this.options,
	            rootProperty = _options.rootProperty,
	            editingValueModel = _options.editingValueModel,
	            roles = _options.roles;
	        var values = rootProperty.possible_values,
	            type = rootProperty.type,
	            default_value = rootProperty.default_value;
	
	        var sorted = [].concat(_toConsumableArray(values)).sort(function (a, b) {
	            return a.order_index - b.order_index;
	        });
	
	        var defaults = void 0;
	        switch (type) {
	            case 'BOOLEAN':
	                if (default_value !== null) defaults = { value: default_value };
	                break;
	            case 'DOUBLE':
	                if (default_value !== null) defaults = { value: default_value };
	                break;
	            case 'INTEGER':
	                if (default_value !== null) defaults = { value: default_value };
	                break;
	            case 'STRING':
	                if (default_value !== null) defaults = { value: default_value };
	                break;
	        }
	
	        return {
	            values: sorted,
	            type: type,
	            editingValueModel: editingValueModel,
	            defaults: defaults,
	            roles: roles
	        };
	    }
	});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        return {
	            languages: _config2.default.languages(),
	            locale: _config2.default.locale(),
	            systemTitle: _config2.default.title()
	        };
	    },
	
	
	    events: {
	        'click .-set-locale': function clickSetLocale(_ref) {
	            var currentTarget = _ref.currentTarget;
	            var locale = currentTarget.dataset.locale;
	
	            _config2.default.locale(locale);
	            location.reload();
	        }
	    }
	
	});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {};
	
	var triggerFn = _underscore2.default.debounce(function (view) {
	    return view.trigger('search', view.$('[type=text]').val());
	}, 350);
	
	var handlerFn = function handlerFn(view) {
	    var prev = values[view.cid] || '';
	    var now = view.$('[type=text]').val();
	    values[view.cid] = now;
	
	    if (prev !== now) triggerFn(view);
	};
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        if (options.queryString) values[this.cid] = options.queryString;
	
	        _view2.default.prototype.initialize.call(this, options);
	    },
	
	
	    events: {
	        'keyup input': function keyupInput(e) {
	            if (13 == e.keyCode) {
	                this.trigger('search:enter');
	                e.preventDefault();
	            }
	        },
	
	        'keydown input': function keydownInput(e) {
	            var _this = this;
	
	            switch (e.keyCode) {
	                case 38:
	                    this.trigger('search:up');
	                    e.preventDefault();
	                    return;
	                case 40:
	                    this.trigger('search:down');
	                    e.preventDefault();
	                    return;
	            }
	
	            // set timeout to correctly handle prev/now values
	            setTimeout(function () {
	                return handlerFn(_this);
	            }, 0);
	        }
	    },
	
	    focus: function focus() {
	        this.$('[type=text]').focus();
	    }
	});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ace = __webpack_require__(104);
	
	var _ace2 = _interopRequireDefault(_ace);
	
	var _modePython = __webpack_require__(105);
	
	var _modePython2 = _interopRequireDefault(_modePython);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var code = this.options.code;
	
	        return { code: code };
	    },
	    afterRender: function afterRender(context, firstTime) {
	        var _this = this;
	
	        var editor = _ace2.default.edit('editor');
	        editor.session.setMode('ace/mode/python');
	        editor.session.on('change', function () {
	            return _this.trigger('edit', editor.getValue());
	        });
	    }
	});

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports) {

	ace.define("ace/mode/python_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(require, exports, module){/*
	 * TODO: python delimiters
	 */
	"use strict";
	var oop = require("../lib/oop");
	var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;
	var PythonHighlightRules = function () {
	    var keywords = ("and|as|assert|break|class|continue|def|del|elif|else|except|exec|" +
	        "finally|for|from|global|if|import|in|is|lambda|not|or|pass|print|" +
	        "raise|return|try|while|with|yield|async|await|nonlocal");
	    var builtinConstants = ("True|False|None|NotImplemented|Ellipsis|__debug__");
	    var builtinFunctions = ("abs|divmod|input|open|staticmethod|all|enumerate|int|ord|str|any|" +
	        "eval|isinstance|pow|sum|basestring|execfile|issubclass|print|super|" +
	        "binfile|bin|iter|property|tuple|bool|filter|len|range|type|bytearray|" +
	        "float|list|raw_input|unichr|callable|format|locals|reduce|unicode|" +
	        "chr|frozenset|long|reload|vars|classmethod|getattr|map|repr|xrange|" +
	        "cmp|globals|max|reversed|zip|compile|hasattr|memoryview|round|" +
	        "__import__|complex|hash|min|apply|delattr|help|next|setattr|set|" +
	        "buffer|dict|hex|object|slice|coerce|dir|id|oct|sorted|intern|" +
	        "ascii|breakpoint|bytes");
	    var keywordMapper = this.createKeywordMapper({
	        "invalid.deprecated": "debugger",
	        "support.function": builtinFunctions,
	        "variable.language": "self|cls",
	        "constant.language": builtinConstants,
	        "keyword": keywords
	    }, "identifier");
	    var strPre = "[uU]?";
	    var strRawPre = "[rR]";
	    var strFormatPre = "[fF]";
	    var strRawFormatPre = "(?:[rR][fF]|[fF][rR])";
	    var decimalInteger = "(?:(?:[1-9]\\d*)|(?:0))";
	    var octInteger = "(?:0[oO]?[0-7]+)";
	    var hexInteger = "(?:0[xX][\\dA-Fa-f]+)";
	    var binInteger = "(?:0[bB][01]+)";
	    var integer = "(?:" + decimalInteger + "|" + octInteger + "|" + hexInteger + "|" + binInteger + ")";
	    var exponent = "(?:[eE][+-]?\\d+)";
	    var fraction = "(?:\\.\\d+)";
	    var intPart = "(?:\\d+)";
	    var pointFloat = "(?:(?:" + intPart + "?" + fraction + ")|(?:" + intPart + "\\.))";
	    var exponentFloat = "(?:(?:" + pointFloat + "|" + intPart + ")" + exponent + ")";
	    var floatNumber = "(?:" + exponentFloat + "|" + pointFloat + ")";
	    var stringEscape = "\\\\(x[0-9A-Fa-f]{2}|[0-7]{3}|[\\\\abfnrtv'\"]|U[0-9A-Fa-f]{8}|u[0-9A-Fa-f]{4})";
	    this.$rules = {
	        "start": [{
	                token: "comment",
	                regex: "#.*$"
	            }, {
	                token: "string", // multi line """ string start
	                regex: strPre + '"{3}',
	                next: "qqstring3"
	            }, {
	                token: "string", // " string
	                regex: strPre + '"(?=.)',
	                next: "qqstring"
	            }, {
	                token: "string", // multi line ''' string start
	                regex: strPre + "'{3}",
	                next: "qstring3"
	            }, {
	                token: "string", // ' string
	                regex: strPre + "'(?=.)",
	                next: "qstring"
	            }, {
	                token: "string",
	                regex: strRawPre + '"{3}',
	                next: "rawqqstring3"
	            }, {
	                token: "string",
	                regex: strRawPre + '"(?=.)',
	                next: "rawqqstring"
	            }, {
	                token: "string",
	                regex: strRawPre + "'{3}",
	                next: "rawqstring3"
	            }, {
	                token: "string",
	                regex: strRawPre + "'(?=.)",
	                next: "rawqstring"
	            }, {
	                token: "string",
	                regex: strFormatPre + '"{3}',
	                next: "fqqstring3"
	            }, {
	                token: "string",
	                regex: strFormatPre + '"(?=.)',
	                next: "fqqstring"
	            }, {
	                token: "string",
	                regex: strFormatPre + "'{3}",
	                next: "fqstring3"
	            }, {
	                token: "string",
	                regex: strFormatPre + "'(?=.)",
	                next: "fqstring"
	            }, {
	                token: "string",
	                regex: strRawFormatPre + '"{3}',
	                next: "rfqqstring3"
	            }, {
	                token: "string",
	                regex: strRawFormatPre + '"(?=.)',
	                next: "rfqqstring"
	            }, {
	                token: "string",
	                regex: strRawFormatPre + "'{3}",
	                next: "rfqstring3"
	            }, {
	                token: "string",
	                regex: strRawFormatPre + "'(?=.)",
	                next: "rfqstring"
	            }, {
	                token: "keyword.operator",
	                regex: "\\+|\\-|\\*|\\*\\*|\\/|\\/\\/|%|@|<<|>>|&|\\||\\^|~|<|>|<=|=>|==|!=|<>|="
	            }, {
	                token: "punctuation",
	                regex: ",|:|;|\\->|\\+=|\\-=|\\*=|\\/=|\\/\\/=|%=|@=|&=|\\|=|^=|>>=|<<=|\\*\\*="
	            }, {
	                token: "paren.lparen",
	                regex: "[\\[\\(\\{]"
	            }, {
	                token: "paren.rparen",
	                regex: "[\\]\\)\\}]"
	            }, {
	                token: ["keyword", "text", "entity.name.function"],
	                regex: "(def|class)(\\s+)([\\u00BF-\\u1FFF\\u2C00-\\uD7FF\\w]+)"
	            }, {
	                token: "text",
	                regex: "\\s+"
	            }, {
	                include: "constants"
	            }],
	        "qqstring3": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string", // multi line """ string end
	                regex: '"{3}',
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "qstring3": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string", // multi line ''' string end
	                regex: "'{3}",
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "qqstring": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string",
	                regex: "\\\\$",
	                next: "qqstring"
	            }, {
	                token: "string",
	                regex: '"|$',
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "qstring": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string",
	                regex: "\\\\$",
	                next: "qstring"
	            }, {
	                token: "string",
	                regex: "'|$",
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "rawqqstring3": [{
	                token: "string", // multi line """ string end
	                regex: '"{3}',
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "rawqstring3": [{
	                token: "string", // multi line ''' string end
	                regex: "'{3}",
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "rawqqstring": [{
	                token: "string",
	                regex: "\\\\$",
	                next: "rawqqstring"
	            }, {
	                token: "string",
	                regex: '"|$',
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "rawqstring": [{
	                token: "string",
	                regex: "\\\\$",
	                next: "rawqstring"
	            }, {
	                token: "string",
	                regex: "'|$",
	                next: "start"
	            }, {
	                defaultToken: "string"
	            }],
	        "fqqstring3": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string", // multi line """ string end
	                regex: '"{3}',
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "fqstring3": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string", // multi line ''' string end
	                regex: "'{3}",
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "fqqstring": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string",
	                regex: "\\\\$",
	                next: "fqqstring"
	            }, {
	                token: "string",
	                regex: '"|$',
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "fqstring": [{
	                token: "constant.language.escape",
	                regex: stringEscape
	            }, {
	                token: "string",
	                regex: "'|$",
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "rfqqstring3": [{
	                token: "string", // multi line """ string end
	                regex: '"{3}',
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "rfqstring3": [{
	                token: "string", // multi line ''' string end
	                regex: "'{3}",
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "rfqqstring": [{
	                token: "string",
	                regex: "\\\\$",
	                next: "rfqqstring"
	            }, {
	                token: "string",
	                regex: '"|$',
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "rfqstring": [{
	                token: "string",
	                regex: "'|$",
	                next: "start"
	            }, {
	                token: "paren.lparen",
	                regex: "{",
	                push: "fqstringParRules"
	            }, {
	                defaultToken: "string"
	            }],
	        "fqstringParRules": [{
	                token: "paren.lparen",
	                regex: "[\\[\\(]"
	            }, {
	                token: "paren.rparen",
	                regex: "[\\]\\)]"
	            }, {
	                token: "string",
	                regex: "\\s+"
	            }, {
	                token: "string",
	                regex: "'[^']*'"
	            }, {
	                token: "string",
	                regex: '"[^"]*"'
	            }, {
	                token: "function.support",
	                regex: "(!s|!r|!a)"
	            }, {
	                include: "constants"
	            }, {
	                token: 'paren.rparen',
	                regex: "}",
	                next: 'pop'
	            }, {
	                token: 'paren.lparen',
	                regex: "{",
	                push: "fqstringParRules"
	            }],
	        "constants": [{
	                token: "constant.numeric", // imaginary
	                regex: "(?:" + floatNumber + "|\\d+)[jJ]\\b"
	            }, {
	                token: "constant.numeric", // float
	                regex: floatNumber
	            }, {
	                token: "constant.numeric", // long integer
	                regex: integer + "[lL]\\b"
	            }, {
	                token: "constant.numeric", // integer
	                regex: integer + "\\b"
	            }, {
	                token: ["punctuation", "function.support"], // method
	                regex: "(\\.)([a-zA-Z_]+)\\b"
	            }, {
	                token: keywordMapper,
	                regex: "[a-zA-Z_$][a-zA-Z0-9_$]*\\b"
	            }]
	    };
	    this.normalizeRules();
	};
	oop.inherits(PythonHighlightRules, TextHighlightRules);
	exports.PythonHighlightRules = PythonHighlightRules;
	
	});
	
	ace.define("ace/mode/folding/pythonic",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode"], function(require, exports, module){"use strict";
	var oop = require("../../lib/oop");
	var BaseFoldMode = require("./fold_mode").FoldMode;
	var FoldMode = exports.FoldMode = function (markers) {
	    this.foldingStartMarker = new RegExp("([\\[{])(?:\\s*)$|(" + markers + ")(?:\\s*)(?:#.*)?$");
	};
	oop.inherits(FoldMode, BaseFoldMode);
	(function () {
	    this.getFoldWidgetRange = function (session, foldStyle, row) {
	        var line = session.getLine(row);
	        var match = line.match(this.foldingStartMarker);
	        if (match) {
	            if (match[1])
	                return this.openingBracketBlock(session, match[1], row, match.index);
	            if (match[2])
	                return this.indentationBlock(session, row, match.index + match[2].length);
	            return this.indentationBlock(session, row);
	        }
	    };
	}).call(FoldMode.prototype);
	
	});
	
	ace.define("ace/mode/python",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/python_highlight_rules","ace/mode/folding/pythonic","ace/range"], function(require, exports, module){"use strict";
	var oop = require("../lib/oop");
	var TextMode = require("./text").Mode;
	var PythonHighlightRules = require("./python_highlight_rules").PythonHighlightRules;
	var PythonFoldMode = require("./folding/pythonic").FoldMode;
	var Range = require("../range").Range;
	var Mode = function () {
	    this.HighlightRules = PythonHighlightRules;
	    this.foldingRules = new PythonFoldMode("\\:");
	    this.$behaviour = this.$defaultBehaviour;
	};
	oop.inherits(Mode, TextMode);
	(function () {
	    this.lineCommentStart = "#";
	    this.$pairQuotesAfter = {
	        "'": /[ruf]/i,
	        '"': /[ruf]/i
	    };
	    this.getNextLineIndent = function (state, line, tab) {
	        var indent = this.$getIndent(line);
	        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
	        var tokens = tokenizedLine.tokens;
	        if (tokens.length && tokens[tokens.length - 1].type == "comment") {
	            return indent;
	        }
	        if (state == "start") {
	            var match = line.match(/^.*[\{\(\[:]\s*$/);
	            if (match) {
	                indent += tab;
	            }
	        }
	        return indent;
	    };
	    var outdents = {
	        "pass": 1,
	        "return": 1,
	        "raise": 1,
	        "break": 1,
	        "continue": 1
	    };
	    this.checkOutdent = function (state, line, input) {
	        if (input !== "\r\n" && input !== "\r" && input !== "\n")
	            return false;
	        var tokens = this.getTokenizer().getLineTokens(line.trim(), state).tokens;
	        if (!tokens)
	            return false;
	        do {
	            var last = tokens.pop();
	        } while (last && (last.type == "comment" || (last.type == "text" && last.value.match(/^\s+$/))));
	        if (!last)
	            return false;
	        return (last.type == "keyword" && outdents[last.value]);
	    };
	    this.autoOutdent = function (state, doc, row) {
	        row += 1;
	        var indent = this.$getIndent(doc.getLine(row));
	        var tab = doc.getTabString();
	        if (indent.slice(-tab.length) == tab)
	            doc.remove(new Range(row, indent.length - tab.length, row, indent.length));
	    };
	    this.$id = "ace/mode/python";
	    this.snippetFileId = "ace/snippets/python";
	}).call(Mode.prototype);
	exports.Mode = Mode;
	
	});                (function() {
	                    ace.require(["ace/mode/python"], function(m) {
	                        if (typeof module == "object" && typeof exports == "object" && module) {
	                            module.exports = m;
	                        }
	                    });
	                })();
	            

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    onBind: function onBind(model) {
	        var dt = (0, _date.fmt)(this.model.get(this.options.bindProperty) || null, 'YYYY-MM-DD HH:mm') || null;
	        this.lastDateValue_ = this.lastTimeValue_ = dt;
	        if (this.lastDateValue_) this.parsedDate_ = this.lastDateValue_.split(' ');else this.parsedDate_ = ['', ''];
	
	        this.parsedDate_[1] = this.parsedDate_[1].substring(0, 5); // truncate :ss
	    },
	    onUnBind: function onUnBind() {
	        this.parsedDate_ = ['', ''];
	    },
	
	
	    computeds: {
	
	        date: {
	            get: function get() {
	                var current = (0, _date.fmt)(this.model.get(this.options.bindProperty) || null, 'YYYY-MM-DD HH:mm') || null;
	
	                var changed = false;
	                if (current === null && this.lastDateValue_ !== null) changed = true;else if (current !== null && this.lastDateValue_ === null) changed = true;else if (current !== this.lastDateValue_) changed = true;
	
	                if (changed) return this.lastDateValue_ = current, this.parsedDate_[0] = current ? current.split(' ')[0] : '';
	
	                return this.parsedDate_[0];
	            },
	            set: function set(value) {
	                this.parsedDate_[0] = value;
	                this.updateBoundProperty(this.parsedDate_);
	            }
	        },
	
	        time: {
	            get: function get() {
	                var current = (0, _date.fmt)(this.model.get(this.options.bindProperty) || null, 'YYYY-MM-DD HH:mm') || null;
	
	                var changed = false;
	                if (current === null && this.lastTimeValue_ !== null) changed = true;else if (current !== null && this.lastTimeValue_ === null) changed = true;else if (current !== this.lastTimeValue_) changed = true;
	
	                if (changed) return this.lastTimeValue_ = current, this.parsedDate_[1] = current ? current.split(' ')[1].substring(0, 5) : ''; // truncate :ss
	
	                return this.parsedDate_[1];
	            },
	            set: function set(value) {
	                this.parsedDate_[1] = value;
	                this.updateBoundProperty(this.parsedDate_);
	            }
	        }
	
	    },
	
	    updateBoundProperty: function updateBoundProperty(parsedDate) {
	        if (!parsedDate[0] || !parsedDate[1]) return this.setBinding(this.options.bindProperty, this.lastDateValue_ = this.lastTimeValue_ = null);
	
	        var text = parsedDate[0] + ' ' + parsedDate[1] + ':00';
	
	        this.setBinding(this.options.bindProperty, (0, _date.unixts)((0, _date.parseYYYYMMDD)(this.lastDateValue_ = this.lastTimeValue_ = text)));
	    }
	});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _form2.default.extend({
	
	    bindingHandlers: {
	
	        defaultPossibleValues: {
	            set: function set($el, value) {
	                var selected = value.selected,
	                    options = value.options;
	
	                $el.html([''].concat(options || []).map(function (s) {
	                    return '<option>' + s + '</option>';
	                }));
	                $el.val(selected);
	            },
	            get: function get($el, value, event) {
	                return $el.val();
	            }
	        }
	
	    }
	
	});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _requests = __webpack_require__(109);
	
	var _file = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _options = this.options,
	            bindProperty = _options.bindProperty,
	            type = _options.type,
	            name = _options.name,
	            disabled = _options.disabled,
	            enabled = _options.enabled;
	
	        return {
	            bindProperty: bindProperty, type: type, name: name, disabled: disabled, enabled: enabled,
	            'messages-for': this.options['messages-for']
	        };
	    },
	
	
	    events: {
	        'click .-attach': function clickAttach() {
	            var _this = this;
	
	            var accept = this.options.accept;
	
	
	            Backbone.$('<input type="file" name="file" accept="' + accept + '" style="visibility:hidden;height:0;">').appendTo(document.body).on('change', function (_ref) {
	                var _ref$target$files = _slicedToArray(_ref.target.files, 1),
	                    binaryFile = _ref$target$files[0];
	
	                return (0, _file.read)(binaryFile).then(function (_ref2) {
	                    var binaryFile = _ref2.binaryFile,
	                        width = _ref2.width,
	                        height = _ref2.height;
	
	                    if (!~accept.indexOf(binaryFile.type)) return alert(ifn('errors::unacceptable file format', { format: accept }));
	
	                    if (_this.options['max-width']) if (width > _this.options['max-width']) return alert(ifn('errors::image dimension exceeded', { width: _this.options['max-width'], height: _this.options['max-height'] }));
	
	                    if (_this.options['max-height']) if (height > _this.options['max-height']) return alert(ifn('errors::image dimension exceeded', { width: _this.options['max-width'], height: _this.options['max-height'] }));
	
	                    _this.model.set(_this.options.bindProperty, binaryFile);
	
	                    binaryFile.upload = (0, _requests.upload)(binaryFile).then(function (response) {
	                        return response.name;
	                    }).catch(function () {
	                        return Promise.reject(['Upload error', _this.options['messages-for'] || _this.options.bindProperty]);
	                    });
	                }, function () {
	                    return (/* e */alert(ifn('errors::cannot read file'))
	                    );
	                });
	            }).click();
	        }
	    },
	
	    bindingFilters: {
	        typeicon: function typeicon(file) {
	            return file instanceof File ? file : 'department_icons/' + file;
	        },
	        priorityicon: function priorityicon(file) {
	            return file instanceof File ? file : 'news_category/' + file;
	        }
	    },
	
	    bindingHandlers: {
	
	        filesource: {
	            set: function set($el, file) {
	                $el[0].src = file instanceof File ? 'data: image/jpeg; base64, ' + btoa(file.content) : '/department_files/' + file;
	            },
	            get: function get() {
	                return {};
	            }
	        }
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.priorityicons = exports.typeicons = exports.dir = exports.upload = undefined;
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.upload = upload;
	exports.dir = dir;
	exports.typeicons = typeicons;
	exports.priorityicons = priorityicons;
	
	
	var _typeicons = Symbol('type-icons'),
	    _priorityicons = Symbol('priority-icons');
	
	function typeicons() {
	    return _typeicons;
	}
	
	function priorityicons() {
	    return _priorityicons;
	}
	
	function dir(filetypeFn) {
	    switch (filetypeFn()) {
	        case _typeicons:
	            return 'type-icons';
	        case _priorityicons:
	            return 'priority-icons';
	    }
	}
	
	function upload(binaryFile) /* also may be type */{
	    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/files';
	
	    if (typeof url === 'function') url = '/files/' + dir(url);
	
	    var data = new FormData();
	    data.append('file', binaryFile);
	
	    return (0, _promisify.promisify)(_backbone2.default.ajax({
	        url: _config2.default.url(url),
	        data: data,
	        contentType: false,
	        processData: false,
	        noLoader: true,
	        method: 'POST'
	    }));
	}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _suggest = __webpack_require__(111);
	
	var _strings = __webpack_require__(67);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// todo: bind into the model
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        // todo: cancel pgdn
	        // todo: correct handle click on OK/Apply
	        this.suggestionInterface_ = (0, _suggest.suggest)(this.$el, '[type=text]', function ($htmlInput, page, firstSearch) {
	            if (!_this.model) return [];
	
	            var fn = typeof _this.options.options === 'function' && _this.options.options;
	            var data = [].concat(_toConsumableArray(_this.datalist_));
	            // const data = [...this.datalist_, ...fn ? fn() : []];
	
	            var q = $htmlInput.val().trim();
	            var prefilteredOptions = q && !firstSearch ? data.filter(function (_ref) {
	                var title = _ref.title,
	                    id = _ref.id;
	                return (0, _strings.find)([title, id], q);
	            }) : data;
	
	            var limit = 10;
	            var offset = page * 10;
	            var pagePrefilteredOptions = prefilteredOptions.filter(function (option, index) {
	                return index >= offset && index < offset + limit;
	            });
	
	            if (!fn || prefilteredOptions.length >= offset + limit) {
	                return {
	                    options: pagePrefilteredOptions,
	                    total: prefilteredOptions.length,
	                    page: page, offset: offset, limit: limit
	                };
	            }
	
	            var remoteQ = q && !firstSearch ? q : '';
	            var remoteOffset = Math.max(0, offset - prefilteredOptions.length);
	            var remoteLimit = Math.min(limit, offset + limit - prefilteredOptions.length);
	            var remoteArgs = [remoteQ, remoteOffset, remoteLimit, _this.$el];
	            return (0, _promisify.promisify)(fn.apply(undefined, remoteArgs)).then(function (result) {
	                if (result instanceof Array) {
	                    // offset, limit, q - ignored
	                    var _prefilteredOptions = q && !firstSearch ? [].concat(_toConsumableArray(data), _toConsumableArray(result)).filter(function (_ref2) {
	                        var title = _ref2.title,
	                            id = _ref2.id;
	                        return (0, _strings.find)([title, id], q);
	                    }) : [].concat(_toConsumableArray(data), _toConsumableArray(result));
	
	                    var _pagePrefilteredOptions = _prefilteredOptions.filter(function (option, index) {
	                        return index >= offset && index < offset + limit;
	                    });
	
	                    return {
	                        options: _pagePrefilteredOptions,
	                        total: _prefilteredOptions.length,
	                        page: page, offset: offset, limit: limit
	                    };
	                } else {
	                    return {
	                        options: [].concat(_toConsumableArray(pagePrefilteredOptions), _toConsumableArray(result.options)),
	                        total: prefilteredOptions.length + result.total,
	                        page: page, offset: offset, limit: limit
	                    };
	                }
	            }).catch(function (ex) {
	                return console.error(ex);
	            });
	        }, function ($htmlInput, title, option) {
	            $htmlInput.add(_this.$('.--hidden-title')).val(title || '');
	            var $hidden = _this.$('.--hidden-id');
	            $hidden[0].dataset.title = title || '';
	            $hidden.val(option.id || '');
	            $hidden.trigger('change');
	            if (_this.model && $hidden[0].dataset.bind)
	                // hack! (change:fields to force readonly to work) todo: no hack
	                if ($hidden[0].dataset.bind.indexOf(':prepareCf(') !== -1) _this.model.trigger('change'), _this.model.trigger('change:fields');
	            _this.suggestionInterface_.hideSuggestion();
	        }, function ($htmlInput) {
	            return $htmlInput.val(_this.$('.--hidden-title').val());
	        }, function (current, items) {});
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            bind = _options.bind,
	            label = _options.label,
	            nothingSelectedLabel = _options.nothingSelectedLabel,
	            noNothingSelectedLabel = _options.noNothingSelectedLabel,
	            name = _options.name,
	            options = _options.options,
	            disabled = _options.disabled,
	            enabled = _options.enabled,
	            onlyId = _options.onlyId;
	
	        return {
	            bind: bind, label: label, nothingSelectedLabel: nothingSelectedLabel, noNothingSelectedLabel: noNothingSelectedLabel,
	            name: name, options: options, disabled: disabled, enabled: enabled, onlyId: onlyId,
	            'messages-for': this.options['messages-for']
	        };
	    },
	    afterRender: function afterRender() {
	        this.suggestionInterface_.unbindEvents();
	        this.suggestionInterface_.bindEvents();
	
	        var options = this.$('datalist option').toArray();
	        this.datalist_ = options.map(function (option) {
	            return { id: option.value || null, title: option.innerText || '' };
	        });
	    },
	
	
	    bindingHandlers: {
	
	        substituteOption: {
	            set: function set($el, option) {
	                // custom field
	                if (option instanceof Array) option = option[0];
	
	                var id = this.view.options.onlyId ? option
	                // todo
	                : option && option.id || option && option.object_id;
	
	                $el.val(id || '');
	
	                var $titles = this.view.$('.--hidden-title, [type=text]');
	
	                if (this.view.options.onlyId)
	                    // option is ID
	                    findOption(this.view, option, function (title) {
	                        return $titles.val(title || '');
	                    });else if (option === null || option === undefined) findOption(this.view, option, function (title) {
	                    return $titles.val(title || '');
	                });else $titles.val(option && option.name || option && option.title || '');
	            },
	            get: function get($el, prevValue) {
	                var id = $el.val() != '' ? isNaN(+$el.val()) ? $el.val() : +$el.val() : null;
	                var title = $el[0].dataset.title;
	
	                var value = this.view.options.onlyId ? id : id != null ? { id: id, title: title } : null;
	
	                // ordinal field
	                if (!(prevValue instanceof Array)) return this.view.options.bind ? _defineProperty({}, this.view.options.bind, value) : value;
	
	                // custom field
	
	                var _prevValue = _slicedToArray(prevValue, 2),
	                    prev = _prevValue[0],
	                    meta = _prevValue[1];
	
	                return [value, meta];
	            }
	        }
	
	    }
	
	});
	
	
	function findOption(view, id, callback) {
	    var _response$filter, _response$filter2;
	
	    var matchFn = function matchFn(option) {
	        if (option.id == id) return true;
	
	        if (id === null || id === undefined) return !option.id;
	
	        return false;
	    };
	
	    var _view$$$toArray$map$f = view.$('datalist option').toArray().map(function (opt) {
	        return { id: opt.value, title: opt.innerText };
	    }).filter(matchFn),
	        _view$$$toArray$map$f2 = _slicedToArray(_view$$$toArray$map$f, 1),
	        option = _view$$$toArray$map$f2[0];
	
	    if (option) return callback(option.title);
	
	    var fn = view.options.options;
	    fn = typeof fn == 'function' && fn;
	    if (!fn) return callback(null);
	
	    var response = fn();
	    if (response instanceof Promise) return response.then(function (options) {
	        return options || [];
	    }).then(function (options) {
	        return options.filter(matchFn);
	    }).then(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 1),
	            option = _ref5[0];
	
	        return callback(option ? option.title : null);
	    });
	
	    if (response instanceof Array) return (_response$filter = response.filter(matchFn), _response$filter2 = _slicedToArray(_response$filter, 1), option = _response$filter2[0], _response$filter), callback(option ? option.title : null);
	
	    return callback(null);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.suggest = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _suggestion = __webpack_require__(112);
	
	var _suggestion2 = _interopRequireDefault(_suggestion);
	
	var _idgen = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var suggestions = {};
	var listener = _underscore2.default.extend({}, _backbone2.default.Events);
	
	exports.suggest = suggest;
	
	
	function suggest($el, selector, _optionsFn, chooseFn, blurFn, hoverFn) {
	    var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
	
	    var open = _underscore2.default.debounce(function () {
	        return suggestion($el.find(selector)).suggest();
	    }, 250);
	
	    bindEvents();
	
	    return {
	        hideSuggestion: function hideSuggestion() {
	            return _hideSuggestion($el.find(selector));
	        },
	        bindEvents: bindEvents,
	        unbindEvents: unbindEvents
	    };
	
	    function chooseSuggestion($htmlInput, title, option) {
	        if (chooseFn) chooseFn($htmlInput, title, option);
	
	        _hideSuggestion($htmlInput);
	    }
	
	    function _hideSuggestion($htmlInput) {
	        suggestion($htmlInput).$el.remove();
	    }
	
	    function suggestion($htmlInput) {
	        var htmlInput = $htmlInput[0];
	        var guid = htmlInput.dataset.guid = htmlInput.dataset.guid || (0, _idgen.idgen)();
	
	        if (suggestions[guid]) return suggestions[guid].undelegateEvents(), suggestions[guid].delegateEvents(), suggestions[guid];
	
	        var suggestionView = suggestions[guid] = new _suggestion2.default(_extends({
	            optionsFn: function optionsFn(page) {
	                var result = _optionsFn($htmlInput, page, suggestionView.firstSearch);
	                suggestionView.$el.insertAfter($htmlInput);
	                return result;
	            }
	        }, options));
	
	        suggestionView.firstSearch = true;
	
	        listener.listenTo(suggestionView, 'choose', function (title, option) {
	            return chooseSuggestion($htmlInput, title, option);
	        });
	
	        listener.listenTo(suggestionView, 'hover', _underscore2.default.debounce(makeHoverHandler(suggestionView), 100));
	
	        return suggestionView;
	    }
	
	    function makeHoverHandler(suggestionView) {
	        return function (item, items, index) {
	            if (hoverFn) if (_backbone2.default.$.contains(document.body, suggestionView.el)) hoverFn(item, items, index);
	        };
	    }
	
	    function bindEvents() {
	        $el.on('keyup', selector, onKeyUp).on('keydown', selector, onKeyDown).on('focus', selector, onFocus).on('blur', selector, onBlur);
	    }
	
	    function unbindEvents() {
	        $el.off('keyup', selector, onKeyUp).off('keydown', selector, onKeyDown).off('focus', selector, onFocus).off('blur', selector, onBlur);
	    }
	
	    function onKeyUp(e) {
	        if (e.keyCode === 33) return;
	        if (e.keyCode === 34) return;
	        if (e.keyCode === 37) return;
	        if (e.keyCode === 38) return;
	        if (e.keyCode === 39) return;
	        if (e.keyCode === 40) return;
	        if (e.keyCode === 9) return; // tab
	        if (e.keyCode === 16) return; // shift
	        if (e.keyCode === 17) return; // ctrl
	
	        var $htmlInput = $el.find(e.currentTarget);
	
	        if (e.keyCode === 13) {
	            suggestion($htmlInput).chooseCurrent();
	
	            e.preventDefault();
	            return false;
	        }
	
	        suggestion($htmlInput).firstSearch = false;
	
	        open();
	    }
	
	    function onKeyDown(e) {
	        var $htmlInput = $el.find(e.currentTarget);
	
	        // to make search, add suggestion to DOM first
	        // (maybe removed in hideSuggestion() call)
	        var suggestionView = suggestion($htmlInput);
	        if (!$.contains(document.body, suggestionView.el)) {
	            suggestionView.$el.insertAfter($htmlInput);
	            suggestionView.firstSearch = false;
	
	            // ignore control keys in this case
	            if (e.keyCode === 33) return;
	            if (e.keyCode === 34) return;
	            if (e.keyCode === 37) return;
	            if (e.keyCode === 38) return;
	            if (e.keyCode === 39) return;
	            if (e.keyCode === 40) return;
	            if (e.keyCode === 9) return; // tab
	            if (e.keyCode === 16) return; // shift
	            if (e.keyCode === 17) return; // ctrl
	        }
	
	        if (e.keyCode === 33) {
	            suggestion($htmlInput).pageUp();
	            e.preventDefault();
	        }
	
	        if (e.keyCode === 34) {
	            suggestion($htmlInput).pageDown();
	            e.preventDefault();
	        }
	
	        if (38 === e.keyCode) {
	            suggestion($htmlInput).prevItem();
	            e.preventDefault();
	        }
	
	        if (40 === e.keyCode) {
	            suggestion($htmlInput).nextItem();
	            e.preventDefault();
	        }
	    }
	
	    function onFocus(e) {
	        var $htmlInput = $el.find(e.currentTarget);
	        $htmlInput[0].select();
	        suggestion($htmlInput).open();
	    }
	
	    function onBlur(e) {
	        var relatedTarget = e.relatedTarget,
	            $relatedTarget = _backbone2.default.$(relatedTarget);
	
	
	        if ($relatedTarget.is('.__page-up') || $relatedTarget.is('.__page-down')) return e.preventDefault(), false;
	
	        var $htmlInput = $el.find(e.currentTarget);
	
	        if (blurFn) blurFn($htmlInput);
	        _hideSuggestion($htmlInput);
	
	        var suggestionView = suggestion($htmlInput);
	        suggestionView.firstSearch = true;
	    }
	}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    template: 'jst/suggestion',
	
	    className: 'suggestion-nest',
	
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	    },
	
	
	    events: {
	
	        'click .suggestion-item': function clickSuggestionItem(e) {
	            this.choose(this.$(e.currentTarget));
	            return e.stopPropagation(), e.preventDefault(), false;
	        },
	
	        // prevent blur in the input
	        'mousedown .suggestion-item': function mousedownSuggestionItem(e) {
	            return e.stopPropagation(), e.preventDefault(), false;
	        },
	
	        // prevent blur in the input
	        'mousedown .__page-down': function mousedown__pageDown(e) {
	            return false;
	        },
	
	        // prevent blur in the input
	        'mousedown .__page-up': function mousedown__pageUp(e) {
	            return false;
	        },
	
	        'mousemove .suggestion-item': function mousemoveSuggestionItem(e) {
	            this.hover(this.$(e.currentTarget));
	        },
	
	        'click .__page-up': function click__pageUp(e) {
	            this.pageUp();
	        },
	
	        'click .__page-down': function click__pageDown(e) {
	            this.pageDown();
	        }
	
	    },
	
	    open: function open() {
	        this.page_ = 0;
	        this.firstPage_ = this.lastPage_ = false;
	        this.currentIndex_ = 0;
	        this.$el.html('');
	        this.render();
	    },
	    suggest: function suggest() {
	        this.currentIndex_ = 0;
	        this.render();
	    },
	    pageDown: function pageDown() {
	        if (!this.lastPage_) {
	            this.page_++;
	            this.render();
	        }
	    },
	    pageUp: function pageUp() {
	        if (!this.firstPage_) {
	            this.page_--;
	            this.render();
	        }
	    },
	    choose: function choose($item) {
	        var index = +$item[0].dataset.index,
	            option = this.lastContext.items[index];
	
	        this.trigger('choose', $item.find('.suggestion-item--text').html(), option);
	    },
	    hover: function hover($item) {
	        var oldIndex = this.currentIndex_;
	        this.currentIndex_ = +$item[0].dataset.index;
	
	        if (this.currentIndex_ != oldIndex) updateItems(this);
	    },
	    chooseCurrent: function chooseCurrent() {
	        this.choose(this.$currentItem());
	    },
	    nextItem: function nextItem() {
	        if (this.currentIndex_ + 1 <= this.itemCount() - 1) {
	            this.currentIndex_++;
	            return updateItems(this);
	        }
	
	        if (!this.lastPage_) {
	            this.currentIndex_ = 0;
	            this.pageDown();
	        }
	    },
	    prevItem: function prevItem() {
	        if (this.currentIndex_ - 1 >= 0) {
	            this.currentIndex_--;
	            return updateItems(this);
	        }
	
	        if (!this.firstPage_) {
	            this.currentIndex_ = 9;
	            this.pageUp();
	        }
	    },
	    serialize: function serialize() {
	        var _this = this;
	
	        return (0, _promisify.promisify)(this.options.optionsFn(this.page_)).then(function (_ref) {
	            var options = _ref.options,
	                total = _ref.total,
	                page = _ref.page,
	                offset = _ref.offset,
	                limit = _ref.limit;
	
	            var first = offset > 0 ? offset + 1 : page * 10 + 1,
	                last = Math.min(total, first + (limit || 10) - 1),
	                showInfo = undefined === _this.options.showInfo ? total > 9 : _this.options.showInfo;
	
	            _this.firstPage_ = page === 0;
	            _this.lastPage_ = last === total;
	
	            return {
	                items: options,
	                currentIndex: _this.currentIndex_,
	                total: total, first: first, last: last, showInfo: showInfo,
	                firstPage: _this.firstPage_,
	                lastPage: _this.lastPage_
	            };
	        });
	    },
	    afterRender: function afterRender() {
	        this.trigger('hover', this.currentItem(), this.lastContext.items, this.currentIndex_);
	    },
	    $items: function $items() {
	        return this.$('li');
	    },
	    itemCount: function itemCount() {
	        return this.$items().length;
	    },
	    currentItem: function currentItem() {
	        return this.lastContext.items[this.currentIndex_];
	    },
	    $currentItem: function $currentItem() {
	        return this.$items().eq(this.currentIndex_);
	    }
	});
	
	
	function updateItems(instance) {
	    instance.$items().removeClass('--active').eq(instance.currentIndex_).addClass('--active');
	
	    instance.trigger('hover', instance.currentItem(), instance.lastContext.items, instance.currentIndex_);
	}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _View$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _task = __webpack_require__(54);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _view2.default.extend((_View$extend = {}, _defineProperty(_View$extend, _view2.default.event('file:toggle'), function (index) {
	    var file = this.files()[index];
	    var id = file.guid || file.id;
	
	    this.model.set('attachments', this.model.get('attachments').map(function (_ref) {
	        var att = _objectWithoutProperties(_ref, []),
	            deleted = _ref.deleted;
	
	        return att.id === id || att.guid === id ? _extends({}, att, { deleted: deleted == undefined || deleted == false || deleted == 'f' }) : _extends({}, att, { deleted: deleted });
	    }));
	}), _defineProperty(_View$extend, _view2.default.event('Controls:file:upload-done'), function (originalName, type, semantics, uploading, binaryFile) {
	    var _options = this.options,
	        def = _options.def,
	        path = _options.path;
	
	    // add to gallery
	
	    var attrs = (0, _task.attach)(this.model, originalName, type, semantics, uploading, binaryFile);
	
	    var _bindingFilters$prepa = this.bindingFilters.prepareCf.get(this.model.get('fields'), def.id, def.translit, def.format, null, def.min_count, undefined, undefined, undefined, undefined, path),
	        _bindingFilters$prepa2 = _slicedToArray(_bindingFilters$prepa, 2),
	        files = _bindingFilters$prepa2[0],
	        meta = _bindingFilters$prepa2[1];
	
	    // always add to the end
	
	
	    var newFiles = [].concat(_toConsumableArray(files), [{ guid: attrs.guid }]);
	    this.model.set(this.bindingFilters.prepareCf.set([newFiles, meta]));
	
	    this.render();
	
	    // todo upload errors
	}), _defineProperty(_View$extend, "files", function files() {
	    var _options2 = this.options,
	        def = _options2.def,
	        path = _options2.path;
	    var translit = def.translit;
	
	
	    var fields = (path || '').split('|').map(function (part) {
	        return part.split('=');
	    }).map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 3),
	            id = _ref3[0],
	            encodedTranslit = _ref3[1],
	            index = _ref3[2];
	
	        return [_field2.default.decodeString(encodedTranslit), index];
	    }).reduce(function (fields, _ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2),
	            translit = _ref5[0],
	            index = _ref5[1];
	
	        return fields && fields[translit] && fields[translit].value && fields[translit].value[index] || undefined;
	    }, this.model.get('fields')) || this.model.get('fields');
	
	    return fields && fields[translit] && fields[translit].value || [];
	}), _defineProperty(_View$extend, "serialize", function serialize() {
	    var deleted = (0, _arrays.hashify)(this.model.get('attachments').filter(function (_ref6) {
	        var deleted = _ref6.deleted;
	        return deleted === true || deleted === 't';
	    }).map(function (_ref7) {
	        var id = _ref7.id,
	            guid = _ref7.guid;
	        return id || guid;
	    }));
	
	    var files = this.files();
	    var filesTotal = files.length;
	    var deletedFilesTotal = files.filter(function (_ref8) {
	        var id = _ref8.id,
	            guid = _ref8.guid;
	        return deleted[id || guid];
	    }).length;
	    return {
	        filesTotal: filesTotal,
	        deletedFilesTotal: deletedFilesTotal,
	        nonDeletedFilesTotal: filesTotal - deletedFilesTotal
	    };
	}), _defineProperty(_View$extend, "onBind", function onBind(model) {
	    var _this = this;
	
	    this.listenTo(model, 'change:attachments', function () {
	        return _this.render();
	    });
	}), _defineProperty(_View$extend, "onUnBind", function onUnBind(previousModel) {
	    this.stopListening(previousModel);
	}), _View$extend));

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _popups = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _options = this.options,
	            collection = _options.collection,
	            label = _options.label,
	            bindProperty = _options.bindProperty,
	            nothingSelectedLabel = _options.nothingSelectedLabel,
	            nItemsSelectedLabel = _options.nItemsSelectedLabel,
	            nItemsSelectedLimit = _options.nItemsSelectedLimit;
	
	
	        return {
	            collection: collection, label: label, bindProperty: bindProperty,
	            nothingSelectedLabel: nothingSelectedLabel, nItemsSelectedLabel: nItemsSelectedLabel,
	            nItemsSelectedLimit: nItemsSelectedLimit
	        };
	    },
	
	
	    events: {
	        'keydown input; click input; click .input-group-btn > button': function keydownInputClickInputClickInputGroupBtnButton(_ref) {
	            var _this = this;
	
	            var keyCode = _ref.keyCode,
	                currentTarget = _ref.currentTarget;
	
	            if (keyCode == 9 || keyCode == 16 || keyCode == 17 || keyCode == 18) return;
	
	            var _options2 = this.options,
	                bindProperty = _options2.bindProperty,
	                collection = _options2.collection;
	
	            var selected = this.getBinding(bindProperty);
	            (0, _popups.pick)(selected, { collection: collection,
	                cluster: this.model.get('cluster'),
	                clusters: this.options.clusters }).then(function (newSelected) {
	                return _this.setBinding(bindProperty, newSelected);
	            });
	
	            currentTarget.blur();
	            return false;
	        }
	    }
	
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Form$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _pick = __webpack_require__(116);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _arrays = __webpack_require__(24);
	
	var _roles = __webpack_require__(117);
	
	var _date = __webpack_require__(29);
	
	var _api = __webpack_require__(77);
	
	var _popups = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _form2.default.extend((_Form$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _form2.default.prototype.initialize.call(this, options);
	
	        options.orgClusters = (0, _arrays.hashify)(options.organizations, function (org) {
	            return [org.id, org.cluster_id];
	        });
	    },
	    onBind: function onBind(model) {
	        var _this = this;
	
	        this.listenTo(model, 'change:service_object_id change:type_id', function () {
	            if (model.get('type_id') && model.get('service_object_id')) attachServiceObject(model.get('service_object_id'), model.get('service_object_layer_id'), model, _this.options.serviceObjectMappings);
	        });
	
	        var manuallyChanged = false;
	        var orgsWithDefaultAssignees = this.organizations().filter(function (org) {
	            return org.default_assigned_organization_id;
	        });
	        var defaultAssignees = (0, _arrays.hashify)(orgsWithDefaultAssignees, function (org) {
	            return [org.id, org.default_assigned_organization_id];
	        });
	        var contractWithAssignees = this.contracts().filter(function (contract) {
	            return contract.assigned_organization;
	        });
	        var assigneesOfContracts = (0, _arrays.hashify)(contractWithAssignees, function (contract) {
	            return [contract.id, contract.assigned_organization.id];
	        });
	
	        this.listenTo(model, 'change:organization_id', function (m, orgId) {
	            if (manuallyChanged && model.get('assigned_organization_id')) return;
	
	            if (model.get('assigned_organization_id') == defaultAssignees[orgId]) return;
	
	            if (model.get('contract_id') && assigneesOfContracts[model.get('contract_id')]) if (defaultAssignees[orgId] != assigneesOfContracts[model.get('contract_id')]) return;
	
	            model.set({
	                assigned_organization_id: defaultAssignees[orgId],
	                assigned_user_id: null
	            });
	            setTimeout(function () {
	                return manuallyChanged = false;
	            }, 0);
	        });
	        this.listenTo(model, 'change:assigned_organization_id', function () {
	            return manuallyChanged = true;
	        });
	    },
	    serialize: function serialize() {
	        var _this2 = this;
	
	        var contractsHash = (0, _arrays.hashify)(this.contracts(), function (contract) {
	            return [contract.id, contract];
	        });
	        var typesHash = (0, _arrays.hashify)(this.types(), function (type) {
	            return [type.id, type];
	        });
	        var capabilities = this.model ? this.model.capabilities_ : undefined;
	
	        return {
	
	            capabilities: capabilities,
	
	            fieldsSorted: [].concat(_toConsumableArray(this.fields().filter(function (f) {
	                return [false, 'f'].indexOf(f.system) !== -1;
	            }))).sort(function (f1, f2) {
	                return !f1.cluster && f2.cluster ? -1 : f1.cluster && !f2.cluster ? 1 : f1.order - f2.order;
	            }),
	
	            orgsFn: function orgsFn() {
	                return filterAvailableOrgs.call(_this2, _this2.model, _this2.organizations().filter(function (org) {
	                    return org.id == _this2.model.get('assigned_organization');
	                })).filter(function (org) {
	                    return _this2.model.id && org.id == _this2.model.get('organization_id') || !_this2.model.get('sys_org_id') && !_this2.model.get('sys_clr_id') && _roles.roleAICK.indexOf(_config2.default.role()) !== -1 || !_this2.model.get('sys_org_id') && !_this2.model.get('sys_clr_id') && _config2.default.orgs().indexOf(+org.id) !== -1 || _this2.model.get('sys_org_id') && org.id == _this2.model.get('sys_org_id') && _roles.roleAICK.indexOf(_config2.default.role()) !== -1 || _this2.model.get('sys_org_id') && org.id == _this2.model.get('sys_org_id') && _roles.roleai.indexOf(_config2.default.role()) !== -1 && _this2.model.get('contract_id') && contractsHash[_this2.model.get('contract_id')].grant_task_creation && contractsHash[_this2.model.get('contract_id')].groups.length && checkContractGroupsAgainstTypeAndObject(_this2.model, contractsHash[_this2.model.get('contract_id')], typesHash[_this2.model.get('type_id')]) || _this2.model.get('sys_clr_id') && org.cluster_id == _this2.model.get('sys_clr_id') && _roles.roleAICK.indexOf(_config2.default.role()) !== -1 || _this2.model.get('sys_clr_id') && org.cluster_id == _this2.model.get('sys_clr_id') && _roles.roleai.indexOf(_config2.default.role()) !== -1 && _this2.model.get('contract_id') && contractsHash[_this2.model.get('contract_id')].grant_task_creation && contractsHash[_this2.model.get('contract_id')].groups.length && checkContractGroupsAgainstTypeAndObject(_this2.model, contractsHash[_this2.model.get('contract_id')], typesHash[_this2.model.get('type_id')]);
	                });
	            },
	
	            assignedOrgsFn: function assignedOrgsFn() {
	                return filterAvailableOrgs.call(_this2, _this2.model, _this2.organizations().filter(function (org) {
	                    return org.id == _this2.model.get('organization_id');
	                })).map(function (org) {
	                    return [org, contractsHash[_this2.model.get('contract_id')]];
	                }).filter(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        org = _ref2[0],
	                        contract = _ref2[1];
	
	                    return !contract || !contract.assigned_organization || org.id == contract.assigned_organization.id;
	                }).map(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 1),
	                        org = _ref4[0];
	
	                    return org;
	                });
	            },
	
	            contractsFn: function contractsFn() {
	                return filterAvailableContracts.call(_this2, _this2.model);
	            },
	
	            typesFn: function typesFn() {
	                return filterAvailableTypes.call(_this2, _this2.model);
	            },
	
	            prioritiesFn: function prioritiesFn() {
	                return filterAvailablePriorities.call(_this2, _this2.model);
	            },
	
	            statusesFn: function statusesFn() {
	                return filterAvailableStatuses.call(_this2, _this2.model).sort(function (a, b) {
	                    if (a.order != undefined && b.order != undefined) return a.order - b.order;else if (a.order != undefined) return -1;else if (b.order != undefined) return 1;else if (a.name < b.name) return -1;else if (a.name > b.name) return 1;else return a.id - b.id;
	                });
	            },
	
	            dataTableObjectsFn: function dataTableObjectsFn(q, offset, limit, $el) {
	                var tableId = $el.closest('[data-table-id]')[0].dataset.tableId;
	                var pageNumber = offset / limit | 0;
	                var dropCount = offset - pageNumber * limit;
	                var realLimit = limit + dropCount;
	
	                return (0, _api.get)('/datatables/{id}/features/count?format=json&sysTitle=true&titleSearch={q}').mapsurfer().map(function (response) {
	                    return response.count;
	                }).chain(function () {
	                    return (0, _api.get)('/datatables/{id}/features?limit={limit}&sysTitle=true&titleSearch={q}').mapsurfer();
	                }).map(function (response, r, total) {
	                    var options = response.features.filter(function (item, index) {
	                        return index >= dropCount;
	                    }).map(function (_ref5) {
	                        var sys_title = _ref5.sys_title,
	                            attrs = _objectWithoutProperties(_ref5, ['sys_title']);
	
	                        return {
	                            id: attrs[response.pkField],
	                            title: sys_title
	                        };
	                    });
	
	                    return { options: options, total: total };
	                }).execute({
	                    q: q,
	                    limit: realLimit,
	                    id: tableId
	                });
	            },
	
	            rolesFn: function rolesFn() {
	                return filterAvailableRoles.call(_this2);
	            }
	
	        };
	    },
	
	
	    bindingFilters: {
	        cfTriplet: function cfTriplet(fieldId, typeId, organizationId) {
	            return { fieldId: fieldId, typeId: typeId, organizationId: organizationId };
	        }
	    },
	
	    bindingHandlers: {
	
	        cfVisible: {
	            set: function set($el, _ref6) {
	                var _this3 = this;
	
	                var fieldId = _ref6.fieldId,
	                    typeId = _ref6.typeId,
	                    organizationId = _ref6.organizationId;
	
	                var find = function find(fields) {
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var f = _step.value;
	
	                            if (f.id == fieldId) return [f, false];
	
	                            var _find = find(f.subfields),
	                                _find2 = _slicedToArray(_find, 1),
	                                g = _find2[0];
	
	                            if (g) return [g, true];
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    return [];
	                };
	
	                var _find3 = find(this.view.fields()),
	                    _find4 = _slicedToArray(_find3, 2),
	                    field = _find4[0],
	                    isNested = _find4[1];
	
	                var isBound = function isBound() {
	                    if (isNested) return true;
	
	                    var _view$organizations$f = _this3.view.organizations().filter(function (organization) {
	                        return organization.id == organizationId;
	                    }),
	                        _view$organizations$f2 = _slicedToArray(_view$organizations$f, 1),
	                        organization = _view$organizations$f2[0];
	
	                    if (!field.cluster || organization && field.cluster.id == organization.cluster_id) return [true, 't'].indexOf(field.is_for_all) !== -1 || field.bindings.filter(function (binding) {
	                        return [true, 't'].indexOf(binding.on) !== -1;
	                    }).some(function (binding) {
	                        return +binding.type.id === +typeId;
	                    });
	
	                    return false;
	                };
	
	                var isVisible = function isVisible() {
	                    if (field.format === 'system:type') if (!_this3.view.model.id) return true;
	
	                    var binding = field.bindings.find(function (binding) {
	                        return [+typeId, '' + typeId].indexOf(binding.type.id) !== -1;
	                    });
	                    if (!binding) return true;
	
	                    var _ref7 = binding.rules || [],
	                        _ref8 = _slicedToArray(_ref7, 1),
	                        rule = _ref8[0];
	
	                    if (!rule) return true;
	
	                    var visible = rule.visible_by_default,
	                        roles = rule.visible_inverted_for_roles;
	
	                    var includes = roles.indexOf(+_config2.default.role()) !== -1 || roles.indexOf('' + _config2.default.role()) !== -1;
	
	                    return [true, 't'].indexOf(visible) !== -1 && !includes || [false, 'f'].indexOf(visible) !== -1 && includes;
	                };
	
	                if (isBound() && isVisible()) $el.removeClass('--none').addClass('--block');else $el.addClass('--none').removeClass('--block');
	            }
	        }
	
	    }
	
	}, _defineProperty(_Form$extend, _form2.default.event('data-objects:pick'), function (tableId, fieldId, translit, format, minCount, path, amountEditable) {
	    var _this4 = this;
	
	    var _bindingFilters$prepa = this.bindingFilters.prepareCf.get(this.model.get('fields'), fieldId, translit, format, null, minCount, tableId, 't', amountEditable, undefined, path),
	        _bindingFilters$prepa2 = _slicedToArray(_bindingFilters$prepa, 2),
	        prev = _bindingFilters$prepa2[0],
	        meta = _bindingFilters$prepa2[1];
	
	    var view = _pick2.default.of({
	        dataTableId: +tableId,
	        multiple: true,
	        amountEditable: amountEditable == 't'
	    });
	
	    var selected = (prev || []).map(function (_ref9) {
	        var object_id = _ref9.object_id,
	            num = _ref9.num;
	        return { object_id: object_id, num: num, layer_id: tableId };
	    });
	
	    return (0, _popups.ask)(view.bind({ selected: selected }), 'datatables::object - choose', 'actions::choose', 'actions::cancel', { large: true }).then(function () {
	        var values = view.model.get('selected');
	        _this4.model.set(_this4.bindingFilters.prepareCf.set([values, meta]));
	    });
	}), _defineProperty(_Form$extend, _form2.default.event('composite:remove-instance'), function (path, fieldId, translit, format, minCount, instanceIndex) {
	    var _bindingFilters$prepa3 = this.bindingFilters.prepareCf.get(this.model.get('fields'), fieldId, translit, format, null, minCount, undefined, undefined, undefined, undefined, path),
	        _bindingFilters$prepa4 = _slicedToArray(_bindingFilters$prepa3, 2),
	        instances = _bindingFilters$prepa4[0],
	        meta = _bindingFilters$prepa4[1];
	
	    var newInstances = instances.filter(function (_, index) {
	        return index != instanceIndex;
	    });
	    this.model.set(this.bindingFilters.prepareCf.set([newInstances, meta]));
	
	    this.render();
	}), _defineProperty(_Form$extend, _form2.default.event('composite:add-instance'), function (path, fieldId, translit, format, minCount) {
	    var _bindingFilters$prepa5 = this.bindingFilters.prepareCf.get(this.model.get('fields'), fieldId, translit, format, null, minCount, undefined, undefined, undefined, undefined, path),
	        _bindingFilters$prepa6 = _slicedToArray(_bindingFilters$prepa5, 2),
	        instances = _bindingFilters$prepa6[0],
	        meta = _bindingFilters$prepa6[1];
	
	    var newInstances = [].concat(_toConsumableArray(instances));
	    for (var i = instances.length; i < meta.min_count; i++) {
	        newInstances.push({});
	    }newInstances.push({});
	
	    this.model.set(this.bindingFilters.prepareCf.set([newInstances, meta]));
	
	    this.render();
	}), _defineProperty(_Form$extend, 'clusters', function clusters() {
	    return arraify(this.options.clusters);
	}), _defineProperty(_Form$extend, 'organizations', function organizations() {
	    return arraify(this.options.organizations);
	}), _defineProperty(_Form$extend, 'contracts', function contracts() {
	    return arraify(this.options.contracts);
	}), _defineProperty(_Form$extend, 'types', function types() {
	    return arraify(this.options.types);
	}), _defineProperty(_Form$extend, 'priorities', function priorities() {
	    return arraify(this.options.priorities);
	}), _defineProperty(_Form$extend, 'statuses', function statuses() {
	    return arraify(this.options.statuses);
	}), _defineProperty(_Form$extend, 'fields', function fields() {
	    return arraify(this.options.fields);
	}), _defineProperty(_Form$extend, 'roles', function roles() {
	    return arraify(this.options.roles);
	}), _Form$extend));
	
	
	function arraify(possiblyCollection) {
	    return possiblyCollection instanceof _collection2.default ? possiblyCollection.toJSON() : possiblyCollection;
	}
	
	function attachServiceObject(objectId, layerId, task, mappings) {
	    var typeId = task.get('type_id');
	
	    var mapping = mappings.find(function (m) {
	        return m.get('layer').id == layerId;
	    });
	    if (!mapping) return Promise.reject();
	
	    return (0, _api.pst)('/tasks/mapping/layer/' + layerId + '/object/' + objectId + '/type/' + typeId + '?apiVersion=2.0').cerebellum().blocking().execute().then(function (_ref10) {
	        var objectResponse = _ref10.task,
	            sys_org_id = _ref10.sys_org_id,
	            sys_clr_id = _ref10.sys_clr_id;
	
	        var id = objectResponse.id,
	            lon = objectResponse.lon,
	            lat = objectResponse.lat,
	            responseFields = objectResponse.fields,
	            responseAttrs = _objectWithoutProperties(objectResponse, ['id', 'lon', 'lat', 'fields']);
	
	        var json = task.toJSON();
	
	        var _ = json.fields,
	            taskAttrs = _objectWithoutProperties(json, ['fields']);
	
	        var taskFields = json.fields ? _extends({}, json.fields) : {};
	        var fieldsChanged = Object.keys(responseFields).filter(function (key) {
	            return taskFields[key] === undefined || taskFields[key].value === undefined || taskFields[key].value === '';
	        }).map(function (key) {
	            return [key, responseFields[key]];
	        }).map(function (_ref11) {
	            var _ref12 = _slicedToArray(_ref11, 2),
	                key = _ref12[0],
	                valueObject = _ref12[1];
	
	            return taskFields[key] = valueObject;
	        }).length > 0;
	
	        var attrsChanged = Object.keys(responseAttrs).filter(function (key) {
	            return taskAttrs[key] === undefined || taskAttrs[key] === '';
	        }).map(function (key) {
	            return [key, responseAttrs[key]];
	        }).reduce(function (hash, _ref13) {
	            var _ref14 = _slicedToArray(_ref13, 2),
	                key = _ref14[0],
	                value = _ref14[1];
	
	            return hash[key] = value, hash;
	        }, {});
	
	        var attrsToSet = _extends({
	            sys_org_id: sys_org_id, sys_clr_id: sys_clr_id,
	            service_object_id: objectId,
	            service_object_layer_id: layerId
	        }, attrsChanged);
	
	        if (lon && lat) attrsToSet.location = { lon: lon, lat: lat };
	        if (fieldsChanged) attrsToSet.fields = taskFields;
	
	        task.set(attrsToSet);
	        if (sys_org_id)
	            // separately from "main" attrsToSet
	            task.set('organization_id', sys_org_id);
	    });
	}
	
	function allowContractChange(model, contracts) {
	    var _contracts$filter = contracts.filter(function (contract) {
	        return contract.id === model.get('contract_id');
	    }),
	        _contracts$filter2 = _slicedToArray(_contracts$filter, 1),
	        oldContract = _contracts$filter2[0];
	
	    if (~_roles.roleAI.indexOf(_config2.default.role())) return true;
	
	    if (~_roles.roleCK.indexOf(_config2.default.role())) return true;
	
	    if (!~_roles.roleai.indexOf(_config2.default.role())) return false;
	
	    if (oldContract && !oldContract.grant_task_creation) return false;
	
	    if (oldContract) if (!~_config2.default.orgs().indexOf(oldContract.assigned_organization.id)) return false;
	
	    return true;
	}
	
	function checkTypeAgainstOrg(type, org) {
	    return !type.cluster && type.default_type === 't' || !type.cluster && type.default_type === 'f' && (type.departments.indexOf(+org.id) !== -1 || type.departments.indexOf('' + org.id) !== -1) || type.cluster && org.cluster_id == type.cluster.id && type.default_type === 't' || type.cluster && org.cluster_id == type.cluster.id && type.default_type === 'f' && (type.departments.indexOf(+org.id) !== -1 || type.departments.indexOf('' + org.id) !== -1);
	}
	
	function checkTypeAgainstRole(type) {
	    return type.role_ids == null || type.role_ids.indexOf(_config2.default.role()) !== -1 || type.role_ids.indexOf(+_config2.default.role()) !== -1;
	}
	
	function filterAvailableOrgs(model, _ref15) {
	    var _ref16 = _slicedToArray(_ref15, 1),
	        otherOrg = _ref16[0];
	
	    var pickedClusterId = model.get('cluster_id');
	
	    var _types$filter = this.types().filter(function (type) {
	        return type.id == model.get('type_id');
	    }),
	        _types$filter2 = _slicedToArray(_types$filter, 1),
	        type = _types$filter2[0];
	
	    var _priorities$filter = this.priorities().filter(function (priority) {
	        return priority.id == model.get('priority_id');
	    }),
	        _priorities$filter2 = _slicedToArray(_priorities$filter, 1),
	        priority = _priorities$filter2[0];
	
	    var _contracts$filter3 = this.contracts().filter(function (contract) {
	        return contract.id == model.get('contract_id');
	    }),
	        _contracts$filter4 = _slicedToArray(_contracts$filter3, 1),
	        contract = _contracts$filter4[0];
	
	    var clusterId = pickedClusterId || type && type.cluster && type.cluster.id || priority && priority.cluster && priority.cluster.id || contract && contract.cluster.id || otherOrg && otherOrg.cluster_id;
	
	    return this.organizations().filter(function (org) {
	        return !clusterId || org.cluster_id == clusterId;
	    }).filter(function (org) {
	        return !type || checkTypeAgainstOrg(type, org);
	    }).map(function (org) {
	        return { id: org.id, title: org.name, cluster_id: org.cluster_id };
	    });
	}
	
	function filterAvailableTypes(model) {
	    var pickedClusterId = model.get('cluster_id');
	
	    var _priorities$filter3 = this.priorities().filter(function (priority) {
	        return priority.id == model.get('priority_id');
	    }),
	        _priorities$filter4 = _slicedToArray(_priorities$filter3, 1),
	        priority = _priorities$filter4[0];
	
	    var _organizations$filter = this.organizations().filter(function (org) {
	        return org.id == model.get('organization_id');
	    }),
	        _organizations$filter2 = _slicedToArray(_organizations$filter, 1),
	        org = _organizations$filter2[0];
	
	    var _organizations$filter3 = this.organizations().filter(function (org) {
	        return org.id == model.get('assigned_organization');
	    }),
	        _organizations$filter4 = _slicedToArray(_organizations$filter3, 1),
	        assOrg = _organizations$filter4[0];
	
	    var _contracts$filter5 = this.contracts().filter(function (contract) {
	        return contract.id == model.get('contract_id');
	    }),
	        _contracts$filter6 = _slicedToArray(_contracts$filter5, 1),
	        contract = _contracts$filter6[0];
	
	    var clusterId = pickedClusterId || priority && priority.cluster && priority.cluster.id || contract && contract.cluster.id || org && org.cluster_id || assOrg && assOrg.cluster_id;
	
	    return this.types()
	
	    // check type against task organization
	    .filter(function (type) {
	        return !org || checkTypeAgainstOrg(type, org);
	    })
	    // check type against task assigned organization
	    .filter(function (type) {
	        return !assOrg || checkTypeAgainstOrg(type, assOrg);
	    }).filter(function (type) {
	        return checkTypeAgainstRole(type);
	    })
	
	    // check type against contract cluster
	    .filter(function (type) {
	        return !clusterId || !type.cluster || type.cluster.id == clusterId;
	    })
	
	    // check type against contract groups
	    .filter(function (type) {
	        return !contract || checkContractGroupsAgainstTypeAndObject(model, contract, type);
	    }).map(function (type) {
	        return { id: type.id, title: type.name };
	    });
	}
	
	function filterAvailableContracts(model) {
	    var pickedClusterId = model.get('cluster_id');
	
	    var _types$filter3 = this.types().filter(function (type) {
	        return type.id == model.get('type_id');
	    }),
	        _types$filter4 = _slicedToArray(_types$filter3, 1),
	        type = _types$filter4[0];
	
	    var _priorities$filter5 = this.priorities().filter(function (priority) {
	        return priority.id == model.get('priority_id');
	    }),
	        _priorities$filter6 = _slicedToArray(_priorities$filter5, 1),
	        priority = _priorities$filter6[0];
	
	    var _organizations$filter5 = this.organizations().filter(function (org) {
	        return org.id == model.get('organization_id');
	    }),
	        _organizations$filter6 = _slicedToArray(_organizations$filter5, 1),
	        org = _organizations$filter6[0];
	
	    var _organizations$filter7 = this.organizations().filter(function (org) {
	        return org.id == model.get('assigned_organization');
	    }),
	        _organizations$filter8 = _slicedToArray(_organizations$filter7, 1),
	        assOrg = _organizations$filter8[0];
	
	    var clusterId = pickedClusterId || type && type.cluster && type.cluster.id || priority && priority.cluster && priority.cluster.id || org && org.cluster_id || assOrg && assOrg.cluster_id;
	
	    var commonPermission = allowContractChange(model, this.contracts());
	    return this.contracts().filter(function (contract) {
	        return !contract.start_date || (0, _date.beforeEq)(contract.start_date, model.get('date'));
	    }).filter(function (contract) {
	        return !contract.finish_date || (0, _date.after)(contract.finish_date, model.get('date'));
	    }).filter(function (contract) {
	        return !clusterId || contract.cluster.id == clusterId;
	    }).filter(function (contract) {
	        return !assOrg || !contract.assigned_organization || contract.assigned_organization.id == assOrg.id;
	    })
	
	    // check contract groups against type and service objects
	    .filter(function (contract) {
	        return checkContractGroupsAgainstTypeAndObject(model, contract, type);
	    }).filter(function (contract) {
	        if (!commonPermission) return false;
	
	        if (~_roles.roleAI.indexOf(_config2.default.role())) return true;
	
	        if (~_roles.roleCK.indexOf(_config2.default.role())) return true;
	
	        if (!contract.grant_task_creation) return false;
	
	        if (!~_config2.default.orgs().indexOf(contract.assigned_organization.id)) return false;
	
	        return true;
	    });
	}
	
	function filterAvailablePriorities(model) {
	    var pickedClusterId = model.get('cluster_id');
	
	    var _types$filter5 = this.types().filter(function (type) {
	        return type.id == model.get('type_id');
	    }),
	        _types$filter6 = _slicedToArray(_types$filter5, 1),
	        type = _types$filter6[0];
	
	    var _organizations$filter9 = this.organizations().filter(function (org) {
	        return org.id == model.get('organization_id');
	    }),
	        _organizations$filter10 = _slicedToArray(_organizations$filter9, 1),
	        org = _organizations$filter10[0];
	
	    var _organizations$filter11 = this.organizations().filter(function (org) {
	        return org.id == model.get('assigned_organization');
	    }),
	        _organizations$filter12 = _slicedToArray(_organizations$filter11, 1),
	        assOrg = _organizations$filter12[0];
	
	    var _contracts$filter7 = this.contracts().filter(function (contract) {
	        return contract.id == model.get('contract_id');
	    }),
	        _contracts$filter8 = _slicedToArray(_contracts$filter7, 1),
	        contract = _contracts$filter8[0];
	
	    var clusterId = pickedClusterId || type && type.cluster && type.cluster.id || contract && contract.cluster.id || org && org.cluster_id || assOrg && assOrg.cluster_id;
	
	    return this.priorities()
	
	    // check against contract cluster
	    .filter(function (priority) {
	        return !clusterId || !priority.cluster || priority.cluster.id == clusterId;
	    }).map(function (priority) {
	        return { id: priority.id, title: priority.name };
	    });
	}
	
	function filterAvailableStatuses(model) {
	    var pickedClusterId = model.get('cluster_id');
	
	    var _types$filter7 = this.types().filter(function (type) {
	        return type.id == model.get('type_id');
	    }),
	        _types$filter8 = _slicedToArray(_types$filter7, 1),
	        type = _types$filter8[0];
	
	    var _priorities$filter7 = this.priorities().filter(function (priority) {
	        return priority.id == model.get('priority_id');
	    }),
	        _priorities$filter8 = _slicedToArray(_priorities$filter7, 1),
	        priority = _priorities$filter8[0];
	
	    var _organizations$filter13 = this.organizations().filter(function (org) {
	        return org.id == model.get('organization_id');
	    }),
	        _organizations$filter14 = _slicedToArray(_organizations$filter13, 1),
	        org = _organizations$filter14[0];
	
	    var _organizations$filter15 = this.organizations().filter(function (org) {
	        return org.id == model.get('assigned_organization');
	    }),
	        _organizations$filter16 = _slicedToArray(_organizations$filter15, 1),
	        assOrg = _organizations$filter16[0];
	
	    var _contracts$filter9 = this.contracts().filter(function (contract) {
	        return contract.id == model.get('contract_id');
	    }),
	        _contracts$filter10 = _slicedToArray(_contracts$filter9, 1),
	        contract = _contracts$filter10[0];
	
	    var clusterId = pickedClusterId || type && type.cluster && type.cluster.id || priority && priority.cluster && priority.cluster.id || contract && contract.cluster.id || org && org.cluster_id || assOrg && assOrg.cluster_id;
	
	    var _ref17 = [].concat(_toConsumableArray(this.clusters().filter(function (cluster) {
	        return cluster.id == clusterId;
	    })), [{ id: clusterId // temp fix if cluster is deleted
	    }]),
	        cluster = _ref17[0];
	
	    return this.statuses()
	
	    // check against cluster
	    .filter(function (status) {
	        return !cluster.isolated && !status.cluster || cluster.isolated && status.cluster && status.cluster.id == cluster.id;
	    }).filter(function (status) {
	        return status.visible;
	    }).map(function (status) {
	        return {
	            id: status.id,
	            title: status.name,
	            order: status.order
	        };
	    });
	}
	
	function filterAvailableRoles() {
	    var _this5 = this;
	
	    var _types$filter9 = this.types().filter(function (type) {
	        return type.id == _this5.model.get('type_id');
	    }),
	        _types$filter10 = _slicedToArray(_types$filter9, 1),
	        type = _types$filter10[0];
	
	    return this.roles().filter(function (role) {
	        return !type || type.role_ids == null || type.role_ids.indexOf(role.id) !== -1 || type.role_ids.indexOf(+role.id) !== -1 || type.role_ids.indexOf('' + role.id) !== -1;
	    });
	}
	
	function checkContractGroupsAgainstTypeAndObject(model, contract, type) {
	    // no groups -> any type is okay
	    return !contract.groups.length ||
	    // otherwise: type is okay if there is any matching group
	    0 < contract.groups
	    // filter groups matched by service object id
	    .filter(function (group) {
	        return (
	            // no objects -> group is okay
	            !group.objects.length ||
	            // no task object -> group is okay
	            !model.get('service_object_id') ||
	            // otherwise: group contains task object -> group is okay
	            group.objects.some(function (_ref18) {
	                var object_id = _ref18.object_id,
	                    layer_id = _ref18.layer_id;
	                return object_id == model.get('service_object_id') && layer_id == model.get('service_object_layer_id');
	            })
	        );
	    })
	    // filter group by matching type
	    .filter(function (group) {
	        return !type ||
	        // no types -> group is okay
	        !group.types.length ||
	        // otherwise: group must contain type
	        group.types.some(function (t) {
	            return t.id == type.id;
	        });
	    }).length;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _View$extend;
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _view2.default.extend((_View$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        var datatables = this.options.datatables;
	
	        if (datatables) options.sorted = _grid2.default.sort({ sort: this.sort_, direction: this.direction_ }, datatables, new _collection2.default()), options.filtered = new _collection2.default(), options.dest = new _collection2.default();else options.sorted = Promise.resolve();
	    },
	
	
	    template: 'pick.objects',
	
	    page_: 1,
	
	    search_: '',
	
	    sort_: 'name',
	
	    direction_: 'asc',
	
	    serialize: function serialize() {
	        var _this = this;
	
	        var _options = this.options,
	            sorted = _options.sorted,
	            filtered = _options.filtered,
	            dest = _options.dest,
	            objects = _options.objects;
	
	        return sorted.then(function (sorted) {
	            if (sorted) _grid2.default.filter({ search: _this.search_, page: _this.page_, limit: 10 }, null, // cluster
	            sorted, filtered, dest);
	
	            return {
	                datatables: dest,
	                objects: objects,
	                searchString: _this.search_,
	                dataTablesSort: _this.sort_, dataTablesDirection: _this.direction_
	            };
	        });
	    },
	
	
	    events: {
	        'click .datatables-grid .-sort': function clickDatatablesGridSort(_ref) {
	            var _this2 = this;
	
	            var currentTarget = _ref.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                direction = _currentTarget$datase.direction,
	                sort = _currentTarget$datase.sort;
	            var _options2 = this.options,
	                datatables = _options2.datatables,
	                sorted = _options2.sorted;
	
	
	            return this.page_ = 1, this.sort_ = sort, this.direction_ = direction, sorted.then(function (sorted) {
	                return _grid2.default.sort({ sort: sort, direction: direction }, datatables, sorted);
	            }).then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.focus();
	            });
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('ObjectsGrid:action:default'), function (index, object) {
	    if (!this.options.multiple) this.trigger('modal:accept', this.chosen_ = object);
	}), _defineProperty(_View$extend, _view2.default.event('ObjectsGrid:activate'), function (index, object) {
	    this.chosen_ = object;
	}), _defineProperty(_View$extend, _view2.default.event('ObjectsGrid:deactivate'), function () {
	    this.chosen_ = null;
	}), _defineProperty(_View$extend, _view2.default.event('DataTablesPaging:page'), function (page) {
	    return this.page_ = page, this.render();
	}), _defineProperty(_View$extend, _view2.default.event('DataTablesSearch:search'), function (search) {
	    return this.search_ = search, this.page_ = 1, this.render();
	}), _defineProperty(_View$extend, _view2.default.event('DataTables:activate'), function (index) {
	    var _this3 = this;
	
	    return this.Objects.render().then(function () {
	        return _this3.Objects.focus();
	    });
	}), _defineProperty(_View$extend, _view2.default.event('DataTables:deactivate'), function () {
	    return this.Objects.render();
	}), _View$extend), {
	
	    // todo sorting
	    of: function of(_ref2) {
	        var datatables = _ref2.datatables,
	            objects = _ref2.objects,
	            options = _objectWithoutProperties(_ref2, ['datatables', 'objects']);
	
	        if (datatables instanceof Array) datatables = new _collection2.default(datatables);
	
	        if (objects instanceof Array) objects = new _collection2.default(objects);
	
	        var Class = this;
	        return new Class(_extends({ datatables: datatables, objects: objects }, options));
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var roleA = exports.roleA = [8, '8'];
	
	var roleC = exports.roleC = [5, '5'];
	
	var rolea = exports.rolea = [10, '10'];
	
	var roleAIai = exports.roleAIai = [].concat(roleA, rolea, [11, 12, '11', '12']);
	
	var roleai = exports.roleai = [].concat(rolea, [11, '11']);
	
	var roleAI = exports.roleAI = [].concat(roleA, [12, '12']);
	
	var roleAC = exports.roleAC = [].concat(roleA, roleC);
	
	var roleCK = exports.roleCK = [4, '4'].concat(roleC);
	
	var roleAICK = exports.roleAICK = [].concat(_toConsumableArray(roleAI), _toConsumableArray(roleCK));
	
	var roleAICKai = exports.roleAICKai = [].concat(_toConsumableArray(roleAICK), _toConsumableArray(roleai));
	
	var roleuc = exports.roleuc = [6, '6', 7, '7'];
	
	var roleaiuc = exports.roleaiuc = [].concat(_toConsumableArray(roleai), roleuc);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _View$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _api = __webpack_require__(77);
	
	var _arrays = __webpack_require__(24);
	
	var _sort = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _view2.default.extend((_View$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        this.collection_ = new _collection2.default();
	        this.filtered_ = new _collection2.default();
	        this.objectsByDataTables_ = {};
	    },
	
	
	    page_: 1,
	
	    dataTableId_: undefined,
	
	    search_: '',
	
	    sort_: 'name',
	
	    direction_: 'asc',
	
	    serialize: function serialize() {
	        var _this = this;
	
	        var dataTableId = this.options.datatables && this.options.datatables.current() ? this.options.datatables.current().id : this.options.dataTableId;
	
	        if (this.dataTableId_ !== dataTableId) this.dataTableId_ = dataTableId, this.search_ = '', this.page_ = 1;
	
	        if (!dataTableId) return {};
	
	        if (this.objectsByDataTables_[dataTableId]) return sort.call(this, this.objectsByDataTables_[dataTableId]);
	
	        if (this.options.objects) return sort.call(this, this.objectsByDataTables_[dataTableId] = new _collection2.default(this.options.objects.toJSON().filter(function (obj) {
	            return obj.layer_id == dataTableId;
	        })));
	
	        return (0, _api.get)('/datatables/{id}/features?limit=1000000&pageNumber=1&sysTitle=true').mapsurfer().blocking().map(function (response) {
	            return response.features;
	        }).map(function (_ref, index, features, response) {
	            var sys_title = _ref.sys_title,
	                attrs = _objectWithoutProperties(_ref, ['sys_title']);
	
	            return _extends({
	                object_id: attrs[response.pkField],
	                fid: attrs[response.pkField],
	                layer_id: dataTableId
	            }, attrs, {
	                name: sys_title
	            });
	        }).execute({ id: dataTableId }).then(function (objects) {
	            return sort.call(_this, _this.objectsByDataTables_[dataTableId] = new _collection2.default(objects));
	        });
	    },
	
	
	    events: {
	        'click .-toggle-selected': function clickToggleSelected(_ref2) {
	            var _this2 = this;
	
	            var currentTarget = _ref2.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                name = _currentTarget$datase.name,
	                object_id = _currentTarget$datase.id;
	
	            var dataTableId = this.dataTableId_;
	
	            var oldSelected = this.model.get('selected');
	            var needAppend = currentTarget.checked;
	            var newSelected = needAppend ? [].concat(_toConsumableArray(oldSelected), [{ name: name, object_id: object_id, layer_id: dataTableId }]) : oldSelected.filter(function (item) {
	                return item.layer_id != dataTableId || item.object_id != object_id;
	            });
	
	            this.$('.-toggle-all')[0].checked = this.filtered_.length > 0 && newSelected.filter(function (obj) {
	                return obj.layer_id == dataTableId;
	            }).length == this.filtered_.length;
	
	            this.model.set('selected', newSelected);
	            setTimeout(function () {
	                return _this2.render().then(function () {
	                    return _this2.focus();
	                });
	            }, 150);
	        },
	        'click .-toggle-all': function clickToggleAll() {
	            var _this3 = this;
	
	            var dataTableId = this.dataTableId_;
	            var oldSelected = this.model.get('selected');
	            var filtered = this.filtered_.toJSON();
	            var ids = (0, _arrays.hashify)(filtered.map(function (obj) {
	                return obj.id;
	            }));
	
	            // by default drop
	            var newSelected = oldSelected.filter(function (obj) {
	                return obj.layer_id != dataTableId || obj.layer_id == dataTableId && !ids[obj.object_id];
	            });
	            // but: add all 
	            if (filtered.some(function (obj) {
	                return !obj.chosen;
	            })) newSelected = [].concat(_toConsumableArray(oldSelected), _toConsumableArray(filtered.filter(function (obj) {
	                return !obj.chosen;
	            }).map(function (_ref3) {
	                var id = _ref3.id,
	                    name = _ref3.name;
	                return {
	                    object_id: id,
	                    layer_id: dataTableId,
	                    name: name };
	            })));
	
	            this.model.set('selected', newSelected);
	            setTimeout(function () {
	                return _this3.render().then(function () {
	                    return _this3.focus();
	                });
	            }, 150);
	        },
	        'click .-sort': function clickSort(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var _currentTarget$datase2 = currentTarget.dataset,
	                direction = _currentTarget$datase2.direction,
	                column = _currentTarget$datase2.sort;
	
	
	            return this.page_ = 1, this.sort_ = column, this.direction_ = direction, this.render();
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('ObjectsPaging:page'), function (page) {
	    return this.page_ = page, this.render();
	}), _defineProperty(_View$extend, _view2.default.event('ObjectsSearch:search'), function (search) {
	    return this.search_ = search, this.page_ = 1, this.render();
	}), _View$extend));
	
	
	function sort(source) {
	    var _this4 = this;
	
	    // objects is always Collection
	    var sorting = 'asc' === this.direction_ ? (0, _sort.asc)(source.models, [this.sort_, 'object_id']) : (0, _sort.desc)(source.models, [this.sort_, 'object_id']);
	
	    return sorting.then(function (sortedModels) {
	        return finishSerialize.call(_this4, new _collection2.default(sortedModels));
	    });
	}
	
	function finishSerialize(objects) {
	    var _this5 = this;
	
	    var objectIds = (0, _arrays.hashify)((this.model && this.model.get('selected') || []).filter(function (ptr) {
	        return ptr.layer_id == _this5.dataTableId_;
	    }).map(function (ptr) {
	        return ptr.object_id;
	    }));
	
	    var searchString = this.search_ && this.search_.toLowerCase() || '';
	    var models = (objects instanceof _collection2.default ? objects.toJSON() : objects).map(function (_ref5) {
	        var object_id = _ref5.object_id,
	            attrs = _objectWithoutProperties(_ref5, ['object_id']);
	
	        return _extends({
	            id: object_id
	        }, attrs, {
	            chosen: objectIds[object_id]
	        });
	    }).filter(function (_ref6) {
	        var id = _ref6.id,
	            name = _ref6.name;
	        return ~(id + '').indexOf(searchString) || ~(name || '').toLowerCase().indexOf(searchString);
	    });
	
	    this.filtered_.reset(models);
	
	    var limit = 10;
	    this.collection_.reset(models.filter(function (object, index) {
	        return index >= limit * (_this5.page_ - 1) && index < limit * _this5.page_;
	    }));
	
	    this.collection_.page = this.page_;
	    this.collection_.limit = limit;
	    this.collection_.total = this.filtered_.length;
	
	    return {
	        collection: this.collection_,
	        multiple: this.options.multiple,
	        allSelected: models.every(function (object) {
	            return object.chosen;
	        }) && models.length > 0,
	        searchString: this.search_,
	        objectsSort: this.sort_, objectsDirection: this.direction_,
	        amountEditable: this.options.amountEditable
	    };
	}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _service = __webpack_require__(120);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _suggest = __webpack_require__(111);
	
	var _arrays = __webpack_require__(24);
	
	var _promisify = __webpack_require__(19);
	
	var _map = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _view2.default.extend({
	
	    className: 'map-container',
	
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        this.boundsHash_ = {};
	        this.closeListener_ = null;
	        this.markers_ = {};
	
	        _backbone2.default.$(window).on('resize', function () {
	            return _this.boundsHash_ = {};
	        });
	
	        this.ready_ = new Promise(function (resolve) {
	            return _this.fireReady_ = resolve;
	        });
	
	        this.suggestionInterface_ = (0, _suggest.suggest)(this.$el, '[name="search-on-map"]', function ($htmlInput, page) {
	            if (!_this.searchMode_) _this.oldCenter_ = _this.map_.center(), _this.oldZoom_ = _this.map_.zoom();
	            _this.searchMode_ = true;
	
	            var q = $htmlInput.val().trim();
	            var r = _service2.default
	            // minx,miny,maxx,maxy
	            .execute({ query: q, bbox: _config2.default.mapExtent() }).then(function (items) {
	                return items.map(function (_ref) {
	                    var objectId = _ref.objectId,
	                        title = _ref.title,
	                        layerId = _ref.layerId,
	                        coords = _ref.coords;
	                    return {
	                        objectId: objectId, layerId: layerId, coords: coords,
	                        title: !layerId ? title : '<span class="glyphicon glyphicon-star"></span> ' + title
	                    };
	                });
	            }).then(function (items) {
	                return items.slice(0, 10);
	            }).then(function (items) {
	                return {
	                    // interface is ({title, coords, fields})
	                    options: items,
	                    total: items.length, limit: 20,
	                    offset: 0, page: 0
	                };
	            });
	
	            r.catch(function (ex) {
	                return console.error(ex);
	            });
	
	            return r;
	        }, function ($htmlInput, itemTitle, itemData) {
	            // choose
	            _this.searchMode_ = false;
	            // will choose point on the map and stay here
	            if (itemData.layerId) _this.trigger('service-object:choose', itemData);else _this.trigger('address:choose', itemData);
	            // so, make blur and stay here because searchmode = false
	            $htmlInput.blur();
	        }, function ($htmlInput) {
	            // blur
	            if (_this.searchMode_) {
	                _this.searchMode_ = false;
	                var _oldCenter_ = _this.oldCenter_,
	                    lat = _oldCenter_.lat,
	                    lng = _oldCenter_.lng;
	
	                _this.map_.setView(new M.LatLng(lat, lng), _this.oldZoom_);
	            }
	            $htmlInput.val('');
	            _this.$('.map-search').removeClass('__searching');
	        }, function (current /*, items*/) {
	            if (!current || !current.coords) return;
	            var _current$coords = current.coords,
	                lat = _current$coords.lat,
	                lon = _current$coords.lon;
	
	            _this.map_.setView(new M.LatLng(+lat, +lon), 17);
	        }, {
	            showInfo: false
	        });
	    },
	
	
	    events: {
	        'mousedown .map-search-btn': function mousedownMapSearchBtn(e) {
	            this.$('.map-search').addClass('__searching');
	            e.preventDefault();
	        },
	
	        'keydown [name="search-on-map"]': function keydownNameSearchOnMap() {
	            this.$('.map-search').addClass('__searching');
	        },
	
	        'mouseenter .map-search': function mouseenterMapSearch() {
	            var $input = this.$('[name="search-on-map"]');
	            if (!$input.is(':focus')) $input.focus();
	        },
	
	        'mouseleave .map-search': function mouseleaveMapSearch() {
	            var $input = this.$('[name="search-on-map"]');
	            if (!$input.val() && !this.$('.map-search').is('.__searching')) $input.blur();
	        },
	
	        'click .__zoom-in': function click__zoomIn() {
	            if (this.map_.zoom() < 20) this.map_.zoomIn();
	        },
	
	        'click .__zoom-out': function click__zoomOut() {
	            if (this.map_.zoom() > 1) this.map_.zoomOut();
	        }
	    },
	
	    serialize: function serialize() {
	        var _options = this.options,
	            locationService = _options.locationService,
	            search = _options.search;
	        var defaults = _config2.default.map(),
	            extent = _config2.default.mapExtent() && [].concat(_toConsumableArray(_config2.default.mapExtent())),
	            _ref2 = this.model && this.model.get('location') || defaults,
	            lon = _ref2.lon,
	            lat = _ref2.lat;
	
	
	        var mapContext = {
	            center: {
	                lat: lat || defaults.lat,
	                lon: lon || defaults.lon,
	                zoom: defaults.zoom
	            },
	            extent: extent,
	            search: search
	        };
	
	        if (extent) {
	            var _extent = _slicedToArray(extent, 4),
	                minLon = _extent[0],
	                minLat = _extent[1],
	                maxLon = _extent[2],
	                maxLat = _extent[3];
	
	            if (minLon && minLat && maxLon && maxLat) {
	                var _lon = (minLon + maxLon) / 2;
	                var _lat = (minLat + maxLat) / 2;
	                mapContext.center = _extends({}, mapContext.center, {
	                    lat: _lat,
	                    lon: _lon
	                });
	            }
	        }
	
	        if (!this.model) return mapContext;
	
	        var userId = this.model.get('assigned_user_id');
	        if (!userId) return mapContext;
	
	        var location = locationService.getLoc(userId);
	        if (location) mapContext.assigneeLocation = { location: location, user: { id: userId } };
	
	        return mapContext;
	    },
	    bounds: function bounds() {
	        return this.map_.bounds();
	    },
	    center: function center() {
	        return this.map_.center();
	    },
	    zoom: function zoom() {
	        return this.map_.zoom();
	    },
	    setView: function setView(lon, lat, zoom) {
	        this.map_.setView(new M.LatLng(lon, lat), zoom);
	    },
	    fitBounds: function fitBounds(minLat, minLon, maxLat, maxLon) {
	        this.map_.fitBounds(new M.LatLngBounds(new M.LatLng(maxLat, maxLon), new M.LatLng(minLat, minLon)));
	    },
	    onMoveOrZoom: function onMoveOrZoom(callback) {
	        this.map_.on('zoomend', callback);
	        this.map_.on('move', callback);
	    },
	    performRender: function performRender(bodyString, context, firstTime) {
	        var _this2 = this;
	
	        if (!firstTime) return;
	
	        this.$el.html(bodyString);
	
	        var _$mapEl = this.$mapEl = this.$('.map-el');
	
	        var _$mapEl2 = _slicedToArray(_$mapEl, 1);
	
	        this.mapEl = _$mapEl2[0];
	
	        if (!this.mapEl.id) this.mapEl.id = String(Math.random());
	
	        var _Config$mapClass = _config2.default.mapClass(),
	            Class = _Config$mapClass.Class,
	            firstAttr = _Config$mapClass.firstAttr,
	            options = _Config$mapClass.options;
	
	        var baseLayer = new Class(firstAttr, options);
	
	        var mapOptions = {
	            center: new M.LatLng(context.center.lat, context.center.lon),
	            zoom: context.center.zoom,
	            layers: [baseLayer],
	            scrollWheelZoom: true
	        };
	
	        this.mapEl.extent = context.extent;
	        this.mapEl.center = mapOptions.center;
	        this.mapEl.MAP = this.map_ = new M.Map(this.mapEl, mapOptions);
	
	        if (_jquery2.default.contains(document.body, this.mapEl)) {
	            this.fireReady_();
	        } else {
	            var interval = setInterval(function () {
	                if (!_jquery2.default.contains(document.body, _this2.mapEl)) return;
	
	                _this2.adjustDimensions();
	                clearInterval(interval);
	
	                _this2.fireReady_();
	            }, 50);
	        }
	
	        this.map_.on('click', function (_ref3) {
	            var _ref3$latlng = _ref3.latlng,
	                lat = _ref3$latlng.lat,
	                lng = _ref3$latlng.lng;
	            return _this2.trigger('map:click', { lat: lat, lon: lng });
	        });
	    },
	    adjustDimensions: function adjustDimensions() {
	        var e = void 0;
	        if (typeof Event === 'function') {
	            e = new Event('resize');
	        } else {
	            e = document.createEvent('Event');
	            e.initEvent('resize', true, true);
	        }
	
	        window.dispatchEvent(e);
	    },
	    afterRender: function afterRender(context, firstTime) {
	        var _this3 = this;
	
	        this.suggestionInterface_.unbindEvents();
	        this.suggestionInterface_.bindEvents();
	
	        if (!this.model || !this.model.get('location')) return _updateLayer(this, 'bydistance', []), _updateLayer(this, 'location', []), _updateLayer(this, 'assignee', []), this.spanToExtent_(context.extent, firstTime);
	
	        if (this.locationsChannel_) this.locationsChannel_.close();
	        this.markers_ = {};
	
	        var mapUsers = context.mapUsers || [];
	
	        var containsAssignee = context.assigneeLocation && mapUsers.some(function (_ref4) {
	            var user_id = _ref4.location.user_id;
	            return user_id = context.assigneeLocation.location.user_id;
	        });
	
	        // show potential assignees at given radius
	        _updateLayer(this, 'bydistance', newLayer(this.map_, mapUsers, function (userLocation) {
	            return getLayerIcon(userLocation);
	        }, function (layer, layerInfo) {
	            newAssigneePopup(_this3, layer, layerInfo, context.capabilities);
	            _this3.markers_[layerInfo.user.id] = layer;
	        })); // { id, title, fio, organization_id }
	
	        // show both point and assignee
	        _updateLayer(this, 'location', _newClusterLayer(this.map_, { location: this.model.get('location') }, _map.PinBlue));
	        _updateLayer(this, 'assignee', newLayer(this.map_, !containsAssignee ? context.assigneeLocation : [], function (userLocation) {
	            return getLayerIcon(userLocation);
	        }, function (layer, layerInfo) {
	            return _this3.markers_[layerInfo.user.id] = layer;
	        }));
	
	        var locations = mapUsers.slice() || [];
	
	        if (!containsAssignee) if (context.assigneeLocation) locations.push(context.assigneeLocation);
	
	        var ids = (0, _arrays.hashify)(locations.map(function (_ref5) {
	            var id = _ref5.user.id;
	            return id;
	        }));
	        this.locationsChannel_ = this.options.locationService.map(function (locations) {
	            return locations.filter(function (_ref6) {
	                var id = _ref6.user.id;
	                return !!ids[id];
	            });
	        });
	
	        this.locationsChannel_.forEach(function (locations) {
	            return locations.forEach(function (_ref7) {
	                var id = _ref7.user.id,
	                    location = _ref7.location;
	                var lon = location.lon,
	                    lat = location.lat;
	
	                _this3.markers_[id].setLatLng(new M.LatLng(lat, lon));
	                _this3.markers_[id].setIcon(getLayerIcon({ location: location }));
	            });
	        });
	
	        if (this.model.get('location')) locations.push({ location: this.model.get('location') });
	
	        if (!locations.length && context.extent) return this.spanToExtent_(context.extent, firstTime);
	
	        return this.spanTo_(locations, firstTime);
	    },
	    spanToExtent_: function spanToExtent_(extent, firstTime) {
	        if (!extent) return;
	
	        var _extent2 = _slicedToArray(extent, 4),
	            minLon = _extent2[0],
	            minLat = _extent2[1],
	            maxLon = _extent2[2],
	            maxLat = _extent2[3];
	
	        var lb = { location: { lat: minLat, lon: minLon } },
	            rt = { location: { lat: maxLat, lon: maxLon } },
	            extentCorners = [lb, rt];
	
	        return this.spanTo_(extentCorners, firstTime);
	    },
	    spanTo_: function spanTo_(locations, firstTime) {
	        var _this4 = this;
	
	        return this.ready_.then(function () {
	            return firstTime ? (0, _promisify.delay)(300) : (0, _promisify.postpone)();
	        }).then(function () {
	            return spanBounds(_this4, locations);
	        });
	    },
	    updateLayer: function updateLayer() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        _updateLayer.apply(undefined, [this].concat(args));
	    },
	    newMarkerLayer: function newMarkerLayer() {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return newLayer.apply(undefined, [this.map_].concat(args));
	    },
	    newClusterLayer: function newClusterLayer() {
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        return _newClusterLayer.apply(undefined, [this.map_].concat(args));
	    }
	});
	
	
	function getLayerIcon(_ref8) {
	    var current = _ref8.current,
	        active = _ref8.location.active;
	
	    if (current) return active ? (0, _map.AssigneeHoverIcon)() : (0, _map.AssigneeInactiveHoverIcon)();
	
	    return active ? (0, _map.AssigneeIcon)() : (0, _map.AssigneeInactiveIcon)();
	}
	
	function _updateLayer(view, layerName, layerValue) {
	    view[layerName] = view[layerName] || [];
	    view[layerName].forEach(function (layer) {
	        return view.map_.removeLayer(layer);
	    });
	
	    if (!layerValue) return;
	
	    if (!(layerValue instanceof Array)) layerValue = [layerValue];
	
	    view[layerName] = [].concat(_toConsumableArray(layerValue));
	    view[layerName].forEach(function (layer) {
	        return view.map_.addLayer(layer);
	    });
	}
	
	function newLayer(map, markersAttrs, Icon) {
	    var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
	
	    if (!markersAttrs) return;
	
	    if (!(markersAttrs instanceof Array)) markersAttrs = [markersAttrs];
	
	    return markersAttrs.filter(function (_ref9) {
	        var location = _ref9.location;
	        return !!location;
	    }).map(function (markerAttrs) {
	        var _markerAttrs$location = markerAttrs.location,
	            lon = _markerAttrs$location.lon,
	            lat = _markerAttrs$location.lat,
	            latlng = new M.LatLng(lat, lon),
	            icon = 'function' === typeof Icon ? Icon(markerAttrs) : Icon;
	
	
	        var marker = new M.Marker(latlng, { icon: 'function' == typeof icon ? new icon() : icon });
	        return cb(marker, markerAttrs) || marker;
	    });
	}
	
	function _newClusterLayer(map, markerAttrs, Icon) {
	    var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
	
	    return newLayer(map, markerAttrs, Icon, function (marker, markerAttrs) {
	        var iconClass = 'function' === typeof Icon ? Icon(markerAttrs) : Icon;
	
	        var cluster = new M.Cluster.Marker(marker, map, {
	            iconClass: iconClass,
	            radius: 1.5,
	            singleClusters: true
	        });
	
	        cluster.options.icon.update(markerAttrs.title || '', cluster._icon);
	
	        return cb(cluster, markerAttrs) || cluster;
	    });
	}
	
	function spanBounds(view, layersInfo) {
	    if (!layersInfo.length) return;
	
	    if (layersInfo.length === 1) {
	        var _layersInfo = _slicedToArray(layersInfo, 1),
	            _layersInfo$0$locatio = _layersInfo[0].location,
	            lon = _layersInfo$0$locatio.lon,
	            lat = _layersInfo$0$locatio.lat;
	
	        if (!eqCenter(view, { lng: lon, lat: lat })) return view.map_.setView(new M.LatLng(+lat, +lon), view.map_.zoom()), (0, _promisify.delay)(300);
	
	        return;
	    }
	
	    var minLon = 1e9,
	        maxLon = -1,
	        minLat = 1e9,
	        maxLat = -1;
	
	    layersInfo.forEach(function (_ref10) {
	        var _ref10$location = _ref10.location,
	            lon = _ref10$location.lon,
	            lat = _ref10$location.lat;
	
	        minLon = Math.min(minLon, +lon);
	        maxLon = Math.max(maxLon, +lon);
	        minLat = Math.min(minLat, +lat);
	        maxLat = Math.max(maxLat, +lat);
	    });
	
	    var midLon = .5 * (minLon + maxLon),
	        midLat = .5 * (minLat + maxLat);
	
	    minLon = midLon + 1.25 * (minLon - midLon);
	    maxLon = midLon + 1.25 * (maxLon - midLon);
	    minLat = midLat + 1.25 * (minLat - midLat);
	    maxLat = midLat + 1.25 * (maxLat - midLat);
	    var b = new M.LatLngBounds(new M.LatLng(maxLat, maxLon), new M.LatLng(minLat, minLon));
	
	    if (!eqBounds(view, b)) return view.map_.fitBounds(b), (0, _promisify.delay)(300).then(function () {
	        return view.boundsHash_[JSON.stringify(b)] = view.map_.bounds();
	    });
	}
	
	function newAssigneePopup(view, layer, layerInfo, caps) {
	    layer.on('click', function () {
	        return view.trigger('assignee:click');
	    });
	
	    if (caps && caps.assign_user) {
	        var guid = 'x' + Math.random().toFixed(10).substr(2);
	        window[guid] = function () {
	            return view.trigger('assignee:assign', layerInfo);
	        }; // title, user, location
	        layer.bindPopup(layerInfo.title + ' <a href="javascript:void(0);" onclick="' + guid + '();">' + ifn('actions::choose') + '</a>', {});
	    } else layer.bindPopup('' + layerInfo.title, {});
	}
	
	function eqBounds(view, bounds) {
	    var code = JSON.stringify(bounds);
	    if (!view.boundsHash_[code]) return false;
	
	    bounds = view.boundsHash_[code];
	    var b = view.map_.bounds();
	    return eqLocation(b._northEast, bounds._northEast) && eqLocation(b._southWest, bounds._southWest);
	}
	
	function eqCenter(view, location) {
	    return eqLocation(view.map_.center(), location);
	}
	
	function eqLocation(x, y) {
	    var lo0 = x.lng,
	        la0 = x.lat,
	        lo1 = y.lng,
	        la1 = y.lat;
	
	
	    return eq(lo0, lo1) && eq(la0, la1);
	}
	
	function eq(x, y) {
	    return Math.abs(x - y) < 1e-3;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _api = __webpack_require__(77);
	
	exports.default = (0, _api.get)('/layers/serviceobjects').mapsurfer().sealed().map(function (layer) {
		return layer.id;
	}).chain(function (ids) {
		return (0, _api.get)('/geocoding?layersId=' + ids + '&query={query}&bbox={bbox}').mapsurfer();
	}).peek(function (_ref) {
		var items = _ref.items,
		    layerId = _ref.layerId;
		return items.forEach(function (it) {
			return it.layerId = layerId;
		});
	}).map(function (_ref2) {
		var items = _ref2.items;
		return items;
	}).concat().map(function (_ref3) {
		var pkid = _ref3.pkid,
		    layerId = _ref3.layerId,
		    label = _ref3.label,
		    point = _ref3.point;
		return { objectId: pkid, layerId: layerId, title: label, coords: point };
	});

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TaskIcon = PinBlueIcon;
	exports.PinBlue = PinBlue;
	exports.PinBlueActiveIcon = PinBlueActiveIcon;
	exports.PinRed = PinRed;
	exports.PinYellow = PinYellow;
	exports.PinGreen = PinGreen;
	exports.PinGray = PinGray;
	exports.UserOnMapIcon = UserOnMapIcon;
	exports.AssigneeIcon = AssigneeIcon;
	exports.AssigneeHoverIcon = AssigneeHoverIcon;
	exports.AssigneeInactiveIcon = AssigneeInactiveIcon;
	exports.AssigneeInactiveHoverIcon = AssigneeInactiveHoverIcon;
	exports.CircleBlue = CircleBlue;
	
	
	function PinBlueIcon() {
	    var Class = PinBlueIcon._ = PinBlueIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/pin-blue.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(40, 52)
	    });
	
	    return new Class();
	}
	
	function PinBlue() {
	    var Class = M.PinBlue = M.PinBlue || M.Cluster.Icon.extend({
	        options: {
	            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view',
	            iconSize: new M.Point(32, 32),
	            iconAnchor: new M.Point(32, 16),
	            popupAnchor: new M.Point(0, -8),
	            labelColor: '#ffffff',
	            className: 'pin pin-blue'
	        }
	    });
	
	    return Class;
	}
	
	function PinGreen() {
	    var Class = M.PinGreen = M.PinGreen || M.Cluster.Icon.extend({
	        options: {
	            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view',
	            iconSize: new M.Point(32, 32),
	            iconAnchor: new M.Point(32, 32),
	            popupAnchor: new M.Point(0, -8),
	            labelColor: '#ffffff',
	            className: 'pin pin-green'
	        }
	    });
	
	    return Class;
	}
	
	function PinYellow() {
	    var Class = PinYellow._ = PinYellow._ || M.Icon.extend({
	        iconUrl: 'images/markers/pin-yellow.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(40, 52)
	    });
	
	    return new Class();
	}
	
	function PinRed() {
	    var Class = M.PinRed = M.PinRed || M.Cluster.Icon.extend({
	        options: {
	            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view',
	            iconSize: new M.Point(32, 32),
	            iconAnchor: new M.Point(32, 32),
	            popupAnchor: new M.Point(0, -8),
	            labelColor: '#ffffff',
	            className: 'pin pin-red'
	        }
	    });
	
	    return Class;
	}
	
	function PinBlueActiveIcon() {
	    var Class = PinBlueActiveIcon._ = PinBlueActiveIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/pin-blue-active.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(40, 52)
	    });
	
	    return new Class();
	}
	
	function PinGray() {
	    var Class = M.PinGray = M.PinGray || M.Cluster.Icon.extend({
	        options: {
	            image: 'https://tariffs.dev.geo4.pro/dictionary/icons/19/view',
	            iconSize: new M.Point(32, 32),
	            iconAnchor: new M.Point(32, 32),
	            popupAnchor: new M.Point(0, -8),
	            labelColor: '#ffffff',
	            className: 'pin pin-gray'
	        }
	    });
	
	    return Class;
	}
	
	function UserOnMapIcon() {
	    var Class = UserOnMapIcon._ = UserOnMapIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/user-blue.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(20, 33)
	    });
	
	    return new Class();
	}
	
	function AssigneeIcon() {
	    var Class = AssigneeIcon._ = AssigneeIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/user-green.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(20, 33)
	    });
	
	    return new Class();
	}
	
	function AssigneeHoverIcon() {
	    var Class = AssigneeHoverIcon._ = AssigneeHoverIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/user-green-hover.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(20, 33)
	    });
	
	    return new Class();
	}
	
	function AssigneeInactiveIcon() {
	    var Class = AssigneeInactiveIcon._ = AssigneeInactiveIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/user-gray.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(20, 33)
	    });
	
	    return new Class();
	}
	
	function AssigneeInactiveHoverIcon() {
	    var Class = AssigneeInactiveHoverIcon._ = AssigneeInactiveHoverIcon._ || M.Icon.extend({
	        iconUrl: 'images/markers/user-gray-hover.png',
	        shadowUrl: 'lib/mapsurfer/images/marker-shadow.png',
	        iconSize: new M.Point(20, 33)
	    });
	
	    return new Class();
	}
	
	function CircleBlue() {
	    var Class = M.CircleBlue = M.CircleBlue || M.Cluster.Icon.extend({ // создаем иконку для кластеров
	        options: {
	            image: "https://tariffs.dev.geo4.pro/dictionary/icons/19/view", // ссылка на изображение
	            iconSize: new M.Point(32, 32), // размер изображения
	            iconAnchor: new M.Point(32, 32), // смещение для отображения
	            popupAnchor: new M.Point(0, -8), // смещение для popup
	            labelColor: '#ffffff'
	        }
	    });
	
	    return Class;
	}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _View$extend;
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _view2.default.extend((_View$extend = {
	    setLocations: function setLocations(locations) {
	        this.locations_ = locations;
	        return this.render();
	    },
	    clearLocations: function clearLocations() {
	        return this.setLocations(null);
	    },
	
	
	    events: {
	        'click .glyphicon-remove': function clickGlyphiconRemove() {
	            this.clearLocations();
	        }
	    },
	
	    onBind: function onBind(model) {
	        var _this = this;
	
	        this.listenTo(model, 'change:point', function () {
	            return _this.render();
	        });
	        this.listenTo(model, 'change:type_id', function () {
	            return _this.render();
	        });
	        this.listenTo(model, 'change:assigned_organization_id', function () {
	            return _this.render();
	        });
	        this.listenTo(model, 'change:assigned_user_id', function () {
	            return _this.render();
	        });
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            locationService = _options.locationService,
	            height = _options.height;
	
	
	        if (this.locations_) return {
	            mapUsers: this.locations_.filter(function (loc) {
	                return !!loc.is_active;
	            }),
	            zonesInactive: true,
	            locationService: locationService,
	            height: height
	        };
	
	        return { locationService: locationService };
	    }
	}, _defineProperty(_View$extend, _view2.default.event('Map:assignee:click'), function () {
	    if (!this.Map.disabled()) this.trigger('assignee:click');
	}), _defineProperty(_View$extend, _view2.default.event('Map:assignee:assign'), function (user) {
	    if (!this.Map.disabled()) this.trigger('assignee:assign', user);
	}), _defineProperty(_View$extend, _view2.default.event('Map:map:click'), function (location) {
	    if (!this.Map.disabled()) this.trigger('map:click', location);
	}), _defineProperty(_View$extend, _view2.default.event('Map:service-object:choose'), function (serviceObjectAttrs) {
	    if (!this.Map.disabled()) this.trigger('map:click', serviceObjectAttrs.coords);
	}), _defineProperty(_View$extend, _view2.default.event('Map:address:choose'), function (addressAttrs) {
	    if (!this.Map.disabled()) this.trigger('map:click', addressAttrs.coords);
	}), _View$extend));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _options = this.options,
	            datatables = _options.datatables,
	            _options$group = _options.group,
	            objects = _options$group.objects,
	            types = _options$group.types;
	
	        var datatablesHash = (0, _arrays.hashify)(datatables, function (datatable) {
	            return [datatable.id, datatable];
	        });
	
	        return {
	            types: types,
	            objects: objects.map(function (_ref) {
	                var layer_id = _ref.layer_id,
	                    attrs = _objectWithoutProperties(_ref, ['layer_id']);
	
	                return _extends({
	                    datatable: datatablesHash[layer_id]
	                }, attrs);
	            })
	        };
	    }
	});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _View$extend;
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _stickers = __webpack_require__(58);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _arrays = __webpack_require__(24);
	
	var _roles = __webpack_require__(117);
	
	var _field = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend((_View$extend = {
	
	    // ???
	    onBind: function onBind() /*model*/{
	        var _this = this;
	
	        this.options.sorted = new _stickers2.default();
	        this.options.filtered = new _stickers2.default();
	        this.options.resulted = new _stickers2.default();
	
	        // wait for sorting & filter (copy of subfields.grid)
	        this.sorting_ = this.reSort().then(function () {
	            return _this.reFilterGrid();
	        });
	    },
	    serialize: function serialize() {
	        var _this2 = this;
	
	        // wait for current sorting & filter? (copy of subfields.grid)
	        // sorting is fast, but it's async now;
	        // so we must wait until sorting in onBind finishes
	        return this.sorting_.then(function () {
	            return {
	                rows: _this2.options.resulted,
	                stickers: _this2.options.filtered
	            };
	        });
	        x;
	    },
	
	
	    events: {
	
	        // copy of subfields.grid
	        'click .-sort': function clickSort(_ref) {
	            var _this3 = this;
	
	            var currentTarget = _ref.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	
	            return this.options.page = 1, this.options.sort = sort, this.options.direction = direction, this.reSort().then(function () {
	                return _this3.reFilterGrid();
	            })
	            // hack: reFilterGrid() to do filtering, then render() to re-render grid header
	            .then(function () {
	                return _this3.render();
	            }).then(function () {
	                return _this3.trigger('sort', { sort: sort, direction: direction });
	            });
	        },
	        'click .-toggle-binding': function clickToggleBinding(_ref2) {
	            var currentTarget = _ref2.currentTarget;
	            var id = currentTarget.dataset.id;
	            var filtered = this.options.filtered;
	
	
	            var needAppend = currentTarget.checked;
	            var oldStickers = this.model.get('sticker_ids') || [];
	            var newStickers = needAppend ? [].concat(_toConsumableArray(oldStickers), [id]) : oldStickers.filter(function (itemId) {
	                return itemId != id;
	            });
	
	            this.model.set('sticker_ids', newStickers);
	
	            var ids = (0, _arrays.hashify)(newStickers);
	            this.$('.-toggle-all')[0].checked =
	            // contains ids of stickers that can be checked/unchecked by current user
	            this.getAvailableFilteredStickerIds(filtered).every(function (stickerId) {
	                return ids[stickerId];
	            });
	        },
	        'click .-toggle-all': function clickToggleAll(_ref3) {
	            var currentTarget = _ref3.currentTarget;
	
	            // contains ids of stickers that can be checked/unchecked by current user
	            var ids = this.getAvailableFilteredStickerIds(this.options.filtered);
	
	            var h = (0, _arrays.hashify)(ids);
	            var drained = (this.model.get('sticker_ids') || []).filter(function (id) {
	                return !h[id];
	            });
	
	            var value = currentTarget.checked;
	            this.model.set('sticker_ids', value ? [].concat(_toConsumableArray(drained), _toConsumableArray(ids)) : [].concat(_toConsumableArray(drained)));
	
	            var values = (0, _arrays.hashify)(this.model.get('sticker_ids'));
	            this.$('.-toggle-binding').toArray().forEach(function (el) {
	                return el.checked = !!values[el.dataset.id];
	            });
	        },
	        'click .-toggle-all-stickers-available': function clickToggleAllStickersAvailable(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	
	            if (!currentTarget.checked) {
	                if (this.model.get('sticker_ids') == null) this.model.set('sticker_ids', []);else
	                    // hack: undefined instead of false to make no diff with default value
	                    this.model.set('__all_stickers_available', undefined);
	            } else this.model.set('__all_stickers_available', true);
	
	            if (this.model.get('sticker_ids') == null || this.model.get('__all_stickers_available')) this.$('.stickers-grid--disability-wrapper').addClass('disabled');else this.$('.stickers-grid--disability-wrapper').removeClass('disabled');
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('Paging:page'), function (page) {
	    return this.options.page = page, this.reFilterGrid(), this.trigger('page', page);
	}), _defineProperty(_View$extend, _view2.default.event('Search:search'), function (search) {
	    return this.options.search = search, this.options.page = 1, this.reFilterGrid(), this.trigger('search', search);
	}), _defineProperty(_View$extend, 'reSort', function reSort(sort, direction) {
	    sort = sort || this.options.sort;
	    direction = direction || this.options.direction;
	
	    return _grid2.default.sort({ sort: sort, direction: direction }, this.options.stickers, this.options.sorted);
	}), _defineProperty(_View$extend, 'reFilterGrid', function reFilterGrid() {
	    var availableStickers = (0, _field.filterAvailableStickers)(this.options.types, this.model, this.options.sorted);
	
	    var _options = this.options,
	        search = _options.search,
	        filtered = _options.filtered,
	        resulted = _options.resulted,
	        page = _options.page,
	        limit = _options.limit;
	
	
	    _grid2.default.filter({ search: search, page: page, limit: limit }, this.model.get('cluster'), availableStickers, filtered, resulted);
	}), _defineProperty(_View$extend, 'getAvailableFilteredStickerIds', function getAvailableFilteredStickerIds(stickerCollection) {
	    var _this4 = this;
	
	    var models = stickerCollection instanceof _collection2.default ? stickerCollection.models : stickerCollection;
	
	    return models
	    // ignore unavailable (disabled) checkboxes
	    .filter(function (sticker) {
	        return (
	            // chief admin may check any sticker
	            // (local stickers of wrong cluster do not pass filtration)
	            _roles.roleA.indexOf(_config2.default.role()) !== -1 ||
	            // local stickers may be checked anyway
	            // (local stickers of wrong cluster do not pass filtration)
	            sticker.get('cluster') ||
	            // local sticker may be joined to any field
	            // (local stickers of wrong cluster do not pass filtration)
	            _this4.model.get('cluster')
	        );
	    }).map(function (type) {
	        return type.id;
	    });
	}), _View$extend));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _View$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _fields = __webpack_require__(27);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _sort = __webpack_require__(66);
	
	var _popups = __webpack_require__(62);
	
	var _messages = __webpack_require__(68);
	
	var _arrays = __webpack_require__(24);
	
	var _messages2 = __webpack_require__(69);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _view2.default.extend((_View$extend = {
	
	    // ???
	    onBind: function onBind() /*model*/{
	        var _this = this;
	
	        this.options.sorted = new _fields2.default();
	        this.options.filtered = new _fields2.default();
	        this.options.resulted = new _fields2.default();
	
	        // todo? wait for sorting & filter
	        this.sorting_ = this.reSort().then(function () {
	            return _this.reFilterGrid();
	        });
	
	        this.listenTo(this.options.resulted, 'activate deactivate', function () {
	            return _this.Buttons && _this.Buttons.render();
	        });
	    },
	    serialize: function serialize() {
	        var _this2 = this;
	
	        // todo wait for current sorting & filter?
	        // sorting is fast, but it's async now;
	        // so we must wait until sorting in onBind finishes
	        return this.sorting_.then(function () {
	            var resulted = _this2.options.resulted;
	
	
	            return {
	                rows: resulted, // subfields: fieldsFiltered
	
	                dragMode: function dragMode() {
	                    return _this2.options.dragMode;
	                },
	
	                rowsToSortCount: function rowsToSortCount() {
	                    return _this2.options.filtered.length;
	                },
	
	                isOrderChanged: function isOrderChanged() {
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = _this2.model.get('subfields')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var subfield = _step.value;
	
	                            if (subfield['new-order'] != subfield['order']) return true;
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    return false;
	                }
	            };
	        });
	        x;
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref) {
	            var _this3 = this;
	
	            var currentTarget = _ref.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	
	            return this.options.page = 1, this.options.sort = sort, this.options.direction = direction, this.reSort().then(function () {
	                return _this3.reRender();
	            })
	            // hack: reRender() to do filtering, then render() to re-render grid header
	            .then(function () {
	                return _this3.render();
	            }).then(function () {
	                return _this3.trigger('sort', { sort: sort, direction: direction });
	            });
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('Paging:page'), function (page) {
	    return this.options.page = page, this.reRender(), this.trigger('page', page);
	}), _defineProperty(_View$extend, _view2.default.event('Search:search'), function (search) {
	    return this.options.search = search, this.options.page = 1, this.reRender(), this.trigger('search', search);
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:new'), function () {
	    this.createSubfield();
	}), _defineProperty(_View$extend, _view2.default.event('Grid:action:create'), function () {
	    if (!this.options.dragMode) this.createSubfield();
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:edit'), function () {
	    this.editSubfield();
	}), _defineProperty(_View$extend, _view2.default.event('Grid:action:default'), function () {
	    if (!this.options.dragMode) this.editSubfield();
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:remove'), function () {
	    this.removeSubfield();
	}), _defineProperty(_View$extend, _view2.default.event('Grid:action:destroy'), function () {
	    if (!this.options.dragMode) this.removeSubfield();
	}), _defineProperty(_View$extend, _view2.default.event('Grid:swap-up'), function (index) {
	    var _this4 = this;
	
	    this.reorder([+index, +index - 1]);
	
	    if (index == 0) this.options.page = this.options.resulted.page - 1;
	
	    this.reSort('new-order', 'asc').then(function () {
	        return _this4.reRender();
	    });
	}), _defineProperty(_View$extend, _view2.default.event('Grid:swap-down'), function (index) {
	    var _this5 = this;
	
	    this.reorder([+index + 1, +index]);
	
	    if (index == this.options.resulted.length - 1) this.options.page = this.options.resulted.page + 1;
	
	    this.reSort('new-order', 'asc').then(function () {
	        return _this5.reRender();
	    });
	}), _defineProperty(_View$extend, _view2.default.event('Grid:rows:order'), function (permutation) {
	    var _this6 = this;
	
	    this.reorder(permutation);
	
	    this.reSort('new-order', 'asc').then(function () {
	        return _this6.reRender();
	    });
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:sort'), function () {
	    var _this7 = this;
	
	    this.options.dragMode = true;
	    // todo cpoy-pasted ??? need to iterate all clusters (options.source) because cluster filter
	    // may be changing during sorting process
	    this.model.get('subfields').forEach(function (model) {
	        return model['new-order'] = model['order'];
	    });
	
	    this.options.page = 1;
	    this.reSort('new-order', 'asc').then(function () {
	        return _this7.reRender();
	    });
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:apply-sort'), function () {
	    var _this8 = this;
	
	    this.model.get('subfields').forEach(function (model) {
	        return model['order'] = model['new-order'];
	    });
	    this.model.trigger('change');
	
	    this.options.dragMode = false;
	    // then sort
	    this.reSort().then(function () {
	        return _this8.reRender();
	    });
	}), _defineProperty(_View$extend, _view2.default.event(':subfields:cancel-sort'), function () {
	    var _this9 = this;
	
	    // drop drag-mode first
	    this.options.dragMode = false;
	    // then sort
	    this.reSort().then(function () {
	        return _this9.reRender();
	    });
	}), _defineProperty(_View$extend, 'createSubfield', function createSubfield() {
	    var _this10 = this;
	
	    _createSubfield.call(this,
	    // just array, not collection
	    this.model.get('subfields')).then(function (subfields) {
	        return _this10.model.set('subfields', subfields);
	    }).then(function () {
	        return _this10.reSort().then(function () {
	            return _this10.reRender();
	        });
	    });
	}), _defineProperty(_View$extend, 'editSubfield', function editSubfield() {
	    var _this11 = this;
	
	    _editSubfield.call(this, this.options.resulted.current(),
	    // just array, not collection
	    this.model.get('subfields')).then(function (subfields) {
	        return _this11.model.set('subfields', subfields);
	    }).then(function () {
	        return _this11.reSort().then(function () {
	            return _this11.reRender();
	        });
	    })
	    // to trigger buttons re-render if child-child model is changed;
	    // listen(field, 'change') in form.template doesn' work
	    .then(function () {
	        return _this11.model.trigger('change');
	    }, function () {
	        return _this11.model.trigger('change');
	    });
	}), _defineProperty(_View$extend, 'removeSubfield', function removeSubfield() {
	    var _this12 = this;
	
	    var _options = this.options,
	        resulted = _options.resulted,
	        page = _options.page;
	
	    var current = resulted.current();
	
	    (0, _popups.ask)('field::modal delete - confirmation text', 'field::modal delete - title', 'actions::yes', 'actions::no', function () {
	        return _this12.model.set('subfields', _this12.model.get('subfields').filter(function (el) {
	            return el.id != current.id;
	        }));
	    }).then(function () {
	        if (resulted.length === 1 && page > 1) _this12.options.page--;
	
	        _this12.reSort().then(function () {
	            return _this12.reRender();
	        });
	    });
	}), _defineProperty(_View$extend, 'reorder', function reorder(newOrder) {
	    // index === value, old position
	    // i     === pos,   new position
	    // order: new position -> old position
	
	    var _options2 = this.options,
	        filtered = _options2.filtered,
	        resulted = _options2.resulted;
	    var page = resulted.page,
	        limit = resulted.limit;
	
	    var offset = (page - 1) * limit;
	    newOrder = newOrder.map(function (index) {
	        return index + offset;
	    });
	
	    var usedIndexes = (0, _arrays.hashify)(newOrder);
	
	    var permutation = [];
	    for (var i = 0; i < filtered.length; i++) {
	        permutation.push(usedIndexes[i] ? newOrder.shift() : i);
	    }var subfields = (0, _arrays.hashify)(this.model.get('subfields'), function (sf) {
	        return [sf.id, sf];
	    });
	    var ids = filtered.models.map(function (model) {
	        return model.id;
	    });
	    permutation.map(function (index, i) {
	        return [ids[index], ids[i]];
	    }).map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            idHere = _ref3[0],
	            prevIdHere = _ref3[1];
	
	        return [subfields[idHere], subfields[prevIdHere]];
	    }).map(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 2),
	            modelHere = _ref5[0],
	            prevModelHere = _ref5[1];
	
	        return [modelHere, prevModelHere['new-order']];
	    }).forEach(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 2),
	            modelHere = _ref7[0],
	            prevOrderHere = _ref7[1];
	
	        return modelHere['new-order'] = prevOrderHere;
	    });
	
	    return permutation;
	}), _defineProperty(_View$extend, 'reSort', function reSort(sort, direction) {
	    sort = sort || this.options.sort;
	    direction = direction || this.options.direction;
	
	    return this.sort({ sort: sort, direction: direction }, this.model.get('subfields'), this.options.sorted);
	}), _defineProperty(_View$extend, 'sort', function sort(_ref8, source, dest) {
	    var sortField = _ref8.sort,
	        direction = _ref8.direction;
	
	    sortField = sortField instanceof Array ? sortField : [sortField];
	    var models = source.models || source;
	
	    var sorting = 'asc' === direction ? (0, _sort.asc)(models, [].concat(_toConsumableArray(sortField), ['id'])) : (0, _sort.desc)(models, [].concat(_toConsumableArray(sortField), ['id']));
	
	    return sorting.then(function (sortedModels) {
	        return dest.reset(sortedModels);
	    });
	}), _defineProperty(_View$extend, 'reFilterGrid', function reFilterGrid() {
	    var _options3 = this.options,
	        search = _options3.search,
	        sorted = _options3.sorted,
	        filtered = _options3.filtered,
	        resulted = _options3.resulted,
	        page = _options3.page,
	        limit = _options3.limit;
	
	
	    _grid2.default.filter({ search: search, page: page, limit: limit }, this.model.get('cluster'), sorted, filtered, resulted);
	}), _defineProperty(_View$extend, 'reRender', function reRender() {
	    this.reFilterGrid();this.Buttons.render();
	}), _View$extend));
	
	
	function _createSubfield(subfieldArray) {
	    var _model$toJSON = this.model.toJSON(),
	        bindings = _model$toJSON.bindings,
	        is_for_all = _model$toJSON.is_for_all,
	        cluster = _model$toJSON.cluster;
	
	    var subfield = new _field2.default({ bindings: bindings, is_for_all: is_for_all, cluster: cluster });
	
	    return openFieldForm.call(this, subfield, 'field::actions - new', 'actions::add').then(function (subfield) {
	        return subfield.toJSON();
	    }).then(function (_ref9) {
	        var json = _objectWithoutProperties(_ref9, []),
	            bindings = _ref9.bindings,
	            is_for_all = _ref9.is_for_all,
	            cluster = _ref9.cluster;
	
	        return _extends({}, json, {
	            // 1 + maxid
	            id: 1 + Math.max.apply(Math, [1000000000].concat(_toConsumableArray(subfieldArray.map(function (f) {
	                return f.id;
	            })))),
	            // 1 + maxorder
	            order: 1 + Math.max.apply(Math, [0].concat(_toConsumableArray(subfieldArray.map(function (f) {
	                return f.order;
	            }))))
	        });
	    }).then(function (subfield) {
	        return [].concat(_toConsumableArray(subfieldArray), [subfield]);
	    });
	}
	
	function _editSubfield(subfieldModel, subfieldArray) {
	    var _subfieldModel$toJSON = subfieldModel.toJSON(),
	        id = _subfieldModel$toJSON.id,
	        attrs = _objectWithoutProperties(_subfieldModel$toJSON, ['id']);
	
	    var _model$toJSON2 = this.model.toJSON(),
	        bindings = _model$toJSON2.bindings,
	        is_for_all = _model$toJSON2.is_for_all,
	        cluster = _model$toJSON2.cluster;
	
	    var subfield = id < 1000000000 ? new _field2.default(_extends({}, attrs, { bindings: bindings, is_for_all: is_for_all, cluster: cluster, id: id })) : new _field2.default(_extends({}, attrs, { bindings: bindings, is_for_all: is_for_all, cluster: cluster }));
	
	    return openFieldForm.call(this, subfield, 'actions::edit', 'actions::apply').then(function (subfield) {
	        return subfield.toJSON();
	    }).then(function (_ref10) {
	        var subfieldJson = _objectWithoutProperties(_ref10, []),
	            bindings = _ref10.bindings,
	            is_for_all = _ref10.is_for_all,
	            cluster = _ref10.cluster;
	
	        return _extends({}, subfieldJson, { id: id });
	    }).then(function (subfield) {
	        return subfieldArray.map(function (json) {
	            return json.id == id ? subfield : json;
	        });
	    });
	}
	
	function openFieldForm(subfieldModel, popupLabel, applyLabel) {
	    var _ref12;
	
	    var extended = !subfieldModel.id || ['composite', 'file'].indexOf(subfieldModel.get('format')) !== -1;
	
	    var binding = new _form2.default((_ref12 = {
	        datatables: this.options.datatables,
	        stickers: this.options.stickers,
	        types: this.options.types,
	
	        stickersPage: 1, stickersSort: 'name', stickersDirection: 'asc', stickersSearch: '',
	
	        level: this.options.level + 1,
	
	        template: extended ? 'module/refbooks/fields.form.subfield.composite' : 'module/refbooks/fields.form.subfield.simple',
	
	        onBind: function onBind(model) {
	            var _this13 = this;
	
	            this.listenTo(model, 'change', function () {
	                return _this13.$el.closest('.modal').find('.action-accept')[0].disabled = (console.log('re-render accept btn'), !_this13.hasDiff());
	            });
	
	            // see fields.form.bound-stickers.js
	            // cannot change cluster in nested model
	
	            // see fields.form.bound-stickers.js
	            this.listenTo(model, 'change:format', function () {
	                if (model.get('format') !== 'file') _this13.stickersPage = 1, _this13.stickersSort = 'name', _this13.stickersDirection = 'asc', _this13.stickersSearch = '';
	                // todo
	                // this.trigger( FieldFormTemplateModule.TOGGLE_BOUND_TYPES,
	                //         this.model,
	                //         this.originalModel,
	                //         this.state() );
	            });
	        },
	
	
	        // see fields.form.bound-stickers.js
	        serialize: function serialize() {
	            var stickersSort = this.stickersSort,
	                stickersDirection = this.stickersDirection,
	                stickersSearch = this.stickersSearch,
	                stickersPage = this.stickersPage;
	
	
	            return {
	                stickersSort: stickersSort, stickersDirection: stickersDirection, stickersSearch: stickersSearch, stickersPage: stickersPage,
	                tmp1: 1
	            };
	        }
	    }, _defineProperty(_ref12, _form2.default.event('Fields:file-semantics:toggle'), function (passedSemantics) {
	        var contains = this.model.get('file_semantics').indexOf(passedSemantics) !== -1;
	        var newSemantics = contains ? this.model.get('file_semantics').filter(function (ft) {
	            return ft !== passedSemantics;
	        }) : [].concat(_toConsumableArray(this.model.get('file_semantics')), [passedSemantics]);
	        this.model.set('file_semantics', newSemantics);
	    }), _defineProperty(_ref12, _form2.default.event('Stickers:page'), function (page) {
	        return this.stickersPage = +page;
	    }), _defineProperty(_ref12, _form2.default.event('Stickers:sort'), function (_ref11) {
	        var sort = _ref11.sort,
	            direction = _ref11.direction;
	
	        return this.stickersSort = sort, this.stickersDirection = direction;
	    }), _defineProperty(_ref12, _form2.default.event('Stickers:search'), function (search) {
	        return this.stickersSearch = search, this.stickersPage = 1;
	    }), _ref12)).bind(subfieldModel);
	
	    return (0, _popups.ask)(binding, popupLabel, applyLabel, 'actions::cancel', {
	        large: extended,
	        afterRender: function afterRender(ctx, firstTime) {
	            if (firstTime) this.$('.action-accept')[0].disabled = true;
	        }
	    }, function () {
	        if (!subfieldModel.get('name').trim()) return (0, _messages.handle)(binding.view, (0, _messages2.error)([ifn('forms::required field'), 'name'])), false;
	    }).then(function () {
	        return subfieldModel;
	    });
	}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Filters = void 0;exports.default = Filters = _form2.default.extend({
	
	    events: {
	        'click .-clear-filters': function clickClearFilters() {
	            this.clear();
	        }
	    },
	
	    onBind: function onBind(filtersModel) {
	        listen.call(this);
	    },
	
	
	    // todo onUnBind
	
	    clear: function clear() {
	        var _constructor$defaultF = this.constructor.defaultFilterValues(),
	            done_checkbox = _constructor$defaultF.done_checkbox,
	            working_checkbox = _constructor$defaultF.working_checkbox,
	            planned_checkbox = _constructor$defaultF.planned_checkbox,
	            fail_checkbox = _constructor$defaultF.fail_checkbox,
	            defaultFilters = _objectWithoutProperties(_constructor$defaultF, ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox']);
	
	        this.stopListening(this.model);
	        this.model.set(defaultFilters);
	        listen.call(this);
	
	        // notify listeners that filters have been cleared
	        this.trigger('change', this.model.values());
	    },
	    serialize: function serialize(context) {
	        var _options = this.options,
	            contracts = _options.contracts,
	            organizations = _options.organizations,
	            types = _options.types;
	
	        var showScheduleFilters = context.showScheduleFilters,
	            otherProps = _objectWithoutProperties(context, ['showScheduleFilters']);
	
	        return _extends({
	            showScheduleFilters: undefined !== showScheduleFilters ? showScheduleFilters : true,
	            contracts: contracts,
	            organizations: organizations.toJSON(),
	            types: types.toJSON().filter(function (type) {
	                return type.role_ids == null || type.role_ids.indexOf(_config2.default.role()) !== -1 || type.role_ids.indexOf(+_config2.default.role()) !== -1;
	            })
	        }, otherProps);
	    }
	}, {
	
	    Model: _model2.default.extend({
	        constructor: function constructor() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (options.time) options = _extends({}, options, {
	                taskTitle: options.time,
	                time: undefined
	            });
	
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }
	
	            _model2.default.apply(this, [options].concat(args));
	        },
	
	
	        computeds: {
	
	            user: {
	                set: function set(value) {
	                    if (!value) return {
	                        assignedUserId: undefined,
	                        assignedUserName: ''
	                    };
	
	                    var id = value.id,
	                        name = value.name;
	
	
	                    return {
	                        assignedUserId: id === 0 ? undefined : id,
	                        assignedUserName: name
	                    };
	                },
	                get: function get() {
	                    var id = this.get('assignedUserId');
	                    var fio = this.get('assignedUserName');
	
	                    return !!id ? { id: id, name: fio } : null;
	                }
	            },
	
	            assignedOrganization: {
	                set: function set(value) {
	                    if (!value) return {
	                        assignedOrganizationId: 0,
	                        assignedUserId: undefined,
	                        assignedUserName: ''
	                    };
	
	                    return {
	                        assignedOrganizationId: +value,
	                        assignedUserId: undefined,
	                        assignedUserName: ''
	                    };
	                },
	                get: function get() {
	                    return this.get('assignedOrganizationId');
	                }
	            },
	
	            changedAttrsCount: {
	                deps: ['scheduleTitle', 'taskTitle', 'typeId', 'priorityId', 'assignedOrganizationId', 'assignedUserId', 'assignedUserName', 'contractId', 'organizationId'],
	                get: function get() {
	                    var filters = _extends({}, Filters.defaultFilterValues(), {
	                        done_checkbox: this.get('done_checkbox'),
	                        working_checkbox: this.get('working_checkbox'),
	                        planned_checkbox: this.get('planned_checkbox'),
	                        fail_checkbox: this.get('fail_checkbox')
	                        // off_checkbox: this.get( 'off_checkbox' ),
	                    });
	
	                    return this.diff(filters).length || '';
	                }
	            },
	
	            changed: {
	                deps: ['changedAttrsCount'],
	                get: function get() {
	                    return this.get('changedAttrsCount');
	                }
	            },
	
	            doneDisabled: {
	                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox' /*, 'off_checkbox'*/],
	                get: function get() {
	                    return this.get('done_checkbox') && !this.get('working_checkbox') && !this.get('planned_checkbox') && !this.get('fail_checkbox');
	                    // && !this.get( 'off_checkbox' );
	                }
	            },
	
	            workingDisabled: {
	                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox' /* , 'off_checkbox'*/],
	                get: function get() {
	                    return !this.get('done_checkbox') && this.get('working_checkbox') && !this.get('planned_checkbox') && !this.get('fail_checkbox');
	                    // && !this.get( 'off_checkbox' );
	                }
	            },
	
	            plannedDisabled: {
	                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox' /*, 'off_checkbox'*/],
	                get: function get() {
	                    return !this.get('done_checkbox') && !this.get('working_checkbox') && this.get('planned_checkbox') && !this.get('fail_checkbox');
	                    // && !this.get( 'off_checkbox' );
	                }
	            },
	
	            failDisabled: {
	                deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox' /*, 'off_checkbox'*/],
	                get: function get() {
	                    return !this.get('done_checkbox') && !this.get('working_checkbox') && !this.get('planned_checkbox') && this.get('fail_checkbox');
	                    // && !this.get( 'off_checkbox' );
	                }
	            }
	
	            // offDisabled: {
	            //     deps: ['done_checkbox', 'working_checkbox', 'planned_checkbox', 'fail_checkbox'/*, 'off_checkbox'*/],
	            //     get() {
	            //         return !this.get( 'done_checkbox' )
	            //             && !this.get( 'working_checkbox' )
	            //             && !this.get( 'planned_checkbox' )
	            //             && !this.get( 'fail_checkbox' )
	            //             // && this.get( 'off_checkbox' );
	            //     }
	            // },
	
	        },
	
	        values: function values() {
	            var filters = _extends({}, this.toJSON()),
	                taskTitle = filters.taskTitle;
	
	
	            var statuses = [];
	            if (filters.done_checkbox) statuses = ['done_expired', 'done_not_expired'];
	            if (filters.working_checkbox) statuses = [].concat(_toConsumableArray(statuses), ['working_expired', 'working_not_expired']);
	            if (filters.planned_checkbox) statuses = [].concat(_toConsumableArray(statuses), ['planned', 'creating']);
	            if (filters.fail_checkbox) statuses = [].concat(_toConsumableArray(statuses), ['fail', 'missed']);
	            // if (filters.off_checkbox)
	            //     statuses = [...statuses, 'off'];
	
	            if (statuses.length) filters.status = statuses.toString();
	
	            var match = /^([1-9]|[0-1][0-9]|2[0-3])[ :]([0-5][0-9])/.exec(taskTitle);
	
	            if (match) {
	                var _match = _slicedToArray(match, 3),
	                    hours = _match[1],
	                    minutes = _match[2];
	
	                filters.time = '' + (hours.length === 1 ? 0 : '') + hours + ':' + minutes;
	                filters.taskTitle = '';
	            }
	
	            var digitsOnly = /^[0-9]+$/.exec(filters.scheduleTitle);
	            var scheduleTitle = digitsOnly ? '' : filters.scheduleTitle;
	            var scheduleSearch = digitsOnly ? filters.scheduleTitle : '';
	
	            var pairs = _extends({}, filters, { scheduleTitle: scheduleTitle, scheduleSearch: scheduleSearch });
	            return Object.keys(pairs)
	            // skip nulls - will break IntegerList filters on server
	            .filter(function (key) {
	                return pairs[key] !== null;
	            }).map(function (key) {
	                return [key, pairs[key]];
	            }).reduce(function (values, _ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    key = _ref2[0],
	                    value = _ref2[1];
	
	                return values[key] = value, values;
	            }, {});
	        }
	    }),
	
	    defaultFilterValues: function defaultFilterValues() {
	        return {
	            scheduleTitle: '',
	            taskTitle: '',
	            typeId: '',
	            priorityId: '',
	            contractId: '',
	            organizationId: '',
	            assignedOrganizationId: 0,
	            assignedUserId: undefined,
	            assignedUserName: '',
	            planned_checkbox: true,
	            done_checkbox: true,
	            working_checkbox: true,
	            fail_checkbox: true
	            // off_checkbox: false,
	        };
	    }
	});
	
	
	function listen() {
	    var _this = this;
	
	    var trigger = function trigger() {
	        return _this.trigger('change', _this.model.toJSON());
	    },
	        debounceTrigger = _underscore2.default.debounce(trigger, 350),
	        shortDebounceTrigger = _underscore2.default.debounce(trigger, 100);
	
	    this.listenTo(this.model, 'change:contractId', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:organizationId', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:typeId', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:priorityId', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:user', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:assignedOrganization', shortDebounceTrigger);
	    this.listenTo(this.model, 'change:taskTitle', debounceTrigger);
	    this.listenTo(this.model, 'change:scheduleTitle', debounceTrigger);
	    this.listenTo(this.model, 'change:done_checkbox', debounceTrigger);
	    this.listenTo(this.model, 'change:working_checkbox', debounceTrigger);
	    this.listenTo(this.model, 'change:planned_checkbox', debounceTrigger);
	    this.listenTo(this.model, 'change:fail_checkbox', debounceTrigger);
	    // this.listenTo( this.model, 'change:off_checkbox', debounceTrigger );
	}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend(_defineProperty({
	    serialize: function serialize() {
	        var _ref;
	
	        var pattern = this.options.pattern;
	        // 1st of August, 2022 is a Monday - so,
	        // it will be the first cell in calendar
	
	        var dateSeed = (0, _date.datify)('2022-08-01 00:00:00');
	
	        return _ref = {
	            calendar: new _calendar2.default(dateSeed)
	
	        }, _defineProperty(_ref, 'color-scheme', this.options['color-scheme']), _defineProperty(_ref, 'dates', new _collection2.default([].concat(_toConsumableArray(Object.keys(pattern.v).map(function (d) {
	            return {
	                date: (0, _date.datify)((0, _date.zp)(d) + '.08.2022 00:00:00'),
	                pickedUp: true,
	                toggleOff: pattern.remove[d]
	            };
	        })), _toConsumableArray(Object.keys(pattern.add).map(function (d) {
	            return {
	                date: (0, _date.datify)((0, _date.zp)(d) + '.08.2022 00:00:00'),
	                pickedUp: true
	            };
	        }))))), _ref;
	    }
	}, _view2.default.event('Calendar:date:toggle'), function (date) {
	    return toggleDate.call(this, date), this.render();
	}));
	
	
	function toggleDate(date) {
	    var _this = this;
	
	    var _model$clonePattern = this.model.clonePattern(this.options.pattern),
	        pattern = _model$clonePattern.pattern,
	        props = _objectWithoutProperties(_model$clonePattern, ['pattern']);
	
	    pattern.value = [].concat(_toConsumableArray(this.options.pattern.value));
	    pattern.v = _extends({}, this.options.pattern.v);
	    pattern.add = _extends({}, this.options.pattern.add);
	    pattern.remove = _extends({}, this.options.pattern.remove);
	
	    this.options.pattern = pattern;
	
	    var finalize = function finalize() {
	        return _this.model.set(props);
	    };
	
	    if (pattern.add[(0, _date.fmt)(date, 'D')]) return delete pattern.add[(0, _date.fmt)(date, 'D')], finalize();
	
	    if (pattern.remove[(0, _date.fmt)(date, 'D')]) return delete pattern.remove[(0, _date.fmt)(date, 'D')], finalize();
	
	    if (pattern.v[(0, _date.fmt)(date, 'D')]) return pattern.remove[(0, _date.fmt)(date, 'D')] = true, finalize();
	
	    return pattern.add[(0, _date.fmt)(date, 'D')] = true, finalize();
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _date = __webpack_require__(29);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Calendar = function () {
	    function Calendar() {
	        var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	        _classCallCheck(this, Calendar);
	
	        this.month = (0, _date.datify)(m);
	    }
	
	    _createClass(Calendar, [{
	        key: 'set',
	        value: function set(date) {
	            this.month = (0, _date.datify)(date);
	        }
	    }, {
	        key: 'nextMonth',
	        value: function nextMonth() {
	            this.month = (0, _date.nextMonth)(this.month);
	        }
	    }, {
	        key: 'prevMonth',
	        value: function prevMonth() {
	            this.month = (0, _date.prevMonth)(this.month);
	        }
	    }, {
	        key: 'nextYear',
	        value: function nextYear() {
	            this.month = (0, _date.nextYear)(this.month);
	        }
	    }, {
	        key: 'prevYear',
	        value: function prevYear() {
	            this.month = (0, _date.prevYear)(this.month);
	        }
	    }, {
	        key: 'getMonth',
	        value: function getMonth() {
	            return this.month;
	        }
	    }, {
	        key: 'getPrevMonth',
	        value: function getPrevMonth() {
	            return (0, _date.prevMonth)(this.month);
	        }
	    }, {
	        key: 'getNextMonth',
	        value: function getNextMonth() {
	            return (0, _date.nextMonth)(this.month);
	        }
	    }, {
	        key: 'list',
	        value: function list() {
	            var date = (0, _date.beginMonth)(this.month);
	            while (!(0, _date.monday)(date)) {
	                date = (0, _date.yesterday)(date);
	            } // to set HH:mm:ss in schedule calendar for subsequent
	            // parsing those dates and triggering them in schedule:list event.
	            // todo remove HH:mm:ss from here
	            date.setHours(0);
	            date.setMinutes(0);
	            date.setSeconds(0);
	
	            var days = [];
	
	            // days of previous month (since monday till current month's beginning)
	            for (; (0, _date.month)(date) !== (0, _date.month)(this.month); date = (0, _date.tomorrow)(date)) {
	                days.push(_extends({}, createDateData(date), {
	                    'prev-month': true
	                }));
	            } // days of current month
	            for (; (0, _date.month)(date) === (0, _date.month)(this.month); date = (0, _date.tomorrow)(date)) {
	                days.push(_extends({}, createDateData(date), {
	                    'current-month': true
	                }));
	            } // always show 6 weeks to avoid "jumping" calendar interface
	            // between 5-week and 6-week months
	            for (; days.length < 42; date = (0, _date.tomorrow)(date)) {
	                days.push(_extends({}, createDateData(date), {
	                    'next-month': true
	                }));
	            }return days;
	        }
	    }, {
	        key: 'fmt',
	        value: function fmt(format) {
	            return (0, _date.fmt)(this.month, format);
	        }
	    }]);
	
	    return Calendar;
	}();
	
	exports.default = Calendar;
	
	
	function createDateData(date) {
	    return {
	        date: date,
	        today: (0, _date.is)(date, (0, _date.today)()),
	        future: (0, _date.future)(date),
	        past: (0, _date.past)(date)
	    };
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _View$extend;
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend((_View$extend = {
	    serialize: function serialize() {
	        var _ref;
	
	        var pattern = this.options.pattern;
	
	        var dateSeed = (0, _date.beginYear)((0, _date.beginDay)(this.options.year));
	
	        return _ref = {
	            calendars: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (monIndex) {
	                return new _calendar2.default((0, _date.nextMonth)(dateSeed, monIndex));
	            })
	
	        }, _defineProperty(_ref, 'marker-color-scheme', this.options['marker-color-scheme']), _defineProperty(_ref, 'dates', new _collection2.default([].concat(_toConsumableArray(Object.keys(pattern.v).map(function (date) {
	            return {
	                date: date,
	                pickedUp: true,
	                toggleOff: pattern.remove[date]
	            };
	        })), _toConsumableArray(Object.keys(pattern.add).map(function (date) {
	            return {
	                date: date,
	                pickedUp: true
	            };
	        }))))), _ref;
	    }
	}, _defineProperty(_View$extend, _view2.default.event(':date:toggle'), function (date) {
	    return toggleDate.call(this, date), this.render();
	}), _defineProperty(_View$extend, _view2.default.event(':month:toggle'), function (month) {
	    return toggleMonth.call(this, month), this.render();
	}), _View$extend));
	
	
	function toggleDate(date) {
	    var _this = this;
	
	    if ((0, _date.past)(date)) return;
	
	    var _model$clonePattern = this.model.clonePattern(this.options.pattern),
	        pattern = _model$clonePattern.pattern,
	        props = _objectWithoutProperties(_model$clonePattern, ['pattern']);
	
	    pattern.value = [].concat(_toConsumableArray(this.options.pattern.value));
	    pattern.v = _extends({}, this.options.pattern.v);
	    pattern.add = _extends({}, this.options.pattern.add);
	    pattern.remove = _extends({}, this.options.pattern.remove);
	
	    this.options.pattern = pattern;
	
	    var finalize = function finalize() {
	        return _this.model.set(props);
	    };
	
	    if (pattern.add[(0, _date.fmt)(date, 'DD.MM.YYYY')]) return delete pattern.add[(0, _date.fmt)(date, 'DD.MM.YYYY')], finalize();
	
	    if (pattern.remove[(0, _date.fmt)(date, 'DD.MM.YYYY')]) return delete pattern.remove[(0, _date.fmt)(date, 'DD.MM.YYYY')], finalize();
	
	    if (pattern.v[(0, _date.fmt)(date, 'DD.MM.YYYY')]) return pattern.remove[(0, _date.fmt)(date, 'DD.MM.YYYY')] = true, finalize();
	
	    return pattern.add[(0, _date.fmt)(date, 'DD.MM.YYYY')] = true, finalize();
	}
	
	function toggleMonth(month) {
	    var firstOfMonth = (0, _date.beginMonth)(month);
	    var contract = this.model.get('contract');
	    var startDate = contract && (0, _date.unixts)(contract.start_date);
	    var finishDate = contract && (0, _date.unixts)(contract.finish_date);
	
	    var onCount = 0,
	        disabledCount = 0;
	    var dates = [];
	    for (var dt = firstOfMonth; _date.same.month(dt, firstOfMonth); dt = (0, _date.tomorrow)(dt)) {
	        if ((0, _date.past)(dt)) disabledCount++;else if (contract && ((0, _date.unixts)(dt) < startDate || (0, _date.unixts)(dt) > finishDate)) disabledCount++;else {
	            dates.push(dt);
	            if (isOn(this.options.pattern, dt)) onCount++;
	        }
	    }var needTurnOff = onCount + disabledCount === (0, _date.monthDuration)(firstOfMonth);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = dates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _dt = _step.value;
	
	            if (isOn(this.options.pattern, _dt) == needTurnOff) toggleDate.call(this, _dt);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	function isOn(_ref2, date) {
	    var v = _ref2.v,
	        add = _ref2.add,
	        remove = _ref2.remove;
	
	    if (add[(0, _date.fmt)(date, 'DD.MM.YYYY')]) return true;
	
	    if (remove[(0, _date.fmt)(date, 'DD.MM.YYYY')]) return false;
	
	    return !!v[(0, _date.fmt)(date, 'DD.MM.YYYY')];
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _View$extend;
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend((_View$extend = {
	    serialize: function serialize() {
	        var _ref;
	
	        var pattern = this.options.pattern;
	        // 1st of January, 2024 is a Monday - so,
	        // it will be the first cell in calendar
	
	        var dateSeed = (0, _date.datify)('2024-01-01 00:00:00');
	
	        return _ref = {
	            calendars: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (monIndex) {
	                return new _calendar2.default((0, _date.nextMonth)(dateSeed, monIndex));
	            })
	
	        }, _defineProperty(_ref, 'marker-color-scheme', this.options['marker-color-scheme']), _defineProperty(_ref, 'dates', new _collection2.default([].concat(_toConsumableArray(Object.keys(pattern.v).map(function (ddmm) {
	            return {
	                date: (0, _date.datify)(ddmm + '.2024 00:00:00'),
	                pickedUp: true,
	                toggleOff: pattern.remove[ddmm]
	            };
	        })), _toConsumableArray(Object.keys(pattern.add).map(function (ddmm) {
	            return {
	                date: (0, _date.datify)(ddmm + '.2024 00:00:00'),
	                pickedUp: true
	            };
	        }))))), _ref;
	    }
	}, _defineProperty(_View$extend, _view2.default.event(':date:toggle'), function (date) {
	    return toggleDate.call(this, date), this.render();
	}), _defineProperty(_View$extend, _view2.default.event(':month:toggle'), function (month) {
	    return toggleMonth.call(this, month), this.render();
	}), _View$extend));
	
	
	function toggleDate(date) {
	    var _this = this;
	
	    var _model$clonePattern = this.model.clonePattern(this.options.pattern),
	        pattern = _model$clonePattern.pattern,
	        props = _objectWithoutProperties(_model$clonePattern, ['pattern']);
	
	    pattern.value = [].concat(_toConsumableArray(this.options.pattern.value));
	    pattern.v = _extends({}, this.options.pattern.v);
	    pattern.add = _extends({}, this.options.pattern.add);
	    pattern.remove = _extends({}, this.options.pattern.remove);
	
	    this.options.pattern = pattern;
	
	    var finalize = function finalize() {
	        return _this.model.set(props);
	    };
	
	    if (pattern.add[(0, _date.fmt)(date, 'DD.MM')]) return delete pattern.add[(0, _date.fmt)(date, 'DD.MM')], finalize();
	
	    if (pattern.remove[(0, _date.fmt)(date, 'DD.MM')]) return delete pattern.remove[(0, _date.fmt)(date, 'DD.MM')], finalize();
	
	    if (pattern.v[(0, _date.fmt)(date, 'DD.MM')]) return pattern.remove[(0, _date.fmt)(date, 'DD.MM')] = true, finalize();
	
	    return pattern.add[(0, _date.fmt)(date, 'DD.MM')] = true, finalize();
	}
	
	function toggleMonth(month) {
	    var firstOfMonth = (0, _date.beginMonth)(month);
	
	    var onCount = 0;
	    var dates = [];
	    for (var dt = firstOfMonth; _date.same.month(dt, firstOfMonth); dt = (0, _date.tomorrow)(dt)) {
	        dates.push(dt);
	        if (isOn(this.options.pattern, dt)) onCount++;
	    }
	
	    var needTurnOff = onCount === (0, _date.monthDuration)(firstOfMonth);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = dates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _dt = _step.value;
	
	            if (isOn(this.options.pattern, _dt) == needTurnOff) toggleDate.call(this, _dt);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	function isOn(_ref2, date) {
	    var v = _ref2.v,
	        add = _ref2.add,
	        remove = _ref2.remove;
	
	    if (add[(0, _date.fmt)(date, 'DD.MM')]) return true;
	
	    if (remove[(0, _date.fmt)(date, 'DD.MM')]) return false;
	
	    return !!v[(0, _date.fmt)(date, 'DD.MM')];
	}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _api = __webpack_require__(77);
	
	var _date = __webpack_require__(29);
	
	var _backbone = __webpack_require__(13);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend(_defineProperty({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        this.options.calendar = new _calendar2.default(options.month);
	    },
	
	
	    template: 'module/schedule.preview',
	
	    serialize: function serialize() {
	        var _options = this.options,
	            attrs = _options.attrs,
	            calendar = _options.calendar;
	
	
	        var url = '/timetables' + (attrs.id ? '/' + attrs.id : '') + '/preview/' + (0, _date.fmt)(calendar.getMonth(), 'YYYY-MM') + '?apiVersion=2.0';
	        return (0, _api.pst)(url).cerebellum().body(this.options.attrs).execute().then(function (_ref) {
	            var runs = _ref.runs,
	                holidays = _ref.holidays;
	
	            holidays = (0, _arrays.hashify)(holidays);
	            var runTimesByDate = (0, _arrays.hashify)(runs, function (_ref2, hash) {
	                var date = _ref2.date,
	                    time = _ref2.time;
	                return [date, [].concat(_toConsumableArray(hash[date] || []), [time])];
	            });
	
	            return {
	                dates: new _backbone.Collection([].concat(_toConsumableArray(Object.keys(runTimesByDate)), _toConsumableArray(Object.keys(holidays))).map(function (date) {
	                    return {
	                        date: date,
	                        times: runTimesByDate[date] || [],
	                        holiday: holidays[date]
	                    };
	                }))
	            };
	        });
	    }
	}, _view2.default.event('preview:set-month'), function (month) {
	    var _this = this;
	
	    return this.options.calendar.set(month), this.enable(false), this.render().then(function () {
	        return _this.enable(true);
	    });
	}));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _tasks = __webpack_require__(133);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _popups = __webpack_require__(62);
	
	var _loader = __webpack_require__(20);
	
	var _api = __webpack_require__(77);
	
	var _comments = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _view2.default.extend(_defineProperty({
	
	    template: 'module/tasks/sublist',
	
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var _options$filters = options.filters,
	            filters = _options$filters === undefined ? {} : _options$filters,
	            _options$page = options.page,
	            page = _options$page === undefined ? 1 : _options$page,
	            activeId = options.activeId,
	            otherOptions = _objectWithoutProperties(options, ["filters", "page", "activeId"]);
	
	        this.filters_ = _extends({}, filters);
	        this.page_ = page;
	        this.activeId_ = activeId;
	
	        options.actions = {
	
	            defaults: 'edit',
	
	            edit: function edit(current) {
	                return _this.trigger('edit', current);
	            },
	
	            destroy: {
	
	                disabled: function disabled(current) {
	                    return !current || !current.capabilities_.delete;
	                },
	
	                handler: function handler(current) {
	                    return (0, _popups.ask)('issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no', function () {
	                        return (0, _api.del)("/tasks/" + current.id).blocking(_this).cerebellum().execute();
	                    }).then(function () {
	                        // deleting last task on the page?
	                        if (_this.tasks_.total == (_this.page_ - 1) * 7 + 1)
	                            // triggering page will force page change + reload + hash change
	                            _this.trigger('Paging:page', _this.page_ - 1);else _this.fetch();
	                    });
	                }
	            }
	
	        };
	
	        this.tasks_ = new _tasks2.default([], { actions: options.actions });
	
	        this.listenTo(this.tasks_, 'activate deactivate', function (activeId) {
	            return _this.trigger('row', activeId);
	        });
	
	        this.listenTo(this.tasks_, 'activate', function () {
	            var current = _this.tasks_.current();
	            if (!current.comments_) (0, _comments.fetch)(current.id).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    json = _ref2[0],
	                    coll = _ref2[1];
	
	                return current.trigger('comments:load', current.comments_ = json);
	            });
	        });
	
	        _view2.default.prototype.initialize.call(this, otherOptions);
	    },
	    fetch: function fetch() {
	        var _this2 = this;
	
	        var _filters_ = this.filters_,
	            bbox = _filters_.bbox,
	            otherFilters = _objectWithoutProperties(_filters_, ["bbox"]);
	
	        var filters = _extends({
	            bbox: bbox.join(',')
	        }, _tasks2.default.getHttpFilters({ filters: otherFilters, activeId: this.activeId_ }));
	
	        var fetching = this.tasks_.filter(filters, this.page_, this.activeId_);
	
	        return (0, _loader.beginLock)(this), fetching.finally(function () {
	            return (0, _loader.endLock)(_this2);
	        }), fetching;
	    },
	    serialize: function serialize() {
	        // const { issues, types, priorities, statuses, 
	        //     contracts, organizations,
	        //     locationService, } = this.options;
	
	        return {
	            // queryString: this.state().queryString || '',
	            collection: this.tasks_
	            // types, 
	            // statuses,
	            // priorities,
	            // contracts, organizations,
	            // locationService,
	        };
	    },
	    afterRender: function afterRender(context, firstTime) {
	        if (firstTime) this.tasks_.plugActionSource(this.Grid);
	    }
	}, _view2.default.event('Paging:page'), function (page) {
	    return this.page_ = page, this.fetch();
	}));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _collection2.default.extend({
	    endpoint: 'tasks/list/with-comments?apiVersion=2.1&sortBy=id&sortDirection=DESC&limit=7',
	    responseAt: 'items',
	    countAt: 'total',
	    model: _task2.default,
	    parseResponse: function parseResponse(modelsAttrs, _ref) {
	        var active_id = _ref.active_id,
	            schedules = _ref.schedules;
	
	        schedules = (0, _arrays.hashify)(schedules, function (schedule) {
	            return [schedule.id, schedule];
	        });
	
	        return modelsAttrs.map(function (_ref2) {
	            var comments = _ref2.comments,
	                task = _ref2.task,
	                capabilities = _ref2.capabilities,
	                attrs = _objectWithoutProperties(_ref2, ["comments", "task", "capabilities"]);
	
	            var taskAttrs = _extends({
	                id: task.id,
	                task: task,
	                schedule: schedules[task.schedule_id],
	                capabilities: capabilities
	            }, attrs);
	
	            if (task.id != active_id) taskAttrs.lastComment = comments[0];else taskAttrs.comments = comments;
	
	            return taskAttrs;
	        });
	    }
	}, {
	    getHttpFilters: function getHttpFilters(tasksModuleState) {
	        var filters = tasksModuleState.filters,
	            activeId = tasksModuleState.activeId;
	        var assigned_status = filters.assigned_status,
	            category_id = filters.category_id,
	            news_type_id = filters.news_type_id,
	            confirmed = filters.confirmed,
	            assigned_organization_id = filters.assigned_organization_id,
	            assigned_user_id = filters.assigned_user_id,
	            contract_id = filters.contract_id,
	            organization_id = filters.organization_id,
	            title = filters.title;
	
	
	        var result = {};
	        if (+assigned_organization_id > 0) result.assignedOrganizationId = assigned_organization_id;
	        if (+assigned_user_id > 0) result.assignedUserId = assigned_user_id;
	        if (+organization_id > 0) result.organizationId = organization_id;
	        if (+contract_id > 0) result.contractId = contract_id;
	        if (assigned_status) result.onlyStatus = assigned_status;
	        if (category_id) result.category_id = category_id;
	        if (news_type_id) result.type_id = news_type_id;
	        if (confirmed) result.confirmed = confirmed;
	        if (title) result.search = title;
	        if (activeId) result.id = activeId;
	
	        return result;
	    }
	});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        if (options.collection) this.grab(options.collection);
	    },
	
	
	    events: {
	        'click .-set-page': function clickSetPage(_ref) {
	            var currentTarget = _ref.currentTarget;
	
	            this.trigger('page', +currentTarget.dataset.page);
	        }
	    },
	
	    grab: function grab(collection) {
	        var _this = this;
	
	        this.collection = collection;
	        // "sync" is full reload from server;
	        this.listenTo(collection, 'sync reset', function () {
	            return _this.render();
	        });
	    },
	    ungrab: function ungrab(collection) {
	        this.stopListening(collection);
	    },
	    serialize: function serialize() {
	        var collection = this.options.collection || this.collection;
	        if (!collection) return;
	
	        var npages = Math.floor((collection.total - 1) / collection.limit) + 1;
	        var left = [],
	            middle = [],
	            right = [];
	
	        if (npages > 1) left.push({ page: 1 });
	
	        var lo = Math.max(2, collection.page - 2),
	            hi = Math.min(npages - 1, collection.page + 2);
	
	        for (var i = lo; i <= hi; i++) {
	            if (lo > 2) middle.push({ page: i });else left.push({ page: i });
	        }if (npages > 1) if (lo === 2 && hi === npages - 1) left.push({ page: npages });else if (hi === npages - 1) middle.push({ page: npages });else right.push({ page: npages });
	
	        var context = { collection: collection, npages: npages, left: left, middle: middle, right: right };
	
	        return context;
	    }
	});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _options = this.options,
	            _options$attrs = _options.attrs,
	            attrs = _options$attrs === undefined ? [] : _options$attrs,
	            _options$customFields = _options.customFields,
	            customFields = _options$customFields === undefined ? [] : _options$customFields;
	
	        return {
	            customFields: customFields,
	            layerAttrFieldName: 'format_adopted.' + this.options.injectedName,
	            taskFieldFieldName: 'field_id_adopted.' + this.options.injectedName,
	            attrs: attrs.map(function (_ref) {
	                var name = _ref.name;
	                return {
	                    name: name,
	                    value: '{' + name + '}'
	                };
	            })
	        };
	    },
	
	
	    bindingHandlers: {
	
	        arrayvalue: {
	            // to DOM
	            set: function set($el, array) {
	                var _$el = _slicedToArray($el, 1),
	                    el = _$el[0],
	                    arrayIndex = el.dataset.arrayIndex,
	                    propName = el.dataset.propName;
	
	                if (arrayIndex >= array.length) return $el.val('');
	
	                var value = array[arrayIndex][propName];
	
	                if (!el.__triggered_array_value__) $el.val(value);
	            },
	
	
	            // to Model
	            get: function get($el, oldArray, event) {
	                var _$el2 = _slicedToArray($el, 1),
	                    el = _$el2[0],
	                    arrayIndex = el.dataset.arrayIndex,
	                    propName = el.dataset.propName;
	
	                el.__triggered_array_value__ = true;
	                (0, _promisify.delay)(100).then(function () {
	                    return el.__triggered_array_value__ = false;
	                });
	
	                var resultArray = [].concat(_toConsumableArray(oldArray)),
	                    valueElement = resultArray[arrayIndex];
	
	                valueElement[propName] = $el.val();
	
	                this.view.model.trigger('change');
	                this.view.model.trigger('change:fields_mapping');
	                return resultArray;
	            }
	        }
	    },
	
	    bindingFilters: {
	        taskFieldFree: function taskFieldFree(taskFieldId, fieldsMapping, index, m) {
	            return fieldsMapping.filter(function (fieldMapping, mappingIndex) {
	                return index !== mappingIndex;
	            }).every(function (fieldMapping) {
	                return +fieldMapping.field_id_adopted !== +taskFieldId;
	            });
	        }
	    }
	});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    events: {
	        'click li': function clickLi(_ref) {
	            var currentTarget = _ref.currentTarget;
	
	            var $li = this.$(currentTarget);
	            if ($li.hasClass('active')) return;
	
	            this.$('li').removeClass('active');
	            $li.addClass('active');
	
	            var tabNames = this.$('a').toArray().map(function (a) {
	                return a.href.substr(a.href.indexOf('#') + 1);
	            }),
	                tabName = $li.find('a').attr('href').substr(1);
	
	            tabNames.map(function (name) {
	                return (0, _jquery2.default)('[name="Tab-' + name + '"]');
	            }).forEach(function ($el) {
	                return $el.addClass('hide');
	            });
	            (0, _jquery2.default)('[name="Tab-' + tabName + '"]').removeClass('hide');
	        }
	    }
	});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TaskNew = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _View$extend;
	
	exports.newTask = newTask;
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _pick = __webpack_require__(116);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _popups = __webpack_require__(62);
	
	var _arrays = __webpack_require__(24);
	
	var _roles = __webpack_require__(117);
	
	var _date = __webpack_require__(29);
	
	var _promisify = __webpack_require__(19);
	
	var _task3 = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TaskNew = exports.TaskNew = _view2.default.extend((_View$extend = {
	
	    template: 'jst/task.new',
	
	    onBind: function onBind(model) {
	        var _this = this;
	
	        this.listenTo(model, 'change:point', function () {
	            return _this.Map.render();
	        });
	    },
	
	
	    events: {
	        'click .-choose-object': function clickChooseObject() {
	            var _this2 = this;
	
	            var contractId = this.model.get('contract_id');
	            var contract = contractId && this.options.contracts.find(function (contract) {
	                return contract.id == contractId;
	            });
	
	            var hasContractObjects = !contract ? false : contract.get('groups').length && contract.get('groups').every(function (_ref) {
	                var objects = _ref.objects;
	                return objects.length;
	            });
	
	            var objects = !hasContractObjects ? undefined : this.options.contracts.find(function (contract) {
	                return contract.id == contractId;
	            }).get('groups').filter(function (_ref2) {
	                var types = _ref2.types;
	                return +_this2.model.get('type_id') > 0 && types.length ? types.some(function (type) {
	                    return type.id == _this2.model.get('type_id');
	                }) : true;
	            }).map(function (group) {
	                return group.objects;
	            }).reduce(function (result, objects) {
	                return [].concat(_toConsumableArray(result), _toConsumableArray(objects));
	            }, []);
	
	            var layerIds = !hasContractObjects ? undefined : (0, _arrays.hashify)(this.options.contracts.find(function (contract) {
	                return contract.id == contractId;
	            }).get('groups').map(function (group) {
	                return group.objects;
	            }).reduce(function (result, objects) {
	                return [].concat(_toConsumableArray(result), _toConsumableArray(objects));
	            }, []).map(function (group) {
	                return group.layer_id;
	            }));
	
	            var view = _pick2.default.of({
	                datatables: new _collection2.default(this.options.datatables.toJSON().filter(function (layer) {
	                    return !hasContractObjects || layerIds[layer.id];
	                }).filter(function (layer) {
	                    return layer.access.serviceObjects;
	                })),
	                objects: objects,
	                multiple: false
	            });
	
	            return (0, _popups.ask)(view.render(), 'service.object::choose', 'actions::choose', 'actions::cancel', { large: true }, function () {
	                return view.chosen_ && _this2.model.set({
	                    service_object_id: view.chosen_.id,
	                    service_object_layer_id: view.chosen_.get('layer_id'),
	                    service_object_title: view.chosen_.get('name')
	                });
	            });
	        },
	        'click .-remove-object': function clickRemoveObject() {
	            this.model.set({
	                service_object_layer_id: undefined,
	                service_object_id: undefined,
	                service_object_title: undefined,
	                sys_org_id: undefined,
	                sys_clr_id: undefined
	            });
	        }
	    }
	
	}, _defineProperty(_View$extend, _view2.default.event('Map:service-object:choose'), function (_ref3) {
	    var objectId = _ref3.objectId,
	        layerId = _ref3.layerId,
	        title = _ref3.title;
	
	    if (this.model) this.model.set({
	        service_object_title: title.replace(/\<\/?span[^\>]*>/g, '').trim(),
	        service_object_id: objectId,
	        service_object_layer_id: layerId
	    });
	}), _defineProperty(_View$extend, _view2.default.event('Map:map:click'), function (location) {
	    if (this.model) this.model.set('location', location);
	}), _defineProperty(_View$extend, _view2.default.event('Map:address:choose'), function (_ref4) {
	    var coords = _ref4.coords;
	
	    if (this.model) this.model.set('location', coords);
	}), _View$extend));
	
	function newTask(taskNew, priorities) {
	    var priorityClusters = (0, _arrays.hashify)(priorities.toJSON().map(function (priority) {
	        return priority.cluster;
	    }).filter(function (cluster) {
	        return cluster;
	    }).map(function (cluster) {
	        return cluster.id;
	    }));
	
	    var _ref5 = Object.keys(priorityClusters).length === 1 ? priorities.models : [],
	        _ref6 = _slicedToArray(_ref5, 1),
	        priority = _ref6[0];
	
	    var organizationId = _config2.default.orgs() && _config2.default.orgs().length == 1 ? _config2.default.orgs()[0] : undefined;
	
	    var task = new _task2.default({
	        date: (0, _date.unixts)(new Date()),
	        priority_id: priority && priority.id,
	        organization_id: organizationId
	    });
	
	    task.capabilities_ = {
	        edit: true,
	        update_title: true, update_text: true,
	        update_type: true, update_priority: true, update_point: true,
	        update_deadline: true,
	        update_custom_fields: true,
	        assign_department: _roles.roleAICKai.indexOf(_config2.default.role()) !== -1,
	        assign_user: _roles.roleAICKai.indexOf(_config2.default.role()) !== -1
	    };
	
	    return (0, _popups.ask)(bindTaskWindow(taskNew, task), 'issue::modal new - title', 'actions::create', 'actions::cancel', function (form, _, modal) {
	        form.enable(), modal.enable();
	
	        var _taskNew$TaskForm$val = taskNew.TaskForm.validate(),
	            result = _taskNew$TaskForm$val.result,
	            messages = _taskNew$TaskForm$val.messages;
	
	        if (!result) return Promise.reject(messages[0] /* [text, field] */);
	
	        return form.disable(), modal.disable(), (0, _task3.save)(taskNew);
	    });
	}
	
	function bindTaskWindow(taskNew, task) {
	    // hack begins
	    taskNew.$el.css({ opacity: 0, transform: 'scale(0.01)' }).appendTo(document.body);
	
	    // render view
	    var binding = (task ? taskNew.bind(task) : taskNew.render()).
	    // hack continues
	    then(function () {
	        return (0, _promisify.delay)(350);
	    })
	    // don't remove, just detach to avoid dropping event handlers
	    .then(function () {
	        return taskNew.$el.detach().css({ opacity: 1, transform: 'scale(1)' });
	    })
	    // hack ends
	    .then(function () {
	        return taskNew;
	    });
	
	    return binding.view = taskNew, binding;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _defaultFilters = {
	    title: '',
	    contract_id: '',
	    organization_id: '',
	    news_type_id: '',
	    category_id: '',
	    confirmed: '1',
	    assigned_status: '',
	    assigned_organization_id: 0,
	    assigned_user_id: 0,
	    assigned_user_fio: '',
	    attachments: []
	};
	
	var Filters = void 0;exports.default = Filters = _view2.default.extend({
	    initialize: function initialize(options) {
	        _view2.default.prototype.initialize.call(this, options);
	        this.model = new Filters.Model(_defaultFilters);
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            contracts = _options.contracts,
	            types = _options.types,
	            statuses = _options.statuses,
	            priorities = _options.priorities,
	            organizations = _options.organizations;
	
	
	        return {
	            contracts: contracts,
	            priorities: priorities.toJSON(),
	            statuses: statuses.toJSON(),
	            types: types.toJSON().filter(function (type) {
	                return type.role_ids == null || type.role_ids.indexOf(_config2.default.role()) !== -1 || type.role_ids.indexOf(+_config2.default.role()) !== -1;
	            }),
	            organizations: organizations.toJSON()
	        };
	    },
	
	
	    events: {
	        'click .-clear-filters': function clickClearFilters() {
	            this.model.clear({ silent: true });
	            this.model.set(_extends({}, _defaultFilters));
	        }
	    },
	
	    afterRender: function afterRender() {
	        var _this = this;
	
	        if (!this.model) return;
	
	        this.stopListening(this.model);
	
	        var fn = function fn() {
	            return _this.trigger('filter', _this.model.toJSON());
	        };
	
	        var title = _defaultFilters.title,
	            ordinaryFilters = _objectWithoutProperties(_defaultFilters, ['title']);
	
	        var eventNames = Object.keys(ordinaryFilters).map(function (prop) {
	            return 'change:' + prop;
	        }).join(' ');
	        this.listenTo(this.model, eventNames, _underscore2.default.debounce(fn, 100));
	        this.listenTo(this.model, 'change:title', _underscore2.default.debounce(fn, 300));
	    },
	    focus: function focus() {
	        this.$('[name=title]').focus();
	    }
	}, {
	    defaultFilters: function defaultFilters() {
	        return _extends({}, _defaultFilters);
	    },
	
	
	    Model: _task2.default.extend({
	        computeds: _extends({}, _task2.default.prototype.computeds, {
	
	            changed: {
	                deps: ['title', 'confirmed', 'contract_id', 'organization_id', 'news_type_id', 'category_id', 'assigned_status', 'assigned_user', 'assigned_organization_id'],
	                get: function get() {
	                    // Task, not Model:
	                    // Task is enough for diff() call;
	                    // and usage of Model will produce
	                    // infinite recursion at momemnt of 
	                    // computing "changed" for a new Model.
	                    var original = new _task2.default(_defaultFilters);
	                    var diff = this.diff(original);
	                    return !!diff.length;
	                }
	            }
	
	        })
	    })
	
	});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	
	    className: 'grid-toolbar',
	
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        // extract actual labels from "actionLabels" hash parameter:
	        // $edit="hello, i am example of button label for task EDIT"
	        var actionList = options.actionList;
	        var actionLabels = options.actionLabels;
	
	        var actionLabelKeys = Object.keys(actionLabels).filter(function (key) {
	            return key.startsWith('$');
	        }).map(function (key) {
	            return key.substr(1);
	        });
	        actionLabels = (0, _arrays.hashify)(actionLabelKeys, function (key) {
	            return [key, actionLabels['$' + key]];
	        });
	
	        // get copy of action data
	        this.actions = (0, _arrays.hashify)(Object.keys(actionList.actions), function (actionCode) {
	            var actionDataCopy = actionList.actions[actionCode];
	            return [actionCode, _extends({}, actionDataCopy, {
	                name: actionLabels[actionCode] || actionDataCopy.name })];
	        });
	
	        actionList.plug(this);
	        // when occurs update of actions' state,
	        // update buttons in toolbar (enabled/disabled state)
	        this.listenTo(actionList, 'update', function () {
	            return _this.render(_this.serialize({}));
	        });
	    },
	
	
	    events: {
	
	        'click button': function clickButton(e) {
	            // action code stored in data-action attribute
	            // (see toolbar.handlebars)
	            this.trigger('action:' + e.target.dataset.action);
	        }
	
	    },
	
	    serialize: function serialize() {
	        var _this2 = this;
	
	        var actions = Object.keys(this.actions).map(function (actionName) {
	            var action = _this2.actions[actionName],
	                code = action.code,
	                name = action.name,
	                disabled = action.disabled,
	                defaults = action.defaults;
	
	            // check enability of button
	            // using "disabled" property of
	            // button definition
	            if ('function' === typeof disabled) disabled = disabled();
	
	            return { code: code, name: name, disabled: disabled, defaults: defaults };
	        });
	
	        return { actions: actions };
	    }
	}, {
	    of: function of(options) {
	        var Class = this;
	        return new Class(options);
	    }
	});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _organizations = __webpack_require__(141);
	
	var _organizations2 = _interopRequireDefault(_organizations);
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _handlebars = __webpack_require__(45);
	
	var _taskAssignee = __webpack_require__(143);
	
	var _suggest = __webpack_require__(111);
	
	var _roles = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	// todo: bind into the model
	exports.default = _view2.default.extend({
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _view2.default.prototype.initialize.call(this, options);
	
	        var userFieldName = options.userFieldName;
	
	        // todo: cancel pgdn
	        // todo: correct handle click on OK/Apply
	
	        this.suggestionInterface_ = (0, _suggest.suggest)(this.$el, '[name="' + userFieldName + '"]', function ($htmlInput, page, firstSearch) {
	            if (!_this.model) return [];
	
	            var offset = page > 0 ? page * 10 - 1 : 0,
	                limit = page > 0 ? 10 : 9,
	                params = {};
	
	            if (options.nonBlockedUsersOnly) params.blocked = false;
	            if (options.nonDeletedRolesOnly) params.nonDeletedRolesOnly = true;
	
	            var val = _this.$('[name="' + userFieldName + '"]').val().trim(),
	                user = _this.model.get(_this.options.userProperty) || {},
	                _user$name = user.name,
	                name = _user$name === undefined ? '' : _user$name;
	
	            // filter users by name typed in form field;
	            // if field contains an chosen value (i.e. value from {id, name} pair)
	            // then filtering is cancelled. 
	            if (!firstSearch) if (val !== _this.options.noUserLabel) params.search = val;
	            //if (val && name.toLowerCase() !== val.toLowerCase())
	
	            if (_this.options.locationProperty) if (_this.model.get(_this.options.locationProperty)) {
	                var _model$get = _this.model.get(_this.options.locationProperty),
	                    lon = _model$get.lon,
	                    lat = _model$get.lat;
	
	                params.lon = lon.toFixed(5);
	                params.lat = lat.toFixed(5);
	            }
	
	            if (options.roles) {
	                var coll = typeof options.roles === 'function' ? options.roles() : options.roles;
	                var ids = (coll.toJSON ? coll.toJSON() : coll).filter(function (_ref) {
	                    var id = _ref.id,
	                        code = _ref.code;
	                    return code === 'ORG_USER' || [].concat(_toConsumableArray(_roles.roleaiuc), _toConsumableArray(_roles.roleCK)).indexOf(id) !== -1;
	                }).map(function (_ref2) {
	                    var id = _ref2.id;
	                    return id;
	                });
	                params.roles = ids.join(',');
	            }
	
	            var req = retrieveOrganizations.call(_this).then(function (orgs) {
	                if (typeof orgs == 'function') orgs = orgs();
	
	                var ids = orgs.map(function (org) {
	                    return org.id;
	                }).filter(function (id) {
	                    return !!id;
	                }).join(',');
	                console.log(ids);
	
	                var pickedOrgId = _this.options.organizationIdProperty && +_this.model.get(_this.options.organizationIdProperty);
	
	                if (pickedOrgId) params.organizationId = pickedOrgId;else if (ids) params.organizationId = ids;
	
	                return (0, _taskAssignee.getLocations)(params, offset, limit);
	            });
	
	            var result = req.then(function (response) {
	                return response.users;
	            }).then(function (options) {
	                return options.map(function (option) {
	                    // { user, location, distance, is_active } 
	                    option.title = option.user.fio;
	                    option.user.organization_id = option.user.department_id;
	
	                    if (!option.location) return option;
	                    if (!option.is_active) return option;
	
	                    var deltaSec = Math.floor((new Date() - option.location.date * 1000) / 1000);
	
	                    var timeNotice = deltaSec !== undefined ? (0, _handlebars.interval)(deltaSec) : undefined;
	
	                    if (!timeNotice) {
	                        delete option.location;
	                        return option;
	                    }
	
	                    option.title = timeNotice + ' \u2014 ' + option.title;
	
	                    if (!option.distance) return option;
	
	                    var distTitle = option.distance < 1 ? Math.round(option.distance * 1000) + ' ' + ifn('units::m') : option.distance.toFixed(2) + ' ' + ifn('units::km');
	
	                    option.title = distTitle + ', ' + option.title;
	
	                    return option;
	                });
	            }).then(function (options) {
	                if (page !== 0) return options;
	
	                options.unshift({
	                    id: 0,
	                    title: _this.options.noUserLabel,
	                    user: { id: 0, fio: '' }
	                });
	
	                return options;
	            });
	
	            return Promise.all([req, result]).then(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    total = _ref4[0].total,
	                    options = _ref4[1];
	
	                return { options: options, total: total, page: page, offset: offset, limit: limit };
	            });
	        }, function ($htmlInput, title, _ref5) {
	            var _ref5$user = _ref5.user,
	                id = _ref5$user.id,
	                fio = _ref5$user.fio,
	                organization_id = _ref5$user.organization_id;
	
	            if (!_this.model.get(_this.options.organizationIdProperty)) _this.model.set(_this.options.organizationIdProperty, organization_id);
	            _this.model.set(_this.options.userProperty, { id: id, name: fio });
	            _this.trigger('user:choose', { id: id, name: fio });
	            _this.trigger('points', []);
	            _this.suggestionInterface_.hideSuggestion();
	        }, function ($htmlInput) {
	            var user = _this.model.get(_this.options.userProperty) || {};
	            var name = user.name;
	
	            $htmlInput.val(name || _this.options.noUserLabel);
	            _this.trigger('assignee:dropdown-hide');
	        }, function (current, items) {
	            items = items.slice().map(function (p) {
	                return p.current = p.user.id == current.user.id, p;
	            });
	            _this.trigger('points', items);
	        });
	    },
	    serialize: function serialize(context) {
	        var _options = this.options,
	            userProperty = _options.userProperty,
	            userFieldLabel = _options.userFieldLabel,
	            userFieldName = _options.userFieldName,
	            enableUserField = _options.enableUserField,
	            messagesForUserField = _options.messagesForUserField,
	            organizationIdProperty = _options.organizationIdProperty,
	            organizationFieldLabel = _options.organizationFieldLabel,
	            organizationFieldName = _options.organizationFieldName,
	            enableOrganizationField = _options.enableOrganizationField,
	            hideOrganizationField = _options.hideOrganizationField,
	            messagesForOrganizationField = _options.messagesForOrganizationField,
	            inline = _options.inline;
	
	
	        return retrieveOrganizations.call(this).then(function (organizations) {
	            return _extends({}, context, {
	                organizations: organizations,
	                userProperty: userProperty,
	                userFieldLabel: userFieldLabel,
	                userFieldName: userFieldName,
	                enableUserField: enableUserField,
	                messagesForUserField: messagesForUserField,
	
	                organizationIdProperty: organizationIdProperty,
	                organizationFieldLabel: organizationFieldLabel,
	                organizationFieldName: organizationFieldName,
	                enableOrganizationField: enableOrganizationField,
	                hideOrganizationField: hideOrganizationField,
	                messagesForOrganizationField: messagesForOrganizationField,
	
	                inline: inline
	            });
	        });
	    },
	    afterRender: function afterRender() {
	        this.suggestionInterface_.unbindEvents();
	        this.suggestionInterface_.bindEvents();
	    },
	
	
	    bindingHandlers: {
	
	        getUserName: {
	            set: function set($el, user) {
	                if (user) $el.val('' + user.name || '');else $el.val(this.view.options.noUserLabel);
	            },
	            get: function get($el, value, event) {
	                return {};
	            }
	        }
	
	    }
	
	});
	
	
	function retrieveOrganizations() {
	    var organizations = this.options.organizations;
	
	    var zeroOption = { id: 0, title: this.options.noOrganizationLabel };
	
	    if (typeof organizations == 'function') return Promise.resolve(function () {
	        return [zeroOption].concat(_toConsumableArray(organizations()));
	    });
	
	    if (organizations instanceof _organizations2.default) return Promise.resolve([zeroOption].concat(_toConsumableArray(organizations.toJSON())));
	
	    if (organizations) return Promise.resolve([zeroOption].concat(_toConsumableArray(organizations)));
	
	    return new _organizations2.default([]).fetch().then(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 1),
	            items = _ref7[0];
	
	        return [zeroOption].concat(_toConsumableArray(items));
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _organization = __webpack_require__(142);
	
	var _organization2 = _interopRequireDefault(_organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'departments/all',
		responseAt: 'departments',
		model: _organization2.default
	});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'departments'
	
	});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTaskFilters = exports.getAssignees = exports.getLocations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.getLocations = getLocations;
	exports.getAssignees = getAssignees;
	exports.getTaskFilters = getTaskFilters;
	
	
	function getAssignees(task) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000000;
	
	    var extendedParams = _extends({}, params, getTaskFilters(task));
	    return getLocations(extendedParams, offset, limit);
	}
	
	function getTaskFilters(task) {
	    if (!task) return {};
	
	    var params = {};
	    if (task.get('location')) {
	        var _task$get = task.get('location'),
	            lon = _task$get.lon,
	            lat = _task$get.lat;
	
	        params.lon = lon.toFixed(5);
	        params.lat = lat.toFixed(5);
	    }
	
	    if (+task.get('assigned_organization_id')) params.organizationId = task.get('assigned_organization_id');
	
	    return params;
	}
	
	function getLocations() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000000;
	
	    var get = function get(url) {
	        return (0, _promisify.requestify)(_backbone2.default.$.getJSON(_config2.default.url(url)));
	    };
	
	    var url = '/users/by-distance?apiVersion=1.3&offset=' + offset + '&limit=' + limit;
	
	    Object.keys(params).forEach(function (name) {
	        return url = _config2.default.add(url, name, params[name]);
	    });
	
	    return get(url);
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _date = __webpack_require__(29);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    serialize: function serialize() {
	        var _options = this.options,
	            calendar = _options.calendar,
	            collection = _options.collection,
	            fiveLines = _options.fiveLines;
	
	
	        var data = this.options.data || collection && (0, _arrays.hashify)(collection.toJSON(), function (item) {
	            return [(0, _date.fmt)(item.date, 'YYYY-MM-DD'), item];
	        }) || {};
	
	        return {
	            dates: calendar.list().filter(function (_, index) {
	                return !fiveLines || index < 35;
	            }).map(function (item) {
	                return item.data = data[(0, _date.fmt)(item.date, 'YYYY-MM-DD')], item;
	            })
	        };
	    }
	});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Trigger;
	function Trigger() {
	    var fired = false,
	        cancelled = false,
	        cancellationReason = void 0,
	        callbacks = [];
	
	    // execute all callbacks, empty callback queue
	    var runCallbacks = function runCallbacks() {
	        var wrappedCallbackFn = void 0;
	        while (wrappedCallbackFn = callbacks.shift()) {
	            wrappedCallbackFn();
	        }
	    };
	
	    // set fired flag,
	    // execute all callbacks, empty callback queue
	    var fire = function fire() {
	        fired = true;
	
	        runCallbacks();
	
	        // to allow:
	        // const {onFire} = new Trigger().fire();
	        return result;
	    };
	
	    // set cancel flag, remember cancellation reason,
	    // execute all callbacks, empty callback queue
	    var cancel = function cancel(reason) {
	        cancelled = true;
	        cancellationReason = reason;
	
	        runCallbacks();
	
	        // to allow:
	        // const {onFire} = new Trigger().cancel();
	        return result;
	    };
	
	    // onFire:
	    // - takes callbackFn,
	    // - wraps it with try catch, 
	    // - executes immediately or registers for later execution 
	    // - and returns promise resolved or rejected depending on callback execution result
	    var onFire = function onFire(callbackFn) {
	        return new Promise(function (resolveFn, rejectFn) {
	            var wrappedCallbackFn = function wrappedCallbackFn() {
	                if (cancelled) return rejectFn(cancellationReason);
	
	                try {
	                    resolveFn(callbackFn());
	                } catch (ex) {
	                    rejectFn(ex);
	                }
	            };
	
	            if (fired || cancelled) wrappedCallbackFn();else callbacks.push(wrappedCallbackFn);
	
	            return result;
	        });
	    };
	
	    var result = void 0;return result = {
	        fire: fire,
	        onFire: onFire,
	        cancel: cancel
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'users/register',
	
	    defaults: {
	        login: undefined,
	        paswd: undefined,
	        role_id: undefined,
	        fio: undefined,
	        email: undefined,
	        passport: undefined,
	        phone: undefined,
	        address: undefined
	    }
	
	});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _priority = __webpack_require__(148);
	
	var _priority2 = _interopRequireDefault(_priority);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'priorities?apiVersion=2.0',
		responseAt: 'items',
		model: _priority2.default
	});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'priorities?apiVersion=2.0',
	
	    defaults: {
	        name: '',
	        cluster: null,
	        icon: 'default_category.png'
	    }
	
	});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _script = __webpack_require__(150);
	
	var _script2 = _interopRequireDefault(_script);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'scripts/list?apiVersion=2.0&limit=1000000',
		responseAt: 'items',
		model: _script2.default
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'scripts?apiVersion=2.0',
	
	    defaults: function defaults() {
	        return {
	            title: '',
	            description: '',
	            on: true,
	            cluster: null,
	            webhook_server: undefined,
	            script: 'return valid()',
	            workgroups: [],
	            types: [],
	            priorities: [],
	            roles: [],
	            statuses_before: [],
	            statuses_after: [],
	            stages_before: [],
	            stages_after: [],
	            user_organizations_before: [],
	            user_organizations_after: [],
	            user_roles_before: [],
	            user_roles_after: [],
	            user_types_before: [],
	            user_types_after: [],
	            user_tags_before: [],
	            user_tags_after: [],
	
	            operation: 'INSERT',
	            type: 'VALIDATION',
	            entity_type: 'TASK'
	        };
	    },
	
	
	    computeds: {
	
	        stages_before_: {
	            get: function get() {
	                return this.get('stages_before').map(function (value) {
	                    return { id: value };
	                });
	            },
	            set: function set(value) {
	                return {
	                    stages_before: value.map(function (item) {
	                        return item.id;
	                    })
	                };
	            }
	        },
	
	        stages_after_: {
	            get: function get() {
	                return this.get('stages_after').map(function (value) {
	                    return { id: value };
	                });
	            },
	            set: function set(value) {
	                return {
	                    stages_after: value.map(function (item) {
	                        return item.id;
	                    })
	                };
	            }
	        }
	
	    }
	
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _server = __webpack_require__(152);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'scripts/servers/list?apiVersion=2.0&limit=1000000',
		responseAt: 'items',
		model: _server2.default
	});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'scripts/servers?apiVersion=2.0',
	
	    defaults: {
	        name: '',
	        cluster: null,
	        url: '',
	        on: true
	    }
	
	});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _serviceObject = __webpack_require__(154);
	
	var _serviceObject2 = _interopRequireDefault(_serviceObject);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	    endpoint: '/service-objects/mappings/list?apiVersion=2.0',
	    responseAt: 'items',
	    model: _serviceObject2.default
	});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _status = __webpack_require__(156);
	
	var _status2 = _interopRequireDefault(_status);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'statuses/list/all?apiVersion=2.0',
		responseAt: 'items',
		model: _status2.default
	});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'statuses?apiVersion=2.0',
	
	    defaults: {
	        name: '',
	        cluster: null,
	        color: '',
	        visible: true,
	        'default': false,
	        closed: false
	    },
	
	    customParser: function customParser(attrs) {
	        return attrs.order = +attrs.order, attrs;
	    },
	
	
	    computeds: {
	
	        // make copy of "default" property
	        // with "defaults" name: Epoxy cannot
	        // deal with property named "default"
	        defaults: {
	            set: function set(value) {
	                return { 'default': value };
	            },
	            get: function get() {
	                return this.get('default');
	            }
	        }
	
	    }
	
	});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _newstype = __webpack_require__(158);
	
	var _newstype2 = _interopRequireDefault(_newstype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'types',
		responseAt: 'newstype',
		model: _newstype2.default
	});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'types', responseAt: 'newstype',
	
	    defaults: function defaults() {
	        return {
	            name: '',
	            cluster: null,
	            group_id: null,
	            period_of_review_in_sec: undefined,
	            deadline_type: 'AT_CREATE',
	            default_type: 'f',
	            departments: [],
	            icon: 'default_icon.png',
	            role_ids: null, __all_roles_available: undefined
	        };
	    },
	    customParser: function customParser(payload) {
	        if (payload.period_of_review_in_sec) payload.period_of_review_in_sec = +payload.period_of_review_in_sec;
	
	        return payload;
	    },
	    diff: function diff(another) {
	        var _hashify = (0, _arrays.hashify)(_model2.default.prototype.diff.call(this, another), function (diff) {
	            return [diff.attrName, diff];
	        }),
	            __all_roles_available = _hashify.__all_roles_available,
	            role_ids = _hashify.role_ids,
	            others = _objectWithoutProperties(_hashify, ['__all_roles_available', 'role_ids']);
	
	        var diff = Object.values(others);
	
	        if (__all_roles_available) {
	            if (__all_roles_available.newValue) return another.get('role_ids') === null ? diff : [].concat(_toConsumableArray(diff), [{ attrName: 'role_ids', newValue: null }]);else return [].concat(_toConsumableArray(diff), [{ attrName: 'role_ids', newValue: this.get('role_ids'), oldValue: null }]);
	        } else if (role_ids) return [].concat(_toConsumableArray(diff), [role_ids]);
	
	        return diff;
	    }
	});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _type = __webpack_require__(160);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'types/groups/list?apiVersion=2.0',
		responseAt: 'items',
		model: _type2.default
	});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'types/groups?apiVersion=2.0',
	
	    defaults: {
	        name: '',
	        cluster: null
	    }
	
	});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _user = __webpack_require__(162);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	  endpoint: 'users/types/list?apiVersion=2.0&limit=1000000',
	  model: _user2.default
	});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'users/types?apiVersion=2.0'
	
	});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _user = __webpack_require__(164);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	  endpoint: 'users/tags/list?apiVersion=2.0&limit=1000000',
	  model: _user2.default
	});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'users/tag?apiVersion=2.0'
	
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _workgroup = __webpack_require__(166);
	
	var _workgroup2 = _interopRequireDefault(_workgroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
		endpoint: 'workgroups/list?apiVersion=2.0&limit=1000000000',
		responseAt: 'items',
		model: _workgroup2.default
	});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	
	    defaults: {
	        title: undefined
	    }
	
	});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import Filters MUST be here for correct work!!!
	
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _capabilities = __webpack_require__(170);
	
	var _capabilities2 = _interopRequireDefault(_capabilities);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _rules = __webpack_require__(172);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _task = __webpack_require__(97);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _statuses = __webpack_require__(155);
	
	var _statuses2 = _interopRequireDefault(_statuses);
	
	var _arrays = __webpack_require__(24);
	
	var _sort = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaults = {
	    roles: undefined,
	    capabilities: undefined
	};
	
	var FiltersModel = _model2.default.extend({
	
	    defaults: defaults,
	
	    computeds: {
	
	        changed: {
	            deps: ['roles', 'capabilities'],
	            get: function get() {
	                // Model, not FiltersModel:
	                // Task is enough for diff() call;
	                // and usage of Model will produce
	                // infinite recursion at momemnt of 
	                // computing "changed" for a new Model.
	                var original = new _model2.default(defaults);
	                var diff = this.diff(original);
	                return !!diff.length;
	            }
	        }
	
	    }
	});
	
	exports.default = _refbooks2.default.extend(_defineProperty({
	
	    template: 'jst/module.capabilities',
	
	    url: function url() {
	        return 'capabilities';
	    },
	    open: function open() {
	        var _this = this;
	
	        return this.capabilities_ = new _capabilities2.default([], {}), this.roles_ = this.options.roles, this.states_ = new _task2.default([], {}), this.statuses_ = new _statuses2.default([], {}), Promise.all([this.capabilities_.fetch(), this.states_.fetch(), this.statuses_.fetch()]).then(function () {
	            return _this.rules_ = new _rules2.default([], {
	                capabilities: _this.capabilities_,
	                roles: _this.roles_,
	                states: _this.states_
	            });
	        }).then(function () {
	            return (0, _sort.sort)(_this.capabilities_.models, _sort.naturalOrder, ['label']);
	        }).then(function () {
	            return _this.rules_.fetch();
	        }).then(function () {
	            return _this.bind(new FiltersModel(_this.state().filters));
	        });
	    },
	    start: function start() {
	        var _this2 = this;
	
	        return this.listenTo(this.model, 'change', function () {
	            return Promise.resolve().then(function () {
	                return _this2.setState({
	                    filters: _this2.model.toJSON(),
	                    page: 1
	                });
	            }).then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.navigated();
	            });
	        });
	    },
	    stop: function stop() {
	        return this.stopListening(this.model), this;
	    },
	    serialize: function serialize() {
	        var _this3 = this;
	
	        var roles = this.model.get('roles') && this.model.get('roles').length ? (0, _arrays.hashify)(this.model.get('roles')) : undefined;
	        var capabilities = this.model.get('capabilities') && this.model.get('capabilities').length ? (0, _arrays.hashify)(this.model.get('capabilities')) : undefined;
	
	        var singleRoleFiltered = Object.keys(roles || {}).length === 1;
	        var singleCapabilityFiltered = Object.keys(capabilities || {}).length === 1;
	
	        var models = this.rules_.predicate(function (model) {
	            // skip unknown roles
	            if (!model.get('role')) return false;
	
	            // skip unknown caps
	            if (!model.get('capability')) return false;
	
	            if (roles) if (!roles[model.get('role_id')]) return false;
	
	            if (capabilities) if (!capabilities[model.get('capability_id')]) return false;
	
	            return true;
	        });
	
	        var _state = this.state(),
	            page = _state.page,
	            field = _state.sort,
	            direction = _state.direction,
	            limit = _state.limit;
	
	        var columns = field === 'role' ? ['role.name', 'capability.label', 'ownership', 'stage'] : ['capability.label', 'role.name', 'ownership', 'stage'];
	        var sortingRules = 'asc' === direction ? (0, _sort.asc)(models, columns) : (0, _sort.desc)(models, columns);
	
	        return sortingRules.then(function (ruleModels) {
	
	            var rules = new _rules2.default(ruleModels.filter(function (model, index) {
	                return index >= (page - 1) * limit && index < page * limit;
	            }).map(function (rule) {
	                var json = rule.toJSON();
	                return new _model2.default(_extends({}, json, {
	                    ownership: rule.get('ownership'),
	                    stage: rule.get('stage'),
	                    status: rule.get('status'),
	                    is_template: rule.get('is_template'),
	                    others: rule.get('others')
	                }));
	            }), {});
	
	            rules.total = ruleModels.length;
	            rules.page = page;
	            rules.limit = limit;
	
	            return {
	                capabilities: _this3.capabilities_.toJSON(),
	                roles: _this3.roles_.toJSON(),
	                states: _this3.states_.toJSON(),
	                statuses: _this3.statuses_.toJSON(),
	                singleRoleFiltered: singleRoleFiltered,
	                singleCapabilityFiltered: singleCapabilityFiltered,
	                sort: field, direction: direction,
	                rules: rules
	            };
	        });
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref) {
	            var _this4 = this;
	
	            var currentTarget = _ref.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	            return this.setState({ page: 1, sort: sort, direction: direction }), this.render().then(function () {
	                return _this4.navigated();
	            });
	        },
	        'click .-limit': function clickLimit(_ref2) {
	            var _this5 = this;
	
	            var currentTarget = _ref2.currentTarget;
	            var limit = currentTarget.dataset.limit;
	
	            return this.setState({ page: 1, limit: limit }), this.render().then(function () {
	                return _this5.navigated();
	            });
	        },
	        'click .-clear-filters': function clickClearFilters() {
	            this.model.set(_extends({}, defaults));
	        }
	    }
	
	}, _refbooks2.default.event('Paging:page'), function (page) {
	    var _this6 = this;
	
	    return this.setState({ page: +page }), this.render().then(function () {
	        return _this6.navigated();
	    });
	}), {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _module2.default.extend({
	
	    events: {
	        'click .-open-types': function clickOpenTypes() {
	            this.trigger(this.constructor.TYPES, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-type-groups': function clickOpenTypeGroups() {
	            this.trigger(this.constructor.TYPEGROUPS, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-statuses': function clickOpenStatuses() {
	            this.trigger(this.constructor.STATUSES, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-priorities': function clickOpenPriorities() {
	            this.trigger(this.constructor.PRIORITIES, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-fields': function clickOpenFields() {
	            this.trigger(this.constructor.FIELDS, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-stickers': function clickOpenStickers() {
	            this.trigger(this.constructor.STICKERS, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-capabilities': function clickOpenCapabilities() {
	            this.trigger(this.constructor.CAPABILITIES, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-servers': function clickOpenServers() {
	            this.trigger(this.constructor.SERVERS, {
	                cluster: this.state().cluster
	            });
	        },
	        'click .-open-scripts': function clickOpenScripts() {
	            this.trigger(this.constructor.SCRIPTS, {
	                cluster: this.state().cluster
	            });
	        }
	    }
	
	}, {
	
	    TYPES: 'types',
	
	    TYPEGROUPS: 'type-groups',
	
	    FIELDS: 'fields',
	
	    STICKERS: 'stickers',
	
	    STATUSES: 'statuses',
	
	    PRIORITIES: 'priorities',
	
	    CAPABILITIES: 'capabilities',
	
	    SERVERS: 'servers',
	
	    SCRIPTS: 'scripts'
	
	});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _promisify = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _view2.default.extend({
	    open: function open() {
	        return this.render();
	    },
	    inject: function inject() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        Object.assign(this.options, options);
	    },
	    start: function start() {
	        return this;
	    },
	    attached: function attached($el) {
	        $(document.body).append('<style>\n            .loader:before { background-color: #d9edf7; }\n        </style>');
	
	        return this;
	    },
	    detached: function detached() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	    state: function state() {
	        return this.state_;
	    },
	    setState: function setState() {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var oldState = this.state_ || {};
	        this.state_ = _extends({}, oldState, state);
	
	        return this;
	    },
	    url: function url() {
	        return '';
	    },
	    navigated: function navigated() {
	        return this.trigger('url:navigate', this.url(), this.state());
	    }
	}, {
	
	    BACK: 'module-common--back'
	
	});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _capability = __webpack_require__(171);
	
	var _capability2 = _interopRequireDefault(_capability);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	    endpoint: 'tasks/capabilities?apiVersion=2.0',
	    responseAt: 'items',
	    model: _capability2.default,
	
	    parseResponse: function parseResponse(attrList /*, response*/) {
	        return attrList.sort(function (a, b) {
	            return a.label < b.label ? -1 : b.label < a.label ? 1 : a.id - b.id;
	        });
	    }
	});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _rule = __webpack_require__(173);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	    endpoint: 'tasks/rules/all?apiVersion=2.0',
	    responseAt: 'items',
	    model: _rule2.default,
	
	    initialize: function initialize(items, options) {
	        _collection2.default.prototype.initialize.call(this, items, options);
	
	        if (options.capabilities) this.options.capabilities = (0, _arrays.hashify)(options.capabilities.toJSON(), function (capability) {
	            return [capability.id, capability];
	        });
	
	        if (options.roles) this.options.roles = (0, _arrays.hashify)(options.roles.toJSON(), function (role) {
	            return [role.id, role];
	        });
	
	        if (options.states) this.options.states = (0, _arrays.hashify)(options.states.toJSON(), function (state) {
	            return [state.id, state];
	        });
	    },
	    parseResponse: function parseResponse(attrsList /*, response*/) {
	        var _this = this;
	
	        return attrsList.map(function (attrs) {
	            var capability_id = attrs.capability_id,
	                role_id = attrs.role_id,
	                states = attrs.states;
	
	            var capability = void 0,
	                role = void 0;
	
	            if (_this.options.capabilities) capability = _this.options.capabilities[capability_id];
	
	            if (_this.options.roles) role = _this.options.roles[role_id];
	
	            if (_this.options.states) states = (states || []).map(function (id) {
	                return _this.options.states[id];
	            });
	
	            return _extends({}, attrs, {
	                capability: capability,
	                role: role,
	                states: states
	            });
	        });
	    }
	});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ownershipNames = ['assigned', 'not_assigned', 'belongs_to_me', 'assigned_me', 'belongs_to_my_department', 'assigned_my_department', 'people_department', 'not_people_department', 'user_from_people_dep', 'user_not_from_people_dep'];
	var stageNames = ['is_new', 'not_is_new', 'confirmed', 'not_confirmed'];
	
	exports.default = _model2.default.extend({
	
	        computeds: {
	
	                ownership: {
	
	                        deps: ['states'],
	
	                        get: function get() {
	                                var dict = (0, _arrays.hashify)(this.get('states').map(function (state) {
	                                        return state.name;
	                                }));
	
	                                var props = ownershipNames.filter(function (name) {
	                                        return dict[name];
	                                });
	                                return props.length > 1 ? props.join(', ') : props[0] || '';
	                        }
	                },
	
	                stage: {
	
	                        deps: ['states'],
	
	                        get: function get() {
	                                var dict = (0, _arrays.hashify)(this.get('states').map(function (state) {
	                                        return state.name;
	                                }));
	
	                                var props = stageNames.filter(function (name) {
	                                        return dict[name];
	                                });
	                                return props.length > 1 ? props.join(', ') : props[0] || '';
	                        }
	                },
	
	                status: {
	
	                        deps: ['states'],
	
	                        get: function get() {
	                                var dict = (0, _arrays.hashify)(this.get('states').filter(function (state) {
	                                        return state.field === 'assigned_status_id';
	                                }), function (state) {
	                                        return [state.name, state];
	                                });
	
	                                var props = Object.keys(dict);
	                                return props.length > 1 ? 'INVALID' : dict[props[0]] || '';
	                        }
	                },
	
	                is_template: {
	
	                        deps: ['states'],
	
	                        get: function get() {
	                                var props = this.get('states').filter(function (state) {
	                                        return state.field === 'is_template';
	                                });
	
	                                return props.length > 1 ? '' : props.length ? 't' === props[0].value || 'true' === props[0].value || true === props[0].value : '';
	                        }
	                },
	
	                others: {
	
	                        deps: ['states'],
	
	                        get: function get() {
	                                var dict = (0, _arrays.hashify)([].concat(ownershipNames, stageNames));
	                                return this.get('states').filter(function (state) {
	                                        return state.field != 'assigned_status_id';
	                                }).filter(function (state) {
	                                        return state.field != 'restricted';
	                                }).filter(function (state) {
	                                        return state.field != 'is_template';
	                                }).map(function (state) {
	                                        return state.name;
	                                }).filter(function (name) {
	                                        return !dict[name];
	                                });
	                        }
	                }
	
	        }
	
	});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _configPossible = __webpack_require__(175);
	
	var _configPossible2 = _interopRequireDefault(_configPossible);
	
	var _config = __webpack_require__(176);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _popups = __webpack_require__(62);
	
	var _api = __webpack_require__(77);
	
	var _promisify = __webpack_require__(19);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _module2.default.extend((_Module$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _module2.default.prototype.initialize.call(this, options);
	
	        this.state_ = {
	            breadcrumbs: [],
	            terminalPropertyName: undefined,
	            // todo: don't allow just close edit form
	            editingPossibleValue: undefined,
	            creatingPossibleValue: undefined,
	            createIntermediatePropertyAttrs: undefined,
	            createTerminalPropertyAttrs: undefined,
	            editIntermediatePropertyAttrs: undefined,
	            editTerminalPropertyAttrs: undefined,
	            createSectionAttrs: undefined,
	            editSectionAttrs: undefined
	        };
	    },
	
	
	    template: 'jst/module.configuration',
	
	    open: function open() {
	        var _this = this;
	
	        return (0, _api.get)('/configuration/root?apiVersion=1.4').cerebellum().blocking().map(function (response) {
	            return response.root_property;
	        }).execute().then(function (configRoot) {
	            return _this.configRoot_ = configRoot;
	        }).then(function () {
	            return console.log('before render', _this.configRoot_);
	        }).then(function () {
	            return _this.render();
	        });
	    },
	    serialize: function serialize() {
	        var _state_ = this.state_,
	            breadcrumbs = _state_.breadcrumbs,
	            terminalPropertyName = _state_.terminalPropertyName,
	            editingPossibleValue = _state_.editingPossibleValue,
	            creatingPossibleValue = _state_.creatingPossibleValue,
	            createIntermediatePropertyAttrs = _state_.createIntermediatePropertyAttrs,
	            createTerminalPropertyAttrs = _state_.createTerminalPropertyAttrs,
	            editIntermediatePropertyAttrs = _state_.editIntermediatePropertyAttrs,
	            editTerminalPropertyAttrs = _state_.editTerminalPropertyAttrs,
	            createSectionAttrs = _state_.createSectionAttrs,
	            editSectionAttrs = _state_.editSectionAttrs;
	        var roles = this.options.roles;
	
	
	        var currentProperty = this.getCurrentIntermediateProperty();
	        var poppedBreadcrumbs = [].concat(_toConsumableArray(breadcrumbs || []));
	        poppedBreadcrumbs.pop();
	        var parentProperty = this.getCurrentIntermediateProperty(poppedBreadcrumbs) || this.configRoot_;
	        var terminalProperty = this.getCurrentTerminalProperty();
	
	        var _breadcrumbs = _slicedToArray(breadcrumbs, 1),
	            activeSection = _breadcrumbs[0];
	
	        var possibleValueModel = editingPossibleValue ? new _configPossible2.default(editingPossibleValue) : undefined;
	
	        var createPossibleValueModel = creatingPossibleValue ? new _configPossible2.default(creatingPossibleValue) : undefined;
	
	        var createIntermediatePropertyModel = createIntermediatePropertyAttrs ? new _config2.default(createIntermediatePropertyAttrs) : undefined;
	
	        var editIntermediatePropertyModel = editIntermediatePropertyAttrs ? new _config2.default(editIntermediatePropertyAttrs) : undefined;
	
	        var editTerminalPropertyModel = editTerminalPropertyAttrs ? new _config2.default(editTerminalPropertyAttrs) : undefined;
	
	        var createTerminalPropertyModel = createTerminalPropertyAttrs ? new _config2.default(createTerminalPropertyAttrs) : undefined;
	
	        var createSectionModel = createSectionAttrs ? new _config2.default(createSectionAttrs) : undefined;
	
	        var editSectionModel = editSectionAttrs ? new _config2.default(editSectionAttrs) : undefined;
	
	        console.log('before sections = [...]');
	
	        var sections = [].concat(_toConsumableArray(this.configRoot_.children));
	
	        console.log('serialize done');
	
	        return {
	            breadcrumbs: breadcrumbs,
	            currentProperty: currentProperty,
	            parentProperty: parentProperty,
	            terminalProperty: terminalProperty,
	            possibleValueModel: possibleValueModel,
	            createPossibleValueModel: createPossibleValueModel,
	            createIntermediatePropertyModel: createIntermediatePropertyModel,
	            createTerminalPropertyModel: createTerminalPropertyModel,
	            editIntermediatePropertyModel: editIntermediatePropertyModel,
	            editTerminalPropertyModel: editTerminalPropertyModel,
	            createSectionModel: createSectionModel,
	            editSectionModel: editSectionModel,
	            activeSection: activeSection,
	            sections: sections,
	            roles: roles,
	            isTopProperty: this.configRoot_.children.indexOf(currentProperty) !== -1
	        };
	    },
	    url: function url() {
	        return 'configuration';
	    },
	    getCurrentIntermediateProperty: function getCurrentIntermediateProperty(breadcrumbs) {
	        if (!breadcrumbs) breadcrumbs = this.state_.breadcrumbs;
	        if (!breadcrumbs || !breadcrumbs.length) return null;
	
	        return breadcrumbs.reduce(function (currentProperty, crumbItem) {
	            var children = currentProperty.children;
	
	            var nextProperties = children.filter(function (property) {
	                return property.name === crumbItem.name;
	            });
	
	            var _nextProperties$filte = nextProperties.filter(function (property) {
	                return property.array_index == crumbItem.array_index;
	            }),
	                _nextProperties$filte2 = _slicedToArray(_nextProperties$filte, 1),
	                nextProperty = _nextProperties$filte2[0];
	
	            return nextProperty;
	        }, this.configRoot_);
	    },
	    getCurrentTerminalProperty: function getCurrentTerminalProperty() {
	        var terminalPropertyName = this.state_.terminalPropertyName;
	
	        if (!terminalPropertyName) return undefined;
	
	        var _getCurrentIntermedia = this.getCurrentIntermediateProperty().children.filter(function (childProperty) {
	            return childProperty.name === terminalPropertyName;
	        }),
	            _getCurrentIntermedia2 = _slicedToArray(_getCurrentIntermedia, 1),
	            terminalProperty = _getCurrentIntermedia2[0];
	
	        return terminalProperty;
	    }
	}, _defineProperty(_Module$extend, _module2.default.event('Sections:section:choose'), function (_ref) {
	    var id = _ref.id,
	        name = _ref.name,
	        label = _ref.label,
	        array_index = _ref.array_index;
	    var breadcrumbs = this.state_.breadcrumbs;
	
	
	    this.setState({
	        breadcrumbs: [{ id: id, name: name, label: label, array_index: array_index }],
	        terminalPropertyName: undefined,
	        editingPossibleValue: undefined,
	        createIntermediatePropertyAttrs: undefined,
	        createTerminalPropertyAttrs: undefined,
	        createSectionAttrs: undefined,
	        editSectionAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Sections:section:add-start'), function () {
	    var _this2 = this;
	
	    this.setState({
	        createSectionAttrs: {
	            is_terminal: false
	        },
	        editSectionAttrs: undefined
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this2.SectionForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Sections:section:edit-start'), function (sectionAttrs) {
	    var _this3 = this;
	
	    this.setState({
	        createSectionAttrs: undefined,
	        editSectionAttrs: _extends({}, sectionAttrs)
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this3.SectionForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('SectionForm:intermediate-property:add-edit-cancel'), function () {
	    this.setState({
	        createSectionAttrs: undefined,
	        editSectionAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('SectionForm:intermediate-property:add-edit-save'), function (sectionAttrs) {
	    var _this4 = this;
	
	    var propertyAttrsToSave = void 0;
	    if (sectionAttrs.id) {
	        // edit mode
	        propertyAttrsToSave = _extends({}, sectionAttrs);
	    } else {
	        // add mode
	        propertyAttrsToSave = _extends({}, this.configRoot_);
	        propertyAttrsToSave.children = [].concat(_toConsumableArray(propertyAttrsToSave.children), [sectionAttrs]);
	    }
	
	    saveTerminalProperty.call(this, propertyAttrsToSave).then(function () {
	        _this4.setState({
	            createSectionAttrs: undefined,
	            editSectionAttrs: undefined
	        });
	        _this4.navigated();
	
	        _this4.render();
	    }).catch(function (message) {
	        return (0, _messages2.handle)(_this4.SectionForm, (0, _messages.error)(message));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Sections:section:remove'), function (sectionId) {
	    var _this5 = this;
	
	    (0, _popups.ask)('configuration::section - modal delete - confirmation text', 'configuration::section - modal delete - title', 'actions::yes', 'actions::no', function () {
	        var currentProperty = _extends({}, _this5.configRoot_);
	        currentProperty.children = currentProperty.children.filter(function (childProperty) {
	            return childProperty.id != sectionId;
	        });
	
	        saveTerminalProperty.call(_this5, currentProperty).then(function () {
	            _this5.setState({
	                // no edit after delete cause maybe editing item
	                // has been deleted
	                editSectionAttrs: undefined
	            });
	            _this5.navigated();
	
	            _this5.render();
	        }).catch(function (message) {
	            return (0, _messages2.handle)(_this5, (0, _messages.error)(message));
	        });
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:level-up'), function () {
	    var breadcrumbs = this.state_.breadcrumbs;
	
	    var newBreadCrumbs = [].concat(_toConsumableArray(breadcrumbs));
	    newBreadCrumbs.pop();
	
	    this.setState({
	        breadcrumbs: newBreadCrumbs,
	        terminalPropertyName: undefined,
	        editingPossibleValue: undefined,
	        createIntermediatePropertyAttrs: undefined,
	        createTerminalPropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:enter-item'), function (_ref2) {
	    var id = _ref2.id,
	        name = _ref2.name,
	        label = _ref2.label,
	        array_index = _ref2.array_index;
	    var breadcrumbs = this.state_.breadcrumbs;
	
	
	    this.setState({
	        breadcrumbs: [].concat(_toConsumableArray(breadcrumbs), [{ id: id, name: name, label: label, array_index: array_index }]),
	        terminalPropertyName: undefined,
	        editingPossibleValue: undefined,
	        createIntermediatePropertyAttrs: undefined,
	        createTerminalPropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Breadcrumb:set-page'), function (_ref3) {
	    var id = _ref3.id,
	        name = _ref3.name,
	        label = _ref3.label,
	        array_index = _ref3.array_index;
	    var breadcrumbs = this.state_.breadcrumbs;
	
	    var newBreadCrumbs = [].concat(_toConsumableArray(breadcrumbs));
	    newBreadCrumbs.pop();
	
	    this.setState({
	        breadcrumbs: [].concat(_toConsumableArray(newBreadCrumbs), [{ id: id, name: name, label: label, array_index: array_index }]),
	        terminalPropertyName: undefined,
	        editingPossibleValue: undefined,
	        createIntermediatePropertyAttrs: undefined,
	        createTerminalPropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:show-possible-values'), function (name) {
	    this.setState({
	        terminalPropertyName: name,
	        editingPossibleValue: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Values:possible-value:add-start'), function () {
	    var _this6 = this;
	
	    var terminalProperty = this.getCurrentTerminalProperty();
	    var type = terminalProperty.type;
	
	
	    this.setState({
	        creatingPossibleValue: {
	            type: type,
	            order_index: terminalProperty.possible_values.map(function (possibleValue) {
	                return possibleValue.order_index;
	            }).reduce(function (a, b) {
	                return Math.max(a, b);
	            }, 0) + 1
	        }
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this6.CreatePossibleValue.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:edit-start'), function (possibleValue) {
	    var _this7 = this;
	
	    var terminalProperty = this.getCurrentTerminalProperty();
	    var type = terminalProperty.type;
	
	
	    possibleValue = _extends({}, possibleValue, { type: type });
	    this.setState({
	        editingPossibleValue: possibleValue
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        var possibleValues = terminalProperty.possible_values,
	            sorted = [].concat(_toConsumableArray(possibleValues)).sort(function (a, b) {
	            return a.order_index - b.order_index;
	        }),
	            viewIndex = sorted.findIndex(function (item) {
	            return item.id === possibleValue.id;
	        });
	
	        if (_this7.Values[viewIndex] && _this7.Values[viewIndex].focus) _this7.Values[viewIndex].focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:add-edit-cancel'), function () {
	    this.setState({
	        editingPossibleValue: undefined,
	        creatingPossibleValue: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:edit-save'), function (possibleValueAttrs) {
	    var _this8 = this;
	
	    var terminalPropertyAttrs = _extends({}, this.getCurrentTerminalProperty());
	    terminalPropertyAttrs.possible_values = terminalPropertyAttrs.possible_values.map(function (possibleValue) {
	        if (possibleValue.id === possibleValueAttrs.id) return possibleValueAttrs;
	        // don't make { ...possibleValue } here,
	        // { ...currentTerminalProperty } is enough.
	        return possibleValue;
	    });
	
	    saveTerminalProperty.call(this, terminalPropertyAttrs).catch(function (message) {
	        var possibleValues = terminalPropertyAttrs.possible_values,
	            sorted = [].concat(_toConsumableArray(possibleValues)).sort(function (a, b) {
	            return a.order_index - b.order_index;
	        }),
	            viewIndex = sorted.findIndex(function (item) {
	            return item.id === possibleValueAttrs.id;
	        });
	
	
	        (0, _messages2.handle)(_this8.Values[viewIndex], (0, _messages.error)(message));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:add-save'), function (possibleValueAttrs) {
	    var _this9 = this;
	
	    var type = possibleValueAttrs.type;
	
	    if (type === 'BOOLEAN') if (possibleValueAttrs.value === undefined) possibleValueAttrs.value = false;
	
	    var terminalPropertyAttrs = _extends({}, this.getCurrentTerminalProperty());
	    // don't make { ...possibleValue } here,
	    // { ...currentTerminalProperty } is enough.
	    terminalPropertyAttrs.possible_values = [].concat(_toConsumableArray(terminalPropertyAttrs.possible_values), [possibleValueAttrs]);
	
	    saveTerminalProperty.call(this, terminalPropertyAttrs).catch(function (message) {
	        return (0, _messages2.handle)(_this9.CreatePossibleValue, (0, _messages.error)(message));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:remove'), function (possibleValueAttrs) {
	    var _this10 = this;
	
	    (0, _popups.ask)('configuration::possible value - modal delete - confirmation text', 'configuration::possible value - modal delete - confirmation title', 'actions::yes', 'actions::no', function () {
	        var currentProperty = _extends({}, _this10.getCurrentTerminalProperty());
	        currentProperty.possible_values = currentProperty.possible_values.filter(function (childProperty) {
	            return childProperty.id != possibleValueAttrs.id;
	        });
	
	        saveTerminalProperty.call(_this10, currentProperty).then(function () {
	            _this10.setState({
	                editingPossibleValue: undefined
	            });
	            _this10.navigated();
	
	            _this10.render();
	        }).catch(function (message) {
	            return (0, _messages2.handle)(_this10, (0, _messages.error)(message));
	        });
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:order-up'), function (possibleValueAttrs) {
	    changePossibleValueOrder.call(this, possibleValueAttrs, -1);
	}), _defineProperty(_Module$extend, _module2.default.event(':possible-value:order-down'), function (possibleValueAttrs) {
	    changePossibleValueOrder.call(this, possibleValueAttrs, 1);
	}), _defineProperty(_Module$extend, _module2.default.event('PropertyActions:intermediate-property:add-start'), function () {
	    var _this11 = this;
	
	    this.setState({
	        createIntermediatePropertyAttrs: {
	            is_terminal: false
	        }
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this11.IntermediatePropertyForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('PropertyActions:terminal-property:add-start'), function () {
	    var _this12 = this;
	
	    this.setState({
	        createTerminalPropertyAttrs: {
	            is_terminal: true
	        }
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this12.TerminalPropertyForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:intermediate-property:edit-start'), function (intermediatePropertyAttrs) {
	    var _this13 = this;
	
	    this.setState({
	        createIntermediatePropertyAttrs: undefined,
	        editIntermediatePropertyAttrs: _extends({}, intermediatePropertyAttrs),
	        editTerminalPropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this13.IntermediatePropertyForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:terminal-property:edit-start'), function (terminalPropertyAttrs) {
	    var _this14 = this;
	
	    this.setState({
	        createIntermediatePropertyAttrs: undefined,
	        editIntermediatePropertyAttrs: undefined,
	        editTerminalPropertyAttrs: _extends({}, terminalPropertyAttrs)
	    });
	    this.navigated();
	
	    this.render().then(function () {
	        return _this14.TerminalPropertyForm.focus();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('IntermediatePropertyForm:intermediate-property:add-edit-cancel'), function () {
	    this.setState({
	        createIntermediatePropertyAttrs: undefined,
	        editIntermediatePropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('TerminalPropertyForm:terminal-property:add-edit-cancel'), function () {
	    this.setState({
	        createTerminalPropertyAttrs: undefined,
	        editTerminalPropertyAttrs: undefined
	    });
	    this.navigated();
	
	    this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('IntermediatePropertyForm:intermediate-property:add-edit-save'), function (intermediatePropertyAttrs) {
	    var _this15 = this;
	
	    var currentProperty = _extends({}, this.getCurrentIntermediateProperty());
	
	    if (intermediatePropertyAttrs.id) {
	        // edit mode
	        var _currentProperty$chil = currentProperty.children.filter(function (childProperty) {
	            return childProperty.id == intermediatePropertyAttrs.id;
	        }).map(function (childProperty) {
	            return childProperty.name;
	        }),
	            _currentProperty$chil2 = _slicedToArray(_currentProperty$chil, 1),
	            nameToMatch = _currentProperty$chil2[0];
	
	        currentProperty.children = currentProperty.children.map(function (childProperty) {
	            // no match - no changes
	            if (childProperty.name !== nameToMatch) return childProperty;
	
	            // same id => full change
	            if (childProperty.id == intermediatePropertyAttrs.id) return intermediatePropertyAttrs;
	
	            // same name => change name/label only
	
	            var name = childProperty.name,
	                label = childProperty.label,
	                otherChildPropertyFields = _objectWithoutProperties(childProperty, ['name', 'label']);
	
	            return _extends({
	                name: intermediatePropertyAttrs.name,
	                label: intermediatePropertyAttrs.label
	            }, otherChildPropertyFields);
	        });
	
	        saveIntermediateProperty.call(this, currentProperty).catch(function (message) {
	            return (0, _messages2.handle)(_this15.IntermediatePropertyForm, (0, _messages.error)(message));
	        });
	    } else {
	        // add mode
	        currentProperty.children = [].concat(_toConsumableArray(currentProperty.children), [intermediatePropertyAttrs]);
	
	        saveIntermediateProperty.call(this, currentProperty).catch(function (message) {
	            return (0, _messages2.handle)(_this15.IntermediatePropertyForm, (0, _messages.error)(message));
	        });
	    }
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:append-child-to'), function (_ref4) {
	    var _this16 = this;
	
	    var name = _ref4.name,
	        label = _ref4.label;
	
	    var currentProperty = _extends({}, this.getCurrentIntermediateProperty());
	    var children = currentProperty.children;
	
	
	    var array_index = 1 + children.filter(function (childProperty) {
	        return childProperty.name == name;
	    }).map(function (childProperty) {
	        return childProperty.array_index;
	    }).reduce(function (a, b) {
	        return Math.max(a, b);
	    }, 0);
	
	    currentProperty.children = [].concat(_toConsumableArray(children), [{
	        name: name, label: label,
	        is_terminal: false,
	        children: [],
	        array_index: array_index
	    }]);
	
	    saveIntermediateProperty.call(this, currentProperty).catch(function (message) {
	        return (0, _messages2.handle)(_this16, (0, _messages.error)(message));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('TerminalPropertyForm:terminal-property:add-edit-save'), function (terminalPropertyAttrs) {
	    var _this17 = this;
	
	    if (terminalPropertyAttrs.id) {
	        // edit mode
	        saveTerminalProperty.call(this, _extends({}, terminalPropertyAttrs)).catch(function (message) {
	            return (0, _messages2.handle)(_this17.TerminalPropertyForm, (0, _messages.error)(message));
	        });
	    } else {
	        // add mode
	        var currentProperty = _extends({}, this.getCurrentIntermediateProperty());
	        // don't make { ...child } here,
	        // { ...currentIntermediateProperty } above is enough.
	        currentProperty.children = [].concat(_toConsumableArray(currentProperty.children), [terminalPropertyAttrs]);
	
	        saveIntermediateProperty.call(this, currentProperty).catch(function (message) {
	            return (0, _messages2.handle)(_this17.TerminalPropertyForm, (0, _messages.error)(message));
	        });
	    }
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:remove'), function (propertyAttrs) {
	    var _this18 = this;
	
	    var confText = propertyAttrs.is_terminal ? 'configuration::terminal property - modal delete - confirmation text' : 'configuration::intermediate property - modal delete - confirmation text';
	
	    var confTitle = propertyAttrs.is_terminal ? 'configuration::terminal property - modal delete - title' : 'configuration::intermediate property - modal delete - title';
	
	    (0, _popups.ask)(confText, confTitle, 'actions::yes', 'actions::no', function () {
	        var currentProperty = _extends({}, _this18.getCurrentIntermediateProperty());
	        currentProperty.children = currentProperty.children.filter(function (childProperty) {
	            return childProperty.name != propertyAttrs.name;
	        });
	
	        saveTerminalProperty.call(_this18, currentProperty).then(function () {
	            _this18.setState({
	                editTerminalPropertyAttrs: undefined
	            });
	            _this18.navigated();
	
	            _this18.render();
	        }).catch(function (message) {
	            return (0, _messages2.handle)(_this18, (0, _messages.error)(message));
	        });
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Properties:property:remove-sibling'), function (_ref5) {
	    var _this19 = this;
	
	    var id = _ref5.id,
	        name = _ref5.name,
	        array_index = _ref5.array_index;
	
	    (0, _popups.ask)('configuration::intermediate property - modal delete - confirmation text', 'configuration::intermediate property - modal delete - title', 'actions::yes', 'actions::no', function () {
	        var currentProperty = _extends({}, _this19.getCurrentIntermediateProperty());
	        currentProperty.children = currentProperty.children.filter(function (childProperty) {
	            return childProperty.id != id;
	        }).map(function (childProperty) {
	            if (childProperty.name === name) if (childProperty.array_index > array_index) childProperty.array_index--;
	
	            return childProperty;
	        });
	
	        saveTerminalProperty.call(_this19, currentProperty).then(function () {
	            _this19.setState({
	                editTerminalPropertyAttrs: undefined,
	                editIntermediatePropertyAttrs: undefined
	            });
	            _this19.navigated();
	
	            _this19.render();
	        }).catch(function (message) {
	            return (0, _messages2.handle)(_this19, (0, _messages.error)(message));
	        });
	    });
	}), _Module$extend));
	
	// todo unify saveTerminalProperty/saveIntermediateProperty
	
	function saveTerminalProperty(propertyAttrs) {
	    var _this20 = this;
	
	    var propertyToSave = new _config2.default(propertyAttrs);
	    return (0, _promisify.requestify)(propertyToSave.save()).then(function (_ref6) {
	        var serverBackedProperty = _ref6.property;
	
	        var _propertyById$call = propertyById.call(_this20, serverBackedProperty.id),
	            parent = _propertyById$call.parent;
	
	        if (!parent) _this20.configRoot_ = serverBackedProperty;else parent.children = parent.children.map(function (childProperty) {
	            if (childProperty.id === serverBackedProperty.id) return serverBackedProperty;
	            return childProperty;
	        });
	
	        _this20.setState({
	            creatingPossibleValue: undefined,
	            editingPossibleValue: undefined,
	            createIntermediatePropertyAttrs: undefined,
	            createTerminalPropertyAttrs: undefined,
	            editIntermediatePropertyAttrs: undefined,
	            editTerminalPropertyAttrs: undefined
	        });
	        _this20.navigated();
	
	        return _this20.render();
	    });
	}
	
	function saveIntermediateProperty(propertyAttrs) {
	    var _this21 = this;
	
	    var propertyToSave = new _config2.default(propertyAttrs);
	    return (0, _promisify.requestify)(propertyToSave.save()).then(function (_ref7) {
	        var serverBackedProperty = _ref7.property;
	
	        // merge server response into the property tree
	        var currentProperty = _this21.getCurrentIntermediateProperty();
	        Object.assign(currentProperty, serverBackedProperty);
	
	        _this21.setState({
	            creatingPossibleValue: undefined,
	            editingPossibleValue: undefined,
	            createIntermediatePropertyAttrs: undefined,
	            createTerminalPropertyAttrs: undefined,
	            editIntermediatePropertyAttrs: undefined,
	            editTerminalPropertyAttrs: undefined
	        });
	        _this21.navigated();
	
	        return _this21.render();
	    });
	}
	
	function propertyById(id) {
	    var rec = function rec(child, parent) {
	        if (child.id == id) return {
	            result: child,
	            parent: parent
	        };
	
	        if (child.is_terminal) return;
	
	        return child.children.reduce(function (found, childProperty) {
	            if (found) return found;
	            return rec(childProperty, child);
	        }, null);
	    };
	
	    return rec(this.configRoot_, null);
	}
	
	function changePossibleValueOrder(possibleValueAttrs, nextValueIndexDelta) {
	    var _this22 = this;
	
	    var currentProperty = _extends({}, this.getCurrentTerminalProperty());
	    var possible_values = currentProperty.possible_values;
	    // prepare array of values for further changes
	
	    var values = [].concat(_toConsumableArray(possible_values)).sort(function (a, b) {
	        return a.order_index - b.order_index;
	    });
	
	    // find possible value to lift up
	    var valueIndex = values.findIndex(function (value) {
	        return value.id == possibleValueAttrs.id;
	    });
	    // swap-es6-style with upper/lower value 
	
	    // set new order index
	    var _ref8 = [values[valueIndex], values[valueIndex + nextValueIndexDelta]];
	    values[valueIndex + nextValueIndexDelta] = _ref8[0];
	    values[valueIndex] = _ref8[1];
	    values.forEach(function (value, index) {
	        return value.order_index = index;
	    });
	    // and set values back
	    currentProperty.possible_values = values;
	
	    saveTerminalProperty.call(this, currentProperty).then(function () {
	        return _this22.render();
	    }).catch(function (message) {
	        return (0, _messages2.handle)(_this22, (0, _messages.error)(message));
	    });
	}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _model2.default.extend({
	    defaults: function defaults() {
	        return {
	            value: undefined,
	            access_rule: {}
	        };
	    },
	
	
	    computeds: {
	
	        role: {
	            set: function set(value) {
	                var _get = this.get('access_rule'),
	                    id = _get.id,
	                    accessRule = _objectWithoutProperties(_get, ['id']);
	
	                if (!+value) accessRule.role = null;else {
	                    accessRule.role = { id: +value };
	                    accessRule.user = null;
	                }
	
	                return { access_rule: accessRule, salt: Math.random() };
	            },
	            get: function get() {
	                var _get2 = this.get('access_rule'),
	                    role = _get2.role;
	
	                return !!role ? role.id : null;
	            }
	        },
	
	        organization_id: {
	            set: function set(value) {
	                var _get3 = this.get('access_rule'),
	                    id = _get3.id,
	                    accessRule = _objectWithoutProperties(_get3, ['id']);
	
	                if (!value) {
	                    accessRule.organization = null;
	                    accessRule.user = null;
	                } else {
	                    accessRule.organization = { id: +value };
	                    accessRule.user = null;
	                }
	
	                return { access_rule: accessRule, salt: Math.random() };
	            },
	            get: function get() {
	                var _get4 = this.get('access_rule'),
	                    organization = _get4.organization;
	
	                return !!organization ? organization.id : 0;
	            }
	        },
	
	        user_id_name: {
	            set: function set(value) {
	                var _get5 = this.get('access_rule'),
	                    id = _get5.id,
	                    accessRule = _objectWithoutProperties(_get5, ['id']);
	
	                if (!value || !value.id) accessRule.user = null;else {
	                    var _id = value.id,
	                        name = value.name;
	
	                    accessRule.user = { id: _id, fio: name };
	                    accessRule.role = null;
	                }
	
	                return { access_rule: accessRule, salt: Math.random() };
	            },
	            get: function get() {
	                var _get6 = this.get('access_rule'),
	                    user = _get6.user;
	
	                if (!user) return null;
	                var id = user.id,
	                    _user$fio = user.fio,
	                    fio = _user$fio === undefined ? '' : _user$fio;
	
	                return { id: id, name: fio };
	            }
	        },
	
	        states: {
	            set: function set(value) {
	                var _get7 = this.get('access_rule'),
	                    id = _get7.id,
	                    accessRule = _objectWithoutProperties(_get7, ['id']);
	
	                if (!value) accessRule.state_rule = null;else accessRule.state_rule = { states: value };
	
	                return { access_rule: _extends({}, accessRule), salt: Math.random() };
	            },
	            get: function get() {
	                var _get8 = this.get('access_rule'),
	                    state_rule = _get8.state_rule;
	
	                return !!state_rule ? state_rule.states || [] : [];
	            }
	        }
	
	    }
	
	});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _model2.default.extend({
	    defaults: function defaults() {
	        return {
	            id: undefined,
	            name: undefined,
	            label: undefined,
	            array_index: 0,
	            children: [],
	            possible_values: [],
	            type: undefined
	        };
	    },
	
	
	    endpoint: 'configuration/properties?apiVersion=1.4'
	});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _contract = __webpack_require__(21);
	
	var _contract2 = _interopRequireDefault(_contract);
	
	var _pick = __webpack_require__(116);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _messages = __webpack_require__(68);
	
	var _messages2 = __webpack_require__(69);
	
	var _popups = __webpack_require__(62);
	
	var _arrays = __webpack_require__(24);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _module2.default.extend({
	
	    template: 'module/tasks/contracts.form',
	
	    url: function url() {
	        return this.model.id ? 'contracts/' + this.model.id : 'contracts/new';
	    },
	    open: function open(model) {
	        return this.bind(model);
	    },
	    start: function start() {
	        var _this = this;
	
	        this.listenTo(this.model, 'change', function () {
	            return _this.Buttons.render();
	        });
	    },
	    stop: function stop() {
	        this.stopListening(this.model);
	    },
	    diff: function diff() {
	        var _this2 = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var diff = this.model.diff(this.originalModel, options);
	        if (diff.length > 0) return diff;
	
	        var hasDiff = this.model.get('groups').some(function (group, index) {
	            var other = _this2.originalModel.get('groups')[index];
	            var groupObjects = group.objects.map(function (_ref) {
	                var object_id = _ref.object_id,
	                    attrs = _objectWithoutProperties(_ref, ['object_id']);
	
	                return _extends({ id: object_id }, attrs);
	            });
	            var otherObjects = other.objects.map(function (_ref2) {
	                var object_id = _ref2.object_id,
	                    attrs = _objectWithoutProperties(_ref2, ['object_id']);
	
	                return _extends({ id: object_id }, attrs);
	            });
	
	            return !(0, _arrays.eq)(groupObjects, otherObjects) || !(0, _arrays.eq)(group.types, other.types);
	        });
	
	        if (hasDiff) return [{
	            attrName: 'groups',
	            oldValue: this.originalModel.get('groups'),
	            newValue: this.model.get('groups')
	        }];
	
	        return [];
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            datatables = _options.datatables,
	            organizations = _options.organizations;
	
	
	        return {
	            datatables: datatables, organizations: organizations,
	            groups: this.model.get('groups')
	        };
	    },
	
	
	    events: {
	        'click .-edit-objects': function clickEditObjects(_ref3) {
	            var _this3 = this;
	
	            var currentTarget = _ref3.currentTarget;
	
	            var $group = this.$(currentTarget).closest('.contract-group');
	            var groupIndex = +$group.attr('name');
	            var group = this.model.get('groups')[groupIndex];
	            pickObjects(group, this.options.datatables).then(function () {
	                return _this3[groupIndex].render(), _this3.Buttons.render();
	            }); // todo focus?
	        },
	        'click .-edit-types': function clickEditTypes(_ref4) {
	            var _this4 = this;
	
	            var currentTarget = _ref4.currentTarget;
	
	            var clusters = (0, _arrays.hashify)(this.options.clusters, function (cluster) {
	                return [cluster.id, cluster];
	            });
	            var orgs = (0, _arrays.hashify)(this.options.organizations, function (org) {
	                return [org.id, org];
	            });
	            var org = this.model.get('assigned_organization') || this.model.get('customer');
	
	            var $group = this.$(currentTarget).closest('.contract-group');
	            var groupIndex = +$group.attr('name');
	            var group = this.model.get('groups')[groupIndex];
	
	            (0, _popups.pick)(group.types, { collection: this.options.types,
	                clusters: this.options.clusters,
	                cluster: org && clusters[orgs[org.id].cluster_id],
	                idOnly: false, fullCollection: true })
	            // skip earlier deleted types
	            .then(function (newTypes) {
	                return newTypes.filter(function (t) {
	                    return !!t;
	                });
	            }).then(function (newTypes) {
	                return group.types = newTypes;
	            }).then(function () {
	                return _this4[groupIndex].render(), _this4.Buttons.render();
	            }); // todo focus?
	        },
	        'click .-add-group': function clickAddGroup() {
	            var groups = this.model.get('groups');
	            this.model.set('groups', [].concat(_toConsumableArray(groups), [{
	                objects: [],
	                types: []
	            }]));
	
	            return this.render();
	        },
	        'click .-remove-group': function clickRemoveGroup(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	
	            var $group = this.$(currentTarget).closest('.contract-group');
	            var groupIndex = +$group.attr('name');
	
	            var groups = this.model.get('groups').filter(function (group, index) {
	                return index != groupIndex;
	            });
	            this.model.set('groups', groups);
	
	            return this.render();
	        },
	        'click .-close': function clickClose() {
	            this.trigger(_module2.default.BACK);
	        },
	        'click .-save': function clickSave() {
	            var _this5 = this;
	
	            var _model$toJSON = this.model.toJSON(),
	                groups = _model$toJSON.groups,
	                types = _model$toJSON.types,
	                otherAttrs = _objectWithoutProperties(_model$toJSON, ['groups', 'types']);
	
	            var oldGroups = (0, _arrays.hashify)(this.originalModel.get('groups'), function (g) {
	                return [g.id, g];
	            });
	            var newGroupIds = (0, _arrays.hashify)(this.model.get('groups').map(function (g) {
	                return g.id;
	            }).filter(function (id) {
	                return id;
	            }));
	            var groups_add = this.model.get('groups').filter(function (g) {
	                return !g.id;
	            }).map(function (_ref6) {
	                var types = _ref6.types,
	                    objects = _ref6.objects,
	                    otherAttrs = _objectWithoutProperties(_ref6, ['types', 'objects']);
	
	                return _extends({
	                    types_add: types,
	                    objects_add: objects
	                }, otherAttrs);
	            });
	            var groups_remove = this.originalModel.get('groups').filter(function (g) {
	                return !newGroupIds[g.id];
	            });
	            // todo groups_remove
	            var groups_edit = this.model.get('groups').filter(function (g) {
	                return g.id;
	            }).map(function (_ref7) {
	                var id = _ref7.id,
	                    types = _ref7.types,
	                    objects = _ref7.objects,
	                    attrs = _objectWithoutProperties(_ref7, ['id', 'types', 'objects']);
	
	                var oldGroup = oldGroups[id];
	
	                var oldTypeIds = (0, _arrays.hashify)(oldGroup.types, function (type) {
	                    return [type.id, true];
	                });
	                var newTypeIds = (0, _arrays.hashify)(types, function (type) {
	                    return [type.id, true];
	                });
	
	                var types_add = types.filter(function (type) {
	                    return !oldTypeIds[type.id];
	                });
	                var types_remove = oldGroup.types.filter(function (type) {
	                    return !newTypeIds[type.id];
	                });
	
	                var oldObjectIds = (0, _arrays.hashify)(oldGroup.objects, function (object) {
	                    return [object.layer_id + '/' + object.object_id, true];
	                });
	                var newObjectIds = (0, _arrays.hashify)(objects, function (object) {
	                    return [object.layer_id + '/' + object.object_id, true];
	                });
	
	                var objects_add = objects.filter(function (object) {
	                    return !oldObjectIds[object.layer_id + '/' + object.object_id];
	                });
	                var objects_remove = oldGroup.objects.filter(function (object) {
	                    return !newObjectIds[object.layer_id + '/' + object.object_id];
	                });
	
	                return _extends({
	                    id: id,
	                    types_add: types_add, types_remove: types_remove,
	                    objects_add: objects_add, objects_remove: objects_remove
	                }, attrs);
	            });
	
	            var json = _extends({
	                groups_add: groups_add,
	                groups_edit: groups_edit,
	                groups_remove: groups_remove
	            }, otherAttrs);
	
	            var onResolve = function onResolve(savedModel) {
	                _this5.options.contracts.add(savedModel, { merge: true });
	                _this5.trigger(_module2.default.BACK);
	            };
	
	            var onReject = function onReject(message) {
	                (0, _loader.endLock)(_this5);
	                (0, _messages.handle)(_this5.Fields, (0, _messages2.error)(message));
	            };
	
	            (0, _loader.beginLock)(this);
	            return new _contract2.default({ id: this.model.id }).patch(json).then(function (response) {
	                return new _contract2.default(response);
	            }).then(onResolve, onReject);
	        }
	    }
	
	}, {
	
	    OPEN: 'open-contract'
	
	});
	
	
	function pickObjects(group, datatables) {
	    var view = _pick2.default.of({
	        datatables: new _collection2.default(datatables.toJSON().filter(function (layer) {
	            return layer.access.serviceObjects;
	        }))
	    });
	
	    var binding = view.bind({ selected: group.objects });
	
	    return (0, _popups.ask)(binding, 'popups::pick - title', 'actions::apply', 'actions::cancel', { large: true }).then(function () {
	        return view.model.get('selected');
	    }).then(function (objects) {
	        return group.objects = objects;
	    });
	}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _contract = __webpack_require__(21);
	
	var _contract2 = _interopRequireDefault(_contract);
	
	var _contracts = __webpack_require__(177);
	
	var _contracts2 = _interopRequireDefault(_contracts);
	
	var _contracts3 = __webpack_require__(10);
	
	var _contracts4 = _interopRequireDefault(_contracts3);
	
	var _list = __webpack_require__(179);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _roles = __webpack_require__(117);
	
	var _actions = __webpack_require__(17);
	
	var _popups = __webpack_require__(62);
	
	var _sort = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'module/tasks/contracts.list',
	
	    url: function url() {
	        return 'contracts/list';
	    },
	    open: function open() {
	        var _this = this;
	
	        var _ref = this.state() || {},
	            _ref$page = _ref.page,
	            page = _ref$page === undefined ? 1 : _ref$page,
	            _ref$limit = _ref.limit,
	            limit = _ref$limit === undefined ? 10 : _ref$limit,
	            _ref$sort = _ref.sort,
	            sort = _ref$sort === undefined ? 'title' : _ref$sort,
	            _ref$direction = _ref.direction,
	            direction = _ref$direction === undefined ? 'asc' : _ref$direction,
	            activeId = _ref.activeId,
	            _ref$filters = _ref.filters,
	            filters = _ref$filters === undefined ? {} : _ref$filters;
	
	        this.setState({ page: page, limit: limit, sort: sort, direction: direction, activeId: activeId, filters: filters });
	
	        var contracts = this.options.contracts;
	
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            // todo cluster admin
	            create: (0, _actions.restrict)(_roles.roleAC,
	            // saved model will be inserted into 
	            // this.options.contracts (which is global)
	            function () {
	                return _this.trigger(_contracts2.default.OPEN, new _contract2.default());
	            }),
	
	            // todo cluster admin
	            edit: (0, _actions.restrict)(_roles.roleAC,
	            // saved model will be merged into 
	            // this.options.contracts (which is global)
	            function (current) {
	                return _this.trigger(_contracts2.default.OPEN, current.clone());
	            }),
	
	            // todo cluster admin
	            destroy: (0, _actions.restrict)(_roles.roleAC, function (current) {
	                return (0, _popups.ask)('contract::label - confirm delete', 'contract::label - delete', 'actions::yes', 'actions::no', function () {
	                    return contracts.destroy(current);
	                }).then(function () {
	                    return contracts.remove(current);
	                }).then(function () {
	                    return _this.options.sorted.remove(current);
	                }).then(function () {
	                    var _state = _this.state(),
	                        page = _state.page,
	                        limit = _state.limit;
	
	                    if (contracts.length < (page - 1) * limit + 1) if (contracts.length) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.sorted = new _contracts4.default();
	        this.options.filtered = new _contracts4.default([], { actions: actions });
	
	        var _state$filters = this.state().filters,
	            _state$filters$title = _state$filters.title,
	            title = _state$filters$title === undefined ? '' : _state$filters$title,
	            _state$filters$cluste = _state$filters.cluster,
	            cluster = _state$filters$cluste === undefined ? null : _state$filters$cluste,
	            _state$filters$custom = _state$filters.customer,
	            customer = _state$filters$custom === undefined ? null : _state$filters$custom,
	            _state$filters$assign = _state$filters.assignedOrganization,
	            assignedOrganization = _state$filters$assign === undefined ? null : _state$filters$assign;
	
	
	        return sortFn(this.state(), this.options.contracts, this.options.sorted).then(function () {
	            return _this.bind(new FilterModel({
	                title: title,
	                cluster: cluster,
	                customer: customer,
	                assignedOrganization: assignedOrganization
	            }));
	        });
	    },
	    start: function start() {
	        var _this2 = this;
	
	        var filtered = this.options.filtered;
	
	        filtered.plugActionSource(this.Grid);
	
	        this.listenTo(filtered, 'activate deactivate', function () {
	            var current = filtered.current();
	            var activeId = current ? current.id : undefined;
	            _this2.setState({ activeId: activeId });
	            _this2.navigated();
	        });
	
	        var fn = function fn() {
	            return onFilter.call(_this2, _this2.model.toJSON());
	        };
	        this.listenTo(this.model, 'change:cluster change:customer change:assignedOrganization', _underscore2.default.debounce(fn, 300));
	        this.listenTo(this.model, 'change:title', _underscore2.default.debounce(fn, 300));
	
	        return this.Grid.focus(), this;
	    },
	    stop: function stop() {
	        var filtered = this.options.filtered;
	
	
	        filtered.unplugActionSource(this.Grid);
	        this.Grid.ungrab(filtered);
	        this.stopListening(filtered);
	
	        this.stopListening(this.model);
	
	        return this;
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            clusters = _options.clusters,
	            organizations = _options.organizations;
	        var filtered = this.options.filtered;
	
	        var _state2 = this.state(),
	            sort = _state2.sort,
	            direction = _state2.direction;
	
	        this.reFilterGrid();
	
	        return {
	            clusters: clusters, organizations: organizations,
	            actionList: filtered.actions,
	            collection: filtered,
	            direction: direction, sort: sort
	        };
	    },
	    reFilterGrid: function reFilterGrid() {
	        var _options2 = this.options,
	            sorted = _options2.sorted,
	            filtered = _options2.filtered;
	
	        var _state3 = this.state(),
	            activeId = _state3.activeId,
	            _state3$filters = _state3.filters,
	            filters = _state3$filters === undefined ? {} : _state3$filters;
	
	        var title = filters.title,
	            cluster = filters.cluster,
	            customer = filters.customer,
	            assignedOrganization = filters.assignedOrganization;
	
	
	        _grid2.default.filter(_extends({ search: title }, this.state()), cluster, sorted, new _collection2.default(), filtered, function (model) {
	            var byCustomer = !customer || model.get('customer') && model.get('customer').id == customer.id;
	            var byAssignee = !assignedOrganization || model.get('assigned_organization') && model.get('assigned_organization').id == assignedOrganization.id;
	            return byCustomer && byAssignee;
	        });
	
	        console.log(filtered.models);
	
	        var activeIndex = filtered.findIndex(function (model) {
	            return +model.id === +activeId;
	        });
	        if (activeIndex > -1) filtered.activate(activeIndex);else filtered.restoreActive();
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref2) {
	            var _this3 = this;
	
	            var currentTarget = _ref2.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                direction = _currentTarget$datase.direction,
	                sortField = _currentTarget$datase.sort;
	            var _options3 = this.options,
	                contracts = _options3.contracts,
	                sorted = _options3.sorted;
	
	
	            return this.setState({ page: 1, direction: direction, sort: sortField }), sortFn(this.state(), contracts, sorted).then(function () {
	                return _this3.render();
	            }).then(function () {
	                return _this3.navigated();
	            });
	        },
	        'click .-clear-filters': function clickClearFilters() {
	            this.model.clear({ silent: true });
	            this.model.set(_extends({}, defaultFilters));
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this4 = this;
	
	    return this.setState({ page: +page }), this.reFilterGrid(), Promise.all([this.Grid.render(), this.Paging.render()]).then(function () {
	        return _this4.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('nav:map'), function () {
	    this.trigger(_list2.default.OPEN_MAP, this.state().tasksFiltersState);
	}), _defineProperty(_Module$extend, _module2.default.event('nav:list'), function () {
	    this.trigger(_list2.default.OPEN_LIST, this.state().tasksFiltersState);
	}), _Module$extend));
	
	
	var defaultFilters = {
	    title: '',
	    cluster: null,
	    customer: null,
	    assignedOrganization: null
	};
	
	var FilterModel = _model2.default.extend({
	    computeds: {
	
	        changed: {
	            deps: ['title', 'cluster', 'customer', 'assignedOrganization'],
	            get: function get() {
	                return !!this.diff(new _model2.default(defaultFilters)).length;
	            }
	        }
	
	    }
	});
	
	function onFilter(jsonAttrs) {
	    var _this5 = this;
	
	    return this.setState({ page: 1, filters: jsonAttrs }), this.reFilterGrid(), Promise.all([this.Grid.render(), this.Paging.render()]).then(function () {
	        return _this5.navigated();
	    }); // todo focus
	}
	
	function sortFn(_ref3, source, dest) {
	    var sortField = _ref3.sort,
	        direction = _ref3.direction;
	
	    var sortById = function sortById(model) {
	        return +model.id;
	    };
	    if (sortField === 'id') sortField = sortById;
	
	    var sorting = 'asc' === direction ? (0, _sort.asc)(source.models, [sortField, sortById]) : (0, _sort.desc)(source.models, [sortField, sortById]);
	
	    return sorting.then(function (sortedModels) {
	        return dest.reset(sortedModels);
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _comments = __webpack_require__(78);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _tasks = __webpack_require__(133);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _tasks3 = __webpack_require__(138);
	
	var _tasks4 = _interopRequireDefault(_tasks3);
	
	var _task = __webpack_require__(137);
	
	var _live = __webpack_require__(16);
	
	var _comments3 = __webpack_require__(76);
	
	var _popups = __webpack_require__(62);
	
	var _api = __webpack_require__(77);
	
	var _promisify = __webpack_require__(19);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OPEN_TASK = 'tasks-form-open',
	    OPEN_LIST = 'tasks-list-open',
	    OPEN_MAP = 'tasks-map-open',
	    OPEN_CONTRACTS = 'contracts-list-open';
	
	exports.default = _module2.default.extend((_Module$extend = {
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _module2.default.prototype.initialize.call(this, options);
	
	        var opts = function opts() {
	            var layers = options.layers,
	                datatables = options.datatables,
	                clusters = options.clusters,
	                types = options.types,
	                organizations = options.organizations,
	                contracts = options.contracts,
	                statuses = options.statuses,
	                priorities = options.priorities,
	                fields = options.fields,
	                roles = options.roles,
	                serviceObjectMappings = options.serviceObjectMappings,
	                locationService = options.locationService;
	
	
	            return {
	                layers: layers, datatables: datatables, clusters: clusters,
	                locationService: locationService,
	                types: types, organizations: organizations, contracts: contracts,
	                statuses: statuses, priorities: priorities,
	                fields: fields,
	                roles: roles,
	                serviceObjectMappings: serviceObjectMappings
	            };
	        };
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            multitask: function multitask() {
	                return (0, _promisify.promisify)((0, _task.newTask)(new _task.TaskNew(opts()), opts().priorities)).then(function () {
	                    return (0, _loader.beginLock)(_this);
	                }).then(function () {
	                    return issues.fetch();
	                }).then(function () {
	                    return (0, _loader.endLock)(_this);
	                });
	            },
	
	            edit: function edit(current) {
	                return _this.trigger(OPEN_TASK, current);
	            },
	
	            destroy: {
	
	                disabled: function disabled(current) {
	                    return !current || !current.capabilities_.delete;
	                },
	
	                handler: function handler(current) {
	                    return (0, _popups.ask)('issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no', function () {
	                        return (0, _api.del)('/tasks/' + current.id).blocking(_this).cerebellum().execute();
	                    }).then(function () {
	                        // deleting last task on the page?
	                        if (issues.total == (_this.state().page - 1) * 7 + 1)
	                            // triggering page will force page change + reload + hash change
	                            _this.trigger('Paging:page', _this.state().page - 1);else (0, _loader.beginLock)(_this), issues.fetch().finally(function () {
	                            return (0, _loader.endLock)(_this);
	                        });
	                    });
	                }
	            }
	
	        };
	
	        var issues = this.options.issues = new _tasks2.default([], { actions: actions });
	
	        this.setState({
	            filters: _tasks4.default.defaultFilters()
	        });
	
	        this.commentsChannel = _comments2.default.filter(function (message) {
	            return message instanceof _live.Insert;
	        }).forEach(function (message) {
	            return _this.trigger('comments:income', message.model);
	        }); // model === attrs of Model
	    },
	
	
	    template: 'jst/module.tasks.list',
	
	    url: function url() {
	        return 'tasks';
	    },
	    open: function open() {
	        var _this2 = this;
	
	        var issues = this.options.issues;
	
	
	        var httpFilters = _tasks2.default.getHttpFilters(this.state());
	
	        var _state = this.state(),
	            page = _state.page,
	            filters = _state.filters,
	            activeId = _state.activeId;
	
	        return (0, _promisify.promisify)(issues.filter(httpFilters, page, activeId)).then(function () {
	            return _this2.render();
	        }).then(function () {
	            var filter = _this2.Filter.bind(new _tasks4.default.Model(filters));
	            var current = issues.current();
	            if (!current) return filter;
	
	            return _this2.setState({ activeId: current.id }), Promise.all([filter, _this2.Map.bind(current)]);
	        }).then(function () {
	            return _this2;
	        });
	    },
	    start: function start() {
	        var _this3 = this;
	
	        var issues = this.options.issues;
	
	        var lastFiltering = Promise.resolve();
	
	        issues.plugActionSource(this.Grid);
	
	        // this.listenTo( this.Search, 'search', queryString => 
	        //     lastFiltering = lastFiltering
	        //         .then( () => {
	        //             this.setState( { queryString, } );
	        //             this.navigated();
	        //             return issues.filter( getHttpFilters( this.state() ) );
	        //         } )
	        //         .catch( () => undefined ) );
	
	        if (issues.current()) this.Comments.bind(issues.current());
	
	        this.Map.listenTo(issues, 'activate deactivate', function () {
	            var current = issues.current();
	            var activeId = current ? current.id : undefined;
	            if (_this3.state().activeId == activeId) return;
	
	            _this3.setState({ activeId: activeId });
	            _this3.navigated();
	
	            if (current && !current.comments_) (0, _comments3.fetch)(current.id).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    json = _ref2[0],
	                    coll = _ref2[1];
	
	                return current.trigger('comments:load', current.comments_ = json);
	            });
	
	            _this3.Map.bind(issues.current());
	            _this3.Comments.bind(issues.current());
	        });
	
	        this.listenTo(this, 'comments:income', function (comment) {
	            return handleIncomingComment.call(_this3, comment);
	        });
	
	        this.Filter.focus();
	    },
	    stop: function stop() {
	        var issues = this.options.issues;
	
	
	        issues.unplugActionSource(this.Grid);
	        this.Grid.ungrab(issues);
	        this.Paging.ungrab(issues);
	
	        this.stopListening(this.Paging);
	        this.stopListening(this.Filter);
	        this.stopListening(this, 'comments:income');
	
	        this.Map.stopListening(issues);
	
	        return this;
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            issues = _options.issues,
	            locationService = _options.locationService;
	
	
	        return {
	            queryString: this.state().queryString || '',
	            actionList: issues.actions,
	            collection: issues,
	            locationService: locationService
	        };
	    },
	
	
	    events: {
	        'keyup [name=title]': function keyupNameTitle(e) {
	            if (13 == e.keyCode) this.Grid.trigger('action:default'), e.preventDefault();
	        },
	        'keydown [name=title]': function keydownNameTitle(e) {
	            switch (e.keyCode) {
	                case 38:
	                    this.options.issues.prevRow();
	                    break;
	                case 40:
	                    this.options.issues.nextRow();
	                    break;
	            }
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this4 = this;
	
	    this.setState({ page: page });
	    this.navigated();
	    (0, _loader.beginLock)(this);
	    this.options.issues.setPage(page).then(function () {
	        return (0, _loader.endLock)(_this4);
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Filter:filter'), function (filters) {
	    var _this5 = this;
	
	    this.setState({ filters: filters });
	    this.navigated();
	    this.Grid.afterRendering().then(function () {
	        return _this5.options.issues.filter(_tasks2.default.getHttpFilters(_this5.state()));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Comments:comments:recalc-unread'), function () {
	    this.Grid.render();
	}), _defineProperty(_Module$extend, _module2.default.event('nav:map'), function () {
	    this.trigger(OPEN_MAP, this.state());
	}), _defineProperty(_Module$extend, _module2.default.event('nav:contracts'), function () {
	    this.trigger(OPEN_CONTRACTS, this.state());
	}), _Module$extend), {
	
	    OPEN_TASK: OPEN_TASK,
	
	    OPEN_LIST: OPEN_LIST,
	
	    OPEN_MAP: OPEN_MAP,
	
	    OPEN_CONTRACTS: OPEN_CONTRACTS
	
	});
	
	
	function handleIncomingComment(commentJson) {
	    var tasks = this.options.issues;
	
	
	    var taskId = +commentJson.task_id || +commentJson.news_id;
	    var task = tasks.find(function (m) {
	        return m.id === taskId;
	    });
	    if (!task) return;
	
	    task.set('lastComment', commentJson);
	    if (task.comments_ && task.comments_ instanceof Array) task.comments_.unshift(commentJson);
	
	    if (commentJson.user_id == _config2.default.userId()) return task.set('unread_message_count', 0), this.Grid.render();
	
	    var unread = task.get('unread_message_count');
	    if (unread === null) return this.Grid.render();
	
	    task.set('unread_message_count', unread + 1), task.trigger('comments:unread-incoming');
	
	    this.Grid.render();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _fields = __webpack_require__(27);
	
	var _fields2 = _interopRequireDefault(_fields);
	
	var _fieldsForm = __webpack_require__(182);
	
	var _fieldsForm2 = _interopRequireDefault(_fieldsForm);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(17);
	
	var _roles = __webpack_require__(117);
	
	var _popups = __webpack_require__(62);
	
	var _api = __webpack_require__(77);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined,
	        sortCluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/fields.list',
	
	    url: function url() {
	        return 'custom-fields';
	    },
	    open: function open() {
	        var _this = this;
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                return !_this.options.dragMode;
	            },
	
	            // todo set cluster if filter is not empty
	            function () {
	                return _this.trigger(_fieldsForm2.default.OPEN_FIELD, new _field2.default(), _this.state().cluster);
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function () {
	                return !_this.options.dragMode;
	            }, function (current) {
	                return _this.trigger(_fieldsForm2.default.OPEN_FIELD, current.clone());
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return [false, 'f'].indexOf(_this.options.paged.current().get('system')) !== -1;
	
	                // can see only "my" fields: with cluster == my cluster;
	                // there are only global and "my" fields in the list;
	                // so, let's check only presence of cluster in field
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('field::modal delete - confirmation text', 'field::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            }),
	
	            sort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.getClustersAvailableToSort().length > 0;
	            }, function () {
	                var _state2 = _this.state(),
	                    cluster = _state2.cluster;
	
	                var availableClusters = _this.getClustersAvailableToSort();
	                // check whether is current cluster can be set as sort-cluster
	                var isAvailable = availableClusters.some(function (candidate) {
	                    return cluster && cluster.id == candidate.id;
	                });
	
	                _this.options.filter.set('sortCluster', isAvailable ? cluster : availableClusters[0], { silent: true });
	
	                // set flag to force sort() take cluster from sort-filter
	                _this.options.dragMode = true;
	                // need to iterate all clusters (options.source) because cluster filter
	                // may be changing during sorting process
	                _this.options.source.models.forEach(function (model) {
	                    return model.set('new-order', model.get('order'));
	                });
	                _this.setState({ page: 1 });
	                _this.sort({ sort: 'order', direction: 'asc' }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            applySort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.isOrderChanged();
	            }, function () {
	                return (0, _api.pst)('/fields/sort').cerebellum().blocking(_this).body({
	                    ids: _this.options.sorted.models.map(function (model) {
	                        return [model.id, model.get('new-order')];
	                    }).sort(function (_ref, _ref2) {
	                        var _ref4 = _slicedToArray(_ref, 2),
	                            idA = _ref4[0],
	                            indexA = _ref4[1];
	
	                        var _ref3 = _slicedToArray(_ref2, 2),
	                            idB = _ref3[0],
	                            indexB = _ref3[1];
	
	                        return indexA - indexB;
	                    }).map(function (_ref5) {
	                        var _ref6 = _slicedToArray(_ref5, 1),
	                            id = _ref6[0];
	
	                        return id;
	                    })
	                }).execute().then(function () {
	                    return _this.options.sorted.models.forEach(function (model) {
	                        return model.set('order', model.get('new-order'));
	                    });
	                }).then(function () {
	                    return _this.options.dragMode = false;
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            cancelSort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return Promise.resolve()
	                // drop drag-mode first
	                .then(function () {
	                    return _this.options.dragMode = false;
	                })
	                // then sort
	                .then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            })
	
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	        this.options.source = new _fields2.default(this.options.fields.models);
	        this.options.sorted = new _fields2.default();
	        this.options.filtered = new _fields2.default();
	        this.options.paged = new _fields2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    },
	    filterClusterFn: function filterClusterFn(model, cluster) {
	        return !cluster || cluster.id == -1 && !model.get('cluster') && (!this.options.dragMode || [false, 'f'].indexOf(model.get('system')) !== -1) || cluster.id != -1 && model.get('cluster') && model.get('cluster').id == cluster.id;
	    },
	    getClustersAvailableToSort: function getClustersAvailableToSort() {
	        var myClusters = (0, _arrays.hashify)(_config2.default.clusters().map(function (cluster) {
	            return +cluster.id;
	        }));
	
	        // gather fields in arrays by cluster id
	        // (null for global)
	        var hash = (0, _arrays.hashify)(this.options.filtered, function (model, hash) {
	            var clusterKey = model.cluster ? model.cluster.id : null;
	            var clusterObj = hash[clusterKey] || {
	                cluster: model.cluster,
	                list: []
	            };
	
	            return clusterObj.list = [].concat(_toConsumableArray(clusterObj.list), [model]), [clusterKey, clusterObj];
	        });
	
	        // filter groups by clusters
	        return Object.values(hash).filter(function (_ref7) {
	            var cluster = _ref7.cluster;
	            return _roles.roleA.indexOf(_config2.default.role()) !== -1
	            // chief admin can sort any group
	            ? true
	            // cluster admin can sort only his groups
	            : cluster && myClusters[cluster.id];
	        })
	        // must be more than one item in filtered group to sort
	        .filter(function (_ref8) {
	            var list = _ref8.list;
	            return list.length > 1;
	        }).map(function (_ref9) {
	            var cluster = _ref9.cluster;
	            return cluster;
	        })
	        // replace "global" null-cluster with fake value
	        .map(function (cluster) {
	            return cluster ? cluster : { id: -1, title: ifn('filters::global') };
	        }).sort(function (clA, clB) {
	            if (clA.id == -1) return -1;else if (clB.id == -1) return 1;else if (clA.title < clB.title) return -1;else if (clA.title > clB.title) return 1;else return 0;
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RefBooksModule$exten;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _i18n = __webpack_require__(30);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _arrays = __webpack_require__(24);
	
	var _sort = __webpack_require__(66);
	
	var _strings = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ifn = void 0;_i18n2.default.then(function (i) {
	    return ifn = i;
	});
	
	exports.default = _refbooks2.default.extend((_RefBooksModule$exten = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        options.dragMode = undefined !== options.dragMode ? options.dragMode : false;
	
	        _refbooks2.default.prototype.initialize.call(this, options);
	    },
	    start: function start() {
	        var _this = this;
	
	        var paged = this.options.paged;
	
	        paged.plugActionSource(this.Grid);
	
	        this.listenTo(paged, 'activate deactivate', function () {
	            var current = paged.current();
	            var activeId = current ? current.id : undefined;
	            _this.setState({ activeId: activeId });
	            _this.navigated();
	        });
	
	        this.listenTo(this.options.filter, 'change', function () {
	            var stateOptions = { page: 1 };
	            if (!_this.options.dragMode) stateOptions.cluster = _this.options.filter.get('cluster');
	            _this.setState(stateOptions);
	
	            var sortParams = _this.options.dragMode ? { sort: 'new-order', direction: 'asc' } : undefined;
	            _this.sort(sortParams).then(function () {
	                return _this.filter();
	            }).then(function () {
	                return _this.render();
	            }).then(function () {
	                return _this.navigated();
	            });
	            // this.bind( this.options.filter ).then( () => this.navigated() );
	        });
	
	        return this.Grid.focus(), this;
	    },
	    stop: function stop() {
	        var paged = this.options.paged;
	
	
	        paged.unplugActionSource(this.Grid);
	        this.Grid.ungrab(paged);
	        this.stopListening(paged);
	
	        this.stopListening(this.options.filter);
	
	        return this;
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref) {
	            var _this2 = this;
	
	            var currentTarget = _ref.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sortField = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	
	            return this.setState({ page: 1, sort: sortField, direction: direction }), this.sort()
	            // todo .then( () => this.bind( this.options.filter ) )
	            .then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.navigated();
	            });
	        }
	    }
	
	}, _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Paging:page'), function (page) {
	    var _this3 = this;
	
	    this.setState({ page: +page });
	    if (!this.options.dragMode) return this.render().then(function () {
	        return _this3.navigated();
	    });
	
	    this.sort({ sort: 'new-order', direction: 'asc' }).then(function () {
	        return _this3.render();
	    }).then(function () {
	        return _this3.navigated();
	    });
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Search:search'), function (search) {
	    var _this4 = this;
	
	    this.setState({ search: search, page: 1 });
	    if (!this.options.dragMode) return this.render().then(function () {
	        return _this4.navigated();
	    });
	
	    this.sort({ sort: 'new-order', direction: 'asc' }).then(function () {
	        return _this4.render();
	    }).then(function () {
	        return _this4.navigated();
	    });
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Grid:rows:order'), function (permutation) {
	    var _this5 = this;
	
	    return this.reorder(permutation), this.sort({ sort: 'new-order', direction: 'asc' }).then(function () {
	        return _this5.render();
	    });
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Grid:swap-up'), function (index) {
	    var _this6 = this;
	
	    this.reorder([+index, +index - 1]);
	
	    if (index == 0) this.setState({ page: this.options.paged.page - 1 });
	
	    this.sort({ sort: 'new-order', direction: 'asc' }).then(function () {
	        return _this6.render();
	    });
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Grid:swap-down'), function (index) {
	    var _this7 = this;
	
	    this.reorder([+index + 1, +index]);
	
	    if (index == this.options.paged.length - 1) this.setState({ page: this.options.paged.page + 1 });
	
	    this.sort({ sort: 'new-order', direction: 'asc' }).then(function () {
	        return _this7.render();
	    });
	}), _defineProperty(_RefBooksModule$exten, 'serialize', function serialize() {
	    var _state = this.state(),
	        sort = _state.sort,
	        direction = _state.direction,
	        searchString = _state.search;
	
	    var dragMode = this.options.dragMode;
	
	    this.filter();
	
	    var isolatedClusters = this.options.clusters.toJSON().filter(function (cluster) {
	        return cluster.isolated;
	    });
	    var isolatedCount = isolatedClusters.length;
	
	    return {
	        actionList: this.options.paged.actions,
	        collection: this.options.paged,
	        sort: sort, direction: direction,
	        dragMode: dragMode,
	        orderChanged: this.isOrderChanged(),
	        searchString: searchString,
	        isolatedCount: isolatedCount,
	        nonIsolatedCount: this.options.clusters.length - isolatedCount,
	        clusters: this.listClusters(),
	        isolatedClusters: isolatedClusters,
	        clusterPicked: this.currentCluster()
	    };
	}), _defineProperty(_RefBooksModule$exten, 'listClusters', function listClusters() {
	    return [{ id: -1, title: ifn('filters::global') }].concat(_toConsumableArray(this.options.clusters.toJSON()));
	}), _defineProperty(_RefBooksModule$exten, 'filterClusterFn', function filterClusterFn(model, cluster) {
	    return !cluster || cluster.id == -1 && !model.get('cluster') || cluster.id != -1 && model.get('cluster') && model.get('cluster').id == cluster.id;
	}), _defineProperty(_RefBooksModule$exten, 'currentCluster', function currentCluster() {
	    var clusterToSearch = this.options.dragMode ? this.options.filter.get('sortCluster') : this.state().cluster;
	
	    // -1 == global, no need to find it
	    if (clusterToSearch && clusterToSearch.id == -1) return clusterToSearch;
	
	    // need to take cluster from list
	    // to "isolated" property
	
	    var _options$clusters$toJ = this.options.clusters.toJSON().filter(function (cluster) {
	        return clusterToSearch && cluster.id == clusterToSearch.id;
	    }),
	        _options$clusters$toJ2 = _slicedToArray(_options$clusters$toJ, 1),
	        cluster = _options$clusters$toJ2[0];
	
	    return cluster;
	}), _defineProperty(_RefBooksModule$exten, 'sort', function sort() {
	    var _this8 = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _state$params = _extends({}, this.state(), params),
	        sort = _state$params.sort,
	        direction = _state$params.direction;
	
	    var sortByOrder = function sortByOrder(model) {
	        return +model.get('order');
	    };
	    var sortById = function sortById(model) {
	        return +model.id;
	    };
	    // for Type
	    var sortByPeriod = function sortByPeriod(model) {
	        return +model.get('period_of_review_in_sec');
	    };
	    var sortField = sort === 'order' ? sortByOrder : sort === 'id' ? sortById : sort === 'period_of_review_in_sec' ? sortByPeriod : sort;
	
	    var cluster = this.currentCluster();
	    var srcModels = this.options.source.models.filter(function (model) {
	        return _this8.filterClusterFn(model, cluster);
	    });
	
	    var sorting = 'asc' === direction ? (0, _sort.asc)(srcModels, [sortField, sortById]) : (0, _sort.desc)(srcModels, [sortField, sortById]);
	
	    return sorting.then(function (sortedModels) {
	        return _this8.options.sorted.reset(sortedModels);
	    });
	}), _defineProperty(_RefBooksModule$exten, 'filterFn', function filterFn() /* model */{
	    return true;
	}), _defineProperty(_RefBooksModule$exten, 'filter', function filter() {
	    var _this9 = this;
	
	    var _state2 = this.state(),
	        search = _state2.search,
	        page = _state2.page,
	        limit = _state2.limit,
	        activeId = _state2.activeId;
	
	    var source = this.options.sorted;
	    var dest1 = this.options.filtered;
	    var dest2 = this.options.paged;
	
	    dest1.reset(source.models.filter(function (model) {
	        return _this9.filterFn(model);
	    }).filter(function (model) {
	        return (0, _strings.find)([model.id, model.get('no'), model.get('name'), model.get('title'), model.get('url')], search);
	    }));
	
	    dest2.reset(dest1.models.filter(function (model, index) {
	        return index >= (page - 1) * limit && index < page * limit;
	    }),
	    // note silent: true
	    // (to avoid automatic rerendering grid on "reset" event)
	    { silent: true });
	
	    var activeIndex = dest2.findIndex(function (model) {
	        return +model.id === +activeId;
	    });
	    if (activeIndex > -1) dest2.activate(activeIndex);else dest2.restoreActive();
	
	    dest2.total = dest1.length;
	    dest2.page = page;
	    dest2.limit = limit;
	    dest2.npages = (dest2.total / dest2.limit | 0) + (dest2.total % dest2.limit == 0 ? 0 : 1);
	}), _defineProperty(_RefBooksModule$exten, 'isOrderChanged', function isOrderChanged() {
	    var _this10 = this;
	
	    var f = function f(prop) {
	        return _this10.options.sorted.models.map(function (model) {
	            return model.get(prop);
	        });
	    };
	
	    var g = function g(arr) {
	        return arr.map(function (el, value) {
	            return [value, el];
	        }).sort(function (_ref2, _ref3) {
	            var _ref5 = _slicedToArray(_ref2, 2),
	                valueA = _ref5[0],
	                indexA = _ref5[1];
	
	            var _ref4 = _slicedToArray(_ref3, 2),
	                valueB = _ref4[0],
	                indexB = _ref4[1];
	
	            return indexA - indexB;
	        }).map(function (_ref6) {
	            var _ref7 = _slicedToArray(_ref6, 1),
	                value = _ref7[0];
	
	            return value;
	        }).join(',');
	    };
	
	    return g(f('order')) !== g(f('new-order'));
	}), _defineProperty(_RefBooksModule$exten, 'reorder', function reorder(newOrder) {
	    // index === value, old position
	    // i     === pos,   new position
	    // order: new position -> old position
	
	    var _options$paged = this.options.paged,
	        page = _options$paged.page,
	        limit = _options$paged.limit;
	
	    var offset = (page - 1) * limit;
	    newOrder = newOrder.map(function (index) {
	        return index + offset;
	    });
	
	    var usedIndexes = (0, _arrays.hashify)(newOrder);
	
	    var permutation = [];
	    for (var i = 0; i < this.options.filtered.length; i++) {
	        permutation.push(usedIndexes[i] ? newOrder.shift() : i);
	    }var m = this.options.filtered.models;
	    permutation.map(function (index, i) {
	        return [m[index], m[i]];
	    }).map(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 2),
	            modelHere = _ref9[0],
	            prevModelHere = _ref9[1];
	
	        return [modelHere, prevModelHere.get('new-order')];
	    }).forEach(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 2),
	            modelHere = _ref11[0],
	            prevOrderHere = _ref11[1];
	
	        return modelHere.set('new-order', prevOrderHere);
	    });
	
	    return permutation;
	}), _RefBooksModule$exten));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RefBooksModule$exten;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _stickers = __webpack_require__(58);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _types = __webpack_require__(157);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _field = __webpack_require__(28);
	
	var _field2 = _interopRequireDefault(_field);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _roles = __webpack_require__(117);
	
	var _arrays = __webpack_require__(24);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _loader = __webpack_require__(20);
	
	var _field3 = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var OPEN_FIELD = 'field-form--popup',
	    TOGGLE_BOUND_TYPES = 'field-form--toggle-bound-types',
	    TOGGLE_NESTED_FIELDS = 'field-form--toggle-nested-fields',
	    TOGGLE_BOUND_STICKERS = 'field-form--toggle-bound-stickers';
	
	exports.default = _refbooks2.default.extend((_RefBooksModule$exten = {
	    open: function open(_ref) {
	        var field = _ref.field,
	            original = _ref.original;
	
	        if (!field.id && !field.get('cluster')) if (this.state().cluster && this.state().cluster.id != -1) field.set('cluster', this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) field.set('cluster', _config2.default.cluster());
	
	        this.original = original;
	
	        this.options.typesSorted = new _types2.default();
	        this.options.typesFiltered = new _types2.default();
	        this.options.typesResulted = new _types2.default();
	
	        return this.finalizeOpen(field);
	    },
	    onBind: function onBind() {
	        // rewrite originalModel with passed value
	        this.originalModel = this.original || this.originalModel;
	    },
	    finalizeOpen: function finalizeOpen() /* field */{},
	    start: function start() {
	        var _this = this;
	
	        this.listenTo(this.model, 'change', function () {
	            return _this.Buttons.render();
	        });
	        this.listenTo(this.model, 'change:format', function () {
	            return _this.model.set('default_value', '');
	        });
	        this.listenTo(this.model, 'change:is_for_all', function () {
	            if (_this.model.get('is_for_all') !== 'f') _this.$('.-toggle-wrapper, .-toggle-all').addClass('--invisible');else _this.$('.-toggle-wrapper, .-toggle-all').removeClass('--invisible');
	
	            _this.Roles.render();
	        });
	        this.finalizeStart(this.model);
	
	        return this;
	    },
	    finalizeStart: function finalizeStart() /* field */{},
	    stop: function stop() {
	        return this.stopListening(this.model), this;
	    },
	
	
	    // copied from form.js
	    diff: function diff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.model ? this.model.diff(this.originalModel, options) : [];
	    },
	    hasDiff: function hasDiff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.diff(options).length > 0;
	    },
	
	
	    events: {
	        'click .-save': function clickSave() {
	            var _this2 = this;
	
	            var _model$clone$toJSON = this.model.clone().toJSON(),
	                json = _objectWithoutProperties(_model$clone$toJSON, []);
	
	            var onReject = function onReject(message) {
	                (0, _loader.endLock)(_this2);
	                (0, _messages2.handle)(_this2, (0, _messages.error)(message));
	            };
	
	            (0, _loader.beginLock)(this);
	
	            var _Fields$validate = this.Fields.validate(),
	                result = _Fields$validate.result,
	                messages = _Fields$validate.messages;
	
	            if (!result) return onReject(messages[0] /* [text, field] */);
	
	            if (this.diff().filter(function (_ref2) {
	                var attrName = _ref2.attrName;
	                return attrName === 'bindings';
	            })) {
	                var bindings = this.model.get('bindings');
	                var roles = (0, _arrays.hashify)(this.options.roles.map(function (role) {
	                    return role.id;
	                }));
	                json.bindings_array = bindings;
	                json.bindings = {
	                    add: bindings.filter(function (binding) {
	                        return !binding.id;
	                    }).filter(function (binding) {
	                        return [undefined, true, 't'].indexOf(binding.on) !== -1 || [true, 't'].indexOf(_this2.model.get('is_for_all')) !== -1;
	                    }),
	                    update: bindings.filter(function (binding) {
	                        return binding.id;
	                    }).filter(function (binding) {
	                        return _field2.default.isBindingChanged(binding, _this2.originalModel);
	                    }).map(function (_ref3) {
	                        var binding = _objectWithoutProperties(_ref3, []),
	                            rules = _ref3.rules;
	
	                        return _extends({}, binding, {
	                            rules: rules.map(function (_ref4) {
	                                var rule = _objectWithoutProperties(_ref4, []),
	                                    visible_inverted_for_roles = _ref4.visible_inverted_for_roles;
	
	                                return _extends({}, rule, {
	                                    visible_inverted_for_roles: visible_inverted_for_roles.filter(function (id) {
	                                        return roles[id];
	                                    })
	                                });
	                            })
	                        });
	                    })
	                };
	            }
	
	            var toSave = adjustAttrsBeforeSave(json, this.options.types, this.options.stickers);
	
	            var fieldToSend = new _field2.default(toSave);
	            if (json.format !== 'file') // no format in fieldToSend at PATCH
	                fieldToSend.set('file_semantics', []), fieldToSend.set('sticker_ids', null);
	
	            return this.options.fields.save(fieldToSend).then(function (attrs) {
	                return new _field2.default(attrs);
	            }).then(function () {
	                return (/*field*/_this2.trigger(_refbooks2.default.BACK)
	                );
	            }, onReject);
	        },
	        'click .-close': function clickClose() {
	            this.trigger(_refbooks2.default.BACK);
	        }
	    }
	
	}, _defineProperty(_RefBooksModule$exten, _refbooks2.default.event(':bound-types:toggle'), function () {
	    this.trigger(TOGGLE_BOUND_TYPES, this.model, this.originalModel, this.state());
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event(':nested-fields:toggle'), function () {
	    this.trigger(TOGGLE_NESTED_FIELDS, this.model, this.originalModel, this.state());
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event(':bound-stickers:toggle'), function () {
	    this.trigger(TOGGLE_BOUND_STICKERS, this.model, this.originalModel, this.state());
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Fields:file-semantics:toggle'), function (passedSemantics) {
	    var contains = this.model.get('file_semantics').indexOf(passedSemantics) !== -1;
	    var newSemantics = contains ? this.model.get('file_semantics').filter(function (ft) {
	        return ft !== passedSemantics;
	    }) : [].concat(_toConsumableArray(this.model.get('file_semantics')), [passedSemantics]);
	    this.model.set('file_semantics', newSemantics);
	}), _defineProperty(_RefBooksModule$exten, 'getAvailableFilteredModelIds', function getAvailableFilteredModelIds(collection) {
	    var _this3 = this;
	
	    var models = collection instanceof _collection2.default ? collection.models : collection;
	
	    return models
	    // ignore unavailable (disabled) checkboxes
	    .filter(function (type) {
	        return (
	            // chief admin may check any MODEL
	            // (local MODELS of wrong cluster do not pass filtration)
	            _roles.roleA.indexOf(_config2.default.role()) !== -1 ||
	            // local MODELS may be checked anyway
	            // (local MODELS of wrong cluster do not pass filtration)
	            type.get('cluster') ||
	            // local field may be joined to any MODEL
	            // (local MODEL of wrong cluster do not pass filtration)
	            _this3.model.get('cluster')
	        );
	    }).map(function (type) {
	        return type.id;
	    });
	}), _RefBooksModule$exten), {
	
	    OPEN_FIELD: OPEN_FIELD,
	
	    TOGGLE_BOUND_TYPES: TOGGLE_BOUND_TYPES,
	
	    TOGGLE_NESTED_FIELDS: TOGGLE_NESTED_FIELDS,
	
	    TOGGLE_BOUND_STICKERS: TOGGLE_BOUND_STICKERS
	
	});
	
	
	function adjustAttrsBeforeSave(topLevelJson, typeCollection, stickerCollection, json) {
	    json = json || topLevelJson;
	
	    var _json = json,
	        id = _json.id,
	        format = _json.format,
	        translit = _json.translit,
	        order = _json.order,
	        is_required = _json.is_required,
	        default_value = _json.default_value,
	        possible_values = _json.possible_values,
	        min_length = _json.min_length,
	        max_length = _json.max_length,
	        multiselect = _json.multiselect,
	        table_id = _json.table_id,
	        allow_add_num = _json.allow_add_num,
	        regexp = _json.regexp,
	        min_count = _json.min_count,
	        max_count = _json.max_count,
	        subfields = _json.subfields,
	        min_size = _json.min_size,
	        max_size = _json.max_size,
	        auto_apply_sticker = _json.auto_apply_sticker,
	        file_semantics = _json.file_semantics,
	        sticker_ids = _json.sticker_ids,
	        __all_stickers_available = _json.__all_stickers_available,
	        attrs = _objectWithoutProperties(_json, ['id', 'format', 'translit', 'order', 'is_required', 'default_value', 'possible_values', 'min_length', 'max_length', 'multiselect', 'table_id', 'allow_add_num', 'regexp', 'min_count', 'max_count', 'subfields', 'min_size', 'max_size', 'auto_apply_sticker', 'file_semantics', 'sticker_ids', '__all_stickers_available']);
	
	    // remove fake ids
	
	
	    if (id < 1000000000) attrs.id = id;
	
	    // don't send "format", "translit", "order" fields to the server - those are unchangeable.
	    // Don't clear "id" field: if cleared, will force
	    // POST-request instead of PUT.
	    if (!attrs.id) attrs.format = format;
	
	    // possible_values is possible only for "list"                
	    if ('list' === format) attrs.possible_values = possible_values;
	
	    // min_length/max_length is possible only for "string", "text"
	    if (~['string', 'text'].indexOf(format)) attrs.min_length = min_length, attrs.max_length = max_length;
	
	    // regexp is possible only for "string", "text", "int", "float"                
	    if (~['string', 'text', 'int', 'float'].indexOf(format)) attrs.regexp = regexp;
	
	    if ('dataTableObjects' === format) attrs.multiselect = multiselect, attrs.allow_add_num = allow_add_num, attrs.table_id = table_id;
	
	    if ('composite' === format || 'file' === format) attrs.min_count = min_count, attrs.max_count = max_count;
	
	    if ('file' === format) attrs.min_size = min_size, attrs.max_size = max_size, attrs.auto_apply_sticker = auto_apply_sticker, attrs.file_semantics = file_semantics, attrs.sticker_ids = sticker_ids == null || __all_stickers_available ? null : filterStickerIds(typeCollection, stickerCollection, topLevelJson, sticker_ids);else attrs.min_size = attrs.max_size = attrs.auto_apply_sticker = attrs.file_semantics = attrs.sticker_ids = undefined;
	
	    if ('composite' === format)
	        // is_for_all, types, bindings, group_name are for top-level fields only
	        attrs.subfields = subfields.sort(function (_ref5, _ref6) {
	            var a = _ref5.order;
	            var b = _ref6.order;
	            return a - b;
	        }).map(function (_ref7) {
	            var is_for_all = _ref7.is_for_all,
	                news_type_ids = _ref7.news_type_ids,
	                bindings = _ref7.bindings,
	                group_name = _ref7.group_name,
	                order = _ref7.order,
	                others = _objectWithoutProperties(_ref7, ['is_for_all', 'news_type_ids', 'bindings', 'group_name', 'order']);
	
	            return adjustAttrsBeforeSave(topLevelJson, typeCollection, stickerCollection, _extends({}, others, {
	                cluster: attrs.cluster // copy parent cluster
	            }));
	        });else
	        // required, defaults is for non-composites only
	        attrs.is_required = is_required, attrs.default_value = default_value;
	
	    return attrs;
	}
	
	function filterStickerIds(typeCollection, stickerCollection, field, stickerIds) {
	    if (stickerIds == null) return stickerIds;
	
	    var ids = (0, _arrays.hashify)(stickerIds);
	    var stickers = new _stickers2.default(stickerCollection.models.filter(function (stickerModel) {
	        return ids[stickerModel.id];
	    }));
	
	    return (0, _field3.filterAvailableStickers)(typeCollection, field, stickers).models.map(function (sticker) {
	        return sticker.id;
	    });
	}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _FieldFormTemplateMod;
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _fieldsForm = __webpack_require__(182);
	
	var _fieldsForm2 = _interopRequireDefault(_fieldsForm);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _fieldsForm2.default.extend((_FieldFormTemplateMod = {
	
	    template: 'module/refbooks/fields.form.types',
	
	    url: function url() {
	        return this.model.id ? 'fields/' + this.model.id + '/edit/bound-types' : 'fields/new/bound-types';
	    },
	    finalizeOpen: function finalizeOpen(field) {
	        var _this = this;
	
	        var _ref = this.state() || {},
	            _ref$typesPage = _ref.typesPage,
	            typesPage = _ref$typesPage === undefined ? 1 : _ref$typesPage,
	            _ref$typesLimit = _ref.typesLimit,
	            typesLimit = _ref$typesLimit === undefined ? 10 : _ref$typesLimit,
	            _ref$typesSort = _ref.typesSort,
	            typesSort = _ref$typesSort === undefined ? 'name' : _ref$typesSort,
	            _ref$typesDirection = _ref.typesDirection,
	            typesDirection = _ref$typesDirection === undefined ? 'asc' : _ref$typesDirection,
	            _ref$typesSearch = _ref.typesSearch,
	            typesSearch = _ref$typesSearch === undefined ? '' : _ref$typesSearch,
	            _ref$rolesPage = _ref.rolesPage,
	            rolesPage = _ref$rolesPage === undefined ? 1 : _ref$rolesPage,
	            _ref$rolesLimit = _ref.rolesLimit,
	            rolesLimit = _ref$rolesLimit === undefined ? 10 : _ref$rolesLimit,
	            _ref$rolesSort = _ref.rolesSort,
	            rolesSort = _ref$rolesSort === undefined ? 'name' : _ref$rolesSort,
	            _ref$rolesDirection = _ref.rolesDirection,
	            rolesDirection = _ref$rolesDirection === undefined ? 'asc' : _ref$rolesDirection;
	
	        this.setState({
	            typesPage: typesPage, typesLimit: typesLimit, typesSort: typesSort, typesDirection: typesDirection, typesSearch: typesSearch,
	            rolesPage: rolesPage, rolesLimit: rolesLimit, rolesSort: rolesSort, rolesDirection: rolesDirection
	        });
	
	        this.options.rolesSorted = new _collection2.default();
	        this.options.rolesFiltered = new _collection2.default();
	        this.options.rolesResulted = new _collection2.default();
	
	        return this.reSortGrid().then(function () {
	            return _this.reSortRolesGrid();
	        }).then(function () {
	            // hack to allow reFilterGrid work
	            // TODO remove this hack
	            _this.model = field;
	            _this.reFilterGrid();
	            // TODO
	            _this.reFilterRolesGrid();
	            _this.model = undefined;
	        }).then(function () {
	            return _this.bind(field);
	        });
	    },
	    finalizeStart: function finalizeStart(field) {
	        var _this2 = this;
	
	        this.listenTo(field, 'change:cluster', function () {
	            _this2.setState({ typesPage: 1 }), _this2.navigated();
	            _this2.reFilterGrid();
	        });
	        this.listenTo(field, 'change:visible', function () {
	            return _this2.Roles.render();
	        });
	    },
	    serialize: function serialize() {
	        var _this3 = this;
	
	        var _state = this.state(),
	            typesSort = _state.typesSort,
	            typesDirection = _state.typesDirection,
	            typesSearch = _state.typesSearch,
	            rolesSort = _state.rolesSort,
	            rolesDirection = _state.rolesDirection;
	
	        var _options = this.options,
	            typesFiltered = _options.typesFiltered,
	            typesResulted = _options.typesResulted,
	            rolesFiltered = _options.rolesFiltered,
	            rolesResulted = _options.rolesResulted;
	
	
	        return {
	            typesSearch: typesSearch,
	            typesSort: typesSort, typesDirection: typesDirection, rolesSort: rolesSort, rolesDirection: rolesDirection,
	
	            current: function current() {
	                return typesResulted.current();
	            },
	
	            currentRule: function currentRule() {
	                return _currentRule(_this3.model, typesResulted.current());
	            },
	
	            currentVisibleRoles: function currentVisibleRoles() {
	                return findVisibleRoles.call(_this3, _this3.model, typesResulted.current());
	            },
	
	            visibleByDefaultToggled: function visibleByDefaultToggled() {
	                var rule = _currentRule(_this3.model, typesResulted.current());
	                return rule && [true, 't'].indexOf(rule.visible_by_default) !== -1;
	            },
	
	            hasDiff: function hasDiff() {
	                return _this3.hasDiff();
	            },
	
	            types: typesFiltered, rows: typesResulted,
	
	            checkedTypes: function checkedTypes() {
	                return _this3.model.get('bindings').filter(function (binding) {
	                    return [undefined, true, 't'].indexOf(binding.on) !== -1;
	                }).map(function (binding) {
	                    return binding.type.id;
	                });
	            },
	
	            clusters: this.options.clusters,
	            roles: rolesFiltered, rolesRows: rolesResulted
	        };
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref2) {
	            var _this4 = this;
	
	            var currentTarget = _ref2.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	            if (this.$(currentTarget).closest('[name="Grid"]').length) this.setState({ typesPage: 1, typesSort: sort, typesDirection: direction });else this.setState({ rolesPage: 1, rolesSort: sort, rolesDirection: direction });
	
	            var rendering = this.$(currentTarget).closest('[name="Grid"]').length ? this.reSortGrid().then(function () {
	                return _this4.reFilterGrid();
	            }) : this.reSortRolesGrid().then(function () {
	                return _this4.reFilterRolesGrid();
	            });
	
	            return rendering
	            // hack: to rerender grid caption with order direction
	            .then(function () {
	                return _this4.render();
	            }).then(function () {
	                return _this4.navigated();
	            });
	        },
	        'click .-toggle-binding': function clickToggleBinding(_ref3) {
	            var currentTarget = _ref3.currentTarget;
	            var id = currentTarget.dataset.id;
	
	
	            var on = currentTarget.checked;
	            var oldBindings = this.model.get('bindings');
	            var newBindings = toggleBinding(id, oldBindings, on);
	
	            this.model.set('bindings', newBindings);
	
	            var checkedTypeIds = (0, _arrays.hashify)(newBindings.filter(function (binding) {
	                return [undefined, true, 't'].indexOf(binding.on) !== -1;
	            }).map(function (binding) {
	                return binding.type.id;
	            }));
	            this.$('.-toggle-all')[0].checked = this.getAvailableFilteredModelIds(this.options.typesFiltered).every(function (typeId) {
	                return checkedTypeIds[typeId];
	            });
	
	            this.Roles.render();
	        },
	        'click .-toggle-all': function clickToggleAll(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	
	            var on = currentTarget.checked;
	            var oldBindings = this.model.get('bindings');
	            var newBindings = this.getAvailableFilteredModelIds(this.options.typesFiltered).reduce(function (oldBindings, id) {
	                return toggleBinding(id, oldBindings, on);
	            }, oldBindings);
	
	            this.model.set('bindings', newBindings);
	
	            this.$('.-toggle-binding:not([disabled])').toArray().forEach(function (el) {
	                return el.checked = on;
	            });
	
	            this.Roles.render();
	        },
	        'click .-toggle-role': function clickToggleRole(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	            var id = currentTarget.dataset.id;
	
	
	            var checked = currentTarget.checked;
	
	            var oldBindings = this.model.get('bindings');
	            var newBindings = toggleRole(id, this.options.typesResulted.current(), oldBindings, checked);
	
	            this.model.set('bindings', newBindings);
	
	            var checkedRoleIds = (0, _arrays.hashify)(findVisibleRoles.call(this, this.model, this.options.typesResulted.current()));
	            this.$('.-toggle-all-roles')[0].checked = this.getAvailableFilteredModelIds(this.options.rolesFiltered).every(function (roleId) {
	                return checkedRoleIds[roleId];
	            });
	        },
	        'click .-toggle-all-roles': function clickToggleAllRoles(_ref6) {
	            var currentTarget = _ref6.currentTarget;
	
	            var checked = currentTarget.checked;
	            var type = this.options.typesResulted.current();
	            var oldBindings = this.model.get('bindings');
	            var visibleRoleIds = (0, _arrays.hashify)(findVisibleRoles.call(this, this.model, this.options.typesResulted.current()));
	            var newBindings = this.getAvailableFilteredModelIds(this.options.rolesFiltered).filter(function (id) {
	                return checked && !visibleRoleIds[id] || !checked && visibleRoleIds[id];
	            }).reduce(function (oldBindings, id) {
	                return toggleRole(id, type, oldBindings, checked);
	            }, oldBindings);
	
	            this.model.set('bindings', newBindings);
	
	            this.$('.-toggle-role:not([disabled])').toArray().forEach(function (el) {
	                return el.checked = checked;
	            });
	        }
	    },
	
	    reSortGrid: function reSortGrid() {
	        var _state2 = this.state(),
	            sort = _state2.typesSort,
	            direction = _state2.typesDirection;
	
	        var _options2 = this.options,
	            types = _options2.types,
	            typesSorted = _options2.typesSorted;
	
	
	        return _grid2.default.sort({ sort: sort, direction: direction }, types, typesSorted);
	    },
	    reFilterGrid: function reFilterGrid() {
	        var _state3 = this.state(),
	            page = _state3.typesPage,
	            limit = _state3.typesLimit,
	            search = _state3.typesSearch,
	            activeId = _state3.typesActiveId;
	
	        var _options3 = this.options,
	            typesSorted = _options3.typesSorted,
	            typesFiltered = _options3.typesFiltered,
	            typesResulted = _options3.typesResulted;
	
	
	        _grid2.default.filter({ page: page, limit: limit, search: search, activeId: activeId }, this.model.get('cluster'), typesSorted, typesFiltered, typesResulted);
	    },
	    reSortRolesGrid: function reSortRolesGrid() {
	        var _state4 = this.state(),
	            sort = _state4.rolesSort,
	            direction = _state4.rolesDirection;
	
	        var _options4 = this.options,
	            roles = _options4.roles,
	            rolesSorted = _options4.rolesSorted;
	
	
	        return _grid2.default.sort({ sort: sort, direction: direction }, roles, rolesSorted);
	    },
	    reFilterRolesGrid: function reFilterRolesGrid() {
	        var _state5 = this.state(),
	            page = _state5.rolesPage,
	            limit = _state5.rolesLimit;
	
	        var typesResulted = this.options.typesResulted;
	        var _options5 = this.options,
	            rolesSorted = _options5.rolesSorted,
	            rolesFiltered = _options5.rolesFiltered,
	            rolesResulted = _options5.rolesResulted;
	
	
	        _grid2.default.filter({ page: page, limit: limit }, this.model.get('cluster') || typesResulted.current() && typesResulted.current().get('cluster'), rolesSorted, rolesFiltered, rolesResulted);
	    }
	}, _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('TypesPaging:page'), function (page) {
	    return this.setState({ typesPage: +page }), this.reFilterGrid(), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('RolesPaging:page'), function (page) {
	    return this.setState({ rolesPage: +page }), this.reFilterRolesGrid(), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('TypesSearch:search'), function (search) {
	    return this.setState({ typesSearch: search, typesPage: 1 }), this.reFilterGrid(), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Grid:activate'), function (index, type) {
	    this.setState({
	        rolesPage: 1, typesActiveId: type.id
	    });
	    this.reFilterRolesGrid();
	    this.Roles.render();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Grid:deactivate'), function () {
	    this.setState({
	        typesActiveId: undefined
	    });
	    this.Roles.render();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Roles:visible-by-default:toggle'), function () {
	    var newBindings = toggleVisibleByDefault.call(this, this.options.typesResulted.current(), this.model.get('bindings'));
	
	    this.model.set('bindings', newBindings);
	
	    this.Roles.render();
	}), _FieldFormTemplateMod));
	
	
	function toggleBinding(id, oldBindings, on) {
	    var containsBinding = oldBindings.find(function (binding) {
	        return binding.type.id == id;
	    });
	    if (on && !containsBinding) return [].concat(_toConsumableArray(oldBindings), [{ on: true, type: { id: id }, rules: [{ visible_by_default: true, visible_inverted_for_roles: [] }] }]);
	
	    return oldBindings.map(function (binding) {
	        return binding.type.id != id ? binding : _extends({}, binding, { on: on });
	    });
	}
	
	function toggleRole(id, type, bindings, checked) {
	    return (0, _arrays.mapEl)(bindings, function (oldBinding) {
	        return oldBinding.type.id == type.id;
	    }, function () {
	        return { on: false, type: { id: type.id } };
	    }, function (oldBinding) {
	        var newRules = (0, _arrays.mapEl)(oldBinding.rules, function () {
	            return true;
	        }, function () {
	            return { visible_by_default: true, visible_inverted_for_roles: [] };
	        }, function (_ref7) {
	            var visible_inverted_for_roles = _ref7.visible_inverted_for_roles,
	                oldRule = _objectWithoutProperties(_ref7, ['visible_inverted_for_roles']);
	
	            visible_inverted_for_roles = visible_inverted_for_roles || [];
	            var needAppend = checked && [false, 'f'].indexOf(oldRule.visible_by_default) !== -1 || !checked && [true, 't'].indexOf(oldRule.visible_by_default) !== -1;
	            var newInvertedForRoles = needAppend ? [].concat(_toConsumableArray(visible_inverted_for_roles), [+id]) : visible_inverted_for_roles.filter(function (roleId) {
	                return roleId != id;
	            });
	
	            // rule удаляется, если оно новое, и ролей нет и checkbox будет включен
	            // (т.е. производится откат к состоянию до начала изменений)
	            if (oldRule.id || [false, 'f'].indexOf(oldRule.visible_by_default) !== -1 || newInvertedForRoles.length) return _extends({}, oldRule, { visible_inverted_for_roles: newInvertedForRoles });
	        });
	
	        // binding удаляется, если он новый, выключенный и правил больше нет
	        // (т.е. производится откат к состоянию до начала изменений)
	        if (oldBinding.id || newRules.length || oldBinding.on) return _extends({}, oldBinding, { rules: newRules });
	    });
	}
	
	function toggleVisibleByDefault(type, bindings) {
	    var _state6 = this.state(),
	        page = _state6.rolesPage,
	        limit = _state6.rolesLimit;
	
	    var typesResulted = this.options.typesResulted;
	
	    var roleIds = _grid2.default.filter({ page: page, limit: limit }, this.model.get('cluster') || typesResulted.current() && typesResulted.current().get('cluster'), this.options.rolesSorted).filtered.toJSON().map(function (role) {
	        return +role.id;
	    });
	
	    return (0, _arrays.mapEl)(bindings, function (oldBinding) {
	        return oldBinding.type.id == type.id;
	    }, function () {
	        return { type: { id: type.id } };
	    }, function (oldBinding) {
	        var newRules = (0, _arrays.mapEl)(oldBinding.rules, function () {
	            return true;
	        }, function () {
	            return { visible_by_default: true, visible_inverted_for_roles: [] };
	        }, function (_ref8) {
	            var visible_by_default = _ref8.visible_by_default,
	                roles = _ref8.visible_inverted_for_roles,
	                oldRule = _objectWithoutProperties(_ref8, ['visible_by_default', 'visible_inverted_for_roles']);
	
	            visible_by_default = [true, 't'].indexOf(visible_by_default) !== -1;
	            roles = roles || [];
	
	            visible_by_default = !visible_by_default;
	            roles = roleIds.filter(function (id) {
	                return !(roles.indexOf(id) !== -1) && !(roles.indexOf('' + id) !== -1);
	            });
	            // rule удаляется, если оно новое, и ролей нет и checkbox будет выключен
	            // (т.е. производится откат к состоянию до начала изменений)
	            if (oldRule.id || !visible_by_default || roles.length) return _extends({}, oldRule, {
	                visible_by_default: visible_by_default,
	                visible_inverted_for_roles: roles
	            });
	        });
	
	        // binding удаляется, если он новый, выключенный и правил больше нет
	        // (т.е. производится откат к состоянию до начала изменений)
	        if (oldBinding.id || newRules.length || oldBinding.on) return _extends({}, oldBinding, { rules: newRules });
	    });
	}
	
	function _currentRule(model, type) {
	    if (!type) return null;
	
	    var _model$get$filter = model.get('bindings').filter(function (binding) {
	        return binding.type.id == type.id;
	    }),
	        _model$get$filter2 = _slicedToArray(_model$get$filter, 1),
	        binding = _model$get$filter2[0];
	
	    if (!binding) if ([true, 't'].indexOf(model.get('is_for_all')) !== -1) return binding || { visible_by_default: true, visible_inverted_for_roles: [] };else return null;
	
	    if (binding && !([undefined, true, 't'].indexOf(binding.on) !== -1)) if (!([true, 't'].indexOf(model.get('is_for_all')) !== -1)) return null;
	
	    if (!binding.rules || !binding.rules.length) return { visible_by_default: true, visible_inverted_for_roles: [] };
	
	    return binding.rules[0];
	}
	
	function findVisibleRoles(model, type) {
	    var rule = _currentRule(model, type);
	    if (!rule) return [];
	
	    var visible_by_default = rule.visible_by_default,
	        roles = rule.visible_inverted_for_roles;
	
	    return [false, 'f'].indexOf(visible_by_default) !== -1 ? roles : this.options.roles.toJSON().map(function (role) {
	        return +role.id;
	    }).filter(function (id) {
	        return !(roles.indexOf(id) !== -1) && !(roles.indexOf('' + id) !== -1);
	    });
	}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _FieldFormTemplateMod;
	
	var _fieldsForm = __webpack_require__(182);
	
	var _fieldsForm2 = _interopRequireDefault(_fieldsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _fieldsForm2.default.extend((_FieldFormTemplateMod = {
	
	    template: 'module/refbooks/fields.form.nested-fields',
	
	    url: function url() {
	        return this.model.id ? 'fields/' + this.model.id + '/edit/nested-fields' : 'fields/new/nested-fields';
	    },
	    open: function open(_ref) {
	        var field = _ref.field,
	            original = _ref.original;
	
	        var _ref2 = this.state() || {},
	            _ref2$fieldsPage = _ref2.fieldsPage,
	            fieldsPage = _ref2$fieldsPage === undefined ? 1 : _ref2$fieldsPage,
	            _ref2$fieldsLimit = _ref2.fieldsLimit,
	            fieldsLimit = _ref2$fieldsLimit === undefined ? 10 : _ref2$fieldsLimit,
	            _ref2$fieldsSort = _ref2.fieldsSort,
	            fieldsSort = _ref2$fieldsSort === undefined ? 'name' : _ref2$fieldsSort,
	            _ref2$fieldsDirection = _ref2.fieldsDirection,
	            fieldsDirection = _ref2$fieldsDirection === undefined ? 'asc' : _ref2$fieldsDirection,
	            _ref2$fieldsSearch = _ref2.fieldsSearch,
	            fieldsSearch = _ref2$fieldsSearch === undefined ? '' : _ref2$fieldsSearch;
	
	        this.setState({
	            fieldsPage: fieldsPage, fieldsLimit: fieldsLimit, fieldsSort: fieldsSort, fieldsDirection: fieldsDirection, fieldsSearch: fieldsSearch
	        });
	
	        return _fieldsForm2.default.prototype.open.call(this, { field: field, original: original });
	    },
	    finalizeOpen: function finalizeOpen(field) {
	        return this.bind(field);
	    },
	    finalizeStart: function finalizeStart(field) {
	        var _this = this;
	
	        this.listenTo(field, 'change:cluster', function () {
	            _this.setState({ page: 1 }), _this.navigated();
	            // no need to change fields' page and rerender grid here -
	            // they share the same parent field's cluster anyway 
	        });
	
	        this.listenTo(field, 'change:format', function () {
	            if (field.get('format') !== 'composite') _this.setState({ fieldsPage: 1, fieldsSearch: '', fieldsSort: 'name', fieldsDirection: 'asc' }), _this.trigger(_fieldsForm2.default.TOGGLE_BOUND_TYPES, _this.model, _this.originalModel, _this.state());
	        });
	    },
	    serialize: function serialize() {
	        var _this2 = this;
	
	        var _state = this.state(),
	            fieldsSort = _state.fieldsSort,
	            fieldsDirection = _state.fieldsDirection,
	            fieldsSearch = _state.fieldsSearch,
	            fieldsPage = _state.fieldsPage;
	
	        return {
	            fieldsSort: fieldsSort, fieldsDirection: fieldsDirection, fieldsSearch: fieldsSearch, fieldsPage: fieldsPage,
	            hasDiff: function hasDiff() {
	                return _this2.hasDiff();
	            }
	        };
	    }
	}, _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Subfields:page'), function (page) {
	    return this.setState({ fieldsPage: +page }), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Subfields:sort'), function (_ref3) {
	    var sort = _ref3.sort,
	        direction = _ref3.direction;
	
	    return this.setState({ fieldsSort: sort, fieldsDirection: direction }), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Subfields:search'), function (search) {
	    return this.setState({ fieldsSearch: search, fieldsPage: 1 }), this.navigated();
	}), _FieldFormTemplateMod));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _FieldFormTemplateMod;
	
	var _fieldsForm = __webpack_require__(182);
	
	var _fieldsForm2 = _interopRequireDefault(_fieldsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _fieldsForm2.default.extend((_FieldFormTemplateMod = {
	
	    template: 'module/refbooks/fields.form.bound-stickers',
	
	    url: function url() {
	        return this.model.id ? 'fields/' + this.model.id + '/edit/bound-stickers' : 'fields/new/bound-stickers';
	    },
	    open: function open(_ref) {
	        var field = _ref.field,
	            original = _ref.original;
	
	        var _ref2 = this.state() || {},
	            _ref2$stickersPage = _ref2.stickersPage,
	            stickersPage = _ref2$stickersPage === undefined ? 1 : _ref2$stickersPage,
	            _ref2$stickersLimit = _ref2.stickersLimit,
	            stickersLimit = _ref2$stickersLimit === undefined ? 10 : _ref2$stickersLimit,
	            _ref2$stickersSort = _ref2.stickersSort,
	            stickersSort = _ref2$stickersSort === undefined ? 'title' : _ref2$stickersSort,
	            _ref2$stickersDirecti = _ref2.stickersDirection,
	            stickersDirection = _ref2$stickersDirecti === undefined ? 'asc' : _ref2$stickersDirecti,
	            _ref2$stickersSearch = _ref2.stickersSearch,
	            stickersSearch = _ref2$stickersSearch === undefined ? '' : _ref2$stickersSearch;
	
	        this.setState({
	            stickersPage: stickersPage, stickersLimit: stickersLimit, stickersSort: stickersSort, stickersDirection: stickersDirection, stickersSearch: stickersSearch
	        });
	
	        return _fieldsForm2.default.prototype.open.call(this, { field: field, original: original });
	    },
	    finalizeOpen: function finalizeOpen(field) {
	        return this.bind(field);
	    },
	    finalizeStart: function finalizeStart(field) {
	        var _this = this;
	
	        this.listenTo(field, 'change:cluster', function () {
	            console.log('cluster changed');
	            _this.setState({ stickersPage: 1 });
	            _this.Stickers.options.page = 1;
	            // render() doesn't re-filter models but reFilterGrid() does
	            _this.Stickers.reFilterGrid();
	            _this.navigated();
	        });
	
	        this.listenTo(field, 'change:format', function () {
	            if (field.get('format') !== 'file') _this.setState({ stickersPage: 1, stickersSearch: '', stickersSort: 'title', stickersDirection: 'asc' }), _this.trigger(_fieldsForm2.default.TOGGLE_BOUND_TYPES, _this.model, _this.originalModel, _this.state());
	        });
	    },
	    serialize: function serialize() {
	        var _this2 = this;
	
	        var _state = this.state(),
	            stickersSort = _state.stickersSort,
	            stickersDirection = _state.stickersDirection,
	            stickersSearch = _state.stickersSearch,
	            stickersPage = _state.stickersPage;
	
	        return {
	            stickersSort: stickersSort, stickersDirection: stickersDirection, stickersSearch: stickersSearch, stickersPage: stickersPage,
	            hasDiff: function hasDiff() {
	                return _this2.hasDiff();
	            }
	        };
	    }
	}, _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Stickers:page'), function (page) {
	    return this.setState({ stickersPage: +page }), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Stickers:sort'), function (_ref3) {
	    var sort = _ref3.sort,
	        direction = _ref3.direction;
	
	    return this.setState({ stickersSort: sort, stickersDirection: direction }), this.navigated();
	}), _defineProperty(_FieldFormTemplateMod, _fieldsForm2.default.event('Stickers:search'), function (search) {
	    return this.setState({ stickersSearch: search, stickersPage: 1 }), this.navigated();
	}), _FieldFormTemplateMod));

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RefBooksModule$exten;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _messages = __webpack_require__(68);
	
	var _messages2 = __webpack_require__(69);
	
	var _arrays = __webpack_require__(24);
	
	var _roles = __webpack_require__(117);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _refbooks2.default.extend((_RefBooksModule$exten = {
	
	    template: 'module/refbooks/scripts.form',
	
	    url: function url() {
	        return this.model.id ? 'scripts/' + this.model.id : 'scripts/new/' + this.model.get('type').toLowerCase() + '/' + this.model.get('operation').toLowerCase();
	    },
	    open: function open(script) {
	        var _this = this;
	
	        var binding = this.bind(script);
	        binding.then(function () {
	            if (!script.id) if (_this.state().cluster && _this.state().cluster.id != -1) script.set('cluster', _this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) script.set('cluster', _config2.default.cluster());
	        });
	
	        return binding;
	    },
	    start: function start() {
	        var _this2 = this;
	
	        this.listenTo(this.model, 'change:title change:webhook_server change:description change:on change:script change:cluster', function () {
	            return _this2.Buttons.render();
	        });
	
	        this.listenTo(this.model, 'change:workgroups change:type change:operation change:entity_type change:types change:priorities change:roles change:statuses_before change:statuses_after change:stages_before change:stages_after change:user_organizations_before change:user_organizations_after change:user_roles_before change:user_roles_after change:user_types_before change:user_types_after change:user_tags_before change:user_tags_after', function () {
	            return _this2.render();
	        });
	    },
	    stop: function stop() {
	        // todo ?
	        this.stopListening(this.model);
	    },
	    serialize: function serialize() {
	        var _this3 = this;
	
	        var types = (0, _arrays.hashify)(this.options.types, function (type) {
	            return [type.id, type];
	        });
	
	        var priorities = (0, _arrays.hashify)(this.options.priorities, function (priority) {
	            return [priority.id, priority];
	        });
	
	        var statuses = (0, _arrays.hashify)(this.options.statuses, function (status) {
	            return [status.id, status];
	        });
	
	        var clusters = (0, _arrays.hashify)(this.options.clusters, function (cluster) {
	            return [cluster.id, cluster];
	        });
	        var organizations = (0, _arrays.hashify)(this.options.organizations.toJSON(), function (org) {
	            return [org.id, _extends({}, org, { cluster: clusters[org.cluster_id] })];
	        });
	        var workgroups = (0, _arrays.hashify)(this.options.workgroups.toJSON().filter(function (model) {
	            return model.defaults;
	        }).map(function (_ref) {
	            var id = _ref.id,
	                _ref$organization = _ref.organization,
	                name = _ref$organization.name,
	                orgId = _ref$organization.id;
	            return { id: id, name: name, cluster: organizations[orgId].cluster };
	        }), function (workgroup) {
	            return [workgroup.id, workgroup];
	        });
	
	        return {
	            workgroupsFn: function workgroupsFn() {
	                return Object.values(workgroups).filter(function (workgroup) {
	                    return !_this3.model.get('cluster') || _this3.model.get('cluster').id == workgroup.cluster.id;
	                }).sort(function (wgA, wgB) {
	                    var nameA = wgA.name.toLowerCase();
	                    var nameB = wgB.name.toLowerCase();
	
	                    if (nameA < nameB) return -1;else if (nameA > nameB) return 1;else return 0;
	                });
	            },
	
	            organizationsFn: function organizationsFn() {
	                return Object.values(organizations).filter(function (org) {
	                    return !_this3.model.get('cluster') || _this3.model.get('cluster').id == org.cluster.id;
	                }).sort(function (orgA, orgB) {
	                    var nameA = orgA.name.toLowerCase();
	                    var nameB = orgB.name.toLowerCase();
	
	                    if (nameA < nameB) return -1;else if (nameA > nameB) return 1;else return 0;
	                });
	            },
	
	            stages: [{ id: 0, name: 'glossary::stage - rejected (0)' }, { id: 1, name: 'glossary::stage - in progress (1)' }, { id: 2, name: 'glossary::stage - completed (2)' }],
	
	            serversFn: function serversFn() {
	                return _this3.options.servers.toJSON().filter(function (server) {
	                    return !server.cluster || !_this3.model.get('cluster') || _this3.model.get('cluster').id == server.cluster.id;
	                }).map(function (_ref2) {
	                    var id = _ref2.id,
	                        name = _ref2.name,
	                        server = _ref2.server;
	                    return { id: id, title: name, server: server };
	                });
	            },
	
	            statusesFn: function statusesFn() {
	                var cluster = _this3.model.get('cluster');
	                var isolated = cluster && clusters[cluster.id].isolated;
	
	                return _this3.options.statuses.toJSON().filter(function (status) {
	                    return !cluster || !isolated && !status.cluster || isolated && status.cluster && status.cluster.id == cluster.id;
	                }).map(function (_ref3) {
	                    var id = _ref3.id,
	                        name = _ref3.name,
	                        cluster = _ref3.cluster;
	                    return { id: id, title: name, cluster: cluster };
	                });
	            },
	
	            clustersFn: function clustersFn() {
	                var clusters = [].concat(_toConsumableArray(_this3.model.get('types').filter(function (type) {
	                    return types[type.id];
	                }).map(function (type) {
	                    return types[type.id].cluster;
	                })), _toConsumableArray(_this3.model.get('priorities').filter(function (priority) {
	                    return priorities[priority.id];
	                }).map(function (priority) {
	                    return priorities[priority.id].cluster;
	                })), _toConsumableArray(_this3.model.get('workgroups').filter(function (workgroup) {
	                    return workgroups[workgroup.id];
	                }).map(function (workgroup) {
	                    return workgroups[workgroup.id].cluster;
	                })), _toConsumableArray([].concat(_toConsumableArray(_this3.model.get('user_organizations_before')), _toConsumableArray(_this3.model.get('user_organizations_after'))).filter(function (organization) {
	                    return organizations[organization.id];
	                }).map(function (organization) {
	                    return organizations[organization.id].cluster;
	                })), _toConsumableArray([].concat(_toConsumableArray(_this3.model.get('statuses_before')), _toConsumableArray(_this3.model.get('statuses_after'))).filter(function (status) {
	                    return statuses[status.id];
	                }).map(function (status) {
	                    return statuses[status.id].cluster;
	                })));
	
	                if (_this3.model.get('webhook_server')) clusters.push(_this3.model.get('webhook_server').cluster);
	
	                var hash = (0, _arrays.hashify)(clusters.filter(function (cluster) {
	                    return !!cluster;
	                }), function (cluster) {
	                    return [cluster.id, cluster];
	                });
	
	                var distinctClusters = Object.values(hash);
	
	                if (distinctClusters.length == 0) return _this3.options.clusters.toJSON();else if (distinctClusters.length == 1) return distinctClusters;else return [];
	            }
	        };
	    },
	
	
	    events: {
	        'click .-close': function clickClose() {
	            this.trigger(_refbooks2.default.BACK);
	        },
	        'click .-save': function clickSave() {
	            var _this4 = this;
	
	            (0, _loader.beginLock)(this);
	
	            return this.options.scripts.save(this.Fields).then(function () {
	                return (/*field*/_this4.trigger(_refbooks2.default.BACK)
	                );
	            }, function (message) {
	                (0, _loader.endLock)(_this4);
	                (0, _messages.handle)(_this4.Fields, (0, _messages2.error)(message));
	            });
	        }
	    }
	
	}, _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Fields:type:toggle'), function (type) {
	    return this.model.set('type', type), this.navigated();
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Fields:entity:toggle'), function (entityType) {
	    return this.model.set('entity_type', entityType), this.navigated();
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Fields:op:toggle'), function (operation) {
	    return this.model.set('operation', operation), this.navigated();
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Ace:edit'), function (newScript) {
	    this.model.set('script', newScript);
	}), _RefBooksModule$exten), {
	
	    NEW: 'new-script',
	
	    EDIT: 'edit-script'
	
	});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RefBooksList$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _script = __webpack_require__(150);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _scripts = __webpack_require__(186);
	
	var _scripts2 = _interopRequireDefault(_scripts);
	
	var _scripts3 = __webpack_require__(149);
	
	var _scripts4 = _interopRequireDefault(_scripts3);
	
	var _popups = __webpack_require__(62);
	
	var _actions = __webpack_require__(17);
	
	var _roles = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend((_RefBooksList$extend = {
	
	    template: 'module/refbooks/scripts.list',
	
	    url: function url() {
	        return 'scripts/list/' + this.state().type.toLowerCase() + '/' + this.state().operation.toLowerCase();
	    },
	    open: function open() {
	        var _this = this;
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.trigger(_scripts2.default.NEW, new _script2.default({
	                    operation: _this.state().operation !== 'ALL-OPS' ? _this.state().operation : 'INSERT',
	                    type: _this.state().type !== 'ALL-TYPES' ? _this.state().type : 'VALIDATION',
	                    script: _this.state().type === 'VALIDATION' || _this.state().type === 'ALL-TYPES' ? 'return valid()' : 'return noop()'
	                }), _this.state().cluster);
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" scripts: with cluster == my cluster;
	                // there are only global and "my" types in the list;
	                // so, let's check only presence of cluster in sctipt
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                return _this.trigger(_scripts2.default.EDIT, current.clone());
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" scripts: with cluster == my cluster;
	                // there are only global and "my" types in the list;
	                // so, let's check only presence of cluster in sctipt
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('script::modal delete - confirmation text', 'script::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	        this.options.source = new _scripts4.default(this.options.scripts.models);
	        this.options.sorted = new _scripts4.default();
	        this.options.filtered = new _scripts4.default();
	        this.options.paged = new _scripts4.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    },
	    filterFn: function filterFn(model) {
	        var _state2 = this.state(),
	            operation = _state2.operation,
	            type = _state2.type;
	
	        return (operation === 'ALL-OPS' || model.get('operation') === operation) && (type === 'ALL-TYPES' || model.get('type') === type);
	    },
	    serialize: function serialize() {
	        var context = _refbooks2.default.prototype.serialize.call(this);
	
	        var workgroups = this.options.workgroups;
	
	        var workgroupsAltered = workgroups.toJSON().filter(function (model) {
	            return model.defaults;
	        }).map(function (_ref) {
	            var id = _ref.id,
	                name = _ref.organization.name;
	            return { id: id, name: name };
	        });
	
	        var _state3 = this.state(),
	            sort = _state3.sort,
	            direction = _state3.direction,
	            searchString = _state3.search,
	            operation = _state3.operation,
	            type = _state3.type;
	
	        this.filter();
	
	        return _extends({}, context, {
	            workgroups: workgroupsAltered,
	            actionList: this.options.paged.actions,
	            collection: this.options.paged,
	            sort: sort, direction: direction,
	            searchString: searchString,
	            operation: operation, type: type
	        });
	    }
	}, _defineProperty(_RefBooksList$extend, _refbooks2.default.event('op:toggle'), function (operation) {
	    var _this2 = this;
	
	    return this.setState({ page: 1, operation: operation }), this.render().then(function () {
	        return _this2.navigated();
	    });
	}), _defineProperty(_RefBooksList$extend, _refbooks2.default.event('type:toggle'), function (type) {
	    var _this3 = this;
	
	    return this.setState({ page: 1, type: type }), this.render().then(function () {
	        return _this3.navigated();
	    });
	}), _RefBooksList$extend));

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _server = __webpack_require__(152);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _servers = __webpack_require__(151);
	
	var _servers2 = _interopRequireDefault(_servers);
	
	var _popups = __webpack_require__(62);
	
	var _actions = __webpack_require__(17);
	
	var _roles = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/servers.list',
	
	    url: function url() {
	        return 'scripts/servers/list';
	    },
	    open: function open() {
	        var _this = this;
	
	        var form = new _form2.default({
	            template: 'module/refbooks/servers.form',
	            clusters: this.options.clusters
	        });
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                var current = new _server2.default();
	                var binding = form.bind(current);
	                binding.then(function () {
	                    if (_this.state().cluster && _this.state().cluster.id != -1) current.set('cluster', _this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) current.set('cluster', _config2.default.cluster());
	                });
	
	                (0, _popups.ask)(binding, 'server::modal new - title', 'actions::create', 'actions::cancel', function () {
	                    return _this.options.servers.save(form);
	                }).then(function () {
	                    return _this.options.source.reset(_this.options.servers.models, { silent: true // a sort of paranoia
	                    });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" servers: with cluster == my cluster;
	                // there are only global and "my" servers in the list;
	                // so, let's check only presence of cluster in server
	                // to separate "my".
	                return !!_this.options.filtered.current().get('cluster');
	            }, function (current) {
	                current = current.clone();
	                (0, _popups.ask)(form.bind(current), 'server::modal edit - title', 'actions::save', 'actions::close', function () {
	                    return _this.options.source.save(form);
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" servers: with cluster == my cluster;
	                // there are only global and "my" servers in the list;
	                // so, let's check only presence of cluster in server
	                // to separate "my".
	                return !!_this.options.filtered.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('server::modal delete - confirmation text', 'server::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	
	        this.options.source = new _servers2.default(this.options.servers.models);
	        this.options.sorted = new _servers2.default();
	        this.options.filtered = new _servers2.default();
	        this.options.paged = new _servers2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    }
	});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _priority = __webpack_require__(148);
	
	var _priority2 = _interopRequireDefault(_priority);
	
	var _priorities = __webpack_require__(147);
	
	var _priorities2 = _interopRequireDefault(_priorities);
	
	var _popups = __webpack_require__(62);
	
	var _roles = __webpack_require__(117);
	
	var _actions = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/priorities.list',
	
	    url: function url() {
	        return 'priorities';
	    },
	    open: function open() {
	        var _this = this;
	
	        var form = new _form2.default({
	            template: 'module/refbooks/priorities.form',
	            clusters: this.options.clusters
	        });
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                var current = new _priority2.default();
	                var binding = form.bind(current);
	                binding.then(function () {
	                    if (_this.state().cluster && _this.state().cluster.id != -1) current.set('cluster', _this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) current.set('cluster', _config2.default.cluster());
	                });
	
	                (0, _popups.ask)(binding, 'priority::modal new - title', 'actions::create', 'actions::cancel', function () {
	                    return _this.options.priorities.save(form);
	                }).then(function () {
	                    return _this.options.source.reset(_this.options.priorities.models, { silent: true // a sort of paranoia
	                    });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" priorities: with cluster == my cluster;
	                // there are only global and "my" priorities in the list;
	                // so, let's check only presence of cluster in priority
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                current = current.clone();
	                (0, _popups.ask)(form.bind(current), 'priority::modal edit - title', 'actions::save', 'actions::cancel', function () {
	                    return _this.options.source.save(form);
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" priorities: with cluster == my cluster;
	                // there are only global and "my" priorities in the list;
	                // so, let's check only presence of cluster in priority
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('priority::modal delete - confirmation text', 'priority::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	
	        this.options.source = new _priorities2.default(this.options.priorities.models);
	        this.options.sorted = new _priorities2.default();
	        this.options.filtered = new _priorities2.default();
	        this.options.paged = new _priorities2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    }
	});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _model2.default.extend({
	
	    endpoint: 'timetables?apiVersion=2.0',
	
	    defaults: function defaults() {
	        return {
	            title: '',
	            time_zone: null,
	            worktime: null,
	            cluster: null,
	            contract: null,
	            organization: null,
	            start_date_time: null,
	            finish_date_time: null,
	            on: true,
	            weekdays: [{
	                on: true,
	                times: [],
	                periods_months: [],
	
	                weekly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                monthly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                random_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                yearly_patterns: [{
	                    on: true,
	                    value: []
	                }]
	            }],
	            holidays: [{
	                on: true,
	
	                weekly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                monthly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                random_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                yearly_patterns: [{
	                    on: true,
	                    value: []
	                }]
	            }]
	        };
	    },
	    customParser: function customParser(_ref) {
	        var weekdays = _ref.weekdays,
	            holidays = _ref.holidays,
	            payload = _objectWithoutProperties(_ref, ['weekdays', 'holidays']);
	
	        // suppose we cannot eliminate patterns 
	        // in weekdays/holidays to []
	
	        if (weekdays && !weekdays.length) weekdays = null;
	
	        if (holidays && !holidays.length) holidays = null;
	
	        var attrs = _extends({
	
	            weekdays: weekdays || [{
	                on: true,
	                times: [],
	                periods_months: [],
	
	                weekly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                monthly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                random_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                yearly_patterns: [{
	                    on: true,
	                    value: []
	                }]
	            }],
	
	            holidays: holidays || [{
	                on: true,
	                times: [],
	                periods_months: [],
	
	                weekly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                monthly_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                random_patterns: [{
	                    on: true,
	                    value: []
	                }],
	
	                yearly_patterns: [{
	                    on: true,
	                    value: []
	                }]
	            }]
	
	        }, payload);
	
	        var checkPattern = function checkPattern(patternArray) {
	            return patternArray && !patternArray.length && patternArray.push({
	                on: true,
	                value: []
	            });
	        };
	        var checkPatterns = function checkPatterns(day) {
	            checkPattern(day.weekly_patterns);
	            checkPattern(day.monthly_patterns);
	            checkPattern(day.yearly_patterns);
	            checkPattern(day.random_patterns);
	        };
	        var checkDays = function checkDays(days) {
	            return days && days.forEach(checkPatterns);
	        };
	
	        checkDays(attrs.weekdays);
	        checkDays(attrs.holidays);
	
	        var commonCmp = function commonCmp(x, y) {
	            return x < y ? -1 : x > y ? 1 : 0;
	        };
	        var dateSplit = function dateSplit(ddmmyyyy) {
	            return ddmmyyyy.split('.').reverse();
	        };
	        var dateCmp = function dateCmp(x, y) {
	            return commonCmp(dateSplit(x), dateSplit(y));
	        };
	        var objCmp = function objCmp(a, b) {
	            return commonCmp(a.id, b.id);
	        };
	
	        var sortFn = function sortFn(group) {
	            group.monthly_patterns.forEach(function (p) {
	                return p.value.sort(function (x, y) {
	                    return x - y;
	                });
	            });
	            group.yearly_patterns.forEach(function (p) {
	                return p.value.sort(dateCmp);
	            });
	            group.random_patterns.forEach(function (p) {
	                return p.value.sort(dateCmp);
	            });
	            group.weekly_patterns.sort(objCmp);
	            group.monthly_patterns.sort(objCmp);
	            group.yearly_patterns.sort(objCmp);
	            group.random_patterns.sort(objCmp);
	        };
	
	        return attrs.weekdays.map(sortFn), attrs.holidays.map(sortFn), attrs.weekdays.sort(objCmp), attrs.holidays.sort(objCmp), attrs;
	    },
	    clonePattern: function clonePattern(pattern) {
	        var _this = this;
	
	        var cloneFn = function cloneFn(groups, patternsPropName) {
	            var searchingPattern = groups.map(function (group, index) {
	                return [index, group[patternsPropName].findIndex(function (p) {
	                    return p === pattern;
	                })];
	            }).filter(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2),
	                    _ = _ref3[0],
	                    patternIndex = _ref3[1];
	
	                return ~patternIndex;
	            });
	            if (!searchingPattern.length) return;
	
	            var _searchingPattern = _slicedToArray(searchingPattern, 1),
	                _searchingPattern$ = _slicedToArray(_searchingPattern[0], 2),
	                groupIndex = _searchingPattern$[0],
	                patternIndex = _searchingPattern$[1];
	
	            return _clonePattern.call(_this, groups, groupIndex, patternIndex, patternsPropName);
	        };
	
	        var f = function f(groups) {
	            return cloneFn(groups, 'random_patterns') || cloneFn(groups, 'yearly_patterns') || cloneFn(groups, 'monthly_patterns') || cloneFn(groups, 'weekly_patterns');
	        };
	
	        return f(this.get('weekdays')) || f(this.get('holidays'));
	    }
	});
	
	
	function _clonePattern(groups, groupIndex, patternIndex, patternProperty) {
	    var newGroups = [].concat(_toConsumableArray(groups));
	
	    if (!newGroups[groupIndex]) return;
	    var group = newGroups[groupIndex] = _extends({}, newGroups[groupIndex]);
	
	    if (!group[patternProperty]) return;
	    var patterns = group[patternProperty] = [].concat(_toConsumableArray(group[patternProperty]));
	
	    if (!patterns[patternIndex]) return;
	    var pattern = patterns[patternIndex] = _extends({}, patterns[patternIndex]);
	
	    return _defineProperty({
	        pattern: pattern
	    }, groups == this.get('weekdays') ? 'weekdays' : 'holidays', newGroups);
	}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Module$extend;
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _tasks = __webpack_require__(195);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _stats = __webpack_require__(197);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _popups = __webpack_require__(62);
	
	var _date = __webpack_require__(29);
	
	var _loader = __webpack_require__(20);
	
	var _api = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OPEN_LAUNCHES_DAILY = 'schedule--open-launches-launches',
	    TOGGLE_LIST_VIEW = 'schedule--toggle-list-view',
	    TOGGLE_CALENDAR = 'schedule--toggle-calendar';
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.calendar',
	
	    url: function url() {
	        var _options = this.options,
	            schedule = _options.schedule,
	            calendar = _options.calendar,
	            time = _options.time;
	
	
	        if (!schedule) return 'schedule/stats/' + calendar.fmt('YYYY-MM');
	
	        return time ? 'schedule/' + schedule.id + '/stats/' + calendar.fmt('YYYY-MM') + '/@/' + time.replace(':', '-') : 'schedule/' + schedule.id + '/stats/' + calendar.fmt('YYYY-MM');
	    },
	    open: function open(_ref) {
	        var _this = this;
	
	        var scheduleId = _ref.scheduleId,
	            time = _ref.time,
	            month = _ref.month,
	            date = _ref.date;
	
	        return this.options.scheduleId = scheduleId, this.options.calendar = new _calendar2.default(month), this.options.time = time, this.setState({
	            date: (0, _date.unixts)((0, _date.datify)(date))
	        }), this.options.stats = new _stats2.default({ calendar: this.options.calendar }), this.lastFiltering_ = Promise.resolve(), this.filtersModel = new _launch2.default.Model(this.state().filters), fetch.call(this).then(function () {
	            return _this.bind(_this.filtersModel);
	        });
	    },
	    start: function start() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	    serialize: function serialize() {
	        var _options2 = this.options,
	            schedule = _options2.schedule,
	            calendar = _options2.calendar,
	            stats = _options2.stats;
	
	        // todo
	        // fetch template task only for orgadmin/orginspector users
	        // to check capability to edit this template task
	        // templateTaskFetching = roleai.includes( Config.role() )
	        //     ? Task.byId( schedule.get( 'template' ).id )
	        //     : Promise.resolve();
	
	        return {
	            calendar: calendar, stats: stats,
	            date: this.state().date,
	            chosenTime: this.options.time,
	            schedule: schedule instanceof _model2.default ? schedule.toJSON() : schedule
	        };
	    },
	
	
	    events: {
	
	        'click .-new-schedule': function clickNewSchedule(_ref2) {
	            var currentTarget = _ref2.currentTarget;
	
	            this.trigger(_form2.default.POPUP_NEW);
	        },
	
	        'click .-toggle-list': function clickToggleList() {
	            this.trigger(TOGGLE_LIST_VIEW, this.options.calendar.getMonth(), this.state().date, this.state().filters, this.options.scheduleId, this.options.schedule ? this.options.time : undefined);
	        },
	        'click .-toggle-daily': function clickToggleDaily() {
	            if (this.options.schedule) this.trigger(_tasks2.default.REPLACE,
	            // pass id only; schedule will be retrieved by /tasks response
	            this.options.schedule.id, this.options.time, this.options.calendar.getMonth(), this.state().date, this.state().filters);else this.trigger(OPEN_LAUNCHES_DAILY, this.options.calendar.getMonth(), this.state().date, this.state().filters);
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Filters:change'), function (filters) {
	    var _this2 = this;
	
	    this.setState({ filters: filters });
	
	    return fetch.call(this).then(function () {
	        return _this2.Calendar.render();
	    }).then(function () {
	        return _this2.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('CalendarControls:set-month'), function (month) {
	    var _this3 = this;
	
	    return this.options.calendar.set(month), fetch.call(this).then(function () {
	        return Promise.all([_this3.Calendar.render(), _this3.CalendarControls.render()]);
	    }).then(function () {
	        return _this3.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Calendar:date:toggle'), function (date) {
	    if (this.options.schedule) this.trigger(_tasks2.default.REPLACE,
	    // pass id only; schedule will be retrieved by /tasks response
	    this.options.schedule.id, this.options.time, this.options.calendar.getMonth(), date, this.state().filters);else this.trigger(OPEN_LAUNCHES_DAILY, this.options.calendar.getMonth(), date, this.state().filters);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:unpin'), function () {
	    this.trigger(TOGGLE_CALENDAR, undefined, undefined, this.options.calendar.getMonth(), this.state().date, this.state().filters);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref3) {
	    var id = _ref3.id;
	
	    return this.trigger(_form2.default.POPUP_EDIT,
	    // pass id only to force Schedule.byId in Form
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref4) {
	    var _this4 = this;
	
	    var id = _ref4.id;
	
	    return (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this4).cerebellum().execute();
	    }).then(function () {
	        return (0, _loader.beginLock)(_this4);
	    }).then(function () {
	        return fetch.call(_this4);
	    }).then(function () {
	        return _this4.Calendar.render();
	    }).then(function () {
	        return (0, _loader.endLock)(_this4);
	    }, function () {
	        return (0, _loader.endLock)(_this4);
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref5) {
	    var id = _ref5.id;
	
	    this.trigger(_templates2.default.POPUP,
	    // pass id only to force Schedule.byId in Template List
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':time:toggle'), function (time) {
	    var _this5 = this;
	
	    this.options.time = time !== this.options.time ? time : undefined;
	    this.setState({ page: 1 });
	
	    return fetch.call(this).then(function () {
	        return _this5.render();
	    }).then(function () {
	        return _this5.navigated();
	    });
	}), _Module$extend), {
	
	    OPEN_LAUNCHES_DAILY: OPEN_LAUNCHES_DAILY,
	
	    TOGGLE_LIST_VIEW: TOGGLE_LIST_VIEW,
	
	    TOGGLE_CALENDAR: TOGGLE_CALENDAR
	
	});
	
	
	function fetch() {
	    var _this6 = this;
	
	    var _options3 = this.options,
	        stats = _options3.stats,
	        scheduleId = _options3.scheduleId,
	        time = _options3.time,
	        filters = this.filtersModel.values();
	
	
	    if (scheduleId) filters.timetableId = scheduleId;
	    if (time) filters.time = time;
	
	    return this.lastFiltering_ = this.lastFiltering_.then(function () {
	        return stats.filter(filters);
	    }).then(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 3),
	            items = _ref7[0],
	            coll = _ref7[1],
	            resp = _ref7[2];
	
	        _this6.options.times = resp.times;
	        _this6.options.schedule = resp.schedule;
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _preview = __webpack_require__(131);
	
	var _preview2 = _interopRequireDefault(_preview);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _arrays = __webpack_require__(24);
	
	var _date = __webpack_require__(29);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _popups = __webpack_require__(62);
	
	var _loader = __webpack_require__(20);
	
	var _roles = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var POPUP_NEW = 'schedule-form--popup-new',
	    POPUP_EDIT = 'schedule-form--popup-edit';
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.form',
	
	    url: function url() {
	        var _options = this.options,
	            schedule = _options.schedule,
	            groupType = _options.groupType;
	
	        var openedTab = this.state()[groupType + '-opened-tab'];
	        var urlTemplate = schedule.id ? 'schedule/' + schedule.id + '/edit/' + groupType + '/' + openedTab : 'schedule/new/' + groupType + '/' + openedTab;
	
	        var yyyy = this.state()[groupType + '-year'];
	        return openedTab == 'random' ? urlTemplate + ('/' + yyyy) : urlTemplate;
	    },
	    open: function open(_ref) {
	        var _this = this;
	
	        var id = _ref.id,
	            schedule = _ref.schedule,
	            otherArgs = _objectWithoutProperties(_ref, ['id', 'schedule']);
	
	        return schedule ? this.openSchedule(_extends({ schedule: schedule }, otherArgs)) : _schedule2.default.byId(id).then(function (schedule) {
	            return _this.openSchedule(_extends({ schedule: schedule }, otherArgs));
	        });
	    },
	    openSchedule: function openSchedule(_ref2) {
	        var schedule = _ref2.schedule,
	            _ref2$groupType = _ref2.groupType,
	            groupType = _ref2$groupType === undefined ? 'weekdays' : _ref2$groupType,
	            openedTab = _ref2.openedTab,
	            yyyy = _ref2.yyyy;
	
	        this.options.groupType = groupType;
	
	        var defaultYear = (0, _date.fmt)(new Date(), 'YYYY');
	        this.setState(_defineProperty({
	            'weekdays-opened-tab': 'times',
	            'holidays-opened-tab': 'weekly',
	            'weekdays-year': defaultYear,
	            'holidays-year': defaultYear
	        }, groupType + '-year', yyyy || defaultYear));
	
	        if (openedTab) this.setState(_defineProperty({}, groupType + '-opened-tab', openedTab));
	
	        var extendPattern = function extendPattern(pattern) {
	            pattern.v = (0, _arrays.hashify)(pattern.value);
	            pattern.add = {};
	            pattern.remove = {};
	        };
	
	        var extendGroup = function extendGroup(group) {
	            group.random_patterns.forEach(extendPattern);
	            group.yearly_patterns.forEach(extendPattern);
	            group.monthly_patterns.forEach(extendPattern);
	        };
	
	        schedule.get('weekdays').forEach(extendGroup);
	        schedule.get('holidays').forEach(extendGroup);
	
	        return this.options.schedule = schedule, this.bind(schedule);
	    },
	    start: function start() {
	        var _this2 = this;
	
	        this.listenTo(this.model, 'change:contract', function () {
	            if (_this2.model.get('contract')) {
	                var contract = _this2.options.contracts.find(function (contract) {
	                    return contract.id == _this2.model.get('contract').id;
	                });
	                if (contract) _this2.model.set('contract', contract.toJSON(), { silent: true });
	            }
	
	            Object.keys(_this2).filter(function (key) {
	                return key.startsWith('Random');
	            }).map(function (key) {
	                return _this2[key];
	            }).forEach(function (randomPatternView) {
	                return randomPatternView.render();
	            });
	        });
	
	        this.listenTo(this.model, 'change:start_date_time change:finish_date_time', function () {
	            Object.keys(_this2).filter(function (key) {
	                return key.startsWith('Random');
	            }).map(function (key) {
	                return _this2[key];
	            }).forEach(function (randomPatternView) {
	                return randomPatternView.render();
	            });
	        });
	
	        this.listenTo(this.model, 'change', function () {
	            return _this2.$('[name="save-schedule"]')[0].disabled = !_this2.hasDiff();
	        });
	
	        return this;
	    },
	    stop: function stop() {
	        return this.stopListening(this.model, 'change:contract'), this;
	    },
	    hasDiff: function hasDiff() /*options = {}*/{
	        if (!this.Fields || !this.model || !this.Fields.originalModel) return false;
	
	        return JSON.stringify(this.model.toJSON()) != JSON.stringify(this.Fields.originalModel.toJSON());
	    },
	    serialize: function serialize() {
	        var weekdays = this.model.get('weekdays');
	        var holidays = this.model.get('holidays');
	        var yyyy = this.state()[this.options.groupType + '-year'];
	        var year = (0, _date.datify)(yyyy + '-01-01');
	
	        var orgsHash = (0, _arrays.hashify)(_config2.default.orgs());
	
	        return {
	            openedTab: this.state()[this.options.groupType + '-opened-tab'],
	            weekdays: weekdays, holidays: holidays,
	            prevYear: (0, _date.prevYear)(year),
	            nextYear: (0, _date.nextYear)(year),
	            year: year,
	            hasDiff: this.hasDiff(),
	            organizations: _roles.roleAICK.indexOf(_config2.default.role()) !== -1 ? this.options.organizations : this.options.organizations.toJSON().filter(function (org) {
	                return orgsHash[org.id];
	            })
	        };
	    },
	    afterRender: function afterRender() {
	        var _this3 = this;
	
	        var _findInvalidInputs$ca = findInvalidInputs.call(this),
	            _findInvalidInputs$ca2 = _slicedToArray(_findInvalidInputs$ca, 2),
	            emptyIndex = _findInvalidInputs$ca2[0],
	            duplicateIndexes = _findInvalidInputs$ca2[1];
	
	        var errFn = function errFn(errIndex) {
	            return _this3.$('.schedule--time-list [type=time]').eq(errIndex).closest('.form-group').addClass('has-error');
	        };
	
	        if (emptyIndex !== undefined) return errFn(emptyIndex);
	
	        if (duplicateIndexes) return duplicateIndexes.forEach(errFn);
	    },
	
	
	    events: {
	        'click .-group-tab-switch': function clickGroupTabSwitch(_ref3) {
	            var _this4 = this;
	
	            var target = _ref3.originalEvent.target;
	            var tabName = target.dataset.tabName;
	
	            // to ignore clicking on inner checkbox
	
	            if (this.$(target).is('.-group-tab-switch')) return this.setState(_defineProperty({}, this.options.groupType + '-opened-tab', tabName)), this.render().then(function () {
	                return _this4.navigated();
	            });
	        },
	        'change [type="time"]': function changeTypeTime(e) {
	            var _e$target$dataset = e.target.dataset,
	                weekdaysIndex = _e$target$dataset.weekdaysIndex,
	                timeIndex = _e$target$dataset.timeIndex;
	
	            var enteredTime = this.$(e.target).val();
	
	            changeTimes.call(this, +weekdaysIndex, function (times) {
	                return times.map(function (tm, index) {
	                    return index == timeIndex ? _extends({}, tm, { time: enteredTime || tm.time }) : tm;
	                });
	            });
	
	            if (enteredTime) this.$(e.target).closest('.form-group').removeClass('has-error');
	        },
	        'change .schedule--time-list [type="checkbox"]': function changeScheduleTimeListTypeCheckbox(e) {
	            var _e$target$dataset2 = e.target.dataset,
	                weekdaysIndex = _e$target$dataset2.weekdaysIndex,
	                timeIndex = _e$target$dataset2.timeIndex;
	
	            changeTimes.call(this, +weekdaysIndex, function (times) {
	                return times.map(function (tm, index) {
	                    return index == timeIndex ? _extends({}, tm, { on: e.target.checked }) : tm;
	                });
	            });
	
	            this.$(e.target).closest('.row-by-3').find('[type=time]').prop('readonly', !e.target.checked);
	        },
	        'click .schedule--time-list-input .input-group-addon': function clickScheduleTimeListInputInputGroupAddon(e) {
	            var _$$closest$find$0$dat = this.$(e.target).closest('.input-group').find('[type="time"]')[0].dataset,
	                weekdaysIndex = _$$closest$find$0$dat.weekdaysIndex,
	                timeIndex = _$$closest$find$0$dat.timeIndex;
	
	
	            changeTimes.call(this, +weekdaysIndex, function (times) {
	                return times.filter(function (_, index) {
	                    return index != timeIndex;
	                });
	            });
	
	            return this.render();
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('form:save'), function () {
	    var _this5 = this;
	
	    var _findInvalidInputs$ca3 = findInvalidInputs.call(this),
	        _findInvalidInputs$ca4 = _slicedToArray(_findInvalidInputs$ca3, 2),
	        emptyIndex = _findInvalidInputs$ca4[0],
	        duplicateIndexes = _findInvalidInputs$ca4[1];
	
	    if (emptyIndex !== undefined || duplicateIndexes) return this.options.groupType = 'weekdays', this.setState({ 'weekdays-opened-tab': 'times' }), this.render().then(function () {
	        return _this5.navigated();
	    });
	
	    (0, _loader.beginLock)(this);
	
	    return save.call(this).then(function (schedule) {
	        return _this5.model.id ? _this5.trigger(_module2.default.BACK) : _this5.trigger(_templates2.default.REPLACE, schedule);
	    }, function (message) {
	        (0, _loader.endLock)(_this5);
	        (0, _messages2.handle)(_this5.Fields, (0, _messages.error)(message));
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('form:preview'), function () {
	    var view = new _preview2.default({
	        month: (0, _date.beginMonth)(new Date()),
	        attrs: json.call(this)
	    });
	
	    return (0, _popups.ask)(view.render(), 'actions::preview', 'actions::close', undefined, { large: true });
	}), _defineProperty(_Module$extend, _module2.default.event('form:close'), function () {
	    this.trigger(_module2.default.BACK);
	}), _defineProperty(_Module$extend, _module2.default.event('group:switch'), function (groupType) {
	    var _this6 = this;
	
	    return this.options.groupType = groupType, this.render().then(function () {
	        return _this6.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('dayOfWeek:toggle'), function (dayOfWeek, originalPattern) {
	    var _model$clonePattern = this.model.clonePattern(originalPattern),
	        pattern = _model$clonePattern.pattern,
	        props = _objectWithoutProperties(_model$clonePattern, ['pattern']);
	
	    if (pattern.value.indexOf(dayOfWeek) !== -1) pattern.value = pattern.value.filter(function (d) {
	        return d !== dayOfWeek;
	    });else pattern.value = [].concat(_toConsumableArray(pattern.value), [dayOfWeek]);
	
	    return this.model.set(props), this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('pattern:toggle'), function (originalPattern) {
	    var _model$clonePattern2 = this.model.clonePattern(originalPattern),
	        pattern = _model$clonePattern2.pattern,
	        props = _objectWithoutProperties(_model$clonePattern2, ['pattern']);
	
	    return pattern.on = !pattern.on, this.model.set(props), this.render();
	}), _defineProperty(_Module$extend, _module2.default.event('time:add'), function (weekdaysIndex) {
	    var _this7 = this;
	
	    changeTimes.call(this, +weekdaysIndex, function (times) {
	        return [].concat(_toConsumableArray(times), [{ time: undefined, on: true }]);
	    });
	
	    return this.render().then(function () {
	        return _this7.$el.find('.schedule--time-list [type=time]').last().focus().closest('.form-group').removeClass('has-error');
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('year:set'), function (year) {
	    var _this8 = this;
	
	    return this.setState(_defineProperty({}, this.options.groupType + '-year', (0, _date.fmt)(year, 'YYYY'))), this.render().then(function () {
	        return _this8.navigated();
	    });
	}), _Module$extend), {
	
	    POPUP_NEW: POPUP_NEW,
	
	    POPUP_EDIT: POPUP_EDIT
	
	});
	
	
	function json() {
	    var _model$toJSON = this.model.toJSON(),
	        templates = _model$toJSON.templates,
	        weekdays = _model$toJSON.weekdays,
	        holidays = _model$toJSON.holidays,
	        otherAttrs = _objectWithoutProperties(_model$toJSON, ['templates', 'weekdays', 'holidays']);
	
	    var mapPatternFn = function mapPatternFn(_ref4) {
	        var value = _ref4.value,
	            v = _ref4.v,
	            add = _ref4.add,
	            remove = _ref4.remove,
	            attrs = _objectWithoutProperties(_ref4, ['value', 'v', 'add', 'remove']);
	
	        return _extends({}, attrs, {
	            value: [].concat(_toConsumableArray(Object.keys(add)), _toConsumableArray(Object.keys(v).filter(function (val) {
	                return !remove[val];
	            })))
	        });
	    };
	
	    var mapGroupFn = function mapGroupFn(group) {
	        var random_patterns = group.random_patterns,
	            yearly_patterns = group.yearly_patterns,
	            monthly_patterns = group.monthly_patterns,
	            otherAttrs = _objectWithoutProperties(group, ['random_patterns', 'yearly_patterns', 'monthly_patterns']);
	
	        return _extends({}, otherAttrs, {
	            random_patterns: random_patterns.map(mapPatternFn),
	            yearly_patterns: yearly_patterns.map(mapPatternFn),
	            monthly_patterns: monthly_patterns.map(mapPatternFn)
	        });
	    };
	
	    var attrs = _extends({}, otherAttrs);
	
	    if (this.Fields.originalModel) {
	        var originalWeekdays = this.Fields.originalModel.get('weekdays');
	        if (JSON.stringify(weekdays) !== JSON.stringify(originalWeekdays)) attrs.weekdays = weekdays.map(mapGroupFn);
	
	        var originalHolidays = this.Fields.originalModel.get('holidays');
	        if (JSON.stringify(holidays) !== JSON.stringify(originalHolidays)) attrs.holidays = holidays.map(mapGroupFn);
	    }
	
	    return attrs;
	}
	
	function save() {
	    if (this.model.id)
	        // todo pattern.v, add, remove
	        return this.model.patch(json.call(this));
	
	    return new _schedule2.default(json.call(this)).save()
	    // todo pattern.v, add, remove
	    .then(function (attrs) {
	        return new _schedule2.default(attrs);
	    });
	}
	
	function findInvalidInputs() {
	    var weekdays = this.model.get('weekdays');
	    var times = (weekdays[0] || []).times.map(function (time, index) {
	        return [time, index];
	    });
	    var emptyTimes = times.filter(function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 1),
	            time = _ref6[0];
	
	        return !time.time;
	    });
	    var nonEmptyTimes = times.filter(function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 1),
	            time = _ref8[0];
	
	        return !!time.time;
	    });
	
	    var _ref9 = emptyTimes.length ? emptyTimes : [[]],
	        _ref10 = _slicedToArray(_ref9, 1),
	        _ref10$ = _slicedToArray(_ref10[0], 2),
	        _ = _ref10$[0],
	        emptyIndex = _ref10$[1];
	
	    var hash = (0, _arrays.hashify)(nonEmptyTimes, function (_ref11, hash) {
	        var _ref12 = _slicedToArray(_ref11, 2),
	            time = _ref12[0],
	            index = _ref12[1];
	
	        var indexes = hash[time.time] || [];
	        return [time.time, [].concat(_toConsumableArray(indexes), [index])];
	    });
	
	    var _Object$values$filter = Object.values(hash).filter(function (indexArray) {
	        return indexArray.length > 1;
	    }),
	        _Object$values$filter2 = _slicedToArray(_Object$values$filter, 1),
	        duplicateIndexes = _Object$values$filter2[0];
	
	    return [emptyIndex, duplicateIndexes];
	}
	
	function changeTimes(weekdaysIndex, timesFn) {
	    var weekdays = [].concat(_toConsumableArray(this.model.get('weekdays')));
	
	    weekdays[weekdaysIndex] = _extends({}, weekdays[weekdaysIndex], {
	        times: timesFn(weekdays[weekdaysIndex].times)
	    });
	
	    return this.model.set('weekdays', weekdays);
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Module$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _templates = __webpack_require__(194);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _popups = __webpack_require__(62);
	
	var _api = __webpack_require__(77);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var POPUP = 'schedule-card-templates--popup',
	    REPLACE = 'schedule-card-templates--open-replace';
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.templates.list',
	
	    url: function url() {
	        return 'schedule/' + this.options.schedule.id + '/templates';
	    },
	    open: function open(_ref) {
	        var _this = this;
	
	        var id = _ref.id,
	            schedule = _ref.schedule;
	
	        var fetchingSchedule = schedule ? Promise.resolve(schedule) : _schedule2.default.byId(id);
	
	        this.lastFiltering_ = Promise.resolve();
	        this.filtersModel = new _launch2.default.Model(this.state().filters);
	        this.options.templates = new _collection2.default({
	            endpoint: 'timetables/' + (schedule ? schedule.id : id) + '/templates?apiVersion=2.0',
	            responseAt: 'items',
	            countAt: 'total'
	        });
	
	        var fetchingTemplates = fetch.call(this);
	
	        return Promise.all([fetchingSchedule, fetchingTemplates]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 1),
	                schedule = _ref3[0];
	
	            return _this.options.schedule = schedule;
	        }).then(function () {
	            return _this.bind(_this.filtersModel);
	        });
	    },
	    start: function start() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	    serialize: function serialize() {
	        var schedule = this.options.schedule;
	
	        return {
	            schedule: schedule instanceof _model2.default ? schedule.toJSON() : schedule
	        };
	    },
	
	
	    events: {
	        'click .-back': function clickBack() {
	            this.trigger(_module2.default.BACK);
	        },
	        'click .-popup-schedule-template': function clickPopupScheduleTemplate(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var templateId = currentTarget.dataset.templateId;
	
	            this.trigger(_templates2.default.POPUP_EDIT, this.options.schedule, templateId);
	        },
	        'click .-remove-schedule-template': function clickRemoveScheduleTemplate(_ref5) {
	            var _this2 = this;
	
	            var currentTarget = _ref5.currentTarget;
	
	            var templateId = currentTarget.dataset.templateId,
	                schedule = this.options.schedule;
	
	
	            return (0, _popups.ask)('schedule::modal delete template - confirmation text', 'schedule::modal delete template - title', 'actions::yes', 'actions::no', function () {
	                (0, _loader.beginLock)(_this2);
	                return new _schedule2.default({ id: schedule.id }).patch({ templates: {
	                        remove: [{ id: +templateId }]
	                    } });
	            }).then(function () {
	                if (_this2.options.templates.length == 1 && _this2.options.templates.total > 1) if (_this2.state().page > 1) _this2.setState({ page: _this2.state().page - 1 });
	            }).then(function () {
	                return fetch.call(_this2);
	            }).then(function () {
	                return Promise.all([_this2.Templates.render(), _this2.Paging.render()]);
	            }).then(function () {
	                return (0, _loader.endLock)(_this2);
	            }, function () {
	                return (0, _loader.endLock)(_this2);
	            }).then(function () {
	                return _this2.navigated();
	            });
	        },
	        'click .-new-template': function clickNewTemplate() {
	            this.trigger(_templates2.default.POPUP_NEW, this.options.schedule);
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Filters:change'), function (filters) {
	    var _this3 = this;
	
	    return this.setState({ filters: filters, page: 1 }), fetch.call(this).then(function () {
	        return Promise.all([_this3.Templates.render(), _this3.Paging.render()]);
	    }).then(function () {
	        return _this3.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this4 = this;
	
	    return this.setState({ page: +page }), fetch.call(this).then(function () {
	        return Promise.all([_this4.Templates.render(), _this4.Paging.render()]);
	    }).then(function () {
	        return _this4.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function () {
	    return this.trigger(_form2.default.POPUP_EDIT, this.options.schedule);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref6) {
	    var _this5 = this;
	
	    var id = _ref6.id;
	
	    return (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this5).cerebellum().execute();
	    }).then(function () {
	        return _this5.trigger(_module2.default.BACK);
	    });
	}), _Module$extend), {
	
	    POPUP: POPUP,
	
	    REPLACE: REPLACE
	
	});
	
	
	function fetch() {
	    var templates = this.options.templates,
	        _state = this.state(),
	        filters = _state.filters,
	        page = _state.page;
	
	
	    return this.lastFiltering_ = this.lastFiltering_.then(function () {
	        return templates.filter(_extends({}, filters, {
	            page: page,
	            limit: 12
	        }));
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _arrays = __webpack_require__(24);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _date = __webpack_require__(29);
	
	var _loader = __webpack_require__(20);
	
	var _roles = __webpack_require__(117);
	
	var _task3 = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var POPUP_NEW = 'schedule-template--popup-new',
	    POPUP_EDIT = 'schedule-template--popup-edit';
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.templates.form',
	
	    url: function url() {
	        return this.model.id ? 'schedule/' + this.schedule_.id + '/template/' + this.model.id : 'schedule/' + this.schedule_.id + '/new-template';
	    },
	    open: function open(_ref) {
	        var _this = this;
	
	        var schedule = _ref.schedule,
	            scheduleId = _ref.scheduleId,
	            templateTask = _ref.templateTask,
	            templateTaskId = _ref.templateTaskId,
	            otherArgs = _objectWithoutProperties(_ref, ['schedule', 'scheduleId', 'templateTask', 'templateTaskId']);
	
	        var schedulePromise = schedule ? Promise.resolve(schedule) : _schedule2.default.byId(scheduleId);
	        var templateTaskPromise = templateTask ? Promise.resolve(templateTask) : _task2.default.byId(templateTaskId);
	
	        return Promise.all([schedulePromise, templateTaskPromise]).then(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                schedule = _ref3[0],
	                templateTask = _ref3[1];
	
	            return _this.openSchedule(_extends({ schedule: schedule, templateTask: templateTask }, otherArgs));
	        });
	    },
	    openSchedule: function openSchedule(_ref4) {
	        var schedule = _ref4.schedule,
	            templateTask = _ref4.templateTask;
	
	        if (schedule.get('contract'))
	            // will not be sent to server
	            templateTask.set('contract_id', schedule.get('contract').id);
	
	        // edit
	        if (templateTask.id) return this.schedule_ = schedule, this.bind(templateTask);
	
	        // create
	        templateTask.capabilities_ = {
	            edit: true,
	            update_title: true, update_text: true,
	            update_type: true, update_priority: true, update_point: true,
	            update_deadline: true,
	            update_custom_fields: true,
	            assign_department: _roles.roleAICKai.indexOf(_config2.default.role()) !== -1,
	            assign_user: _roles.roleAICKai.indexOf(_config2.default.role()) !== -1
	        };
	
	        templateTask.set('date', (0, _date.unixts)(new Date()));
	
	        if (schedule.get('cluster')) templateTask.set('cluster_id', schedule.get('cluster').id);else if (schedule.get('organization')) {
	            var defaultAssigneeId = this.options.organizations.toJSON().filter(function (org) {
	                return org.id == schedule.get('organization').id;
	            })[0].default_assigned_organization_id;
	            templateTask.set({
	                organization_id: schedule.get('organization').id,
	                assigned_organization_id: defaultAssigneeId || undefined
	            });
	        }
	
	        var cluster = schedule.get('contract') ? schedule.get('contract').cluster : schedule.get('cluster') ? schedule.get('cluster') : schedule.get('organization') ? schedule.get('organization').cluster : null;
	
	        var filteredPriorities = this.options.priorities.toJSON()
	        // global schedule -> any priority
	        // global priority -> any schedule
	        // otherwise match clusters
	        .filter(function (priority) {
	            return !cluster || !priority.cluster || cluster.id == priority.cluster.id;
	        });
	        var priorityClusters = (0, _arrays.hashify)(filteredPriorities.map(function (priority) {
	            return priority.cluster ? priority.cluster.id : -1;
	        }));
	        // all priorities belong to the same cluster? 
	        // take first priority as default
	
	        var _ref5 = Object.keys(priorityClusters).length === 1 ? filteredPriorities : [],
	            _ref6 = _slicedToArray(_ref5, 1),
	            priority = _ref6[0];
	
	        if (priority) templateTask.set('priority_id', priority.id);
	
	        return this.schedule_ = schedule, this.bind(templateTask);
	    },
	    start: function start() {
	        var _this2 = this;
	
	        this.listenTo(this.model, 'change', function () {
	            return _this2.Buttons.render();
	        });
	
	        // AS IN /module/tasks/form.js
	
	        // but this form also works in CREATE-mode,
	        // so do not block interface in this case
	        if (!this.model.id) return this;
	
	        var org = this.options.organizations.toJSON().find(function (org) {
	            return org.id == _this2.model.get('organization_id');
	        });
	        var type = this.options.types.toJSON().find(function (type) {
	            return type.id == _this2.model.get('type_id');
	        });
	        var isTypeAvailable = type ? type.role_ids == null || type.role_ids.indexOf(_config2.default.role()) !== -1 || type.role_ids.indexOf(+_config2.default.role()) !== -1 : false;
	        if (org && isTypeAvailable) this.TaskForm.focus();else
	            // task of deleted org/cluster or unavailable type
	            this.TaskForm.disable(),
	            // this.Schedule && this.Schedule.disable(),
	            this.Map.disable(),
	            // this.Comments.disable();
	            this.Attachments.disable();
	
	        // no checking for capabilities ("edit", "update_point")
	        // because all caps are "true"-valued (see serialize() below)
	
	        return this;
	    },
	    stop: function stop() {
	        this.stopListening(this.model);
	        return this;
	    },
	    serialize: function serialize() {
	        var _this3 = this;
	
	        return {
	            schedule: this.schedule_ instanceof _model2.default ? this.schedule_.toJSON() : this.schedule_,
	            capabilities: {
	                edit: true,
	                update_title: true, update_text: true,
	                update_type: true, update_priority: true, update_point: true,
	                update_deadline: true,
	                update_custom_fields: true,
	                assign_department: true,
	                assign_user: true
	            },
	            hasDiff: function hasDiff() {
	                return _this3.TaskForm.hasDiff({ fields: _this3.options.fields });
	            }
	        };
	    },
	
	
	    events: {
	        'click .-save': function clickSave() {
	            var _this4 = this;
	
	            var onResolve = function onResolve() {
	                return (/*schedule*/_this4.trigger(_module2.default.BACK)
	                );
	            },
	                onReject = function onReject(message) {
	                (0, _loader.endLock)(_this4);
	                (0, _messages2.handle)(_this4.TaskForm, (0, _messages.error)(message));
	            };
	
	            (0, _loader.beginLock)(this);
	
	            var _TaskForm$validate = this.TaskForm.validate(),
	                result = _TaskForm$validate.result,
	                messages = _TaskForm$validate.messages;
	
	            if (!result) return onReject(messages[0] /* [text, field] */);
	
	            return (0, _task3.save)(this, { contract_id: true }).then(function (_ref7) {
	                var task = _ref7.task;
	                return new _schedule2.default({ id: _this4.schedule_.id }).patch({
	                    templates: {
	                        add: [{ id: task.id }]
	                    }
	                });
	            }).then(onResolve, onReject);
	        },
	        'click .-close': function clickClose() {
	            this.trigger(_module2.default.BACK);
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Map:map:click'), function (location) {
	    if (!this.Map.disabled()) this.model.set('location', location), this.Map.render();
	}), _defineProperty(_Module$extend, _module2.default.event('Map:service-object:choose'), function (_ref8) {
	    var objectId = _ref8.objectId,
	        layerId = _ref8.layerId;
	
	    if (!this.Map.disabled()) if (this.model) this.model.set({
	        service_object_id: objectId,
	        service_object_layer_id: layerId
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Map:address:choose'), function (attrs) {
	    if (!this.Map.disabled()) this.model.set('location', attrs.coords), this.Map.render();
	}), _Module$extend), {
	
	    POPUP_NEW: POPUP_NEW,
	
	    POPUP_EDIT: POPUP_EDIT
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Module$extend;
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _tasks = __webpack_require__(196);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _calendar3 = __webpack_require__(191);
	
	var _calendar4 = _interopRequireDefault(_calendar3);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _stats = __webpack_require__(197);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _templates = __webpack_require__(194);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _templates3 = __webpack_require__(193);
	
	var _templates4 = _interopRequireDefault(_templates3);
	
	var _list = __webpack_require__(179);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _popups = __webpack_require__(62);
	
	var _date = __webpack_require__(29);
	
	var _api = __webpack_require__(77);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var REPLACE = 'schedule-card--open-replace';
	
	exports.default = _module2.default.extend((_Module$extend = {
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _module2.default.prototype.initialize.call(this, options);
	
	        this.lastFiltering_ = Promise.resolve();
	    },
	
	
	    template: 'jst/module.schedule.tasks',
	
	    url: function url() {
	        return this.options.time ? 'schedule/' + this.options.schedule.id + '/tasks/' + (0, _date.fmt)(this.options.date, 'YYYY-MM-DD') + '/@/' + this.options.time.replace(':', '-') : 'schedule/' + this.options.schedule.id + '/tasks/' + (0, _date.fmt)(this.options.date, 'YYYY-MM-DD');
	    },
	    open: function open(_ref) {
	        var _this = this;
	
	        var scheduleId = _ref.scheduleId,
	            time = _ref.time,
	            month = _ref.month,
	            date = _ref.date;
	
	        return this.options.scheduleId = scheduleId, this.options.time = time, this.setState({ month: (0, _date.unixts)((0, _date.datify)(month)) }), this.options.date = date, this.options.tasks = new _tasks2.default([]), this.options.calendar = new _calendar2.default(this.state().month), this.options.stats = new _collection2.default(), this.filtersModel = new _launch2.default.Model(this.state().filters), this.lastFiltering_ = Promise.resolve(), this.postpone(fetchTasks, fetchCalendar).then(function () {
	            return _this.bind(_this.filtersModel);
	        });
	    },
	    start: function start() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	
	
	    events: {
	        'click .-toggle-list': function clickToggleList() {
	            this.trigger(_calendar4.default.TOGGLE_LIST_VIEW, (0, _date.datify)(this.state().month), this.options.date, this.state().filters, this.options.schedule.id, this.options.time);
	        },
	
	
	        'click .-new-schedule': function clickNewSchedule(_ref2) {
	            var currentTarget = _ref2.currentTarget;
	
	            this.trigger(_form2.default.POPUP_NEW);
	        },
	
	        'click .-popup-schedule-template': function clickPopupScheduleTemplate(_ref3) {
	            var currentTarget = _ref3.currentTarget;
	            var templateId = currentTarget.dataset.templateId;
	
	            this.trigger(_templates2.default.POPUP_EDIT,
	            // pass id only to force Schedule.byId in Template form
	            this.options.schedule.id, templateId, this.state().month); // todo month?
	        },
	        'click .-remove-schedule-template': function clickRemoveScheduleTemplate(_ref4) {
	            var _this2 = this;
	
	            var currentTarget = _ref4.currentTarget;
	
	            var templateId = currentTarget.dataset.templateId,
	                schedule = this.options.schedule;
	
	
	            var deletion = (0, _popups.ask)('schedule::modal delete template - confirmation text', 'schedule::modal delete template - title', 'actions::yes', 'actions::no', function () {
	                (0, _loader.beginLock)(_this2);
	                return new _schedule2.default({ id: schedule.id }).patch({ templates: {
	                        remove: [{ id: +templateId }]
	                    } });
	            });
	
	            deletion.then(function () {
	                return (0, _loader.endLock)(_this2);
	            }, function () {
	                return (0, _loader.endLock)(_this2);
	            });
	
	            return reRenderAfterDeletion.call(this, deletion);
	        },
	        'click .-toggle-monthly': function clickToggleMonthly() {
	            this.trigger(_calendar4.default.TOGGLE_CALENDAR,
	            // pass id only; schedule will be retrieved by /stats response
	            this.options.schedule.id, this.options.time, this.state().month, this.options.date, this.state().filters);
	        },
	        'click .-open-task': function clickOpenTask(e) {
	            var taskId = e.currentTarget.dataset.taskId;
	
	            this.trigger(_list2.default.OPEN_TASK, +taskId);
	            return e.stopPropagation(), undefined;
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref5) {
	    var id = _ref5.id;
	
	    return this.trigger(_form2.default.POPUP_EDIT,
	    // pass id only to force Schedule.byId in Form
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref6) {
	    var _this3 = this;
	
	    var id = _ref6.id;
	
	    var deletion = (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this3).cerebellum().execute();
	    });
	
	    return reRenderAfterDeletion.call(this, deletion);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref7) {
	    var id = _ref7.id;
	
	    return this.trigger(_templates4.default.POPUP,
	    // pass id only to force Schedule.byId in Template List
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event('Filters:change'), function (filters) {
	    var _this4 = this;
	
	    this.setState({ filters: filters, page: 1 });
	    return this.postpone(fetchTasks, fetchCalendar).then(function () {
	        return Promise.all([_this4.Calendar.render(), _this4.Tasks.render(), _this4.Paging.render()]);
	    }).then(function () {
	        return _this4.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this5 = this;
	
	    return this.setState({ page: +page }), (0, _loader.beginLock)(this), this.postpone(fetchTasks).then(function () {
	        return _this5.Tasks.render();
	    }).then(function () {
	        return (0, _loader.endLock)(_this5);
	    }).then(function () {
	        return _this5.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Calendar:set-month'), function (month) {
	    var _this6 = this;
	
	    return this.options.calendar.set(month), this.setState({ month: (0, _date.unixts)(this.options.calendar.getMonth()) }), this.postpone(fetchCalendar).then(function () {
	        return _this6.Calendar.render();
	    }).then(function () {
	        return _this6.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Calendar:date:toggle'), function (date) {
	    var _this7 = this;
	
	    return this.options.date = date, this.setState({ page: 1 }), this.postpone(fetchTasks).then(function () {
	        return _this7.render();
	    }).then(function () {
	        return _this7.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:unpin'), function () {
	    this.trigger(_calendar4.default.OPEN_LAUNCHES_DAILY, this.state().month, this.options.date, this.state().filters);
	}), _defineProperty(_Module$extend, _module2.default.event(':time:toggle'), function (time) {
	    var _this8 = this;
	
	    this.options.time = time != this.options.time ? time : undefined;
	    this.setState({ page: 1 });
	    (0, _loader.beginLock)(this);
	
	    return this.postpone(fetchTasks, fetchCalendar).then(function () {
	        return _this8.render();
	    }).then(function () {
	        return _this8.navigated();
	    }).then(function () {
	        return (0, _loader.endLock)(_this8);
	    }, function () {
	        return (0, _loader.endLock)(_this8);
	    });
	}), _defineProperty(_Module$extend, 'postpone', function postpone() {
	    var _this9 = this;
	
	    for (var _len = arguments.length, fetchFunctions = Array(_len), _key = 0; _key < _len; _key++) {
	        fetchFunctions[_key] = arguments[_key];
	    }
	
	    return this.lastFiltering_ = this.lastFiltering_.then(function () {
	        return Promise.all(fetchFunctions.map(function (fn) {
	            return fn.call(_this9);
	        }));
	    });
	}), _Module$extend), {
	
	    REPLACE: REPLACE
	
	});
	
	
	function reRenderAfterDeletion(promise) {
	    var _this10 = this;
	
	    return promise.then(function () {
	        return (0, _loader.beginLock)(_this10);
	    }).then(function () {
	        return _this10.postpone(fetchTasks, fetchCalendar);
	    }).then(function () {
	        if (_this10.options.tasks.total > 0 && !_this10.options.tasks.length) if (_this10.state().page > 1) return _this10.setState({ page: _this10.state().page - 1 }), _this10.postpone(fetchTasks, fetchCalendar);
	    }).then(function () {
	        return _this10.render();
	    }).then(function () {
	        return (0, _loader.endLock)(_this10);
	    }, function () {
	        return (0, _loader.endLock)(_this10);
	    }).then(function () {
	        return _this10.navigated();
	    });
	}
	
	function fetchTasks() {
	    var _this11 = this;
	
	    var _options = this.options,
	        scheduleId = _options.scheduleId,
	        time = _options.time,
	        date = _options.date,
	        _state = this.state(),
	        page = _state.page;
	
	    var filters = _extends({
	        date: date, time: time,
	        limit: 12,
	        page: page,
	        timetableId: scheduleId
	    }, this.filtersModel.values());
	
	    return this.options.tasks.filter(filters).then(function (_ref8) {
	        var _ref9 = _slicedToArray(_ref8, 3),
	            items = _ref9[0],
	            coll = _ref9[1],
	            resp = _ref9[2];
	
	        _this11.options.times = resp.times;
	        _this11.options.schedule = resp.schedule;
	    });
	}
	
	function fetchCalendar() {
	    var _this12 = this;
	
	    var scheduleId = this.options.scheduleId;
	
	
	    var filters = _extends({
	        time: this.options.time,
	        timetableId: scheduleId
	    }, this.filtersModel.values());
	
	    var collection = new _stats2.default({ calendar: this.options.calendar });
	    return collection.filter(filters).then(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 1),
	            items /*, coll*/ = _ref11[0];
	
	        return _this12.options.stats.reset(items);
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	
	    responseAt: 'items',
	    countAt: 'total',
	
	    model: _model2.default.extend({
	        customParser: function customParser(payload) {
	            var task = payload.task;
	
	            if (task) task.date = (0, _date.datify)(task.date), task.update_date = (0, _date.datify)(task.update_date);
	
	            return payload;
	        }
	    }),
	
	    getUrl: function getUrl() {
	        var _filters = this.filters,
	            timetableId = _filters.timetableId,
	            date = _filters.date,
	            time = _filters.time;
	
	
	        var url = time ? 'timetables/' + timetableId + '/tasks/' + (0, _date.fmt)(date, 'YYYY-MM-DD') + '/@/' + time.replace(':', '-') + '?apiVersion=2.0' : 'timetables/' + timetableId + '/tasks/' + (0, _date.fmt)(date, 'YYYY-MM-DD') + '?apiVersion=2.0';
	
	        for (var name in this.filters) {
	            if (this.filters.hasOwnProperty(name)) if (undefined !== this.filters[name]) url = _config2.default.add(url, name, this.filters[name]);
	        }return _config2.default.url(url);
	    },
	    parseResponse: function parseResponse(modelsAttrs /*, response*/) {
	        return modelsAttrs
	        // generate id by client-side to avoid duplicating server id if there are many tasks per template
	        .map(function (attrs) {
	            return _extends({}, attrs, { id: Math.random() * 1e12 | 0 });
	        }).sort(function (a, b) {
	            if (a.run.date < b.run.date) return -1;else if (a.run.date > b.run.date) return 1;else if (a.run.time < b.run.time) return -1;else if (a.run.time > b.run.time) return 1;
	
	            var aTitle = a.template.title || '',
	                bTitle = b.template.title || '';
	
	            if (aTitle.toLowerCase() < bTitle.toLowerCase()) return -1;
	            if (aTitle.toLowerCase() > bTitle.toLowerCase()) return 1;
	
	            /*const scheduleIdDiff = a.run.schedule.id - b.run.schedule.id;
	            if (scheduleIdDiff)
	                return scheduleIdDiff;*/
	
	            return a.template.id - b.template.id;
	        });
	    }
	});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Stats = _collection2.default.extend({
	
	    responseAt: 'stats',
	
	    model: _model2.default.extend({
	        customParser: function customParser(payload) {
	            return Stats.extendStats(payload);
	        }
	    }),
	
	    getUrl: function getUrl() {
	        var date = this.options.calendar.getMonth();
	        var datePart = (0, _date.fmt)(date, 'YYYY-MM');
	
	        var _filters = this.filters,
	            timetableId = _filters.timetableId,
	            time = _filters.time,
	            otherFilters = _objectWithoutProperties(_filters, ['timetableId', 'time']);
	
	        var url = !timetableId ? 'timetables/stats/' + datePart + '?apiVersion=2.0' : time ? 'timetables/' + timetableId + '/stats/' + datePart + '/@/' + time.replace(':', '-') + '?apiVersion=2.0' : 'timetables/' + timetableId + '/stats/' + datePart + '?apiVersion=2.0';
	
	        for (var name in otherFilters) {
	            if (otherFilters.hasOwnProperty(name)) if (undefined !== otherFilters[name]) url = _config2.default.add(url, name, otherFilters[name]);
	        }return _config2.default.url(url);
	    }
	}, {
	    extendStats: function extendStats(stats) {
	        stats.expired = +stats.done_expired + stats.working_expired;
	
	        stats.done = +stats.done_expired + stats.done_not_expired;
	
	        stats.working = +stats.working_expired + stats.working_not_expired;
	
	        stats.planned = +stats.planned + stats.creating;
	
	        stats.fail = +stats.fail + stats.missed;
	
	        return stats;
	    }
	});
	
	exports.default = Stats;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Module$extend;
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _calendar = __webpack_require__(191);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _tasks = __webpack_require__(195);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _schedules = __webpack_require__(199);
	
	var _schedules2 = _interopRequireDefault(_schedules);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _api = __webpack_require__(77);
	
	var _popups = __webpack_require__(62);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.list',
	
	    url: function url() {
	        return 'schedule/list';
	    },
	    open: function open() {
	        var _this = this;
	
	        return this.options.schedules = new _schedules2.default([]), this.filtersModel = new _launch2.default.Model(this.state().filters), this.lastFiltering_ = Promise.resolve(), this.postpone(fetch).then(function () {
	            return _this.bind(_this.filtersModel);
	        });
	    },
	    start: function start() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	    serialize: function serialize() {
	        return {
	            date: this.state().date
	        };
	    },
	
	
	    events: {
	        'click .-toggle-monthly': function clickToggleMonthly() {
	            this.trigger(_calendar2.default.TOGGLE_CALENDAR,
	            // pass id only; schedule will be retrieved by /stats response
	            this.state().scheduleId, this.state().time, this.state().month, this.state().date, this.state().filters);
	        },
	        'click .-toggle-daily': function clickToggleDaily() {
	            if (this.state().scheduleId) this.trigger(_tasks2.default.REPLACE,
	            // pass id only; schedule will be retrieved by /tasks response
	            this.state().scheduleId, this.state().time, this.state().month, this.state().date, this.state().filters);else this.trigger(_calendar2.default.OPEN_LAUNCHES_DAILY, this.state().month, this.state().date, this.state().filters);
	        },
	
	
	        'click .-new-schedule': function clickNewSchedule() /*{currentTarget}*/{
	            this.trigger(_form2.default.POPUP_NEW);
	        }
	
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref) {
	    var id = _ref.id;
	
	    this.trigger(_form2.default.POPUP_EDIT, this.options.schedules.findWhere({ id: +id }));
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref2) {
	    var _this2 = this;
	
	    var id = _ref2.id;
	
	    return (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this2).cerebellum().execute();
	    }).then(function () {
	        return (0, _loader.beginLock)(_this2);
	    }).then(function () {
	        return _this2.postpone(fetch);
	    }).then(function () {
	        if (_this2.options.schedules.total > 0 && !_this2.options.schedules.length) if (_this2.state().page > 1) return _this2.setState({ page: _this2.state().page - 1 }), _this2.postpone(fetch);
	    }).then(function () {
	        return Promise.all([_this2.Schedules.render(), _this2.Paging.render()]);
	    }).then(function () {
	        return (0, _loader.endLock)(_this2);
	    }, function () {
	        return (0, _loader.endLock)(_this2);
	    }).then(function () {
	        return _this2.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref3) {
	    var id = _ref3.id;
	
	    this.trigger(_templates2.default.POPUP, this.options.schedules.findWhere({ id: +id }));
	}), _defineProperty(_Module$extend, _module2.default.event('Filters:change'), function (filters) {
	    var _this3 = this;
	
	    return this.setState({ filters: filters, page: 1 }), this.postpone(fetch).then(function () {
	        return Promise.all([_this3.Schedules.render(), _this3.Paging.render()]);
	    }).then(function () {
	        return _this3.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this4 = this;
	
	    return this.setState({ page: +page }), (0, _loader.beginLock)(this), this.postpone(fetch).then(function () {
	        return Promise.all([_this4.Schedules.render(), _this4.Paging.render()]);
	    }).then(function () {
	        return (0, _loader.endLock)(_this4);
	    }).then(function () {
	        return _this4.navigated();
	    });
	}), _defineProperty(_Module$extend, 'postpone', function postpone() {
	    var _this5 = this;
	
	    for (var _len = arguments.length, fetchFunctions = Array(_len), _key = 0; _key < _len; _key++) {
	        fetchFunctions[_key] = arguments[_key];
	    }
	
	    return this.lastFiltering_ = this.lastFiltering_.then(function () {
	        return Promise.all(fetchFunctions.map(function (fn) {
	            return fn.call(_this5);
	        }));
	    });
	}), _Module$extend));
	
	
	function fetch() {
	    return this.options.schedules.filter(_extends({
	        page: this.state().page,
	        limit: 12
	    }, this.filtersModel.values()));
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _schedule = __webpack_require__(190);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _collection2.default.extend({
	   endpoint: 'timetables/list?apiVersion=2.0',
	   responseAt: 'items',
	   countAt: 'total',
	   model: _schedule2.default
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Module$extend;
	
	var _jquery = __webpack_require__(6);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _calendar = __webpack_require__(128);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _launch = __webpack_require__(126);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _runs = __webpack_require__(201);
	
	var _runs2 = _interopRequireDefault(_runs);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _calendar3 = __webpack_require__(191);
	
	var _calendar4 = _interopRequireDefault(_calendar3);
	
	var _tasks = __webpack_require__(195);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _stats = __webpack_require__(197);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _api = __webpack_require__(77);
	
	var _date = __webpack_require__(29);
	
	var _popups = __webpack_require__(62);
	
	var _loader = __webpack_require__(20);
	
	var _backbone = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = _module2.default.extend((_Module$extend = {
	
	    template: 'jst/module.schedule.runs',
	
	    url: function url() {
	        return 'schedule/runs/' + (0, _date.fmt)(this.options.date, 'YYYY-MM-DD');
	    },
	    open: function open(month, date) {
	        var _this = this;
	
	        this.options.date = date;
	
	        this.setState({ month: (0, _date.unixts)((0, _date.datify)(month)) });
	        if (!this.state().page) this.setState({ page: 1 });
	
	        this.options.calendar = new _calendar2.default(this.state().month);
	        this.options.stats = new _backbone.Collection();
	        this.options.runs = new _runs2.default([]);
	
	        return this.filtersModel = new _launch2.default.Model(this.state().filters), this.lastFiltering_ = Promise.resolve(), this.postpone(fetchRuns, fetchCalendar).then(function () {
	            return _this.bind(_this.filtersModel);
	        });
	    },
	    start: function start() {
	        return this;
	    },
	    stop: function stop() {
	        return this;
	    },
	    serialize: function serialize() {
	        var date = this.options.date;
	
	
	        return {
	            date: date,
	            stats: this.options.stats
	        };
	    },
	
	
	    events: {
	
	        'click .-new-schedule': function clickNewSchedule(_ref) {
	            var currentTarget = _ref.currentTarget;
	
	            this.trigger(_form2.default.POPUP_NEW);
	        },
	
	        'click .-toggle-monthly': function clickToggleMonthly() {
	            this.trigger(_calendar4.default.TOGGLE_CALENDAR, undefined, undefined, this.state().month, this.options.date, this.state().filters);
	        },
	        'click .-toggle-list': function clickToggleList() {
	            this.trigger(_calendar4.default.TOGGLE_LIST_VIEW, (0, _date.datify)(this.state().month), this.options.date, this.state().filters);
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref2) {
	    var id = _ref2.id;
	
	    return this.trigger(_form2.default.POPUP_EDIT,
	    // pass id only to force Schedule.byId in Form
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref3) {
	    var _this2 = this;
	
	    var id = _ref3.id;
	
	    return (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this2).cerebellum().execute();
	    }).then(function () {
	        return (0, _loader.beginLock)(_this2);
	    }).then(function () {
	        return _this2.postpone(fetchRuns, fetchCalendar);
	    }).then(function () {
	        if (_this2.options.runs.total > 0 && !_this2.options.runs.length) if (_this2.state().page > 1) return _this2.setState({ page: _this2.state().page - 1 }), _this2.postpone(fetchRuns, fetchCalendar);
	    }).then(function () {
	        return _this2.render();
	    }).then(function () {
	        return (0, _loader.endLock)(_this2);
	    }, function () {
	        return (0, _loader.endLock)(_this2);
	    }).then(function () {
	        return _this2.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Runs:run:restart'), function (attrs, dateStr, timeStr, e) {
	    var _this3 = this;
	
	    var datetime = (0, _date.datify)(dateStr + ' ' + timeStr + ':00');
	    return (0, _api.pst)('/timetables/' + attrs.id + '/restart/' + (0, _date.fmt)(datetime, 'YYYY-MM-DD/@/HH-mm') + '?apiVersion=2.0').blocking(this).cerebellum().execute().then(function () {
	        _this3.$(e.currentTarget).remove();
	        (0, _loader.beginLock)();
	        location.reload();
	    }).catch(function () {
	        return (0, _popups.ask)('errors::common notification', 'errors::common notification', 'actions::close');
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Runs:schedule:pin'), function (_ref4, time) {
	    var id = _ref4.id;
	
	    return this.trigger(_tasks2.default.REPLACE,
	    // pass id only; schedule will be retrieved by /tasks response
	    id, time, this.state().month, this.options.date, this.state().filters);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref5) {
	    var id = _ref5.id;
	
	    return this.trigger(_templates2.default.POPUP,
	    // pass id only to force Schedule.byId in Template List
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event('Filters:change'), function (filters) {
	    var _this4 = this;
	
	    this.setState({ filters: filters, page: 1 });
	
	    return this.postpone(fetchRuns, fetchCalendar).then(function () {
	        return Promise.all([_this4.Calendar.render(), _this4.Runs.render(), _this4.Paging.render()]);
	    }).then(function () {
	        return _this4.navigated();
	    }).then(function () {
	        return (0, _jquery2.default)(window).scrollTop(0);
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Paging:page'), function (page) {
	    var _this5 = this;
	
	    return this.setState({ page: +page }), (0, _loader.beginLock)(this), this.postpone(fetchRuns).then(function () {
	        return _this5.Runs.render();
	    }).then(function () {
	        return (0, _loader.endLock)(_this5);
	    }).then(function () {
	        return _this5.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Calendar:set-month'), function (month) {
	    var _this6 = this;
	
	    return this.options.calendar.set(month), this.setState({ month: (0, _date.unixts)(this.options.calendar.getMonth()) }), this.postpone(fetchCalendar).then(function () {
	        return _this6.Calendar.render();
	    }).then(function () {
	        return _this6.navigated();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event('Calendar:date:toggle'), function (date) {
	    var _this7 = this;
	
	    return this.options.date = date, this.setState({ page: 1 }), this.postpone(fetchRuns).then(function () {
	        return _this7.render();
	    }).then(function () {
	        return _this7.navigated();
	    });
	}), _defineProperty(_Module$extend, 'postpone', function postpone() {
	    var _this8 = this;
	
	    for (var _len = arguments.length, fetchFunctions = Array(_len), _key = 0; _key < _len; _key++) {
	        fetchFunctions[_key] = arguments[_key];
	    }
	
	    return this.lastFiltering_ = this.lastFiltering_.then(function () {
	        return Promise.all(fetchFunctions.map(function (fn) {
	            return fn.call(_this8);
	        }));
	    });
	}), _Module$extend));
	
	
	function fetchRuns() {
	    var date = this.options.date,
	        _state = this.state(),
	        page = _state.page;
	
	
	    var dailyFilters = _extends({
	        date: date,
	        limit: 12,
	        page: page
	    }, this.filtersModel.values());
	
	    return this.options.runs.filter(dailyFilters);
	}
	
	function fetchCalendar() {
	    var _this9 = this;
	
	    var filters = _extends({}, this.filtersModel.values());
	
	    var collection = new _stats2.default({ calendar: this.options.calendar });
	    return collection.filter(filters).then(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 1),
	            items /*, coll*/ = _ref7[0];
	
	        return _this9.options.stats.reset(items);
	    });
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _stats = __webpack_require__(197);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = _collection2.default.extend({
	
	    responseAt: 'items',
	    countAt: 'total',
	
	    getUrl: function getUrl() {
	        var _filters = this.filters,
	            date = _filters.date,
	            otherFilters = _objectWithoutProperties(_filters, ['date']);
	
	        var url = 'timetables/runs/' + (0, _date.fmt)(date, 'YYYY-MM-DD') + '?apiVersion=2.0';
	
	        for (var name in otherFilters) {
	            if (otherFilters.hasOwnProperty(name)) if (undefined !== otherFilters[name]) url = _config2.default.add(url, name, otherFilters[name]);
	        }return _config2.default.url(url);
	    },
	    parseResponse: function parseResponse(modelsAttrs /*, response*/) {
	        return modelsAttrs
	        // generate id by client-side
	        .map(function (batch) {
	            batch.id = batch.id || Math.random() * 1e12 | 0;
	            batch.runs.forEach(parseRun);
	        }), modelsAttrs;
	    }
	});
	
	
	function parseRun(payload) {
	    // date here is unix ts
	    var now = (0, _date.unixts)(new Date());
	    var date = payload.date,
	        time = payload.time;
	
	    var datetime = (0, _date.datify)(date + ' ' + time + ':00');
	    // now - 15 mins
	    if ((0, _date.unixts)(datetime) > now - 15 * 60) payload.planned = true;
	
	    _stats2.default.extendStats(payload.stats);
	}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _status = __webpack_require__(156);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _statuses = __webpack_require__(155);
	
	var _statuses2 = _interopRequireDefault(_statuses);
	
	var _popups = __webpack_require__(62);
	
	var _actions = __webpack_require__(17);
	
	var _roles = __webpack_require__(117);
	
	var _api = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	    initialize: function initialize() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        options.dragMode = undefined !== options.dragMode ? options.dragMode : false;
	
	        _refbooks2.default.prototype.initialize.call(this, options);
	    },
	
	
	    template: 'module/refbooks/statuses.list',
	
	    url: function url() {
	        return 'statuses';
	    },
	    open: function open() {
	        var _this = this;
	
	        var form = new _form2.default({
	            template: 'module/refbooks/statuses.form',
	            clusters: this.options.clusters.toJSON().filter(function (cluster) {
	                return cluster.isolated;
	            }),
	
	            events: {
	                'click [name="visible"]': function clickNameVisible(_ref) {
	                    var checked = _ref.currentTarget.checked;
	
	                    this.$('[name="defaults"]')[0].disabled = !checked;
	                    this.$('[name="closed"]')[0].disabled = !checked;
	                },
	                'click [name="defaults"]': function clickNameDefaults(_ref2) {
	                    var checked = _ref2.currentTarget.checked;
	
	                    this.$('[name="visible"]')[0].disabled = checked;
	                }
	            }
	        });
	
	        var checkPermissions = function checkPermissions() {
	            if (_this.options.dragMode) return false;
	
	            var cluster = _this.currentCluster();
	            if (!cluster) return _roles.roleA.indexOf(_config2.default.role()) !== -1;
	
	            if (cluster.id == -1) return _roles.roleA.indexOf(_config2.default.role()) !== -1;
	
	            if (!cluster.isolated) return _roles.roleA.indexOf(_config2.default.role()) !== -1;
	
	            return true;
	        };
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, checkPermissions, function () {
	                var current = new _status2.default();
	                var binding = form.bind(current);
	                binding.then(function () {
	                    var cluster = _this.currentCluster();
	                    if (cluster && cluster.id != -1 && cluster.isolated) current.set({ cluster: cluster });else if (~_roles.roleC.indexOf(_config2.default.role())) {
	                        current.set({ cluster: _config2.default.cluster() });
	                    }
	                });
	
	                (0, _popups.ask)(binding, 'status::modal new - title', 'actions::create', 'actions::cancel', function () {
	                    return _this.options.statuses.save(form);
	                }
	                /*.then( () => current.get( 'default' )
	                    ? this.options.statuses.fetch()
	                    : undefined )*/).then(function () {
	                    return _this.options.source.reset(_this.options.statuses.models, { silent: true // a sort of paranoia
	                    });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, checkPermissions, function (original) {
	                var current = original.clone();
	                var isDefault = original.get('default');
	                (0, _popups.ask)(form.bind(current), 'status::modal edit - title', 'actions::save', 'actions::cancel', function () {
	                    return _this.options.source.save(form).then(function () {
	                        return current.get('default') != isDefault ? _this.options.statuses.fetch() : undefined;
	                    });
	                }).then(function () {
	                    return _this.options.source.reset(_this.options.statuses.models, { silent: true // a sort of paranoia
	                    });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, checkPermissions, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('status::modal delete - confirmation text', 'status::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            }),
	
	            sort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return checkPermissions();
	            }, function () {
	                var _state2 = _this.state(),
	                    cluster = _state2.cluster;
	
	                _this.options.filter.set('sortCluster', cluster, { silent: true });
	
	                // set flag to force sort() take cluster from sort-filter
	                _this.options.dragMode = true;
	                // need to iterate all clusters (options.source) because cluster filter
	                // may be changing during sorting process
	                _this.options.source.models.forEach(function (model) {
	                    return model.set('new-order', model.get('order'));
	                });
	                _this.setState({ page: 1 });
	                _this.sort({ sort: 'order', direction: 'asc' }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            applySort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.isOrderChanged();
	            }, function () {
	                return (0, _api.pst)('/statuses/sort').cerebellum().blocking(_this).body({
	                    ids: _this.options.sorted.models.map(function (model) {
	                        return [model.id, model.get('new-order')];
	                    }).sort(function (_ref3, _ref4) {
	                        var _ref6 = _slicedToArray(_ref3, 2),
	                            idA = _ref6[0],
	                            indexA = _ref6[1];
	
	                        var _ref5 = _slicedToArray(_ref4, 2),
	                            idB = _ref5[0],
	                            indexB = _ref5[1];
	
	                        return indexA - indexB;
	                    }).map(function (_ref7) {
	                        var _ref8 = _slicedToArray(_ref7, 1),
	                            id = _ref8[0];
	
	                        return id;
	                    })
	                }).execute().then(function () {
	                    return _this.options.sorted.models.forEach(function (model) {
	                        return model.set('order', model.get('new-order'));
	                    });
	                }).then(function () {
	                    return _this.options.dragMode = false;
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            cancelSort: (0, _actions.restrict)(_roles.roleAC, function () {
	                return Promise.resolve()
	                // drop drag-mode first
	                .then(function () {
	                    return _this.options.dragMode = false;
	                })
	                // then sort
	                .then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            })
	
	        };
	
	        this.options.clusterPassed = this.state().cluster;
	        // there is no such option in cluster filter in Statuses list
	        var hasNoClusterOption = !this.options.clusterPassed || this.options.clusterPassed.id == -1 && _roles.roleC.indexOf(_config2.default.role()) !== -1;
	        this.options.clusterPicked = hasNoClusterOption ? this.listClusters()[0] : this.options.clusterPassed;
	        this.setState({
	            cluster: this.options.clusterPicked
	        });
	
	        this.options.filter = new FilterModel({
	            cluster: this.options.clusterPicked
	        });
	        this.options.source = new _statuses2.default(this.options.statuses.models);
	        this.options.sorted = new _statuses2.default();
	        this.options.filtered = new _statuses2.default();
	        this.options.paged = new _statuses2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    },
	    listClusters: function listClusters() {
	        if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return _refbooks2.default.prototype.listClusters.call(this);
	
	        return this.options.clusters.toJSON();
	    },
	    filterClusterFn: function filterClusterFn(model, cluster) {
	        return !model.get('cluster') && (!cluster || !cluster.isolated) || model.get('cluster') && cluster && model.get('cluster').id == cluster.id;
	    },
	    getClusterToPass: function getClusterToPass() {
	        var _state3 = this.state(),
	            cluster = _state3.cluster;
	
	        var _options = this.options,
	            clusterPassed = _options.clusterPassed,
	            clusterPicked = _options.clusterPicked;
	
	        var changed = !!clusterPicked !== !!cluster || clusterPicked && cluster && clusterPicked.id != cluster.id;
	        var changedInitially = !!clusterPicked !== !!clusterPassed || clusterPicked && clusterPassed && clusterPicked.id != clusterPassed.id;
	
	        return {
	            cluster: changed ? cluster : changedInitially ? clusterPassed : clusterPicked
	        };
	    },
	
	
	    // rewrite events to pass out correct cluster
	    events: {
	        'click .-open-types': function clickOpenTypes() {
	            this.trigger(this.constructor.TYPES, this.getClusterToPass());
	        },
	        'click .-open-type-groups': function clickOpenTypeGroups() {
	            this.trigger(this.constructor.TYPEGROUPS, this.getClusterToPass());
	        },
	        'click .-open-priorities': function clickOpenPriorities() {
	            this.trigger(this.constructor.PRIORITIES, this.getClusterToPass());
	        },
	        'click .-open-fields': function clickOpenFields() {
	            this.trigger(this.constructor.FIELDS, this.getClusterToPass());
	        },
	        'click .-open-stickers': function clickOpenStickers() {
	            this.trigger(this.constructor.STICKERS, this.getClusterToPass());
	        },
	        'click .-open-capabilities': function clickOpenCapabilities() {
	            this.trigger(this.constructor.CAPABILITIES, this.getClusterToPass());
	        },
	        'click .-open-servers': function clickOpenServers() {
	            this.trigger(this.constructor.SERVERS, this.getClusterToPass());
	        },
	        'click .-open-scripts': function clickOpenScripts() {
	            this.trigger(this.constructor.SCRIPTS, this.getClusterToPass());
	        }
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _sticker = __webpack_require__(59);
	
	var _sticker2 = _interopRequireDefault(_sticker);
	
	var _stickers = __webpack_require__(58);
	
	var _stickers2 = _interopRequireDefault(_stickers);
	
	var _stickers3 = __webpack_require__(204);
	
	var _stickers4 = _interopRequireDefault(_stickers3);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _roles = __webpack_require__(117);
	
	var _actions = __webpack_require__(17);
	
	var _popups = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/stickers.list',
	
	    url: function url() {
	        return 'stickers';
	    },
	    open: function open() {
	        var _this = this;
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.trigger(_stickers4.default.OPEN_STICKER, new _sticker2.default(), _this.state().cluster);
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function (current) {
	                return _this.trigger(_stickers4.default.OPEN_STICKER, current.clone());
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" stickers: with cluster == my cluster;
	                // there are only global and "my" stickers in the list;
	                // so, let's check only presence of cluster in sticker
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('sticker::modal delete - confirmation text', 'sticker::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	
	        this.options.source = new _stickers2.default(this.options.stickers.models);
	        this.options.sorted = new _stickers2.default();
	        this.options.filtered = new _stickers2.default();
	        this.options.paged = new _stickers2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    }
	});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _RefBooksModule$exten;
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _sticker = __webpack_require__(59);
	
	var _sticker2 = _interopRequireDefault(_sticker);
	
	var _types = __webpack_require__(157);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _roles = __webpack_require__(117);
	
	var _arrays = __webpack_require__(24);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var OPEN_STICKER = 'sticker-form--popup';
	
	exports.default = _refbooks2.default.extend((_RefBooksModule$exten = {
	
	    template: 'module/refbooks/stickers.form',
	
	    url: function url() {
	        return this.options.sticker.id ? 'stickers/' + this.options.sticker.id + '/edit' : 'stickers/new';
	    },
	    open: function open(sticker) {
	        var _this = this;
	
	        this.options.sticker = sticker, this.options.original = sticker.clone();
	        if (!sticker.id) if (this.state().cluster && this.state().cluster.id != -1) sticker.set('cluster', this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) sticker.set('cluster', _config2.default.cluster());
	
	        this.options.sorted = new _types2.default();
	        this.options.filtered = new _types2.default();
	        this.options.resulted = new _types2.default();
	
	        return _grid2.default.sort(this.state(), this.options.types, this.options.sorted).then(function () {
	            return _this.reFilterGrid();
	        }).then(function () {
	            return _this.bind(sticker);
	        });
	    },
	    start: function start() {
	        var _this2 = this;
	
	        this.listenTo(this.options.sticker, 'change:cluster', function () {
	            _this2.setState({ page: 1 }), _this2.navigated();
	            _this2.reFilterGrid();
	        });
	        this.listenTo(this.model, 'change', function () {
	            return _this2.$('.-save')[0].disabled = !_this2.hasDiff();
	        });
	        this.listenTo(this.model, 'change:is_for_all', function () {
	            return _this2.TypeGrid.enable(_this2.model.get('is_for_all') === 'f');
	        });
	
	        return this;
	    },
	    stop: function stop() {
	        return this.stopListening(this.model), this;
	    },
	    serialize: function serialize() {
	        var _state = this.state(),
	            sort = _state.sort,
	            direction = _state.direction,
	            searchString = _state.search;
	
	        var _options = this.options,
	            filtered = _options.filtered,
	            resulted = _options.resulted;
	        var clusters = this.options.clusters;
	
	
	        return {
	            searchString: searchString, sort: sort, direction: direction,
	            hasDiff: this.hasDiff(),
	            clusters: clusters, types: filtered, rows: resulted
	        };
	    },
	    diff: function diff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var _options2 = this.options,
	            sticker = _options2.sticker,
	            original = _options2.original;
	
	        var baseDiff = sticker.diff(original, options).filter(function (_ref) {
	            var attrName = _ref.attrName;
	            return attrName !== 'types';
	        });
	
	        var oldValue = original.get('types');
	        var newValue = sticker.get('types');
	
	        var originalTypes = oldValue.map(function (id) {
	            return +id;
	        }).sort();
	        var stickerTypes = newValue.map(function (id) {
	            return +id;
	        }).sort();
	
	        if ('' + originalTypes === '' + stickerTypes) return baseDiff;
	
	        return [].concat(_toConsumableArray(baseDiff), [{
	            attrName: 'types',
	            oldValue: oldValue, newValue: newValue
	        }]);
	    },
	    hasDiff: function hasDiff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.diff(options).length > 0;
	    },
	    reFilterGrid: function reFilterGrid() {
	        var _options3 = this.options,
	            sticker = _options3.sticker,
	            sorted = _options3.sorted,
	            filtered = _options3.filtered,
	            resulted = _options3.resulted;
	
	        _grid2.default.filter(this.state(), sticker.get('cluster'), sorted, filtered, resulted);
	    },
	
	
	    events: {
	        'click .-save': function clickSave() {
	            var _this3 = this;
	
	            var toSave = this.model.clone();
	
	            if (this.diff().filter(function (_ref2) {
	                var attrName = _ref2.attrName;
	                return attrName === 'types';
	            })) {
	                var _options4 = this.options,
	                    sticker = _options4.sticker,
	                    original = _options4.original;
	
	                var cluster = sticker.get('cluster');
	
	                var availableToChange = (0, _arrays.hashify)(getAvailableFilteredTypeIds.call(this, this.options.sorted.models.filter(function (type) {
	                    return !cluster || !type.get('cluster') || type.get('cluster').id == cluster.id;
	                })));
	
	                var after = (0, _arrays.hashify)(sticker.get('types'));
	                var applyRemove = original.get('types').filter(function (id) {
	                    return after[id] || !availableToChange[id];
	                });
	
	                var before = (0, _arrays.hashify)(original.get('types'));
	                var applyAdd = sticker.get('types').filter(function (id) {
	                    return !before[id] && availableToChange[id];
	                });
	
	                toSave.set('types', [].concat(_toConsumableArray(applyRemove), _toConsumableArray(applyAdd)));
	            }
	
	            (0, _loader.beginLock)(this);
	
	            // cannot invoke model.save() because
	            // "news_type_ids" prop from server
	            // breaks `this.get( 'types' ) code`
	            return this.options.stickers.save(toSave).then(function (attrs) {
	                return new _sticker2.default(attrs);
	            }).then(function () {
	                return (/*sticker*/_this3.trigger(_refbooks2.default.BACK)
	                );
	            }, function (message) {
	                (0, _loader.endLock)(_this3);
	                (0, _messages2.handle)(_this3, (0, _messages.error)(message));
	            });
	        },
	        'click .-close': function clickClose() {
	            this.trigger(_refbooks2.default.BACK);
	        },
	        'click .-sort': function clickSort(_ref3) {
	            var _this4 = this;
	
	            var currentTarget = _ref3.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	            var _options5 = this.options,
	                types = _options5.types,
	                sorted = _options5.sorted;
	
	
	            return this.setState({ page: 1, sort: sort, direction: direction }), _grid2.default.sort(this.state(), types, sorted).then(function () {
	                return _this4.reFilterGrid();
	            })
	            // hack: to rerender grid caption with order direction
	            .then(function () {
	                return _this4.render();
	            }).then(function () {
	                return _this4.navigated();
	            });
	        },
	        'click .-toggle-binding': function clickToggleBinding(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var id = currentTarget.dataset.id;
	            var _options6 = this.options,
	                sticker = _options6.sticker,
	                filtered = _options6.filtered;
	
	
	            var needAppend = currentTarget.checked;
	            var oldTypes = sticker.get('types');
	            var newTypes = needAppend ? [].concat(_toConsumableArray(oldTypes), [id]) : oldTypes.filter(function (itemId) {
	                return itemId != id;
	            });
	
	            sticker.set('types', newTypes);
	
	            var ids = (0, _arrays.hashify)(newTypes);
	            this.$('.-toggle-all')[0].checked = getAvailableFilteredTypeIds.call(this, filtered).every(function (typeId) {
	                return ids[typeId];
	            });
	        },
	        'click .-toggle-all': function clickToggleAll(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	            var sticker = this.options.sticker;
	
	            // contains ids of types that can be
	            // checked/unchecked by current user
	
	            var ids = getAvailableFilteredTypeIds.call(this, this.options.filtered);
	
	            var h = (0, _arrays.hashify)(ids);
	            var drained = sticker.get('types').filter(function (id) {
	                return !h[id];
	            });
	
	            var value = currentTarget.checked;
	            sticker.set('types', value ? [].concat(_toConsumableArray(drained), _toConsumableArray(ids)) : [].concat(_toConsumableArray(drained)));
	
	            var values = (0, _arrays.hashify)(sticker.get('types'));
	            this.$('.-toggle-binding').toArray().forEach(function (el) {
	                return el.checked = !!values[el.dataset.id];
	            });
	        }
	    }
	
	}, _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Paging:page'), function (page) {
	    return this.setState({ page: +page }), this.reFilterGrid(), this.navigated();
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event('Search:search'), function (search) {
	    return this.setState({ search: search, page: 1 }), this.reFilterGrid(), this.navigated();
	}), _RefBooksModule$exten), {
	
	    OPEN_STICKER: OPEN_STICKER
	
	});
	
	
	function getAvailableFilteredTypeIds(typeCollection) {
	    var sticker = this.options.sticker;
	
	    var models = typeCollection instanceof _collection2.default ? typeCollection.models : typeCollection;
	
	    return models
	    // ignore unavailable (disabled) checkboxes
	    .filter(function (type) {
	        return (
	            // chief admin may check any type
	            // (local types of wrong cluster do not pass filtration)
	            _roles.roleA.indexOf(_config2.default.role()) !== -1 ||
	            // local types may be checked anyway
	            // (local types of wrong cluster do not pass filtration)
	            type.get('cluster') ||
	            // local sticker may be joined to any type
	            // (local types of wrong cluster do not pass filtration)
	            sticker.get('cluster')
	        );
	    }).map(function (type) {
	        return type.id;
	    });
	}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _actionList = __webpack_require__(14);
	
	var _actionList2 = _interopRequireDefault(_actionList);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _task = __webpack_require__(56);
	
	var _task2 = _interopRequireDefault(_task);
	
	var _promisify = __webpack_require__(19);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _api = __webpack_require__(77);
	
	var _popups = __webpack_require__(62);
	
	var _loader = __webpack_require__(20);
	
	var _task3 = __webpack_require__(54);
	
	var _date = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// todo: module stop!
	
	var BACK = 'back--from-task';
	
	exports.default = _module2.default.extend((_Module$extend = {
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _module2.default.prototype.initialize.call(this, options);
	
	        var actionDefs = {
	
	            ok: {
	                handler: function handler() {
	                    return save(_this).then(function () {
	                        return close(_this);
	                    });
	                },
	
	                disabled: function disabled() {
	                    return _this.options.isRoot || !_this.TaskForm || !_this.TaskForm.hasDiff({ fields: _this.options.fields });
	                }
	            },
	
	            apply: {
	                handler: function handler() {
	                    return save(_this);
	                },
	
	                disabled: function disabled() {
	                    return !_this.TaskForm || !_this.TaskForm.hasDiff({ fields: _this.options.fields });
	                }
	            },
	
	            rollback: {
	                handler: function handler() {
	                    _this.TaskForm.rollback();
	                    _this.bind(_this.model);
	                },
	
	                disabled: function disabled() {
	                    return !_this.TaskForm || !_this.TaskForm.hasDiff({ fields: _this.options.fields });
	                }
	            },
	
	            close: {
	                handler: function handler() {
	                    return close(_this);
	                },
	
	                disabled: function disabled() {
	                    return _this.options.isRoot;
	                }
	            }
	        };
	
	        this.options.actions = new _actionList2.default(actionDefs);
	    },
	
	
	    template: 'jst/module.tasks.form',
	
	    url: function url() {
	        return 'task/' + this.model.id;
	    },
	    open: function open(taskModel) {
	        var _this2 = this;
	
	        var fetchingTask = taskModel instanceof _task2.default ? Promise.resolve(taskModel) : _task2.default.byId(taskModel);
	
	        return fetchingTask.then(function (taskModel) {
	            var objId = taskModel.get('service_object_id');
	            var layerId = taskModel.get('service_object_layer_id');
	            if (objId) _this2.object = {
	                attrs: [],
	                loaded: false,
	                failed: false
	            }, (0, _api.get)('/datatables/' + layerId + '/features/' + objId + '?taskId=' + taskModel.id).mapsurfer().map(function (response) {
	                return response.feature;
	            }).chain(function () {
	                return (0, _api.get)('/datatables/' + layerId).mapsurfer();
	            }).map(function (response) {
	                return response.attributes;
	            }).filter(function (field) {
	                return field.view;
	            }).map(function (_ref, index, fields, response, obj) {
	                var nameDb = _ref.nameDb,
	                    title = _ref.title,
	                    type = _ref.type;
	
	                var arrayTypes = ['systemcluster[]', 'systemorg[]', 'systemuser[]', 'systemrole[]', 'systemtasktype[]', 'systemtaskpriority[]'];
	
	                var refTypes = ['systemcluster', 'systemorg', 'systemuser', 'systemrole', 'systemtasktype', 'systemtaskpriority'];
	
	                var value = obj[nameDb];
	                if (arrayTypes.indexOf(type) !== -1) return {
	                    name: title,
	                    value: value == null ? value : value.map(function (_ref2) {
	                        var refValue = _ref2.refValue,
	                            refValueName = _ref2.refValueName;
	                        return refValueName + ' (#' + refValue + ')';
	                    }).join(', ')
	                };
	
	                if (type === 'reference' || refTypes.indexOf(type) !== -1) return {
	                    name: title,
	                    value: value == null ? value : value.refValueName + ' (#' + value.refValue + ')'
	                };
	
	                if (type === 'date') return {
	                    name: title,
	                    value: (0, _date.fmt)(value, 'DD.MM.YYYY')
	                };
	
	                if (type === 'dateTime') return {
	                    name: title,
	                    value: (0, _date.fmt)(value, 'DD.MM.YYYY HH:mm')
	                };
	
	                return { name: title, value: value };
	            }).execute().then(function (attrs) {
	                var _object$attrs;
	
	                return (_object$attrs = _this2.object.attrs).push.apply(_object$attrs, _toConsumableArray(attrs));
	            }).then(function () {
	                return _this2.object.loaded = true;
	            }, function (e, x) {
	                console.error(e, x);
	                _this2.object.failed = true;
	            }).then(function () {
	                return _this2.Card.render();
	            });
	
	            return _this2.bind(taskModel);
	        });
	    },
	    start: function start() {
	        var _this3 = this;
	
	        this.listenTo(this.TaskForm.Assignee, 'points', function (points) {
	            return _this3.Map.setLocations(points);
	        });
	        this.listenTo(this.TaskForm.Assignee, 'assignee:dropdown-hide',
	        // clear filtered locations after 250ms delay
	        // but don't clear if user clicks on map in these 250ms
	        function (points) {
	            return Promise.race([(0, _promisify.rejectOn)('assignee:click', _this3.Map), (0, _promisify.delay)(250)]).then(function () {
	                return _this3.Map.clearLocations();
	            });
	        });
	        this.listenTo(this.Map, 'assignee:assign', function (_ref3) {
	            var user = _ref3.user;
	            return _this3.TaskForm.model.assign(user);
	        });
	
	        // AS IN /module/schedule/templates.form.js
	
	        var org = this.options.organizations.toJSON().find(function (org) {
	            return org.id == _this3.model.get('organization_id');
	        });
	        var type = this.options.types.toJSON().find(function (type) {
	            return type.id == _this3.model.get('type_id');
	        });
	        var isTypeAvailable = type ? type.role_ids == null || type.role_ids.indexOf(_config2.default.role()) !== -1 || type.role_ids.indexOf(+_config2.default.role()) !== -1 : false;
	        if (org && isTypeAvailable) this.TaskForm.focus();else
	            // task of deleted org/cluster or unavailable type
	            this.TaskForm.disable(), this.Schedule && this.Schedule.disable(), this.Map.disable(), this.Comments.disable();
	
	        if (this.model.capabilities_) if (!this.model.capabilities_.edit && !this.model.capabilities_.update_point) this.Map.disable();
	
	        return this;
	    },
	    stop: function stop() {
	        this.stopListening(this.TaskForm.Assignee);
	        this.stopListening(this.Map);
	
	        this.options.actions.clearDependencies(this.model);
	
	        return this;
	    },
	    onBind: function onBind(model, previousModel) {
	        if (previousModel) this.options.actions.clearDependencies(previousModel);
	        this.options.actions.depend(model, 'change');
	    },
	    serialize: function serialize() {
	        return _extends({}, this.model.toJSON(), {
	            date: this.model.get('date'),
	            capabilities: this.model.capabilities_,
	            object: this.object
	        });
	    }
	}, _defineProperty(_Module$extend, _module2.default.event('Map:map:click'), function (location) {
	    if (!this.Map.disabled()) this.model.set('location', location);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref4) {
	    var id = _ref4.id;
	
	    return this.trigger(_form2.default.POPUP_EDIT,
	    // pass id only to force Schedule.byId in Form
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref5) {
	    var _this4 = this;
	
	    var id = _ref5.id;
	
	    (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this4).cerebellum().execute();
	    }).then(function () {
	        _this4.model.get('schedule').deleted = true;
	        return _this4.Schedule.render();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref6) {
	    var id = _ref6.id;
	
	    return this.trigger(_templates2.default.POPUP,
	    // pass id only to force Schedule.byId in Template List
	    id);
	}), _Module$extend), {
	
	    BACK: BACK
	
	});
	
	
	function create(form) {
	    return (0, _promisify.promisify)(new _task2.default(form.model.toJSON()).save()).then(function (resp) {
	        return resp.newsId;
	    }).then(function (id) {
	        return form.model.set('id', id);
	    });
	}
	
	function save(layout) {
	    var _this5 = this;
	
	    var form = layout.TaskForm;
	
	    var _form$validate = form.validate(),
	        result = _form$validate.result,
	        messages = _form$validate.messages;
	
	    if (!result) return Promise.reject((0, _messages2.handle)(form, (0, _messages.error)(messages[0] /* [text, field] */)));
	
	    var op = !form.model.id ? create(form) : (0, _task3.save)(layout);
	
	    return (0, _loader.beginLock)(this), op.then(function (response) {
	        return new _task2.default(response, { parse: true });
	    })
	    // .then( model => form.model.set( model.toJSON() ) )
	    // make form "remember" changes
	    // .then( () => form.commit() )
	    // force toolbar to update itself (firing event on its actionList)
	    // .then( () => actions.trigger( 'update' ) )
	    // .then( postpone )
	    // .then( () => form.focus() )
	    // todo don't use render here
	    .then(function (updatedModel) {
	        return layout.bind(updatedModel);
	    })
	    // need to call update here because there is pending
	    // onBindDone() for TaskForm when onBind called
	    .finally(function () {
	        return (0, _loader.endLock)(_this5);
	    }).finally(function () {
	        return layout.options.actions.trigger('update');
	    }).catch(function (message) {
	        return (0, _messages2.handle)(form, (0, _messages.error)(message));
	    });
	    ;
	}
	
	function close(layout) {
	    layout.trigger(BACK);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Module$extend;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(12);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _tasks = __webpack_require__(138);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _tasks3 = __webpack_require__(133);
	
	var _tasks4 = _interopRequireDefault(_tasks3);
	
	var _list = __webpack_require__(179);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _form = __webpack_require__(192);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _templates = __webpack_require__(193);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _sublist = __webpack_require__(132);
	
	var _sublist2 = _interopRequireDefault(_sublist);
	
	var _task = __webpack_require__(137);
	
	var _comments = __webpack_require__(76);
	
	var _popups = __webpack_require__(62);
	
	var _promisify = __webpack_require__(19);
	
	var _api = __webpack_require__(77);
	
	var _arrays = __webpack_require__(24);
	
	var _loader = __webpack_require__(20);
	
	var _map = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _module2.default.extend((_Module$extend = {
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _module2.default.prototype.initialize.call(this, options);
	
	        var opts = function opts() {
	            var layers = options.layers,
	                datatables = options.datatables,
	                clusters = options.clusters,
	                types = options.types,
	                organizations = options.organizations,
	                contracts = options.contracts,
	                statuses = options.statuses,
	                priorities = options.priorities,
	                fields = options.fields,
	                serviceObjectMappings = options.serviceObjectMappings,
	                locationService = options.locationService;
	
	
	            return {
	                layers: layers, datatables: datatables, clusters: clusters,
	                locationService: locationService,
	                types: types, organizations: organizations, contracts: contracts,
	                statuses: statuses, priorities: priorities,
	                fields: fields,
	                serviceObjectMappings: serviceObjectMappings
	            };
	        };
	
	        this.options.actions = {
	
	            defaults: 'edit',
	
	            multitask: function multitask() {
	                return (0, _promisify.promisify)((0, _task.newTask)(new _task.TaskNew(opts()), opts().priorities)).then(function (_ref) {
	                    var task = _ref.task;
	
	                    if (task.point || task.lon && task.lat) return _this.fetchAndUpdateLayers();
	                });
	            },
	
	            edit: function edit(current) {
	                return _this.trigger(_list2.default.OPEN_TASK, current);
	            },
	
	            destroy: {
	
	                disabled: function disabled(current) {
	                    return !current || !current.capabilities_.delete;
	                },
	
	                handler: function handler(current) {
	                    return (0, _popups.ask)('issue::modal delete - confirmation text', undefined, 'actions::yes', 'actions::no', function () {
	                        return (0, _api.del)('/tasks/' + current.id).blocking(_this).cerebellum().execute();
	                    }).then(function () {
	                        return _this.fetchAndUpdateLayers();
	                    });
	                }
	            }
	
	        };
	
	        this.options.issues = new _tasks4.default([], {
	            endpoint: 'tasks/bbox?apiVersion=2.1&sortBy=id&sortDirection=DESC&maxClusters=25&limit=100000',
	            responseAt: 'tasks',
	            actions: this.options.actions,
	
	            // override to avoid picking up the first row as active row
	            restoreActive: function restoreActive() {
	                if (!this.activeId || this.activeRow() == undefined) this.deactivate();
	            }
	        });
	
	        this.setState({
	            filters: _tasks2.default.defaultFilters()
	        });
	
	        // this.commentsChannel = CommentsLive
	        //     .filter( message => message instanceof Insert )
	        //     .forEach( message => this.trigger( 'comments:income', message.model ) ); // model === attrs of Model
	    },
	
	
	    template: 'jst/module.tasks.map',
	
	    url: function url() {
	        return 'map';
	    },
	    open: function open() {
	        var _this2 = this;
	
	        return this.render()
	        // need this delay to make fitBounds below work correctly
	        .then(function () {
	            return (0, _promisify.delay)(500);
	        }).then(function () {
	            return _this2.Filter.bind(new _tasks2.default.Model(_this2.state().filters));
	        }).then(function () {
	            var _Map;
	
	            var _state = _this2.state(),
	                map = _state.map;
	
	            if (map && map.bounds) (_Map = _this2.Map).fitBounds.apply(_Map, _toConsumableArray(map.bounds));
	        }).then(function () {
	            return (0, _promisify.delay)(500);
	        }).then(function () {
	            var _Map$bounds = _this2.Map.bounds(),
	                _Map$bounds$_northEas = _Map$bounds._northEast,
	                maxlat = _Map$bounds$_northEas.lat,
	                maxlon = _Map$bounds$_northEas.lng,
	                _Map$bounds$_southWes = _Map$bounds._southWest,
	                minlat = _Map$bounds$_southWes.lat,
	                minlon = _Map$bounds$_southWes.lng;
	
	            _this2.setState({
	                map: {
	                    bounds: [minlat, minlon, maxlat, maxlon]
	                }
	            });
	        }).then(function () {
	            var _state2 = _this2.state(),
	                popup = _state2.popup;
	
	            if (!popup) return _this2.fetchAndUpdateLayers();
	
	            var subList = _this2.createListPopup(popup.filters.bbox, popup.page || 1, popup.activeId);
	
	            return Promise.all([_this2.fetchAndUpdateLayers(), subList.fetching]).then(function () {
	                return subList;
	            });
	        }).then(function (subList) {
	            var current = _this2.options.issues.current();
	            if (current) _this2.fetchCurrentComments();
	
	            _this2.setState({
	                activeId: current ? current.id : undefined
	            });
	
	            return _this2.Toolbar.render().then(function () {
	                return current && _this2.Task.bind(current);
	            }).then(function () {
	                return [_this2, subList];
	            });
	        });
	    },
	    start: function start(subList) {
	        var _this3 = this;
	
	        var issues = this.options.issues;
	
	        var lastFiltering = Promise.resolve();
	
	        // issues.plugActionSource( this.Grid );
	
	        // this.listenTo( this.Search, 'search', queryString => 
	        //     lastFiltering = lastFiltering
	        //         .then( () => {
	        //             this.setState( { queryString, } );
	        //             this.navigated();
	        //             return issues.filter( getHttpFilters( this.state() ) );
	        //         } )
	        //         .catch( () => undefined ) );
	
	        // if (issues.current())
	        //     this.Comments.bind( issues.current() );
	
	        this.Map.onMoveOrZoom(_underscore2.default.debounce(function () {
	            _this3.fetchAndUpdateLayers();
	
	            var _Map$bounds2 = _this3.Map.bounds(),
	                _Map$bounds2$_northEa = _Map$bounds2._northEast,
	                maxlat = _Map$bounds2$_northEa.lat,
	                maxlon = _Map$bounds2$_northEa.lng,
	                _Map$bounds2$_southWe = _Map$bounds2._southWest,
	                minlat = _Map$bounds2$_southWe.lat,
	                minlon = _Map$bounds2$_southWe.lng;
	
	            _this3.setState({
	                map: {
	                    bounds: [minlat, minlon, maxlat, maxlon]
	                }
	            });
	            _this3.navigated();
	        }, 500));
	
	        this.Map.listenTo(issues, 'activate deactivate', function () {
	            var current = issues.current();
	            if (current) _this3.Task.bind(current), _this3.fetchCurrentComments();else _this3.Task.unbind();
	
	            var activeId = current ? current.id : undefined;
	            if (_this3.state().activeId != activeId) _this3.setState({ activeId: activeId }), _this3.navigated();
	        });
	
	        // this.listenTo( this, 'comments:income',
	        //     comment => handleIncomingComment.call( this, comment ) );
	
	        this.Filter.focus();
	
	        if (subList) this.openPopupList(subList);
	    },
	    stop: function stop() {
	        var issues = this.options.issues;
	
	
	        this.stopListening(this.Filter);
	        // this.stopListening( this, 'comments:income' );
	
	        // this.Map.stopListening( issues );
	
	        return this;
	    },
	    createListPopup: function createListPopup(bbox) {
	        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var activeId = arguments[2];
	
	        var view = new _sublist2.default({
	            // ...not all state, but some props of it
	            filters: _extends({
	                bbox: bbox
	            }, this.state().filters || {}),
	            page: page,
	            activeId: activeId
	        });
	
	        var state = {
	            filters: { bbox: bbox },
	            page: page,
	            activeId: activeId
	        };
	
	        return {
	            view: view, state: state,
	            fetching: view.fetch()
	        };
	    },
	    openPopupList: function openPopupList(_ref2) {
	        var _this4 = this;
	
	        var view = _ref2.view,
	            state = _ref2.state,
	            fetching = _ref2.fetching;
	
	        this.setState({ popup: state });
	        this.navigated();
	
	        this.listenTo(view, 'Paging:page', function (page) {
	            var _state3 = _this4.state(),
	                popup = _state3.popup;
	
	            _this4.setState({
	                popup: _extends({}, popup, {
	                    page: page
	                })
	            });
	            _this4.navigated();
	        });
	
	        this.listenTo(view, 'row', function (activeId) {
	            var _state4 = _this4.state(),
	                popup = _state4.popup;
	
	            _this4.setState({
	                popup: _extends({}, popup, {
	                    activeId: activeId
	                })
	            });
	            _this4.navigated();
	        });
	
	        (0, _loader.beginLock)(this);
	        var rendering = fetching.then(function () {
	            return view.render();
	        }).finally(function () {
	            return (0, _loader.endLock)(_this4);
	        }).then(function () {
	            return view;
	        });
	
	        (0, _popups.ask)(rendering, undefined, undefined, 'actions::close', {
	            // 900px-wide
	            medium: true,
	            // arrow function to save "this"
	            onOpen: function onOpen(_ref3) {
	                var reject = _ref3.reject;
	
	                _this4.listenTo(view, 'edit', function (task) {
	                    _this4.trigger(_list2.default.OPEN_TASK, task);
	                    // first initiate module-opening, 
	                    // next call reject to close popup - 
	                    // this combination will prevent removing
	                    // popup from state-hash because 
	                    // event-listening for closing popup is over
	                    // before reject() call
	                    reject();
	                });
	            }
	        }).finally(function () {
	            _this4.stopListening(view);
	            // remove information about popup from state-hash
	            _this4.setState({
	                popup: undefined
	            });
	            _this4.navigated();
	            _this4.fetchAndUpdateLayers();
	        });
	    },
	    serialize: function serialize() {
	        var _options = this.options,
	            issues = _options.issues,
	            locationService = _options.locationService;
	
	
	        return {
	            queryString: this.state().queryString || '',
	            actionList: issues.actions,
	            collection: issues,
	            locationService: locationService
	        };
	    },
	
	
	    events: {
	        'keyup [name=title]': function keyupNameTitle(e) {
	            if (13 == e.keyCode) this.Grid.trigger('action:default'), e.preventDefault();
	        }
	    }
	
	}, _defineProperty(_Module$extend, _module2.default.event('Filter:filter'), function (filters) {
	    this.setState({ filters: filters, page: 1 /*activeId: undefined,*/ });
	    this.navigated();
	    this.fetchAndUpdateLayers();
	}), _defineProperty(_Module$extend, _module2.default.event('nav:list'), function () {
	    this.trigger(_list2.default.OPEN_LIST, this.state());
	}), _defineProperty(_Module$extend, _module2.default.event('nav:contracts'), function () {
	    this.trigger(_list2.default.OPEN_CONTRACTS, this.state());
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:edit'), function (_ref4) {
	    var id = _ref4.id;
	
	    return this.trigger(_form2.default.POPUP_EDIT,
	    // pass id only to force Schedule.byId in Form
	    id);
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:delete'), function (_ref5) {
	    var _this5 = this;
	
	    var id = _ref5.id;
	
	    (0, _popups.ask)('schedule::modal delete schedule - confirmation text', 'schedule::modal delete schedule - title', 'actions::yes', 'actions::no', function () {
	        return (0, _api.del)('/timetables/' + id).blocking(_this5).cerebellum().execute();
	    }).then(function () {
	        _this5.options.issues.current().get('schedule').deleted = true;
	        return _this5.Task.render();
	    });
	}), _defineProperty(_Module$extend, _module2.default.event(':schedule:templates'), function (_ref6) {
	    var id = _ref6.id;
	
	    return this.trigger(_templates2.default.POPUP,
	    // pass id only to force Schedule.byId in Template List
	    id);
	}), _defineProperty(_Module$extend, 'requestCount_', 0), _defineProperty(_Module$extend, 'fetchAndUpdateLayers', function fetchAndUpdateLayers() {
	    var _this6 = this;
	
	    var requestId = ++this.requestCount_;
	
	    var bounds = this.Map.bounds();
	    var bbox = [bounds._southWest.lng, bounds._southWest.lat, bounds._northEast.lng, bounds._northEast.lat];
	
	    var degDist = bounds._northEast.lat - bounds._southWest.lat;
	    var minDegDist = degDist * 1.5 * 48 / this.Map.$el.height();
	    var minKmDist = 20000 * minDegDist / 180;
	
	    var httpFilters = _extends({}, _tasks4.default.getHttpFilters(this.state()), {
	        bbox: bbox,
	        minD: minKmDist
	    });
	
	    return this.options.issues.filter(httpFilters, 1, this.state().activeId).then(function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 3),
	            a = _ref8[0],
	            coll = _ref8[1],
	            _ref8$ = _ref8[2],
	            tasks = _ref8$.tasks,
	            items = _ref8$.items;
	
	        if (requestId != _this6.requestCount_) return;
	
	        var hash = (0, _arrays.hashify)(coll.models.map(function (task, index) {
	            return [task.id, index];
	        }), function (_ref9) {
	            var _ref10 = _slicedToArray(_ref9, 2),
	                id = _ref10[0],
	                index = _ref10[1];
	
	            return [id, index];
	        });
	
	        var clusters = items.filter(function (cluster) {
	            return cluster.count > 1;
	        }).map(function (_ref11) {
	            var count = _ref11.count,
	                lon = _ref11.lon,
	                lat = _ref11.lat,
	                extent = _ref11.extent;
	            return { title: count, location: { lon: lon, lat: lat }, extent: extent };
	        });
	
	        var locations = tasks.map(function (_ref12) {
	            var _ref12$task = _ref12.task,
	                id = _ref12$task.id,
	                lon = _ref12$task.lon,
	                lat = _ref12$task.lat;
	            return { id: id, location: { lon: lon, lat: lat } };
	        });
	
	        _this6.Map.updateLayer('clusters', _this6.Map.newClusterLayer(clusters, _map.CircleBlue, function (marker, _ref13) {
	            var extent = _ref13.extent;
	            return marker.on('click', function () {
	                var _extent = _slicedToArray(extent, 4),
	                    x1 = _extent[0],
	                    y1 = _extent[1],
	                    x2 = _extent[2],
	                    y2 = _extent[3];
	
	                console.log(extent, x1 - x2, y1 - y2, _this6.Map.zoom());
	                if (_this6.Map.zoom() >= 17) _this6.openPopupList(_this6.createListPopup(extent));
	                // 0.0005 grad ~= 50 meters on the equator
	                else if (Math.abs(x1 - x2) < 5e-4 && Math.abs(y1 - y2) < 5e-4) _this6.openPopupList(_this6.createListPopup(extent));else return _this6.Map.spanToExtent_(extent);
	            });
	        }));
	        _this6.Map.updateLayer('tasks', _this6.Map.newClusterLayer(locations, function (_ref14) {
	            var id = _ref14.id;
	
	            var task = coll.at(hash[id]);
	            switch (task.get('stage')) {
	                case 0:
	                    return (0, _map.PinGray)();
	                case 1:
	                    return (0, _map.PinBlue)();
	                case 2:
	                    return (0, _map.PinGreen)();
	            }
	
	            return (0, _map.PinBlue)();
	        }, function (marker, attrs) {
	            return marker.on('click', function (a, b) {
	                _this6.options.issues.activate(hash[attrs.id]);
	                _this6.Map.updateLayer('activeTasks', _this6.Map.newClusterLayer([attrs], _map.PinRed));
	            });
	        }));
	        _this6.Map.updateLayer('activeTasks', _this6.Map.newClusterLayer(locations.filter(function (_ref15) {
	            var id = _ref15.id;
	            return id == _this6.state().activeId;
	        }), _map.PinRed));
	    });
	}), _defineProperty(_Module$extend, 'fetchCurrentComments', function fetchCurrentComments() {
	    var current = this.options.issues.current();
	    if (current && !current.comments_) return (0, _comments.fetch)(current.id).then(function (_ref16) {
	        var _ref17 = _slicedToArray(_ref16, 2),
	            json = _ref17[0],
	            coll = _ref17[1];
	
	        return current.trigger('comments:load', current.comments_ = json);
	    });
	}), _Module$extend), {});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _newstype = __webpack_require__(158);
	
	var _newstype2 = _interopRequireDefault(_newstype);
	
	var _typesForm = __webpack_require__(208);
	
	var _typesForm2 = _interopRequireDefault(_typesForm);
	
	var _types = __webpack_require__(157);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _roles = __webpack_require__(117);
	
	var _actions = __webpack_require__(17);
	
	var _popups = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/types.list',
	
	    url: function url() {
	        return 'types';
	    },
	    open: function open() {
	        var _this = this;
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                return _this.trigger(_typesForm2.default.OPEN_TYPE, new _newstype2.default(), _this.state().cluster);
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function (current) {
	                return _this.trigger(_typesForm2.default.OPEN_TYPE, current.clone());
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" types: with cluster == my cluster;
	                // there are only global and "my" types in the list;
	                // so, let's check only presence of cluster in type
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('type::modal delete - confirmation text', 'type::modal delete - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	        this.options.source = new _types2.default(this.options.types.models);
	        this.options.sorted = new _types2.default();
	        this.options.filtered = new _types2.default();
	        this.options.paged = new _types2.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    },
	
	
	    // need to override to pass typeGroups to grid
	    serialize: function serialize() {
	        return _extends({}, _refbooks2.default.prototype.serialize.call(this), {
	            typeGroups: this.options.typeGroups
	        });
	    }
	});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _RefBooksModule$exten;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _collection = __webpack_require__(11);
	
	var _collection2 = _interopRequireDefault(_collection);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _refbooks = __webpack_require__(168);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _newstype = __webpack_require__(158);
	
	var _newstype2 = _interopRequireDefault(_newstype);
	
	var _roles = __webpack_require__(117);
	
	var _messages = __webpack_require__(69);
	
	var _messages2 = __webpack_require__(68);
	
	var _loader = __webpack_require__(20);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OPEN_TYPE = 'type-form--popup',
	    TOGGLE_BOUND_ORGANIZATIONS = 'type-form--toggle-bound-organizations',
	    TOGGLE_BOUND_ROLES = 'type-form--toggle-bound-roles';
	
	exports.default = _refbooks2.default.extend((_RefBooksModule$exten = {
	    open: function open(_ref) {
	        var _this = this;
	
	        var type = _ref.type,
	            original = _ref.original;
	
	        this.options.type = type, this.original = original;
	
	        if (!type.id) if (this.state().cluster && this.state().cluster.id != -1) type.set('cluster', this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) type.set('cluster', _config2.default.cluster());
	
	        // both views (Orgs & Roles) contain Grid -
	        // so we can make preparation in their common parent
	        this.options.sorted = new _collection2.default();
	        this.options.filtered = new _collection2.default();
	        this.options.resulted = new _collection2.default();
	
	        return this.reSortGrid().then(function () {
	            return _this.reFilterGrid();
	        }).then(function () {
	            return _this.bind(type);
	        });
	    },
	    onBind: function onBind() {
	        // rewrite originalModel with passed value
	        this.originalModel = this.original || this.originalModel;
	    },
	    start: function start() {
	        var _this2 = this;
	
	        this.listenTo(this.options.type, 'change:cluster', function () {
	            _this2.setState({ page: 1 }), _this2.navigated();
	            _this2.reFilterGrid(_this2);
	
	            var type = _this2.options.type;
	
	            if (!type.get('group_id')) return;
	
	            var cluster = type.get('cluster');
	
	            var _options$typeGroups$t = _this2.options.typeGroups.toJSON().filter(function (tg) {
	                return tg.id == type.get('group_id');
	            }),
	                _options$typeGroups$t2 = _slicedToArray(_options$typeGroups$t, 1),
	                typeGroup = _options$typeGroups$t2[0];
	
	            if (!!cluster !== !!typeGroup.cluster) _this2.model.set('group_id', null);
	
	            if (typeGroup.cluster) if (typeGroup.cluster.id != cluster.id) _this2.model.set('group_id', null);
	        });
	        this.listenTo(this.options.type, 'change', function () {
	            return _this2.$('.-save')[0].disabled = !_this2.hasDiff();
	        });
	
	        return this;
	    },
	    stop: function stop() {
	        return this.stopListening(this.options.type), this;
	    },
	    serialize: function serialize() {
	        var _this3 = this;
	
	        var _options = this.options,
	            typeGroups = _options.typeGroups,
	            clusters = _options.clusters;
	
	
	        var typeGroupsFn = function typeGroupsFn() {
	            return typeGroups.toJSON().filter(function (tg) {
	                return !tg.cluster && !_this3.model.get('cluster') || tg.cluster && _this3.model.get('cluster') && _this3.model.get('cluster').id == tg.cluster.id;
	            }).map(function (tg) {
	                return { id: tg.id, title: tg.name };
	            });
	        };
	
	        return {
	            typeGroupsFn: typeGroupsFn, clusters: clusters,
	            hasDiff: function hasDiff() {
	                return _this3.hasDiff();
	            }
	        };
	    },
	
	
	    // copied from form.js
	    diff: function diff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.model ? this.model.diff(this.originalModel, options) : [];
	    },
	    hasDiff: function hasDiff() {
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return this.diff(options).length > 0;
	    },
	
	
	    events: {
	        'click .-save': function clickSave() {
	            var _this4 = this;
	
	            // cluster may be set only at create
	            if (!this.model.id) if (this.model.get('cluster')) {
	                var clusterId = this.model.get('cluster').id;
	                var clusterIds = (0, _arrays.hashify)(this.options.organizations, function (org) {
	                    return [org.id, org.cluster_id];
	                });
	
	                this.model.set('departments', this.model.get('departments').filter(function (orgId) {
	                    return clusterId == clusterIds[orgId];
	                }));
	            }
	
	            (0, _loader.beginLock)(this);
	
	            // dirty hack to force types.save() to invoke save(view) in actions.js
	            var stubView = new _form2.default();
	            stubView.model = adjustAttrsBeforeSave(this.model, this.options.roles);
	            stubView.originalModel = this.originalModel;
	
	            return this.options.types.save(stubView).then(function () {
	                return (/*type*/_this4.trigger(_refbooks2.default.BACK)
	                );
	            }, function (message) {
	                (0, _loader.endLock)(_this4);
	                (0, _messages2.handle)(_this4, (0, _messages.error)(message));
	            });
	        },
	        'click .-close': function clickClose() {
	            this.trigger(_refbooks2.default.BACK);
	        }
	    }
	
	}, _defineProperty(_RefBooksModule$exten, _refbooks2.default.event(':bound-organizations:toggle'), function () {
	    this.trigger(TOGGLE_BOUND_ORGANIZATIONS, this.model, this.originalModel, this.state());
	}), _defineProperty(_RefBooksModule$exten, _refbooks2.default.event(':bound-roles:toggle'), function () {
	    this.trigger(TOGGLE_BOUND_ROLES, this.model, this.originalModel, this.state());
	}), _RefBooksModule$exten), {
	
	    OPEN_TYPE: OPEN_TYPE,
	
	    TOGGLE_BOUND_ORGANIZATIONS: TOGGLE_BOUND_ORGANIZATIONS,
	
	    TOGGLE_BOUND_ROLES: TOGGLE_BOUND_ROLES
	
	});
	
	
	function adjustAttrsBeforeSave(type, roles) {
	    var _type$toJSON = type.toJSON(),
	        role_ids = _type$toJSON.role_ids,
	        __all_roles_available = _type$toJSON.__all_roles_available,
	        other = _objectWithoutProperties(_type$toJSON, ['role_ids', '__all_roles_available']);
	
	    var rolesById = (0, _arrays.hashify)(roles, function (role) {
	        return [role.id, role];
	    });
	
	    var filteredRoleIds = role_ids == null ? role_ids : role_ids.filter(function (id) {
	        var role = rolesById[id];
	        // no access to role -> must preserve
	        if (!role) return true;
	
	        // global type is ok for any role
	        return !other.cluster ||
	        // global role is ok for any type
	        !role.cluster ||
	        // otherwise cluster must match
	        role.cluster.id == type.get('cluster').id;
	    });
	
	    var json = _extends({
	        role_ids: __all_roles_available ? null : filteredRoleIds
	    }, other);
	
	    return new _newstype2.default(json);
	}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Template$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _typesForm = __webpack_require__(208);
	
	var _typesForm2 = _interopRequireDefault(_typesForm);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _typesForm2.default.extend((_Template$extend = {
	
	    template: 'module/refbooks/types.form.bound-organizations',
	
	    url: function url() {
	        return this.options.type.id ? 'types/' + this.options.type.id + '/edit/bound-organizations' : 'types/new/bound-organizations';
	    },
	    open: function open(_ref) {
	        var type = _ref.type,
	            original = _ref.original;
	
	        var _ref2 = this.state() || {},
	            _ref2$orgsPage = _ref2.orgsPage,
	            orgsPage = _ref2$orgsPage === undefined ? 1 : _ref2$orgsPage,
	            _ref2$orgsLimit = _ref2.orgsLimit,
	            orgsLimit = _ref2$orgsLimit === undefined ? 10 : _ref2$orgsLimit,
	            _ref2$orgsSort = _ref2.orgsSort,
	            orgsSort = _ref2$orgsSort === undefined ? 'name' : _ref2$orgsSort,
	            _ref2$orgsDirection = _ref2.orgsDirection,
	            orgsDirection = _ref2$orgsDirection === undefined ? 'asc' : _ref2$orgsDirection,
	            _ref2$orgsSearch = _ref2.orgsSearch,
	            orgsSearch = _ref2$orgsSearch === undefined ? '' : _ref2$orgsSearch;
	
	        this.setState({
	            orgsPage: orgsPage, orgsLimit: orgsLimit, orgsSort: orgsSort, orgsDirection: orgsDirection, orgsSearch: orgsSearch
	        });
	
	        return _typesForm2.default.prototype.open.call(this, { type: type, original: original });
	    },
	    start: function start() {
	        var _this = this;
	
	        _typesForm2.default.prototype.start.call(this);
	
	        this.listenTo(this.options.type, 'change:default_type', function () {
	            return _this.OrgGrid.enable(_this.model.get('default_type') === 'f');
	        });
	
	        return this;
	    },
	    serialize: function serialize() {
	        var _state = this.state(),
	            orgsSort = _state.orgsSort,
	            orgsDirection = _state.orgsDirection,
	            orgsSearch = _state.orgsSearch;
	
	        var _options = this.options,
	            filtered = _options.filtered,
	            resulted = _options.resulted;
	
	
	        return _extends({}, _typesForm2.default.prototype.serialize.call(this), {
	            organizations: filtered,
	            rows: resulted,
	            orgsSearch: orgsSearch, orgsSort: orgsSort, orgsDirection: orgsDirection
	        });
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref3) {
	            var _this2 = this;
	
	            var currentTarget = _ref3.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	
	            return this.setState({ orgsPage: 1, orgsSort: sort, orgsDirection: direction }), this.reSortGrid().then(function () {
	                return _this2.reFilterGrid();
	            })
	            // hack: to rerender grid caption with order direction
	            .then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.navigated();
	            });
	        },
	        'click .-toggle-binding': function clickToggleBinding(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var id = currentTarget.dataset.id;
	            var _options2 = this.options,
	                type = _options2.type,
	                filtered = _options2.filtered;
	
	
	            var needAppend = currentTarget.checked;
	            var oldOrganizations = type.get('departments');
	            var newOrganizations = needAppend ? [].concat(_toConsumableArray(oldOrganizations), [id]) : oldOrganizations.filter(function (itemId) {
	                return itemId != id;
	            });
	
	            type.set('departments', newOrganizations);
	
	            var ids = (0, _arrays.hashify)(newOrganizations);
	            this.$('.-toggle-all')[0].checked = filtered.every(function (org) {
	                return ids[org.id];
	            });
	        },
	        'click .-toggle-all': function clickToggleAll(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	
	            var value = currentTarget.checked;
	            var _options3 = this.options,
	                type = _options3.type,
	                filtered = _options3.filtered;
	
	
	            var ids = filtered.models.map(function (item) {
	                return item.id;
	            });
	            var h = (0, _arrays.hashify)(ids);
	            var drained = type.get('departments').filter(function (id) {
	                return !h[id];
	            });
	
	            type.set('departments', value ? [].concat(_toConsumableArray(drained), _toConsumableArray(ids)) : [].concat(_toConsumableArray(drained)));
	
	            this.$('.-toggle-binding').prop('checked', value);
	        }
	    }
	
	}, _defineProperty(_Template$extend, _typesForm2.default.event('Paging:page'), function (page) {
	    return this.setState({ orgsPage: +page }), this.reFilterGrid(this), this.navigated();
	}), _defineProperty(_Template$extend, _typesForm2.default.event('Search:search'), function (orgsSearch) {
	    return this.setState({ orgsSearch: orgsSearch, orgsPage: 1 }), this.reFilterGrid(this), this.navigated();
	}), _defineProperty(_Template$extend, 'reSortGrid', function reSortGrid() {
	    var clusters = (0, _arrays.hashify)(this.options.clusters, function (cl) {
	        return [cl.id, cl];
	    });
	
	    var _state2 = this.state(),
	        column = _state2.orgsSort,
	        direction = _state2.orgsDirection;
	
	    var sort = column === 'cluster.title' ? function (model) {
	        return clusters[model.get('cluster_id')].title;
	    } : column;
	
	    return _grid2.default.sort({ sort: sort, direction: direction }, this.options.organizations, this.options.sorted);
	}), _defineProperty(_Template$extend, 'reFilterGrid', function reFilterGrid() {
	    var _state3 = this.state(),
	        page = _state3.orgsPage,
	        search = _state3.orgsSearch,
	        limit = _state3.orgsLimit;
	
	    var _options4 = this.options,
	        type = _options4.type,
	        sorted = _options4.sorted,
	        filtered = _options4.filtered,
	        resulted = _options4.resulted;
	
	
	    _grid2.default.filter({ page: page, search: search, limit: limit }, type.get('cluster'), sorted, filtered, resulted);
	}), _Template$extend));

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Template$extend;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _grid = __webpack_require__(65);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _typesForm = __webpack_require__(208);
	
	var _typesForm2 = _interopRequireDefault(_typesForm);
	
	var _arrays = __webpack_require__(24);
	
	var _roles = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = _typesForm2.default.extend((_Template$extend = {
	
	    template: 'module/refbooks/types.form.bound-roles',
	
	    url: function url() {
	        return this.options.type.id ? 'types/' + this.options.type.id + '/edit/bound-roles' : 'types/new/bound-roles';
	    },
	    open: function open(_ref) {
	        var type = _ref.type,
	            original = _ref.original;
	
	        var _ref2 = this.state() || {},
	            _ref2$rolesPage = _ref2.rolesPage,
	            rolesPage = _ref2$rolesPage === undefined ? 1 : _ref2$rolesPage,
	            _ref2$rolesLimit = _ref2.rolesLimit,
	            rolesLimit = _ref2$rolesLimit === undefined ? 10 : _ref2$rolesLimit,
	            _ref2$rolesSort = _ref2.rolesSort,
	            rolesSort = _ref2$rolesSort === undefined ? 'name' : _ref2$rolesSort,
	            _ref2$rolesDirection = _ref2.rolesDirection,
	            rolesDirection = _ref2$rolesDirection === undefined ? 'asc' : _ref2$rolesDirection,
	            _ref2$rolesSearch = _ref2.rolesSearch,
	            rolesSearch = _ref2$rolesSearch === undefined ? '' : _ref2$rolesSearch;
	
	        this.setState({
	            rolesPage: rolesPage, rolesLimit: rolesLimit, rolesSort: rolesSort, rolesDirection: rolesDirection, rolesSearch: rolesSearch
	        });
	
	        return _typesForm2.default.prototype.open.call(this, { type: type, original: original });
	    },
	    start: function start() {
	        var _this = this;
	
	        _typesForm2.default.prototype.start.call(this);
	
	        this.listenTo(this.options.type, 'change:role_ids change:__all_roles_available', function () {
	            return _this.Buttons.render();
	        });
	
	        return this;
	    },
	    serialize: function serialize() {
	        var _state = this.state(),
	            rolesSort = _state.rolesSort,
	            rolesDirection = _state.rolesDirection,
	            rolesSearch = _state.rolesSearch;
	
	        var _options = this.options,
	            filtered = _options.filtered,
	            resulted = _options.resulted;
	
	
	        return _extends({}, _typesForm2.default.prototype.serialize.call(this), {
	            // TODO in Template?
	            roles: filtered,
	            rows: resulted,
	            rolesSearch: rolesSearch, rolesSort: rolesSort, rolesDirection: rolesDirection
	        });
	    },
	
	
	    events: {
	        'click .-sort': function clickSort(_ref3) {
	            var _this2 = this;
	
	            var currentTarget = _ref3.currentTarget;
	            var _currentTarget$datase = currentTarget.dataset,
	                sort = _currentTarget$datase.sort,
	                direction = _currentTarget$datase.direction;
	
	
	            return this.setState({ rolesPage: 1, rolesSort: sort, rolesDirection: direction }), this.reSortGrid().then(function () {
	                return _this2.reFilterGrid(_this2);
	            })
	            // hack: to rerender grid caption with order direction
	            .then(function () {
	                return _this2.render();
	            }).then(function () {
	                return _this2.navigated();
	            });
	        },
	        'click .-toggle-binding': function clickToggleBinding(_ref4) {
	            var currentTarget = _ref4.currentTarget;
	            var id = currentTarget.dataset.id;
	            var _options2 = this.options,
	                type = _options2.type,
	                filtered = _options2.filtered;
	
	
	            var needAppend = currentTarget.checked;
	            var oldRoles = type.get('role_ids');
	            var newRoles = needAppend ? [].concat(_toConsumableArray(oldRoles), [id]) : oldRoles.filter(function (itemId) {
	                return itemId != id;
	            });
	
	            type.set('role_ids', newRoles);
	
	            var ids = (0, _arrays.hashify)(newRoles);
	            this.$('.-toggle-all')[0].checked = filtered.every(function (role) {
	                return ids[role.id];
	            });
	        },
	        'click .-toggle-all': function clickToggleAll(_ref5) {
	            var currentTarget = _ref5.currentTarget;
	
	            var value = currentTarget.checked;
	            var _options3 = this.options,
	                type = _options3.type,
	                filtered = _options3.filtered;
	
	
	            var ids = filtered.models.map(function (item) {
	                return item.id;
	            });
	            var h = (0, _arrays.hashify)(ids);
	            var drained = type.get('role_ids').filter(function (id) {
	                return !h[id];
	            });
	
	            type.set('role_ids', value ? [].concat(_toConsumableArray(drained), _toConsumableArray(ids)) : [].concat(_toConsumableArray(drained)));
	
	            this.$('.-toggle-binding').prop('checked', value);
	        },
	        'click .-toggle-all-roles-available': function clickToggleAllRolesAvailable(_ref6) {
	            var currentTarget = _ref6.currentTarget;
	
	            // TODO the same in StickersGrid
	            if (!currentTarget.checked) {
	                if (this.model.get('role_ids') == null) this.model.set('role_ids', []);else
	                    // hack: undefined instead of false to make no diff with default value
	                    this.model.set('__all_roles_available', undefined);
	            } else this.model.set('__all_roles_available', true);
	
	            // TODO .disable()/.enable()
	            if (this.model.get('role_ids') == null || this.model.get('__all_roles_available')) this.RolesGrid.$el.addClass('disabled');else this.RolesGrid.$el.removeClass('disabled');
	        }
	    }
	
	}, _defineProperty(_Template$extend, _typesForm2.default.event('Paging:page'), function (page) {
	    return this.setState({ rolesPage: +page }), this.reFilterGrid(this), this.navigated();
	}), _defineProperty(_Template$extend, _typesForm2.default.event('Search:search'), function (rolesSearch) {
	    return this.setState({ rolesSearch: rolesSearch, rolesPage: 1 }), this.reFilterGrid(this), this.navigated();
	}), _defineProperty(_Template$extend, 'reSortGrid', function reSortGrid() {
	    var _state2 = this.state(),
	        sort = _state2.rolesSort,
	        direction = _state2.rolesDirection;
	
	    return _grid2.default.sort({ sort: sort, direction: direction }, this.options.roles, this.options.sorted);
	}), _defineProperty(_Template$extend, 'reFilterGrid', function reFilterGrid() {
	    var _state3 = this.state(),
	        page = _state3.rolesPage,
	        search = _state3.rolesSearch,
	        limit = _state3.rolesLimit;
	
	    var _options4 = this.options,
	        type = _options4.type,
	        sorted = _options4.sorted,
	        filtered = _options4.filtered,
	        resulted = _options4.resulted;
	
	
	    _grid2.default.filter({ page: page, search: search, limit: limit }, type.get('cluster'), sorted, filtered, resulted,
	    // additional filtering by role cluster/type cluster
	    function (role) {
	        // chief admin/inspector can see all roles
	        if (_roles.roleAI.indexOf(_config2.default.role()) !== -1) return true;
	
	        // local type -> standard filtering is enough
	        if (type.get('cluster') !== null) return true;
	
	        // global type & cluster admin -> local roles only
	        return role.get('cluster') !== null;
	    });
	}), _Template$extend));

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _refbooks = __webpack_require__(181);
	
	var _refbooks2 = _interopRequireDefault(_refbooks);
	
	var _config = __webpack_require__(8);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _form = __webpack_require__(42);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _type = __webpack_require__(160);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _type3 = __webpack_require__(159);
	
	var _type4 = _interopRequireDefault(_type3);
	
	var _roles = __webpack_require__(117);
	
	var _popups = __webpack_require__(62);
	
	var _actions = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterModel = _model2.default.extend({ defaults: {
	        cluster: undefined
	    } });
	
	exports.default = _refbooks2.default.extend({
	
	    template: 'module/refbooks/type.groups.list',
	
	    url: function url() {
	        return 'types/groups';
	    },
	    open: function open() {
	        var _this = this;
	
	        var form = new _form2.default({
	            template: 'module/refbooks/type.groups.form',
	            clusters: this.options.clusters
	        });
	
	        var actions = this.options.actions = {
	
	            defaults: 'edit',
	
	            create: (0, _actions.restrict)(_roles.roleAC, function () {
	                var current = new _type2.default();
	                var binding = form.bind(current);
	                binding.then(function () {
	                    if (_this.state().cluster && _this.state().cluster.id != -1) current.set('cluster', _this.state().cluster);else if (~_roles.roleC.indexOf(_config2.default.role())) current.set('cluster', _config2.default.cluster());
	                });
	
	                (0, _popups.ask)(binding, 'type::modal new type group - title', 'actions::create', 'actions::cancel', function () {
	                    return _this.options.typeGroups.save(form);
	                }).then(function () {
	                    return _this.options.source.reset(_this.options.typeGroups.models, { silent: true // a sort of paranoia
	                    });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            edit: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" type groups: with cluster == my cluster;
	                // there are only global and "my" type groups in the list;
	                // so, let's check only presence of cluster in type group
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                current = current.clone();
	                (0, _popups.ask)(form.bind(current), 'type::modal edit type group - title', 'actions::save', 'actions::close', function () {
	                    return _this.options.source.save(form);
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                });
	            }),
	
	            destroy: (0, _actions.restrict)(_roles.roleAC, function () {
	                if (_roles.roleA.indexOf(_config2.default.role()) !== -1) return true;
	
	                // can see only "my" type groups: with cluster == my cluster;
	                // there are only global and "my" type groups in the list;
	                // so, let's check only presence of cluster in type group
	                // to separate "my".
	                return !!_this.options.paged.current().get('cluster');
	            }, function (current) {
	                var _state = _this.state(),
	                    page = _state.page;
	                // length will be updated by "destroy" call on model
	
	
	                var length = _this.options.paged.length;
	
	                (0, _popups.ask)('type::modal delete type group - confirmation text', 'type::modal delete type group - title', 'actions::yes', 'actions::no', function () {
	                    return _this.options.source.destroy(current);
	                }).then(function () {
	                    if (length === 1 && page > 1) _this.setState({ page: page - 1 });
	                }).then(function () {
	                    return _this.sort();
	                }).then(function () {
	                    return _this.render();
	                }).then(function () {
	                    return _this.navigated();
	                });
	            })
	        };
	
	        this.options.filter = new FilterModel({
	            cluster: this.state().cluster
	        });
	
	        this.options.source = new _type4.default(this.options.typeGroups.models);
	        this.options.sorted = new _type4.default();
	        this.options.filtered = new _type4.default();
	        this.options.paged = new _type4.default({ actions: actions });
	
	        return this.sort().then(function () {
	            return _this.bind(_this.options.filter);
	        });
	    }
	});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.event = exports.route = exports.Router = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _channel = __webpack_require__(74);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _arrays = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Router = _backbone2.default.Router.extend({
	    initialize: function initialize() {
	        var _this = this;
	
	        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _backbone2.default.Router.prototype.initialize.call(this, options);
	
	        this.channel_ = new _channel2.default(function (writeFn) {
	            return _this.writeFn_ = writeFn;
	        });
	    },
	    execute: function execute(callback, args, name) {
	        var filteredArgs = [].concat(_toConsumableArray(args));
	        // got null in the end. why?
	        filteredArgs.pop();
	
	        if (callback) this.channel_.write_([callback, filteredArgs]);
	    },
	    getChannel: function getChannel() {
	        return this.channel_;
	    }
	}, {
	    from: function from(definition) {
	        // filter route/event names
	        // (event name starts from ":")
	        var routeNames = Object.keys(definition).filter(function (name) {
	            return !name.startsWith(':');
	        });
	        var eventNames = Object.keys(definition).filter(function (name) {
	            return name.startsWith(':');
	        }).map(function (name) {
	            return name.substring(1);
	        });
	
	        // build route/event hashes
	        var routes = (0, _arrays.hashify)(routeNames, function (name) {
	            return [name, definition[name]];
	        });
	        var events = (0, _arrays.hashify)(eventNames, function (name) {
	            return [name, definition[':' + name]];
	        });
	
	        var router = new Router({ routes: routes });
	        var channel = router.getChannel();
	
	        // attach events from definition to router
	        Object.keys(events)
	        // event name is JSON object with event definition
	        .map(function (eventName) {
	            return [eventName, events[eventName]];
	        }).forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                eventName = _ref2[0],
	                callbackFn = _ref2[1];
	
	            return (
	                // when `name` event triggered on router, take its args
	                // and pass to router channel with callbackFn defined 
	                // for this event.
	                router.on(eventName, function () {
	                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                        args[_key] = arguments[_key];
	                    }
	
	                    return channel.write_([callbackFn, args]);
	                })
	            );
	        });
	
	        return router;
	    }
	});
	
	exports.Router = Router;
	exports.route = route;
	exports.event = event;
	
	
	function route(urlMask) {
	    if (urlMask === '') return urlMask;
	
	    if (urlMask.endsWith('(/*appState)')) return urlMask;
	
	    if (urlMask.endsWith('/*appState')) return urlMask;
	
	    if (urlMask.endsWith('/')) return urlMask + '(*appState)';
	
	    return urlMask + '(/*appState)';
	}
	
	function event(name) {
	    return ':' + name;
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.handle = exports.rejectPopup = exports.closePopup = exports.popup = exports.replace = exports.root = exports.restore = exports.routing = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _backbone = __webpack_require__(13);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _jsBase = __webpack_require__(214);
	
	var _module = __webpack_require__(169);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _promisify = __webpack_require__(19);
	
	var _router = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.routing = routing;
	exports.restore = restore;
	exports.root = root;
	exports.replace = replace;
	exports.popup = popup;
	exports.closePopup = closePopup;
	exports.rejectPopup = rejectPopup;
	exports.handle = handle;
	
	
	function routing(application, appState, routes) {
	    var router = _router.Router.from(routes);
	
	    var lastModule = null;
	
	    // function to router navigation
	    var navigate = function navigate(url, options, popupResult) {
	        router.popupResult = popupResult;
	        router.navigate(url, options);
	    };
	
	    var navigationFn = function navigationFn(moduleUrl, moduleState) {
	        // replace current application's top stack state with new one
	        appState.replaceTop(moduleUrl, moduleState);
	        navigate(appState.urlify(), { trigger: false });
	    };
	
	    var proxyEventsFn = function proxyEventsFn(eventName) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	            args[_key - 1] = arguments[_key];
	        }
	
	        return router.trigger.apply(router, [eventName].concat(args));
	    };
	
	    router.getChannel().map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            callback = _ref2[0],
	            args = _ref2[1];
	
	        return callback.apply(null, args);
	    }).filter(function (routeParams) {
	        return routeParams && routeParams.openFn;
	    }).forEach(function (_ref3) {
	        var openFn = _ref3.openFn,
	            transformStateFn = _ref3.transformStateFn,
	            transformArgsFn = _ref3.transformArgsFn,
	            mod = _ref3.mod,
	            module = _ref3.module,
	            args = _ref3.args;
	
	        // console.log( 'ch foreach, args are: ', args );
	        // stop listening for navigation events for
	        // previously opened module 
	        if (lastModule) {
	            lastModule.off('url:navigate', navigationFn);
	            lastModule.off('all', proxyEventsFn);
	        }
	
	        var options = {
	            application: application,
	            appState: appState,
	            navigate: navigate,
	            mod: mod,
	            module: module,
	            transformStateFn: transformStateFn,
	            transformArgsFn: transformArgsFn
	        };
	
	        // non-module-related-opening aka back
	        // (module-related-opening goes below)
	        if (!module) return (0, _promisify.requestify)(openFn.apply(undefined, [options].concat(_toConsumableArray(args))));
	
	        // listen for events in new module
	        module.on('url:navigate', navigationFn);
	        module.on('all', proxyEventsFn);
	
	        lastModule = module;
	
	        // open module in application by specified function
	        return (0, _promisify.requestify)(openFn.apply(undefined, [options].concat(_toConsumableArray(args))));
	    });
	
	    _backbone2.default.history.start();
	}
	
	function restore(options) {
	    for (var _len2 = arguments.length, moduleArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        moduleArgs[_key2 - 1] = arguments[_key2];
	    }
	
	    // console.log( 'called restore, moduleArgs are: ', moduleArgs );
	
	    var application = options.application,
	        appState = options.appState,
	        mod = options.mod,
	        module = options.module,
	        transformStateFn = options.transformStateFn;
	
	    var _moduleArgs$slice$rev = moduleArgs.slice().reverse(),
	        _moduleArgs$slice$rev2 = _toArray(_moduleArgs$slice$rev),
	        stringifiedAppState = _moduleArgs$slice$rev2[0],
	        otherModuleArgs = _moduleArgs$slice$rev2.slice(1);
	
	    otherModuleArgs.reverse();
	
	    if (stringifiedAppState) ; // console.log( Base64.decode( stringifiedAppState ) );
	
	    if (stringifiedAppState) appState.restore(stringifiedAppState);else appState.clear();
	
	    var _appState$getTopState = appState.getTopState(),
	        _appState$getTopState2 = _slicedToArray(_appState$getTopState, 2),
	        moduleUrl = _appState$getTopState2[0],
	        moduleState = _appState$getTopState2[1];
	
	    return (0, _promisify.promisify)(transformStateFn.apply(undefined, [moduleState].concat(_toConsumableArray(otherModuleArgs)))).then(function (_ref4) {
	        var moduleState = _ref4.moduleState,
	            moduleArgs = _ref4.moduleArgs;
	
	        return module.options.isRoot = appState.size() < 2, application.open.apply(application, [mod, module, moduleState].concat(_toConsumableArray(moduleArgs)));
	    });
	}
	
	function root(options) {
	    for (var _len3 = arguments.length, moduleArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        moduleArgs[_key3 - 1] = arguments[_key3];
	    }
	
	    var application = options.application,
	        appState = options.appState,
	        mod = options.mod,
	        module = options.module,
	        transformArgsFn = options.transformArgsFn;
	
	
	    return (0, _promisify.promisify)(transformArgsFn.apply(undefined, moduleArgs)).then(function (_ref5) {
	        var moduleState = _ref5.moduleState,
	            moduleArgs = _ref5.moduleArgs;
	
	        appState.replace(null, moduleState);
	
	        return module.options.isRoot = true, application.open.apply(application, [mod, module, moduleState].concat(_toConsumableArray(moduleArgs)));
	    });
	}
	
	function replace(options) {
	    for (var _len4 = arguments.length, moduleArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        moduleArgs[_key4 - 1] = arguments[_key4];
	    }
	
	    var application = options.application,
	        appState = options.appState,
	        mod = options.mod,
	        module = options.module,
	        transformArgsFn = options.transformArgsFn;
	
	
	    return (0, _promisify.promisify)(transformArgsFn.apply(undefined, moduleArgs)).then(function (_ref6) {
	        var moduleState = _ref6.moduleState,
	            moduleArgs = _ref6.moduleArgs;
	
	        appState.replaceTop(null, moduleState);
	
	        return module.options.isRoot = appState.size() < 2, application.open.apply(application, [mod, module, moduleState].concat(_toConsumableArray(moduleArgs)));
	    });
	}
	
	function popup(options) {
	    for (var _len5 = arguments.length, moduleArgs = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        moduleArgs[_key5 - 1] = arguments[_key5];
	    }
	
	    var application = options.application,
	        appState = options.appState,
	        mod = options.mod,
	        module = options.module,
	        transformArgsFn = options.transformArgsFn;
	
	
	    return (0, _promisify.promisify)(transformArgsFn.apply(undefined, moduleArgs)).then(function (_ref7) {
	        var moduleState = _ref7.moduleState,
	            moduleArgs = _ref7.moduleArgs;
	
	        appState.push(null, moduleState);
	
	        return module.options.isRoot = false, application.popup.apply(application, [mod, module, moduleState].concat(_toConsumableArray(moduleArgs)));
	    });
	}
	
	function closePopup(options, popupResult) {
	    return pop(options, Promise.resolve(popupResult));
	}
	
	function rejectPopup(options) {
	    return pop(options, Promise.reject());
	}
	
	function pop(options, popupResult) {
	    var appState = options.appState,
	        navigate = options.navigate;
	
	
	    appState.pop();
	    navigate(appState.urlify(), { trigger: true }, popupResult);
	}
	
	function handle(openFn, mod, Module, transformFn) {
	    var transformStateFn = function transformStateFn(moduleState) {
	        for (var _len6 = arguments.length, moduleArgs = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	            moduleArgs[_key6 - 1] = arguments[_key6];
	        }
	
	        return makeTransformation.apply(undefined, [function (moduleState) {
	            for (var _len7 = arguments.length, moduleArgs = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	                moduleArgs[_key7 - 1] = arguments[_key7];
	            }
	
	            // console.log( 'callback for t-state:', JSON.stringify( moduleState ), JSON.stringify( ...moduleArgs ) );
	            return transformFn.apply(undefined, [moduleState].concat(moduleArgs));
	        }, moduleState].concat(moduleArgs));
	    };
	
	    var transformArgsFn = function transformArgsFn() {
	        for (var _len8 = arguments.length, moduleArgs = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	            moduleArgs[_key8] = arguments[_key8];
	        }
	
	        return makeTransformation.apply(undefined, [function (moduleState) {
	            for (var _len9 = arguments.length, moduleArgs = Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
	                moduleArgs[_key9 - 1] = arguments[_key9];
	            }
	
	            // console.log( 'callback for t-args:', JSON.stringify( moduleArgs ) );
	            return transformFn.apply(undefined, moduleArgs);
	        }, {}].concat(moduleArgs));
	    };
	
	    var makeTransformation = function makeTransformation(callTransformFn, moduleState) {
	        for (var _len10 = arguments.length, moduleArgs = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	            moduleArgs[_key10 - 2] = arguments[_key10];
	        }
	
	        // console.log( 'make transformation call with state, args:', JSON.stringify( moduleState ), JSON.stringify( moduleArgs ) );
	
	        if (!transformFn) return {
	            moduleState: moduleState,
	            moduleArgs: moduleArgs
	        };
	
	        return (0, _promisify.promisify)(callTransformFn.apply(undefined, [moduleState].concat(moduleArgs))).then(function (response) {
	            if (response instanceof Array) return {
	                moduleState: moduleState,
	                moduleArgs: response
	            };
	
	            if (response.moduleState || response.moduleArgs) return {
	                moduleState: response.moduleState || moduleState,
	                moduleArgs: response.moduleArgs || moduleArgs
	            };
	
	            return {
	                moduleState: moduleState,
	                moduleArgs: [response]
	            };
	        });
	    };
	
	    return function () {
	        for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
	            args[_key11] = arguments[_key11];
	        }
	
	        // for "back" actions there is no Module
	        var module = Module ? new Module({}) : undefined;
	        return { openFn: openFn, transformStateFn: transformStateFn, transformArgsFn: transformArgsFn, module: module, mod: mod, args: args };
	    };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Application = undefined;
	
	var _view = __webpack_require__(43);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _promisify = __webpack_require__(19);
	
	var _loader = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var Application = _view2.default.extend({
	
	    el: document.body,
	
	    template: 'jst/application',
	
	    popup: function popup(mod, module, state) {
	        for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	            args[_key - 3] = arguments[_key];
	        }
	
	        return this.module.apply(this, [mod, module, state].concat(args));
	    },
	    open: function open(mod, module, state) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	            args[_key2 - 3] = arguments[_key2];
	        }
	
	        return this.module.apply(this, [mod, module, state].concat(args));
	    },
	    module: function module(mod, _module, state) {
	        for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	            args[_key3 - 3] = arguments[_key3];
	        }
	
	        var _this = this;
	
	        _module.$el
	        // this is hack
	        .css({ opacity: 0 /*transform: 'scale(0.01)'*/ })
	        // this is not
	        .appendTo(document.body);
	
	        var startingModule = mod.init().then(function () {
	            return _module.inject(mod.injectable());
	        }).then(function () {
	            return _module.setState(state);
	        }).then(function () {
	            return _module.open.apply(_module, args);
	        }).then(function (result) {
	            return result instanceof Array ? result : [result];
	        });
	        // mark that THIS mod (not another one) 
	        // must be shown in application after starting.
	        this.last = startingModule;
	
	        (0, _loader.beginLock)(this);
	
	        var startingProcess = (0, _promisify.requestify)(startingModule).then(function (_ref) {
	            var _module$attached$navi;
	
	            var _ref2 = _toArray(_ref),
	                module = _ref2[0],
	                args = _ref2.slice(1);
	
	            // some module is opening now,
	            // our module is outdated.
	            if (startingModule !== _this.last) return;
	
	            // remove currently shown module
	            if (_this.currentModule) {
	                _this.currentModule.$el.detach();
	
	                _this.currentModule.detached().stop();
	
	                _this.stopListening(_this.currentModule);
	            }
	
	            // and remember new one.
	            _this.currentModule = module;
	
	            (0, _loader.endLock)(_this);
	            module.$el
	            // this is hack
	            .css({ opacity: 1 /* transform: '' */ });
	
	            // clear container for module and 
	            // notify it about attachment
	            (_module$attached$navi = module.attached(_this.$el).navigated()).start.apply(_module$attached$navi, _toConsumableArray(args));
	        });
	
	        return startingProcess.catch(function (cause) {
	            // some module is opening now,
	            // our module is outdated.
	            if (startingModule !== _this.last) return;
	
	            console.error('Failed to open module, reason is ' + cause);
	
	            throw cause;
	        });
	    }
	});
	
	exports.Application = Application;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _model = __webpack_require__(22);
	
	var _model2 = _interopRequireDefault(_model);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppState = function () {
	    function AppState() {
	        _classCallCheck(this, AppState);
	
	        this.clear();
	    }
	
	    _createClass(AppState, [{
	        key: 'clear',
	        value: function clear() {
	            this.state_ = [[null, {}]];
	        }
	    }, {
	        key: 'restore',
	        value: function restore(stringified) {
	            this.state_ = JSON.parse(Base64.decode(stringified));
	        }
	    }, {
	        key: 'stringify',
	        value: function stringify() {
	            var deepcopy = function deepcopy(value) {
	                if (value instanceof _model2.default) return value.id;
	
	                if (value instanceof Array) return value.map(deepcopy);
	
	                if (value instanceof Object) return Object.keys(value).map(function (k) {
	                    return [k, deepcopy(value[k])];
	                }).reduce(function (obj, _ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        k = _ref2[0],
	                        v = _ref2[1];
	
	                    return obj[k] = v, obj;
	                }, {});
	
	                return value;
	            };
	
	            return Base64.encodeURI(JSON.stringify(deepcopy(this.state_)));
	        }
	    }, {
	        key: 'urlify',
	        value: function urlify() {
	            var _getTopState = this.getTopState(),
	                _getTopState2 = _slicedToArray(_getTopState, 1),
	                moduleBaseUrl = _getTopState2[0];
	
	            if (!moduleBaseUrl.endsWith('/')) moduleBaseUrl += '/';
	
	            return '' + moduleBaseUrl + this.stringify();
	        }
	    }, {
	        key: 'getTopState',
	        value: function getTopState() {
	            return this.state_[this.state_.length - 1];
	        }
	    }, {
	        key: 'push',
	        value: function push(moduleUrl, moduleState) {
	            this.state_.push([moduleUrl, moduleState]);
	        }
	    }, {
	        key: 'pop',
	        value: function pop() {
	            this.state_.pop();
	        }
	    }, {
	        key: 'replaceTop',
	        value: function replaceTop(moduleUrl, moduleState) {
	            this.state_.pop();
	            this.state_.push([moduleUrl, moduleState]);
	        }
	    }, {
	        key: 'replace',
	        value: function replace(moduleUrl, moduleState) {
	            this.state_ = [[moduleUrl, moduleState]];
	        }
	    }, {
	        key: 'size',
	        value: function size() {
	            return this.state_.length;
	        }
	    }]);
	
	    return AppState;
	}();
	
	exports.default = AppState;

/***/ })
]);
